(function () {
  'use strict';

  angular
    .module('assistApp', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'toastr',
      'ngResource',
      'ui.router',
      'config',
      'portalText',
      'ui.bootstrap',
      'lbServices',
      'ui.select',
      'ui.sortable',
      'angularFileUpload',
      'pascalprecht.translate',
      'angularMoment',
      'jlareau.bowser',
      'vcRecaptcha',
      'angular-google-analytics',
      'rzModule',
      'chart.js',
      'angulartics', 'angulartics.google.analytics'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'Password.Reset.Controller',
      function ($state, AuthService, NotificationService) {
        var vm = this;

        vm.loading = false;
        vm.email = '';
        vm.error = null;

        function afterReset() {
          vm.loading = false;
          $state.go('guest.password-reset-info');
        }

        function afterResetError(error) {
          vm.loading = false;

          if (error.status === 404) {
            vm.error = 'User with this email does not exist.';
            return;
          }

          NotificationService.error('Data access error', error);
        }

        vm.reset = function () {
          vm.loading = true;
          AuthService.resetPassword(
            vm.email,
            afterReset,
            afterResetError
          );
        };

        vm.onEmailChange = function () {
          vm.error = null;
        };

        vm.isDisabled = function(form) {
          return (!form.$valid && form.$submitted) || vm.loading
        };

        vm.hasError = function(form) {
          return (form.$submitted && !form.$valid) || vm.error;
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'Password.New.Controller',
      function (
        $state,
        $stateParams,
        AuthService,
        NotificationService,
        passwordRegex
      ) {
        var vm = this;

        vm.password = '';
        vm.error = '';
        vm.loading = false;
        vm.passwordRegex = passwordRegex;
        vm.passwordErrorMessage = "Your password must contain at minimum 12 " +
                                  "characters and must include an upper case " +
                                  "letter, a lower case letter, a number and " +
                                  "a symbol.";

        function afterSave() {
          vm.loading = false;
          $state.go('guest.password-new-info');
        }

        function afterSaveError(error) {
          NotificationService.error('Data access error', error);
          vm.loading = false;
        }

        vm.new = function () {
          vm.loading = true;
          AuthService.newPassword(
            vm.password,
            $stateParams.accessToken,
            afterSave,
            afterSaveError
          );
        };

        vm.isDisabled = function(form) {
          return (!form.$valid && form.$submitted) || vm.loading
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'MyeAssist.Signup.Controller',
      function (
        $rootScope,
        $state,
        $stateParams,
        config,
        UserService,
        NotificationService,
        passwordRegex,
        passwordErrorMessage,
        DeviceDetectService,
        $document,
        $timeout,
        $sce,
        $http
      ) {
        var vm = this;

        vm.landingUrls = {
          myeassist: 'https://myeassist.assistplus.com.au/'
        };

        vm.randomId = makeId();

        vm.user = {
          firstName: 'Guest',
          lastName: vm.randomId,
          email: '',
          password: '',
          birthDate: '',
          gender: '',
          employment: ''
        };
        vm.passwordConfirmation = '';
        vm.errors = {};
        vm.emailExistError = false;
        vm.loading = false;

        vm.passwordRegex = passwordRegex;
        vm.passwordErrorMessage = passwordErrorMessage;

        vm.returnTo = $stateParams.returnTo;
        vm.returnToParams = $stateParams.params;

        vm.params = {
          registerCheckup: true
        };

        vm.passwordRegexes = [
          /[a-zA-Z0-9]{6,}/,
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !@#$%^&*(),.?':{}|<>]).{12,}$/
        ];

        vm.passwordStrengths = [
          'moderate',
          'strong'
        ];

        vm.passwordStrength = 'strength';

        vm.checkPassword = function (passwordInput) {
          var passwordChecks = vm.passwordRegexes.map(function (regex) {
            return regex.test(vm.user.passwordData);
          });

          vm.passwordStrength = 'weak';
          passwordInput.$setValidity('strength', false);

          angular.forEach(passwordChecks, function (passwordCheck, index) {
            if (passwordCheck) {
              vm.passwordStrength = vm.passwordStrengths[index];
              passwordInput.$setValidity('strength', true);
            }
          });

          if (!vm.user.password) { vm.passwordStrength = 'strength'; }
          vm.user.password = vm.user.passwordData;
        };

        vm.getPasswordStrengthLabel = function (passwordStrength) {
          switch (passwordStrength) {
            case 'weak': return 'Too short';
            case 'moderate': return 'Moderate';
            case 'strong': return 'Strong';
            case 'strength': return 'Strength';
          }
        };

        function afterSignup(data) {
          vm.loading = false;
          if (data.id) {
            $state.go('guest.myeAssist-confirm-email');
          } else {
            _.each(data.errors, function (error) {
              vm.errors[error.param] = error.msg;
            });
          }

          // if(vm.params.registerCheckup) {
          //   var data = {
          //     user: {
          //       firstName: vm.user.firstName,
          //       lastName: vm.user.lastName,
          //       email: vm.user.email,
          //       password: vm.user.password
          //     },
          //     portalAccessCode: null
          //   }
          //   $http.post('https://mycheckup.adelaide.edu.au/api/WineUsers/createAccount', data);            
          // }
        }

        function afterSignupError(error) {
          if (error.status === 422 &&
            error.data.error.details &&
            error.data.error.details.codes &&
            error.data.error.details.codes.email &&
            error.data.error.details.codes.email[0] === 'uniqueness') {

            vm.emailExistError = true;
          }
          NotificationService.error('Data access error', error);
          vm.loading = false;
        }

        vm.signup = function (e) {
          vm.loading = true;
          vm.errors = {};
          UserService.create(
            { user: vm.user },
            afterSignup,
            afterSignupError
          );
        };

        vm.isDisabled = function (form) {
          return (form && !form.$valid && form.$submitted) ||
            form.userAgreement.$error.required ||
            vm.loading;
        };

        vm.isYearOfBirthValid = function (yearOfBirth) {
          var d = new Date();
          var currentYear = d.getFullYear();
          return (currentYear - yearOfBirth) >= 18 ? true : false;
        }

        function makeId() {
          var text = '';
          var possible = '0123456789';

          for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

          return text;
        }

        vm.makeId = function () {
          vm.user.lastName = makeId();
        }

      });
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'Settings.Index.Controller',
      function (
        AuthService,
        LoopBackAuth,
        NotificationService,
        UserService,
        $state,
        $stateParams,
        passwordRegex,
        $rootScope,
        $scope, toastr
      ) {
        var vm = this;
        vm.isRightActive = false;
        var isMfa = $stateParams.mfa || false;
        vm.deleteAccountMode = false;
        vm.changePasswordMode = false;
        vm.changeEmailMode = false;
        vm.emailChanged = false;
        vm.changeNotificationMode = false;
        vm.errorPassword = '';
        vm.errorEmail = '';
        vm.credentials = {};
        vm.newEmail = null;
        vm.notification = {};
        vm.passwordRegex = passwordRegex;
        vm.social = {};
        vm.is2FAEnable = true;
        vm.activeTab = isMfa ? 1 : 0;

        vm.linkingError = $stateParams.error ? 'Account already linked' : '';

        vm.toggleNavRight = function () {
          vm.isRightActive = !vm.isRightActive;
          $scope.$emit('changeNavRight', vm.isRightActive);
        };
        $scope.$on('changeNavRight', function (event, state) {
          vm.isRightActive = state;
        });

        vm.passwordRegexes = [
          /[a-zA-Z0-9]{6,}/,
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !@#$%^&*(),.?':{}|<>]).{12,}$/
        ];
        vm.passwordStrengths = [
          'moderate',
          'strong'
        ];
        vm.passwordStrength = 'strength';

        vm.checkPassword = function (passwordInput) {
          var passwordChecks = vm.passwordRegexes.map(function (regex) {
            return regex.test(vm.credentials.passwordData);
          });

          vm.passwordStrength = 'weak';
          passwordInput.$setValidity('strength', false);

          angular.forEach(passwordChecks, function (passwordCheck, index) {
            if (passwordCheck) {
              vm.passwordStrength = vm.passwordStrengths[index];
              passwordInput.$setValidity('strength', true);
            }
          });

          if (!vm.credentials.newPassword) { vm.passwordStrength = 'strength'; }
          vm.credentials.newPassword = vm.credentials.passwordData;
        };

        $rootScope.$watch('User', function () {
          $rootScope.User.$promise.then(function (User) {
            vm.user = User;
            onGetBarcodeFor2FA();
          });
        });

        vm.showDeleteForm = function () {
          vm.deleteAccountMode = true;
        };

        function onGetBarcodeFor2FA() {
          UserService.getQRCode({
            id: vm.user.id
          }).then(function (qrCode) {
            vm.qrCode = qrCode.qrCode;
          }, function (err) {
            console.log(err);
          });
        }

        vm.cancelDeleteAccount = function () {
          vm.deleteAccountMode = false;
        };

        vm.change2FASetting = function () {
          vm.user.is2FAEnable = vm.is2FAEnable;
          UserService.updateMainAttributes({ is2FAEnable: vm.user.is2FAEnable }, function (success) {
            toastr.success('2FA setting changed successfully!', 'Setting Updated');
            $rootScope.User.is2FAEnable = vm.user.is2FAEnable;
            if (isMfa) {
              $state.go('user.report');
              return;
            }
          }, function (err) {
            vm.user.is2FAEnable = !vm.is2FAEnable;
            toastr.error('2FA settings not updated!', 'Error');
          });
        };

        vm.deleteAccount = function () {
          UserService.deleteAccount(
            function () {
            },
            function (error) {
              NotificationService.error('Data access error');
            }
          );
        };

        vm.forgot = function () {
          UserService.logout().finally(function () {
            $state.go('guest.password-reset');
          });
        };

        vm.showPasswordForm = function () {
          vm.credentials = {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: ''
          };
          vm.errorPassword = '';

          vm.changePasswordMode = true;
        };

        vm.changePassword = function () {
          vm.loading = true;
          AuthService.changePassword(
            vm.credentials.oldPassword,
            vm.credentials.newPassword,
            LoopBackAuth.accessTokenId,
            function (data) {
              if (data.success) {
                console.log('password has been changed');
                vm.loading = false;
                vm.changePasswordMode = false;
              } else {
                vm.loading = false;
                vm.errorPassword = 'Your old password is wrong';
              }
            },
            function (error) {
              NotificationService.error('Data access error', error);
              vm.loading = false;
            }
          );
        };

        vm.verifyOtp = function () {
          vm.invalidToken = false;
          UserService.verify2Fa(vm.user.id, vm.otpToken).then(function (res) {
            toastr.success('2FA enabled successfully!', 'Success');
            vm.user.is2FAVerified = true;
            vm.otpToken = null;
          }, function (err) {
            toastr.error('2FA not enabled!', 'Error');
            vm.invalidToken = true;
          });
        };

        vm.isValidPasswordForm = function () {
          return (!!vm.credentials.oldPassword && !!vm.credentials.newPassword && !!vm.credentials.confirmNewPassword &&
            vm.credentials.confirmNewPassword === vm.credentials.newPassword);
        };

        vm.cancelPasswordForm = function () {
          vm.changePasswordMode = false;
        };

        vm.isPasswordValid = function () {
          return vm.credentials.newPassword.match(vm.passwordRegex);
        };

        vm.showNotificationForm = function () {
          vm.notification = angular.copy(vm.user.notification);
          vm.changeNotificationMode = true;
        };

        vm.changeNotification = function () {
          vm.loading = true;
          UserService.updateNotification(
            vm.notification,
            function (user) {
              $rootScope.User.notification = user.notification;
              vm.changeNotificationMode = false;
              vm.loading = false;
            },
            function (error) {
              NotificationService.error('Data access error', error);
              vm.loading = false;
            }
          );
        };

        vm.showEmailForm = function () {
          vm.newEmail = null;
          vm.changeEmailMode = true;
          vm.errorEmail = '';
        };

        vm.isValidEmailForm = function () {
          return !!vm.newEmail && vm.newEmail !== vm.user.email;
        };

        vm.changeEmail = function () {
          vm.loading = true;
          UserService.changeEmail(
            vm.newEmail,
            function (user) {
              vm.emailChanged = true;
              vm.changeEmailMode = false;
              vm.loading = false;
            },
            function (error) {
              vm.errorEmail = error.data.error.message;
              NotificationService.error('Data access error', error);
              vm.loading = false;
            }
          );
        };

        vm.cancelNotificationForm = function () {
          vm.changeNotificationMode = false;
        };

        vm.cancelEmailForm = function () {
          vm.changeEmailMode = false;
        };

        vm.isPasswordValid = function () {
          return vm.credentials.newPassword.match(vm.passwordRegex);
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'User.Layout.Controller',
      function (
        $scope,
        $rootScope,
        $state,
        UserService,
        NotificationService,
        config,
        $sce,
        LoopBackAuth,
        $window,
        WineUser,
        $cookies,
        DeviceDetectService
      ) {
        var vm = this;

        $rootScope.isTouch = DeviceDetectService.isTouch();

        vm.FOOTER_PATH = 'app/components/layout/partials/footer.' +
          $rootScope.portalText.hostName +
          '.partial.html';

        vm.isSearchActive = false;
        vm.isLeftActive = false;
        vm.isLeftExpanded = false;
        vm.isRightActive = false;

        $rootScope.$watch('User', function () {
          if ($rootScope.User) {
            $rootScope.User.$promise.then(function () {
              vm.User = $rootScope.User;
              if ((vm.User.surveyAdmin || vm.User.isAdmin) &&
                (!vm.User.is2FAEnable)) {
                $state.go('user.settings', { mfa: true });
              }

              vm.adminLogoutUrl = $sce.trustAsResourceUrl(
                config.appBaseUrl + '/auth/logout'
              );

              vm.userLogoutUrl = $sce.trustAsResourceUrl(
                config.appBaseUrl + '/#/mye-assist'
              );
            });
          }
        });

        vm.adminLogout = function () {
          UserService.logout().finally(function () {
            $window.location.href = vm.adminLogoutUrl;
          });
        };

        vm.userLogout = function () {
          UserService.logout().finally(function () {
            $window.location.href = vm.userLogoutUrl;
          });
        };

        $scope.$on('changeNavRight', function (event, state) {
          vm.isRightActive = state;
        });

        vm.toggleSearch = function () {
          vm.isSearchActive = !vm.isSearchActive;
        };

        vm.toggleNavLeft = function () {
          vm.isLeftActive = !vm.isLeftActive;
        };

        vm.toggleExpandLeft = function () {
          vm.isLeftExpanded = !vm.isLeftExpanded;
        };

        vm.toggleNavRight = function () {
          vm.isRightActive = !vm.isRightActive;
          $scope.$broadcast('changeNavRight', vm.isRightActive);
        };

        vm.resetOverlays = function () {
          vm.isLeftActive = false;
          vm.isRightActive = false;
          $scope.$broadcast('changeNavRight', vm.isRightActive);
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'Guest.Layout.Controller',
      function ($rootScope, DeviceDetectService) {
        var vm = this;
        vm.isNavCollapsed = true;

        vm.FOOTER_ASSIST_PATH = 'app/components/layout/partials/footer-landing.' +
          $rootScope.portalText.hostName +
          '.partial.html';

        vm.FOOTER_PATH = 'app/components/layout/partials/footer.' +
          $rootScope.portalText.hostName +
          '.partial.html';

        vm.HEADER_PATH = 'app/components/layout/partials/header.' +
          $rootScope.portalText.hostName +
          '.partial.html';

        $rootScope.openMobileMenu = false;

        $rootScope.toggleMenu = function () {
          $rootScope.openMobileMenu = !$rootScope.openMobileMenu;
        };


        $rootScope.isTouch = DeviceDetectService.isTouch();
      }
    );
})();

(function () {
  'use strict';

  angular.module('assistApp').controller(
    'UserExists.Controller',
    function (
      UserService,
      NotificationService,
      $rootScope,
      $window,
      $sce,
      $state,
      $stateParams,
      config
    ) {
      var vm = this;

      $rootScope.$watch('User', function () {
        if ($rootScope.User) {
          $rootScope.User.$promise.then(function () {
            vm.User = $rootScope.User;

            vm.logoutUrl = $sce.trustAsResourceUrl(
              config.appBaseUrl + '/logout'
            );

            vm.logout = function () {
              UserService.logout().finally(function() {
                var logoutUrl = $sce.trustAsResourceUrl(
                  config.appBaseUrl + '/auth/logout'
                );
                $window.location.href = logoutUrl;
              });
            };

            vm.accept = function () {
              if($stateParams.returnTo) {
                $state.go($stateParams.returnTo, $stateParams.params);
              }else{
                $state.go('user.report');
              }
            };
          });
        }
      });
    }
  );
})();

(function () {
  'use strict';

  angular.module('assistApp').controller(
    'Policy.Controller',
    function (
      UserService,
      NotificationService,
      $rootScope,
      $window,
      $sce,
      $state,
      $stateParams,
      config
    ) {
      var vm = this;

      $rootScope.$watch('User', function () {
        if ($rootScope.User) {
          $rootScope.User.$promise.then(function () {
            vm.User = $rootScope.User;

            vm.logoutUrl = $sce.trustAsResourceUrl(
              config.appBaseUrl + '/logout'
            );

            vm.logout = function () {
              UserService.deleteAccount(
                function () {
                },
                function (error) {
                  NotificationService.error('Data access error');
                }
              );
            };

            vm.accept = function () {
              vm.loading = true;
              UserService.verifyPolicy(vm.User.id).then(
                function (user) {
                  $rootScope.User = user;

                  if ($stateParams.returnTo) {
                    $state.go($stateParams.returnTo, $stateParams.params);
                  } else {
                    $state.go('user.report');
                  }
                },
                function (error) {
                  NotificationService.error('Data access error', error);
                  vm.loading = false;
                }
              );
            };
          });
        }
      });
    }
  );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'Login.Controller',
      function (
        $state,
        $rootScope,
        $stateParams,
        UserService,
        NotificationService,
        AuthService,
        WineUser,
        config,
        $sce
      ) {
        var vm = this;

        vm.landingUrls = {
          my: 'https://about.opentute.com/',
          assist: 'https://assistportal.com.au',
          wine: 'https://assistApp.com.au',
          demo: 'https://lms.opentute.com/',
          rwtc: 'http://robynwilson.com.au',
          myeassist: 'https://myeassist.assistplus.com.au/'
        };

        vm.user = {
          email: '',
          password: ''
        };
        vm.params = {
          rememberMe: true
        };

        vm.error = '';
        if ($stateParams.error) {
          vm.error = 'Incorrect email or password.';
        }

        vm.returnTo = $stateParams.returnTo;
        vm.returnToParams = $stateParams.params;

        vm.loginUrl = $sce.trustAsResourceUrl(
          config.appBaseUrl + '/auth/login' +
          "?returnTo=" + (vm.returnTo || "") +
          "&params=" + (vm.returnToParams || "")
        );

        vm.hasError = function (form) {
          return vm.error || (form && !form.$valid && form.$submitted);
        };

        vm.isDisabled = function (form) {
          return (form && !form.$valid && form.$submitted) || vm.loading;
        };

        vm.resendConfirmationEmail = function () {
          vm.resendingConfirmationEmail = true;
          UserService.sendConfirmationEmail(vm.resendTo)
            .then(function () {
              vm.confirmationEmailResent = true;
            })
            .finally(function () {
              vm.resendingConfirmationEmail = false;
            });
        };

        vm.loginFormSubmit = function (e) {
          e.preventDefault();
          e.returnValue = false;
          var formLogin = $('#formLogin');

          vm.errors = {};
          vm.resendingConfirmationEmail = false;
          vm.confirmationEmailResent = false;
          vm.resendingInvitationEmail = false;
          vm.invitationEmailResent = false;

          vm.loading = true;
          UserService.checkEmail($('#email').val())
            .then(onEmailCheckSuccess)
            .catch(onEmailCheckError)
            .finally(function () {
              vm.loading = false;
            });

          function onEmailCheckSuccess(emailDetails) {
            vm.emailDetails = emailDetails;

            if (!vm.emailDetails.isAvailable && !vm.emailDetails.isVerified) {
              vm.resendTo = $('#email').val();
              vm.emailNotVerified = true;
              vm.resendingConfirmationEmail = false;
              vm.confirmationEmailResent = false;
            } else {
              formLogin.submit();
            }
          }

          function onEmailCheckError(res) {
            console.log('Email check failed', res);
          }
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'Confirm.Registration.Controller',
      function (
        $cookies,
        $state,
        $stateParams,
        LoopBackAuth,
        UserService,
        NotificationService,
        AuthService,
        passwordRegex,
        $translate
      ) {
        var vm = this;

        vm.landingUrls = {
          my: 'https://about.opentute.com/',
          assist: 'https://assistportal.com.au',
          wine: 'https://assistApp.com.au',
          demo: 'https://lms.opentute.com/',
          rwtc: 'http://robynwilson.com.au',
          myeassist: 'https://myeassist.opentute.com/'
        };

        vm.birthDay = '';
        vm.birthMonth = '';
        vm.birthYear = '';
        vm.user = {
          password: '',
          token: $stateParams.token,
          marketingEmails: false,
          is18Plus: false
        };
        vm.passwordConfirmation = '';
        vm.errors = {};
        vm.loading = false;
        vm.social = {};
        vm.passwordRegex = passwordRegex;
        $translate('CONST.PASS_ERROR_MSG').then(function (res) {
          vm.passwordErrorMessage = res;
        });
        vm.isDateOfBirthValid = true;
        vm.isDatepickerPopupOpen = false;

        vm.passwordRegexes = [
          /[a-zA-Z0-9]{6,}/,
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !@#$%^&*(),.?':{}|<>]).{12,}$/
        ];
        vm.passwordStrengths = [
          'moderate',
          'strong'
        ];
        vm.passwordStrength = 'strength';

        UserService.getByConfirmationToken(vm.user.token).then(function (user) {
          if (user) {
            vm.isUserExist = false;
          } else {
            vm.isUserExist = true;
          }
        }).catch(function (error) {
          vm.isUserExist = true;
        });

        vm.checkPassword = function (passwordInput) {
          var passwordChecks = vm.passwordRegexes.map(function (regex) {
            return regex.test(vm.user.passwordData);
          });

          vm.passwordStrength = 'weak';
          passwordInput.$setValidity('strength', false);

          angular.forEach(passwordChecks, function (passwordCheck, index) {
            if (passwordCheck) {
              vm.passwordStrength = vm.passwordStrengths[index];
              passwordInput.$setValidity('strength', true);
            }
          });

          if (!vm.user.password) { vm.passwordStrength = 'strength'; }
          vm.user.password = vm.user.passwordData;
        };

        AuthService.setSocialLinks(vm.social);

        function afterConfirm(data) {
          var user = data.user;
          var token = data.token;

          vm.loading = false;

          $cookies.put('access_token', token.id);
          $cookies.put('userId', user.id);

          LoopBackAuth.setUser(token.id, user.id, null);
          LoopBackAuth.rememberMe = true;
          LoopBackAuth.save();


          $state.go('guest.login-success', {
            userId: user.id,
            accessToken: token.id
          });
        }

        function afterConfirmError(error) {
          NotificationService.error('Data access error', error);
          vm.loading = false;
        }

        vm.signup = function (e) {
          vm.loading = true;
          vm.errors = {};
          if (vm.birthDay && vm.birthMonth && vm.birthYear) {
            vm.user.dateOfBirth = vm.birthMonth + '/' + vm.birthDay + '/' + vm.birthYear;
          }
          vm.user.marketingEmails = vm.marketingEmails;
          vm.user.is18Plus = vm.params.dateOfBirthTick;
          vm.checkDateOfBirth();
          if (vm.isDateOfBirthValid) {
            UserService.confirmRegistration(vm.user)
              .then(afterConfirm)
              .catch(afterConfirmError);
          } else {
            vm.loading = false;
          }
        };



        vm.isDisabled = function (form) {
          return (form && !form.$valid && form.$submitted) ||
            form.userAgreement.$error.required || form.emailNotifications.$error.required || form.dateOfBirthTick.$error.required ||
            vm.loading;
        };

        vm.checkDateOfBirth = function () {
          var day = vm.birthDay;
          var month = vm.birthMonth;
          var year = vm.birthYear;
          var d = new Date();
          var currentDate = moment(d);
          var dateOfBirth = moment(day + '/' + month + '/' + year, 'DD/MM/YYYY');
          var diff = currentDate.diff(dateOfBirth, 'years', true);
          if (!day && !month && !year) {
            vm.isDateOfBirthValid = true;
          } else if (diff < 100 && diff > 16) {
            vm.isDateOfBirthValid = true;
          } else {
            vm.isDateOfBirthValid = false;
          }
        };
      }
    );
})();

(function () {
  'use strict';

  angular.module('assistApp').controller(
    '2FA.Controller',
    function (
      WineUser,
      NotificationService,
      $rootScope,
      $window,
      $sce,
      $state,
      $stateParams,
      config
    ) {
      var vm = this;

      $rootScope.$watch('User', function () {
        if ($rootScope.User) {
          $rootScope.User.$promise.then(function () {
            vm.User = $rootScope.User;
            vm.validateOtp = function (token) {
              WineUser.validateOTP({
                id: vm.User.id,
                token: token
              }).$promise.then(function (res) {
                localStorage.removeItem('is2FARequired');
                if ($stateParams.returnTo) {
                  $state.go($stateParams.returnTo, $stateParams.params);
                } else {
                  $state.go('user.report');
                }
              }, handleValidateError);

            };


            function handleValidateError(err) {
              var error = err.data.error;
              vm.loggingIn = false;
              vm.error = error;
              if (error.code === 'LOGIN_FAILED_InActive') {
                vm.inActiveError = true;
                return;
              }
              if (error.code === 'LOGIN_FAILED_EMAIL_NOT_VERIFIED') {
                vm.emailVerifyError = true;
                return;
              }
              vm.badcredentials = (err.status === 401);
            }

            vm.clearError = function onClearError() {
              vm.badcredentials = null;
              vm.error = null;
              vm.emailVerifyError = null;
              vm.inActiveError = null;
            };

          });
        }
      });
    }
  );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'eAssistSA.Controller',
      function (
        $q,
        $state,
        $window,
        config,
        EAssistSAService,
        $scope
      ) {
        var vm = this;

        vm.currentTestIndex = 0;
        vm.readyPercentage = 0;
        vm.videoView = false;
        vm.isFeedback = false;
        vm.isBriefOpen = false;
        vm.isModerateOpen = false;
        vm.isReferralOpen = false;
        vm.results = EAssistSAService.results;
        vm.comparison = EAssistSAService.comparison;
        vm.language = EAssistSAService.language;
        vm.currentTest = EAssistSAService.firstTest;
        vm.secondTest = EAssistSAService.secondTest;
        vm.tests = angular.copy(EAssistSAService.tests);
        vm.hospitalCodes = EAssistSAService.hospitalCodes;
        vm.facilityCodes = EAssistSAService.facilityCodes;
        vm.feedback = [];
        vm.isError = false;
        vm.phone = '';
        vm.phoneError = false;
        vm.codeError = false;
        vm.loading = false;
        vm.trialCode = EAssistSAService.trialCode;
        vm.isSendingEmail = false;
        vm.isEmailSent = false;
        vm.appBaseUrl = config.appBaseUrl;

        function updatePercentage() {
          vm.readyPercentage =
            Math.ceil(vm.currentTestIndex / vm.tests.length * 100);
        }

        function setAdvice() {
          var currentTest = vm.tests[vm.currentTestIndex];
          if (!currentTest.isTest) return;

          var score = vm.getTestScore(currentTest);

          currentTest.advice = '';

          if (score >= currentTest.feedbackParams.briefAdvice) {
            currentTest.advice = 'briefAdvice';
          }

          if (score >= currentTest.feedbackParams.referralAdvice) {
            currentTest.advice = 'referralAdvice';
          }
        }


        vm.isTest = function () {
          return !vm.videoView && !vm.isError && !vm.isFeedback;
        };

        vm.changeTestState = function (test, question) {
          test.testQuestions.forEach(function (questionOfTest, index) {
            if (index === 0) return;
            questionOfTest.isDisabled = question.value === 'No';
            questionOfTest.value = question.value === 'No' ? '' : test.value;
          });
        };



        vm.finish = function () {
          $state.reload();
          $window.scrollTo(0, 0);
        };



        vm.backToTest = function () {
          vm.isFeedback = false;
          vm.currentTestIndex = Object.keys(vm.tests.length);
          vm.previousTest();
        };

        vm.isRequiredNext = function (formValid) {
          if (
            vm.tests[vm.currentTestIndex].isTest &&
            (vm.tests[vm.currentTestIndex].testQuestions[0].value == 'No')
          ) {
            return false;
          }
          else {
            return formValid;
          }
        };

        vm.introParams = {
          clientId: '',
          isTrial: false
        };

        function onSuccessSendId(data) {
          vm.loading = false;

          vm.errors = {};
          if (data.errorMessage == 'ID_EXISTS') {
            vm.errors.clientId = 'Someone already has that Participant code. Try another?';
            return;
          }

          if (data.errorMessage == 'ID_NOT_FOUND') {
            vm.errors.clientId = 'Participant code is not found.';
            return;
          }

          if (data.success) {
            var intro = data.success.data.tests.intro;
            var currentIntro = vm.tests.intro;
            currentIntro.form = intro.form;
          }

          vm.nextTest();
        }

        function onErrorSendId(error) {
          vm.loading = false;
        }

        vm.sendID = function () {
          vm.loading = true;
          vm.errors = {};

          EAssistSAService.saveID(
            { clientId: vm.currentTest.form.clientId, isTrial: vm.currentTest.form.isTrial },
            onSuccessSendId,
            onErrorSendId
          );
        };

        vm.nextTest = function () {

          if (vm.currentTestIndex < Object.keys(vm.tests).length - 1) {
            vm.currentTestIndex++;
            updatePercentage();
          } else {
            // vm.isFeedback = true;
            // vm.feedback = EAssistSAService.getFeedback(vm.tests);
          }
          vm.next();

          $scope.surveyForm.$setPristine();
          $window.scrollTo(0, 0);
        };

        vm.previousTest = function () {
          if (vm.currentTestIndex > 0) {
            vm.currentTestIndex--;
            updatePercentage();
          }
        };

        vm.next = function (form) {

          vm.loading = true;
          if (vm.currentTestIndex == 0) {
            vm.sendID();
          } else {
            vm.currentTest.next(vm.currentTest.form, function (nextTest) {
              if (vm.currentTestIndex < Object.keys(vm.tests).length - 1) {
                vm.currentTestIndex++;
              }
              vm.currentTest = nextTest;
              vm.readyPercentage = nextTest.readyPercentage;
              vm.questions = nextTest.questions;
              vm.loading = false;
              $scope.surveyForm.$setPristine();
              $window.scrollTo(0, 0);
            });
          }
        };

        vm.prev = function () {
          vm.loading = true;
          vm.currentTest.prev(function (prevTest) {
            vm.currentTest = prevTest;
            vm.readyPercentage = prevTest.readyPercentage;
            vm.questions = prevTest.questions;
            vm.loading = false;
            vm.previousTest();
          });
        };


        vm.validateHospitalCodeReport = function (form) {
          var intro = _.find(vm.tests, { name: "Introduction" });

          var code = form.hospitalCodeReport.$modelValue;
          var validCode = intro.testQuestions.hospitalCode.value;

          form.hospitalCodeReport.$setValidity('hospitalError', code === validCode);
          form.hospitalCodeReport.$error.hospitalError = code !== validCode;
        };

        vm.downloadParticipantReportCSV = function () {
          var id = EAssistSAService.savedSurvey.id;

          var url =
            config.appBaseUrl
            + '/api/AssistSurveySAs/downloadParticipantReportCSV?id='
            + id;

          $window.open(url, "_blank");
        };

        vm.emailParticipantReport = function (email) {
          var id = EAssistSAService.savedSurvey.id;
          vm.results.otherText = vm.secondTest.form.otherText ? vm.secondTest.form.otherText : '';
          vm.isSendingEmail = true;
          EAssistSAService.emailParticipantReport(email, id, vm.results)
            .then(function () {
              vm.isEmailSent = true;
            })
            .finally(function () {
              vm.isSendingEmail = false;
            });
        };

        vm.dropdownSelected = function (form) {
          return form && form.hospital && !form.hospital.$error.required && form.department && !form.department.$error.required;
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'eAssistLite.Controller',
      function (
        $state,
        $window,
        config,
        fileDownloadService,
        EAssistLiteService
      ) {
        var vm = this;

        vm.currentTestIndex = 0;
        vm.readyPercentage = 0;
        vm.videoView = false;
        vm.isFeedback = false;
        vm.isBriefOpen = false;
        vm.isModerateOpen = false;
        vm.isReferralOpen = false;
        vm.tests = angular.copy(EAssistLiteService.tests);
        vm.feedback = [];
        vm.isError = false;
        vm.codeError = false;
        vm.loading = false;
        vm.recaptchaWidgetId = null;
        vm.savedSurvey = null;
        vm.isSendingEmail = false;
        vm.isEmailSent = false;
        vm.appBaseUrl = config.appBaseUrl;
        vm.otherText = EAssistLiteService.otherText;

        vm.surveyName = 'eassist-lite';

        function updatePercentage() {
          vm.readyPercentage =
            Math.ceil(vm.currentTestIndex / vm.tests.length * 100);
        }

        function setAdvice() {
          var currentTest = vm.tests[vm.currentTestIndex];
          if (!currentTest.isTest) return;

          var score = vm.getTestScore(currentTest);
          currentTest.advice = '';
          if (currentTest.name == 'Other') {
            var otherText = questionOtherValue(currentTest);
            if (otherText) {
              currentTest.otherText = otherText.value;
              EAssistLiteService.otherText = currentTest.otherText;
              if (score > currentTest.feedbackParams.briefAdvice) {
                currentTest.advice = 'briefAdvice';
              }

              if (score >= currentTest.feedbackParams.moderateAdvice) {
                currentTest.advice = 'moderateAdvice';
              }

              if (score >= currentTest.feedbackParams.referralAdvice) {
                currentTest.advice = 'referralAdvice';
              }
            }
          } else if (currentTest.name == 'Alcohol') {
            if (score && score <= currentTest.feedbackParams.briefAdvice) {
              currentTest.advice = 'briefAdvice';
            }

            if (score == currentTest.feedbackParams.moderateAdvice) {
              currentTest.advice = 'moderateAdvice';
            }

            if (score >= currentTest.feedbackParams.referralAdvice) {
              currentTest.advice = 'referralAdvice';
            }
          } else {
            if (score > currentTest.feedbackParams.briefAdvice) {
              currentTest.advice = 'briefAdvice';
            }

            if (score >= currentTest.feedbackParams.moderateAdvice) {
              currentTest.advice = 'moderateAdvice';
            }

            if (score >= currentTest.feedbackParams.referralAdvice) {
              currentTest.advice = 'referralAdvice';
            }
          }
        }

        vm.isTest = function () {
          return !vm.videoView && !vm.isError && !vm.isFeedback;
        };


        function questionOtherValue(test) {
          return test.testQuestions.find(function (question) {
            return question.doNotCount && !question.toggleOtherQuestions && question.value;
          });
        }

        vm.changeGenderTestState = function (test, question) {
          if (question.gender) {
            question.otherGender = '';
          }
        };

        vm.changeTestState = function (test, question) {

          test.testQuestions.forEach(function (questionOfTest, index) {
            if (index === 0) return;
            questionOfTest.isDisabled = question.value === 'No';
            questionOfTest.value = question.value === 'No' ? '' : test.value;
          });
        };

        vm.backToFeedback = function () {
          vm.isFeedback = true;
          vm.videoView = false;
          vm.currentTestIndex = vm.tests.length;
        };

        vm.saveAnswers = function () {
          EAssistLiteService.save(vm.tests)
            .then(function (survey) {
              var criteria = survey.result;
              vm.savedSurvey = survey;
              vm.savedSurvey.criteria = criteria;
              vm.savedSurvey.criteria.otherText = survey.data.otherText;
              vm.isFeedback = false;
              vm.videoView = true;

              // vm.tests = angular.copy(EAssistLiteService.tests);
            })
            .catch(function (err) {
              vm.videoView = false;
              vm.isError = true;
            });
        };

        vm.getTestScore = function (test) {
          return test.testQuestions.filter(function (question) {
            return !question.doNotCount && question.value === 'Yes';
          }).length;
        };

        vm.finish = function () {
          $state.reload();
        };

        vm.nextTest = function (form) {
          setAdvice();

          if (vm.currentTestIndex < vm.tests.length - 1) {
            vm.currentTestIndex++;
            updatePercentage();
          } else {
            vm.isFeedback = true;
            vm.feedback = EAssistLiteService.getFeedback(vm.tests);
          }

          form.$setPristine();
          $window.scrollTo(0, 0);
        };

        vm.previousTest = function (form) {
          if (vm.currentTestIndex > 0) {
            vm.currentTestIndex--;
            updatePercentage();
          }
        };

        vm.backToTest = function () {
          vm.isFeedback = false;
          vm.currentTestIndex = vm.tests.length;
          vm.previousTest();
        };

        vm.isRequiredNext = function (formValid) {
          if (
            vm.tests[vm.currentTestIndex].isTest &&
            (vm.tests[vm.currentTestIndex].testQuestions[0].value == 'No')
          ) {
            return false;
          }
          else {
            return formValid;
          }
        };

        vm.downloadParticipantReportCSV = function () {
          var id = vm.savedSurvey.id;

          var url =
            config.appBaseUrl
            + '/api/EAssistLiteSurveys/downloadParticipantReportCSV?id='
            + id;

          $window.open(url, "_blank");
        };

        vm.emailParticipantReport = function (email) {
          var id = vm.savedSurvey.id;

          var results = {
            criteria: vm.savedSurvey.criteria,
            feedback: vm.feedback
          };

          vm.isSendingEmail = true;
          EAssistLiteService.emailParticipantReport(email, id, results)
            .then(function () {
              vm.isEmailSent = true;
            })
            .finally(function () {
              vm.isSendingEmail = false;
            });
        };

        vm.reportType = 'pdf';
        vm.setReport = function (reportType) {
          vm.reportType = reportType;
        }

        vm.downloadFeedbackPdf = function () {
          var results = {
            feedback: vm.feedback
          };
          vm.downloadingFeedbackPdf = true;
          fileDownloadService.fileDownloadWithPost('/api/EAssistLiteSurveys/downloadFeedbackPdf',
            { results: results },
            'application/pdf', 'feedback.pdf').then(function (response) {
            }, function (error) {
            }).finally(function () {
              vm.downloadingFeedbackPdf = false;
            });
        };
        vm.downloadingReportFileName = 'report_' + Date.now();

        vm.downloadReportPdf = function (downloadingReportFileName) {
          if (vm.reportType === 'csv') {
            return vm.downloadParticipantReportCSV();
          }
          var results = {
            feedback: vm.feedback
          };
          if (downloadingReportFileName) {
            vm.downloadingReportPdf = true;
            fileDownloadService.fileDownloadWithPost('/api/EAssistLiteSurveys/downloadParticipantReportPdf',
              { id: vm.savedSurvey.id, results: results },
              'application/pdf', downloadingReportFileName + '.pdf').then(function (response) {
              }, function (error) {
              }).finally(function () {
                vm.downloadingReportPdf = false;
              });
          }
        };

      });
})();

(function () {
  'use strict';

  angular.module('assistApp').controller(
    'EAssist.Controller',
    function (
      $scope,
      $window,
      config,
      portalText,
      fileDownloadService,
      EAssistService,
      AssistLiteService
    ) {
      var vm = this;

      vm.language = EAssistService.language;
      vm.currentTest = EAssistService.firstTest;
      vm.secondTest = EAssistService.secondTest;
      vm.tests = EAssistService.tests;
      vm.results = EAssistService.results;
      vm.hospitalCodes = AssistLiteService.hospitalCodes;
      vm.questions = vm.currentTest.questions;
      vm.isBriefOpen = false;
      vm.isReferralOpen = false;
      vm.recaptchaWidgetId = null;
      vm.isSendingEmail = false;
      vm.isEmailSent = false;

      vm.surveyName = 'eassist';

      vm.readyPercentage = 0;
      vm.appBaseUrl = config.appBaseUrl;
      vm.introParams = {
        gRecaptchaResponse: false
      };
      $scope.downloadingReportFileName = 'report_' + Date.now();
      vm.apiBaseModel = '/api/EAssistSurveys/';
      if (portalText.hostName == 'assist-knowyouroptions' || portalText.hostName == 'myeassist-knowyouroptions') {
        vm.apiBaseModel = '/api/EAssistSurveyKnowYourOptions/';
      }
      vm.isNextDisabled = function () {
        if (vm.currentTest.nextEnabled) {
          return false;
        }
        return vm.currentTest.isNextDisabled(vm.currentTest.form, $scope.surveyForm);
      };

      vm.dropdownSelected = function (form) {
        return !form.hospital.$error.required && !form.department.$error.required;
      };

      vm.changeGenderTestState = function (form) {
        if (form.otherGender) {
          form.otherGender = '';
        }
      };

      vm.next = function (form) {
        vm.loading = true;
        vm.currentTest.next(vm.currentTest.form, function (nextTest) {
          vm.currentTest = nextTest;
          vm.readyPercentage = nextTest.readyPercentage;
          vm.questions = nextTest.questions;
          vm.loading = false;
          $window.scrollTo(0, 0);
          if (form)
            form.$setPristine();
          if (vm.currentTest.name === 'question5') {
            vm.questions = _.filter(nextTest.questions, function (question) { return question !== 'tobacco' });
            if (!vm.questions.length) {
              vm.next(vm.currentTest.form);
            }
          }
        });
      };

      vm.prev = function () {
        vm.loading = true;
        vm.currentTest.prev(function (prevTest) {
          vm.currentTest = prevTest;
          vm.readyPercentage = prevTest.readyPercentage;
          vm.questions = prevTest.questions;
          vm.loading = false;
          if (vm.currentTest.name === 'question5') {
            vm.questions = _.filter(prevTest.questions, function (question) { return question !== 'tobacco' });
            if (!vm.questions.length) {
              vm.prev();
            }
          }
        });
      };

      vm.backToFeedback = function () {
        var nextTest = EAssistService.tests.feedback;
        vm.currentTest = nextTest;
        vm.readyPercentage = nextTest.readyPercentage;
        vm.questions = nextTest.questions;
        vm.loading = false;
        $window.scrollTo(0, 0);
        vm.isEmailSent = false;
      };

      vm.downloadParticipantReportCSV = function () {
        var id = EAssistService.savedSurvey.id;

        var url =
          config.appBaseUrl
          + vm.apiBaseModel + 'downloadParticipantReportCSV?id='
          + id;

        $window.open(url, "_blank");
      };

      vm.reportType = 'pdf';

      vm.setReport = function (reportType) {
        vm.reportType = reportType;
      }

      vm.downloadFeedbackPdf = function () {
        vm.downloadingFeedbackPdf = true;
        fileDownloadService.fileDownloadWithPost(vm.apiBaseModel + 'downloadFeedbackPdf',
          { results: vm.results },
          'application/pdf', 'feedback.pdf').then(function (response) {
          }, function (error) {
          }).finally(function () {
            vm.downloadingFeedbackPdf = false;
          });
      };


      vm.downloadReportPdf = function (downloadingReportFileName) {
        if (vm.reportType === 'csv') {
          return vm.downloadParticipantReportCSV();
        }
        if (downloadingReportFileName) {
          vm.downloadingReportPdf = true;
          fileDownloadService.fileDownloadWithPost(vm.apiBaseModel + 'downloadParticipantReportPdf',
            { id: EAssistService.savedSurvey.id, results: vm.results },
            'application/pdf', downloadingReportFileName + '.pdf').then(function (response) {
            }, function (error) {
            }).finally(function () {
              vm.downloadingReportPdf = false;
            });
        }
      };

      vm.emailParticipantReport = function (email) {
        var id = EAssistService.savedSurvey.id;
        vm.results.otherText = vm.secondTest.form.otherText ? vm.secondTest.form.otherText : ''
        vm.isSendingEmail = true;
        EAssistService.emailParticipantReport(email, id, vm.results)
          .then(function () {
            vm.isEmailSent = true;
          })
          .finally(function () {
            vm.isSendingEmail = false;
          });
      };


      vm.validateAge = function (age) {
        if (!age) {
          return;
        }
        if (Number(age) < 0 || Number(age) > 150) {
          if (!vm.currentTest.form) {
            vm.currentTest.form = {};
          }
          vm.currentTest.form.age = vm.oldAgeValue || 0;
        } else {
          vm.oldAgeValue = age;
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'HelpContent.Controller',
      function (
        $scope,
        $rootScope,
        NotificationService,
        PortalSettingsService
      ) {
        var vm = this;

        vm.loading = false;
        vm.componentLoaded = false;
        vm.userLoaded = false;
        vm.isOpened = false;
        vm.editMode = false;
        vm.settings.helpContent = vm.settings.helpContent || {};
        vm.isContent = !!vm.settings.helpContent[vm.name] || !_.isEmpty(vm.settings.helpContent[vm.name]);
        vm.defaultContentTemplate = 'app/directives/help-content/partials/' + vm.name + '.html';

        $rootScope.User.$promise.then(function (User) {
          vm.isAdmin = User.isAdmin;
          vm.userLoaded = true;
        });

        vm.init = function() {
          if (vm.isContent) {
            vm.content = vm.settings.helpContent[vm.name];
          } else {
            setDefaults();
          }
          vm.componentLoaded = true;
        };

        function setDefaults() {
          vm.settings.helpContent[vm.name] = {};
          vm.content = vm.settings.helpContent[vm.name];
          vm.content.title = $('[help-content-default-title=' + vm.name +']').first().text().trim();
          vm.content.text = $('[help-content-default-text=' + vm.name +']').first().text().trim();
        }

        vm.toggleContent = function () {
          vm.isOpened = !vm.isOpened;
        };

        vm.edit = function () {
          vm.editMode = true;
          // set default
          vm.contentCopy = angular.copy(vm.content);
        };

        vm.cancelEdit = function (e) {
          vm.content = vm.contentCopy;
          vm.editMode = false;
        };

        vm.isDisabled = function(form) {
          return (!form.$valid && form.$submitted) || vm.loading;
        };

        vm.save = function () {
          vm.loading = true;

          updateHelpContent();
        };

        function updateHelpContent() {
          vm.loading = true;
          return PortalSettingsService.updateHelpContent(vm.settings, vm.name)
            .then(function (settings) {
              vm.loading = false;
              vm.settings = settings;
              vm.editMode = false;
              return settings;
            }, function (error) {
              NotificationService.error('Data access error', error);
              vm.loading = false;
            });
        }
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .component('helpContent', {
      templateUrl: 'app/directives/help-content/help-content.template.html',
      bindings: {
        settings: '=settings',
        name: '@name'
      },
      controller: 'HelpContent.Controller',
      controllerAs: 'vm'
    });
})();
angular.module("portalText", [])

.constant("portalText", {
	"subtitlePortal": "Alcohol, Smoking, Substance<br>Involvement Screening Test",
	"hostName": "assist",
	"favicon": "assist_portal.ico",
	"portalDescription": "Welcome to eLearning on the ASSIST Portal. We are dedicated to accessible, on-demand learning for professionals in managing addiction, anywhere, any time.",
	"lite": "ASSIST Lite",
	"eLite": "eASSIST",
	"eAssist": {
		"English": {
			"questionTitle": {
				"tobacco": "Tobacco products (cigarettes, chewing tobacco, cigars, etc.)",
				"alcoholic": "Alcoholic beverages (beer, wine, spirits, etc.)",
				"cannabis": "Cannabis (marijuana, pot, grass, hash, etc.)",
				"cocaine": "Cocaine (coke, crack, etc.)",
				"amphetamine": "Amphetamine type stimulants (speed, meth, ecstasy, ice etc.)",
				"inhalants": "Inhalants (nitrous, glue, petrol, paint thinner, etc.)",
				"sedatives": "Sedatives or Sleeping Pills (diazepam, alprazolam, flunitrazepam, temazepam etc.)",
				"hallucinogens": "Hallucinogens (LSD, acid, mushrooms, trips, Ketamine, etc.)",
				"opioids": "Opioids (heroin, morphine, methadone, opium, buprenorphine, codeine, etc.)",
				"other": "Other"
			},
			"question1": {
				"title": "1. In your life, which of the following substances have you <u>ever used</u>? (NON-MEDICAL USE ONLY)",
				"answers": [
					{
						"label": "No",
						"value": 0
					},
					{
						"label": "Yes",
						"value": 1
					}
				],
				"questions": [
					"tobacco",
					"alcoholic",
					"cannabis",
					"cocaine",
					"amphetamine",
					"inhalants",
					"sedatives",
					"hallucinogens",
					"opioids",
					"other"
				]
			},
			"question2": {
				"title": "2. In the <u>past three months</u>, how often have you used the substances you mentioned (FIRST DRUG, SECOND DRUG, ETC)?",
				"answers": [
					{
						"label": "Never",
						"value": 0
					},
					{
						"label": "Once or Twice",
						"value": 1
					},
					{
						"label": "Monthly",
						"value": 2
					},
					{
						"label": "Weekly",
						"value": 3
					},
					{
						"label": "Daily or Almost Daily",
						"value": 4
					}
				]
			},
			"question3": {
				"title": "3. During the <u>past three months</u>, how often have you had a strong desire or urge to use (FIRST DRUG, SECOND DRUG, ETC)?",
				"answers": [
					{
						"label": "Never",
						"value": 0
					},
					{
						"label": "Once or Twice",
						"value": 1
					},
					{
						"label": "Monthly",
						"value": 2
					},
					{
						"label": "Weekly",
						"value": 3
					},
					{
						"label": "Daily or Almost Daily",
						"value": 4
					}
				]
			},
			"question4": {
				"title": "4. During the <u>past three months</u>, how often has your use of (FIRST DRUG, SECOND DRUG, ETC) led to health, social, legal or financial problems?",
				"answers": [
					{
						"label": "Never",
						"value": 0
					},
					{
						"label": "Once or Twice",
						"value": 1
					},
					{
						"label": "Monthly",
						"value": 2
					},
					{
						"label": "Weekly",
						"value": 3
					},
					{
						"label": "Daily or Almost Daily",
						"value": 4
					}
				]
			},
			"question5": {
				"title": "5. During the <u>past three months</u>, how often have you failed to do what was normally expected of you because of your use of (FIRST DRUG, SECOND DRUG, ETC)?",
				"answers": [
					{
						"label": "Never",
						"value": 0
					},
					{
						"label": "Once or Twice",
						"value": 1
					},
					{
						"label": "Monthly",
						"value": 2
					},
					{
						"label": "Weekly",
						"value": 3
					},
					{
						"label": "Daily or Almost Daily",
						"value": 4
					}
				]
			},
			"question6": {
				"title": "6. Has a friend or relative or anyone else <u>ever</u> expressed concern about your use of (FIRST DRUG, SECOND DRUG, ETC.)?",
				"answers": [
					{
						"label": "No, never",
						"value": 0
					},
					{
						"label": "Yes, in the past 3 months",
						"value": 1
					},
					{
						"label": "Yes, but not in the past 3 months",
						"value": 2
					}
				]
			},
			"question7": {
				"title": "7. Have you <u>ever</u> tried to cut down on using (FIRST DRUG, SECOND DRUG, ETC.) but failed?",
				"answers": [
					{
						"label": "No, never",
						"value": 0
					},
					{
						"label": "Yes, in the past 3 months",
						"value": 1
					},
					{
						"label": "Yes, but not in the past 3 months",
						"value": 2
					}
				]
			},
			"question8": {
				"title": "8. Have you ever used any drug by injection? (NON-MEDICAL USE ONLY)",
				"answers": [
					{
						"label": "No, never",
						"value": 0
					},
					{
						"label": "Yes, in the past 3 months",
						"value": 1
					},
					{
						"label": "Yes, but not in the past 3 months",
						"value": 2
					}
				]
			}
		}
	}
})

;
(function () {
  'use strict';

  angular.module('assistApp').controller(
    'Report.Controller',
    function (
      ReportService,
      UserService,
      EAssistService,
      AssistLiteService,
      NotificationService,
      $rootScope,
      $scope,
      config,
      $window,
      $uibModal,
      User,
      PortalSettingsService
    ) {
      var vm = this;
      vm.settings = $rootScope.settings;
      vm.isRightActive = false;
      vm.isChart = true;
      vm.isList = false;
      vm.surveys = [];
      vm.graphDates = [];
      vm.graphData = [];
      vm.initGraph = {
        id: 'alcoholic',
        label: 'Alcohol'
      };

      vm.toggleNavRight = function () {
        vm.isRightActive = !vm.isRightActive;
        $scope.$emit('changeNavRight', vm.isRightActive);
      };
      $scope.$on('changeNavRight', function (event, state) {
        vm.isRightActive = state;
      });

      vm.User = User;

      vm.downloadCsvSummaryURL = '';
      vm.downloadCsvIndividualURL = '';
      vm.data = null;

      vm.params = {};
      vm.data = {};
      vm.displayData = {};
      vm.loading = true;
      vm.headers = {};
      vm.filters = {};

      vm.orders = [
        {
          id: 'gender',
          label: 'By gender',
          table: 'statisticTable'
        },
        {
          id: 'age',
          label: 'By age',
          table: 'statisticTable'
        },
        {
          id: 'risk',
          label: 'By risk',
          table: 'weekTable'
        },
        {
          id: 'substances',
          label: 'By substances',
          table: 'substancesTable'
        }
      ];


      vm.orderFilters = [
        { text: 'Male', value: 'male' },
        { text: 'Female', value: 'female' },
        { text: 'X', value: 'x' }, { text: 'T', value: 't' }, { text: 'Z', value: 'z' }
      ];

      vm.orderFilter = vm.orderFilters[0];

      vm.graphs = [
        {
          id: 'alcoholic',
          label: 'Alcohol'
        },
        {
          id: 'amphetamine',
          label: 'Amphetamines'
        },
        {
          id: 'cannabis',
          label: 'Cannabis'
        },
        {
          id: 'cocaine',
          label: 'Cocaine'
        },
        {
          id: 'hallucinogens',
          label: 'Hallucinogens'
        },
        {
          id: 'inhalants',
          label: 'Inhalants'
        },
        {
          id: 'opioids',
          label: 'Opioids'
        },
        {
          id: 'tobacco',
          label: 'Tobacco'
        },
        {
          id: 'sedatives',
          label: 'Sedatives'
        },
        {
          id: 'other',
          label: 'Other'
        }
      ];

      $scope.labels = vm.graphDates;
      $scope.series = ['Score'];
      $scope.graphData = [vm.graphData];
      $scope.colors = ['#005a9c'];

      vm.userReport = [
        {
          id: 'My eASSIST',
          strategy: 'eAssistReport',
          csv: 'EAssistSurveys'
        }
      ];




      function init() {
        vm.filter = vm.orders[0];
        vm.filters.practiceName = vm.anyPractice;
        vm.filters.clinicName = vm.anyClinic;
        vm.filters.location = vm.anyLocation;

        vm.isActiveAssistAboriginalPilot = vm.settings.isActiveAssistAboriginalPilot;

        checkSurveyAdmin();

        setUrlsCSV();
        getReport();
        findSurveys();
      }


      vm.onChangePilotProject = function () {
        PortalSettingsService.updateSettings({
          isActiveAssistAboriginalPilot: vm.isActiveAssistAboriginalPilot
        }).then(function (res) {
          console.log(res);
        }, function (err) {
          vm.isActiveAssistAboriginalPilot = !vm.isActiveAssistAboriginalPilot;
        });
      };

      function checkSurveyAdmin() {
        if (vm.User.isAdmin && vm.User.surveyAdmin) {
          var surveyAdmins = vm.User.surveyAdmin.split(',');
          vm.reports = [];
          _.each(surveyAdmins, function (surveyAdmin) {
            switch (surveyAdmin) {
              case 'eASSIST':
                vm.reports.push(
                  {
                    id: 'eASSIST',
                    strategy: 'eAssistReport',
                    csv: 'EAssistSurveys'
                  }
                );
                break;
              case 'My eASSIST':
                vm.reports.push(
                  {
                    id: 'My eASSIST',
                    strategy: 'eAssistReport',
                    csv: 'EAssistSurveys',
                    type: 'myeassist'
                  }
                );
                break;
              case 'eASSIST Lite':
                vm.reports.push({
                  id: 'eASSIST',
                  strategy: 'eAssistReport',
                  csv: 'EAssistSurveys'
                });
                vm.reports.push({
                  id: 'eASSIST Lite',
                  strategy: 'eAssistLiteReport',
                  csv: 'EAssistLiteSurveys'
                }
                );

                break;
              case 'eASSIST Lite Research Project':
                vm.reports.push(
                  {
                    id: 'eASSIST Lite Research Project',
                    strategy: 'eAssistLiteResearchReport',
                    csv: 'AssistSurveys'
                  }
                );
                break;
              case 'eASSIST SA Research Project':
                vm.reports.push({
                  id: 'eASSIST SA Research Project',
                  strategy: 'eAssistSAReport',
                  csv: 'AssistSurveySAs',
                  genderEnable: true
                }
                );
                break;
              case 'eAssist KnowYourOptions':
                vm.reports.push(
                  {
                    id: 'eAssist KnowYourOptions',
                    strategy: 'eAssistKnowYourOptionReport',
                    csv: 'EAssistSurveyKnowYourOptions'
                  }
                );
                break;
              case 'My eAssist KnowYourOptions':
                vm.reports.push(
                  {
                    id: 'My eAssist KnowYourOptions',
                    strategy: 'eAssistKnowYourOptionReport',
                    csv: 'EAssistSurveyKnowYourOptions',
                    type: 'myeassist-knowyouroptions'
                  }
                );
                break;
              case 'ASSIST App Indigenous Adaptation':
                vm.reports.push(
                  {
                    id: 'ASSIST App Indigenous Adaptation',
                    strategy: 'assistAboriginalsReport',
                    csv: 'AssistAboriginals',
                    type: 'assist-aboriginals'
                  });
                vm.reports.push({
                  id: 'ASSIST App Indigenous Adaptation Feedback',
                  strategy: 'assistAboriginalFeedbackReport',
                  csv: 'AssistAboriginalFeedbacks',
                  type: 'assist-aboriginals-feedback'
                });
                break;
              case 'ASSIST App Indigenous Adaptation Pilot':
                vm.reports.push(
                  {
                    id: 'ASSIST App Indigenous Adaptation Pilot',
                    strategy: 'assistAboriginalPilotsReport',
                    csv: 'AssistAboriginalPilots',
                    type: 'assist-aboriginals-pilot'
                  });
                vm.reports.push({
                  id: 'ASSIST App Indigenous Adaptation Pilot Feedback',
                  strategy: 'assistAboriginalPilotFeedbackReport',
                  csv: 'AssistAboriginalPilotFeedbacks',
                  type: 'assist-aboriginals-pilot-feedback'
                });
                break;
            }
          });
        } else {
          vm.reports = [
            {
              id: 'eASSIST',
              strategy: 'eAssistReport',
              csv: 'EAssistSurveys'
            },
            {
              id: 'eASSIST Lite',
              strategy: 'eAssistLiteReport',
              csv: 'EAssistLiteSurveys'
            },
            {
              id: 'eASSIST Lite Research Project',
              strategy: 'eAssistLiteResearchReport',
              csv: 'AssistSurveys'
            },
            {
              id: 'My eASSIST',
              strategy: 'eAssistReport',
              csv: 'EAssistSurveys',
              type: 'myeassist'
            },
            {
              id: 'eASSIST SA Research Project',
              strategy: 'eAssistSAReport',
              csv: 'AssistSurveySAs'
            },
            {
              id: 'eAssist KnowYourOptions',
              strategy: 'eAssistKnowYourOptionReport',
              csv: 'EAssistSurveyKnowYourOptions'
            },
            {
              id: 'My eAssist KnowYourOptions',
              strategy: 'eAssistKnowYourOptionReport',
              csv: 'EAssistSurveyKnowYourOptions',
              type: 'myeassist-knowyouroptions'
            },
            {
              id: 'ASSIST App Indigenous Adaptation',
              strategy: 'assistAboriginalsReport',
              csv: 'AssistAboriginals',
              type: 'assist-aboriginals'
            },
            {
              id: 'ASSIST App Indigenous Adaptation Feedback',
              strategy: 'assistAboriginalFeedbackReport',
              csv: 'AssistAboriginalFeedbacks',
              type: 'assist-aboriginals-feedback'
            },
            {
              id: 'ASSIST App Indigenous Adaptation Pilot',
              strategy: 'assistAboriginalPilotsReport',
              csv: 'AssistAboriginalPilots',
              type: 'assist-aboriginals'
            },
            {
              id: 'ASSIST App Indigenous Adaptation Pilot Feedback',
              strategy: 'assistAboriginalPilotFeedbackReport',
              csv: 'AssistAboriginalPilotFeedbacks',
              type: 'assist-aboriginals-feedback'
            }
          ];
        }
        vm.report = vm.reports[0];
      }

      vm.dateOptions = {
        maxDate: new Date(),
        minDate: new Date(1970, 1, 1),
        showWeeks: false
      };

      vm.datepickerPopup = {
        beginDate: false,
        endDate: false
      };

      vm.timeZones = [
        'GMT-1', 'GMT-2', 'GMT-3', 'GMT-4', 'GMT-5', 'GMT-6', 'GMT-7', 'GMT-8', 'GMT-9',
        'GMT-10', 'GMT-11', 'GMT+0', 'GMT+1', 'GMT+2', 'GMT+3', 'GMT+4', 'GMT+5', 'GMT+6',
        'GMT+7', 'GMT+8', 'GMT+9', 'GMT+10', 'GMT+11', 'GMT+12'
      ];
      vm.anyPractice = 'Any Practice';
      vm.anyClinic = 'Any Clinic';
      vm.anyLocation = 'Any Location';
      vm.clinics = [vm.anyClinic, 'Royal Adelaide Hospital', 'Flinders Hospital'];
      vm.locations = [vm.anyLocation, 'Clinic1', 'Clinic2'];
      vm.practices = [vm.anyPractice, 'COSUP Mamelodi East', 'COSUP Mamelodi West', 'COSUP Sunnyside', 'COSUP Bosman Street',
        'COSUP TDH', 'COSUP Atttridgeville', 'COSUP Daspoort', 'COSUP Garankuwa', 'COSUP M17',
        'COSUP North Church', 'COSUP Laudium', 'COSUP Oliewen', 'COSUP Eersterust', 'BHS Hospital',
        'TDH Casualty', 'TDH OPD', 'SBAH Casualty', 'Pretoria West Hospital Casualty',
        'Pretoria West Hospital Mental Health', 'Pretoria West OPD', 'Kalafong Casualty',
        'Kalafong Family Medicine Clinic', 'Kalafong Mental Health Ward', 'Mamelodi Hospital Casualty',
        'Mamelodi Hospital OPD', 'SIC Family Medicine', 'SIC District Health',
        'SIC Anaestetics', 'SIC Surgery', 'SIC Internal Medicine', 'SIC Orthopeadics',
        'SIC Neurology', 'SIC O&G', 'LCAS', 'Block 16', 'BCMP Mamelodi',
        'BCMP TDH', 'BCMP Pretoria West Hospital', 'BCMP Kalafong', 'BCMP 1 Military Hospital'];

      vm.sites = [vm.anyPractice, "Flinders Wellbeing Centre",
        "Yadu Aboriginal Health  (instead of Ceduna-Koonibba)",
        "ADAC Ceduna Day Centre",
        "ADAC Port Augusta Day Centre",
        "Umoona Tjutagku Health Service",
        "DASSA Quarantine Facility, Glenside",
        "Other (input)"];


      init();

      vm.openDatepickerPopup = function (name) {
        vm.datepickerPopup[name] = true;
      };

      vm.setGraph = function (graph) {
        vm.graph = graph;
        createGraph(graph.id);
      };

      vm.openInviteModal = function (survey) {
        $uibModal.open({
          templateUrl: 'app/components/invite/invite.html',
          controller: 'Invite.Controller as inviteCtrl',
          size: 'md',
          backdropClass: 'modal-backdrop',
          resolve: {
            survey: function () {
              return survey;
            }
          }
        });

      };

      function createGraph(id) {
        vm.graphDates.length = 0;
        vm.graphData.length = 0;
        vm.surveys.map(function (survey) {
          var graphDate = moment(survey.createdAt).format("MM/DD/YYYY");
          vm.graphDates.push(graphDate);
          vm.graphData.push(survey.result[id]);
        });
      };

      vm.setFilter = function (filter) {
        vm.filter = filter;
        if (filter.id != 'gender') {
          vm.orderFilter = null;
        } else {
          vm.orderFilter = vm.orderFilters[0];
        }
        setUrlsCSV();
        vm.setData();
      };

      vm.setOrderFilter = function (filter) {
        vm.orderFilter = filter;
        vm.setData();
      };

      vm.setData = function () {
        vm.displayData = vm.data[vm.filter.table];

        if (vm.filter.table === 'statisticTable') {
          if (vm.data[vm.filter.table])
            vm.displayData = vm.data[vm.filter.table][vm.filter.id];
          if (vm.orderFilter) {
            var objDisplayData = {};
            objDisplayData[vm.orderFilter.text] = vm.displayData[vm.orderFilter.value];
            vm.displayData = objDisplayData;
          }
        }
      };

      vm.setReport = function (report) {
        // if (report.id !== 'eASSIST Research') {
        //   delete vm.filters.clinicName;
        // }

        vm.report = report;
        if (report.id != 'eASSIST' && report.id != 'eASSIST Lite' && report.id != 'My eASSIST') {
          vm.orderFilter = null;
        } else {
          vm.orderFilter = vm.orderFilters[0];
        }
        vm.getReport();
      };

      vm.resetTable = function () {
        vm.filters = {};
        vm.filters.practiceName = vm.anyPractice;
        vm.filters.clinicName = vm.anyClinic;
        vm.filters.location = vm.anyLocation;
        vm.getReport();
      };

      vm.validateDates = function (form) {
        var beginDate = form.beginDate.$modelValue,
          endDate = form.endDate.$modelValue;

        if (beginDate && endDate && (beginDate > endDate)) {
          form.beginDate.$setValidity('dateError', false);
          form.endDate.$setValidity('dateError', false);

          form.beginDate.$error.dateError = true;
          form.endDate.$error.dateError = true;
        } else {
          form.beginDate.$setValidity('dateError', true);
          form.endDate.$setValidity('dateError', true);

          form.beginDate.$error.dateError = false;
          form.endDate.$error.dateError = false;
        }
      };

      function assistSuccess(data) {
        vm.data = data;
        vm.setFilter(vm.filter);
        vm.loading = false;
      }

      function errorCallback(error) {
        NotificationService.error('Data access error', error);
        vm.loading = false;
      }

      vm.getReport = getReport;

      function getReport() {
        var params = angular.copy(vm.filters);
        if (vm.filters.clinicName && vm.filters.clinicName === vm.anyClinic) {
          delete params.clinicName;
        }

        if (vm.filters.practiceName && vm.filters.practiceName === vm.anyPractice) {
          delete params.practiceName;
        }

        if (vm.filters.location && vm.filters.location === vm.anyLocation) {
          delete params.location;
        }

        if (vm.report.type) {
          params.portal = vm.report.type;
        } else {
          delete params.portal;
        }

        ReportService[vm.report.strategy](params)
          .then(assistSuccess, errorCallback);
      }

      function setUrlsCSV() {
        var params = {};
        params.filter = vm.filter.id;

        if (vm.report.id === 'eASSIST Lite Research Project' && vm.filters.clinicName && vm.filters.clinicName !== vm.anyClinic) {
          params.clinicName = vm.filters.clinicName;
        }

        if (vm.report.id === 'eASSIST SA Research Project' && vm.filters.practiceName && vm.filters.practiceName !== vm.anyPractice) {
          params.practiceName = vm.filters.practiceName;
        }

        if ((vm.report.id === 'eASSIST' || vm.report.id === 'eASSIST Lite') && vm.filters.location && vm.filters.location !== vm.anyLocation) {
          params.location = vm.filters.location;
        }

        if (vm.filters.beginDate && vm.filters.endDate) {
          params.beginDate = vm.filters.beginDate;
          params.endDate = vm.filters.endDate;
        }

        if (vm.report.type) {
          params.portal = vm.report.type;
        } else {
          delete params.portal;
        }

        vm.downloadCsvSummaryURL =
          config.appBaseUrl
          + '/api/'
          + vm.report.csv
          + '/summaryResultsCSV?params='
          + JSON.stringify(params) + '&access_token=' + UserService.getAccessToken();

        vm.downloadCsvIndividualURL =
          config.appBaseUrl
          + '/api/'
          + vm.report.csv
          + '/individualAnswersCSV?params='
          + JSON.stringify(params) + '&access_token=' + UserService.getAccessToken();
      }

      vm.changeView = function () {
        vm.isChart = !vm.isChart;
        vm.isList = !vm.isList;
      }

      $scope.$watch(
        function () {
          return vm.filter;
        },
        setUrlsCSV
      );
      $scope.$watch(
        function () {
          return vm.filters;
        },
        setUrlsCSV, true
      );

      vm.findSurveys = findSurveys;

      function findSurveys() {
        var params = angular.copy(vm.filters);
        if (vm.filters.clinicName && vm.filters.clinicName === vm.anyClinic) {
          delete params.clinicName;
        }

        if (vm.filters.practiceName && vm.filters.practiceName === vm.anyPractice) {
          delete params.practiceName;
        }
        ReportService.findSurveys(params)
          .then(findSurveysSuccess, errorCallback);
      };

      function findSurveysSuccess(surveys) {
        vm.surveys.length = 0;
        angular.forEach(surveys, function (survey) {
          survey.results = getFeedBack(survey);
          vm.surveys.push(survey);
        });
        vm.setFilter(vm.filter);
        vm.loading = false;
      };

      function getFeedBack(survey) {
        var criteria = survey.result;
        var results = {};
        results.criteria = criteria;
        results.feedback = {
          briefAdvice: [],
          referralAdvice: []
        };

        for (var c in criteria) {
          var drugName = c;
          if (drugName === 'alcoholic') {
            drugName = 'alcohol';
          }

          var feedback = AssistLiteService.feedback[drugName];
          if (!feedback) continue;

          var advice;


          if (c === 'alcoholic') {
            if (criteria[c] >= 11 && criteria[c] <= 26) {
              advice = 'briefAdvice';
            }
          } else {
            if (criteria[c] >= 4 && criteria[c] <= 26) {
              advice = 'briefAdvice';
            }
          }

          if (criteria[c] > 26) {
            advice = 'referralAdvice';
          }

          if (advice) {
            var result = {
              drugName: drugName,
              advice: advice.replace('Advice', '')
            };

            if (c === 'other') {
              result.substance = vm.secondTest.form.otherText;
            }

            if (c === 'alcoholic' || c === 'tobacco') {
              var gender = survey.result.info.gender;

              result.content = feedback[advice][gender];
              result.gender = gender;
            } else {
              result.content = feedback[advice];
            }

            results.feedback[advice].push(result);
          }

          advice = undefined;
        }
        return results;
      }

      vm.emailParticipantReport = function (email, surveyId, surveyResults, survey) {
        var id = surveyId;
        var results = surveyResults;
        survey.isSendingEmail = true;
        EAssistService.emailParticipantReport(email, id, results)
          .then(function () {
            vm.isEmailSent = true;
          })
          .finally(function () {
            vm.isSendingEmail = false;
          });
      }

      vm.downloadCSV = function (surveyId) {
        var id = surveyId;

        var url =
          config.appBaseUrl
          + '/api/EAssistSurveys/downloadParticipantReportCSV?id='
          + id;

        $window.open(url, "_blank");
      }

      vm.downloadAllResultsCSV = function () {
        var userId = vm.User.id;
        var url =
          config.appBaseUrl
          + '/api/EAssistSurveys/downloadAllParticipantReportCSV?id='
          + userId;

        $window.open(url, "_blank");
      }


    })
})();

(function () {
  'use strict';

  angular.module('assistApp').controller(
    'Mydiary.Controller',
    function (
      NotificationService,
      $rootScope,
      MydiaryService,
      $scope,
      moment
    ) {
      var vm = this;

      vm.isRightActive = false;
      vm.toggleNavRight = function () {
        vm.isRightActive = !vm.isRightActive;
        $scope.$emit('changeNavRight', vm.isRightActive);
      };
      $scope.$on('changeNavRight', function (event, state) {
        vm.isRightActive = state;
      });

      vm.today = moment(new Date()).format("MM/DD/YYYY");
      vm.date = new Date();
      vm.user = $rootScope.User;

      vm.filters = {
        week: '',
        month: ''
      };

      vm.slider = {
        alcoholValue: 0,
        amphetaminesValue: 0,
        cannabisValue: 0,
        cocaineValue: 0,
        ecstasyValue: 0,
        inhalantsValue: 0,
        opioidsValue: 0,
        prescriptionMedsValue: 0,
        tobaccoValue: 0
      };

      vm.sliderOptions = {
        options: {
          floor: 0,
          ceil: 500,
          step: 1,
          translate: function (value) {
            return '$' + value;
          },
          showSelectionBar: true,
          selectionBarGradient: {
            from: '#d8e0f3',
            to: '#005a9c'
          }
        }
      };

      vm.labels = ['Alcohol', 'Amphetamines', 'Cannabis', 'Cocaine', 'Ecstasy', 'Inhalants', 'Opioids', 'Prescription Meds', 'Tobacco'];
      vm.dataToday = [];
      vm.dataWeek = [];
      vm.dataMonth = [];
      vm.dataAllTime = [];
      vm.events = [];

      vm.calendarOptions = {
        customClass: getDayClass,
        showWeeks: false
      };

      vm.monthOptions = {
        minMode: 'month'
      };

      vm.monthpickerPopup = {
        month: false
      };

      function init() {
        var startDate = moment().startOf('day');
        var endDate = moment(startDate).endOf('day');
        findTodayDiary(startDate, endDate);
        findMarkedDates();
      };

      function getDayClass(data) {
        var date = data.date,
          mode = data.mode;
        if (mode === 'day') {
          var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

          for (var i = 0; i < vm.events.length; i++) {
            var currentDay = new Date(vm.events[i].date).setHours(0, 0, 0, 0);

            if (dayToCheck === currentDay) {
              return vm.events[i].status;
            }
          }
        }

        return '';
      };

      function findMarkedDates() {
        var startDate = '2018-01-01T00:00:00.000Z';
        var endDate = '2200-01-01T00:00:00.000Z';
        MydiaryService.findDiary(startDate, endDate)
          .then(findMarkedDatesSuccess, errorCallback);
      };

      vm.openMonthpickerPopup = function () {
        vm.monthpickerPopup.month = true;
      };

      vm.saveSliderValue = function (date) {
        var startDate = new Date(moment(date).startOf('day'));
        var endDate = new Date(moment(startDate).endOf('day'));
        var data = vm.slider;
        MydiaryService.saveSliderValue(startDate, endDate, data, date);
        vm.events.push({
          date: date,
          status: 'marked'
        });
      };

      vm.resetValue = function () {
        vm.slider = {
          alcoholValue: 0,
          amphetaminesValue: 0,
          cannabisValue: 0,
          cocaineValue: 0,
          ecstasyValue: 0,
          inhalantsValue: 0,
          opioidsValue: 0,
          prescriptionMedsValue: 0,
          tobaccoValue: 0
        };
      };

      vm.findTodayData = function () {
        var startDate = new Date(moment().startOf('day'));
        var endDate = new Date(moment(startDate).endOf('day'));
        findTodayDiary(startDate, endDate);
      };

      vm.findWeekData = function () {
        var today = new Date();
        var endDate = moment(today).endOf('day').toDate();
        var date = today.setDate(today.getDate() - 7);
        var startDate = moment(date).startOf('day').toDate();
        findWeekDiary(startDate, endDate);
      };

      vm.findMonthData = function (month) {
        var month = new Date(month);
        var startDate = new Date(month.getFullYear(), month.getMonth(), 1);
        var endOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
        var endDate = moment(endOfMonth).endOf('day').toDate();
        findMonthDiary(startDate, endDate);
      };

      vm.findAllTimeData = function () {
        var startDate = '2018-01-01T00:00:00.000Z';
        var endDate = '2200-01-01T00:00:00.000Z';
        findAllTimeDiary(startDate, endDate);
      };

      function findTodayDiary(startDate, endDate) {
        MydiaryService.findDiary(startDate, endDate)
          .then(findTodayDiarySuccess, errorCallback);
      };

      function findWeekDiary(startDate, endDate) {
        MydiaryService.findDiary(startDate, endDate)
          .then(findWeekDiarySuccess, errorCallback);
      };

      function findMonthDiary(startDate, endDate) {
        MydiaryService.findDiary(startDate, endDate)
          .then(findMonthDiarySuccess, errorCallback);
      };

      function findAllTimeDiary(startDate, endDate) {
        MydiaryService.findDiary(startDate, endDate)
          .then(findAllTimeDiarySuccess, errorCallback);
      };

      function findTodayDiarySuccess(diaries) {
        var data = diaries[0].data;
        vm.dataToday = Object.values(data);
        vm.slider = data;
        vm.loading = false;
      };

      function findWeekDiarySuccess(diaries) {
        var data = diaries.reduce(function (acc, obj) {
          return acc = deepMergeSum(acc, obj)
        }).data;
        vm.dataWeek = Object.values(data);
      };

      function findMonthDiarySuccess(diaries) {
        var data = diaries.reduce(function (acc, obj) {
          return acc = deepMergeSum(acc, obj)
        }).data;
        vm.dataMonth = Object.values(data);
      };

      function findAllTimeDiarySuccess(diaries) {
        var data = diaries.reduce(function (acc, obj) {
          return acc = deepMergeSum(acc, obj)
        }).data;
        vm.dataAllTime = Object.values(data);
      };

      function findMarkedDatesSuccess(diaries) {
        var results = diaries.map(function (diary) {
          return ({
            date: diary.date,
            status: 'marked'
          });
        });
        vm.events = results;
      };

      function errorCallback(error) {
        NotificationService.error('Data access error', error);
        vm.loading = false;
      };

      function deepMergeSum(obj1, obj2) {

        return Object.keys(obj1).reduce(function (acc, key) {
          if (typeof obj2[key] === 'object') {
            acc[key] = deepMergeSum(obj1[key], obj2[key]);
          } else if (obj2.hasOwnProperty(key) && !isNaN(parseFloat(obj2[key]))) {
            acc[key] = obj1[key] + obj2[key]
          }
          return acc;
        }, {});
      };

    });
})();
(function () {
    'use strict';

    angular
        .module('assistApp')
        .controller('Invite.Controller', InviteController);

    InviteController.$inject = ['$uibModalInstance', '$rootScope', 'UserService', 'survey', 'toastr'];
    function InviteController($uibModalInstance, $rootScope, UserService, survey, toastr) {
        var vm = this;
        vm.User = $rootScope.User;
        vm.invite = [{ firstName: '', lastName: '', email: '', surveyAdmin: survey.id }];
        vm.admins = [];
        //bind events
        vm.close = onClose;
        vm.addInviteField = onAddInviteField;
        vm.removeInviteField = onRemoveInviteField;
        vm.isMailSent = [];
        vm.sendMails = onSendMails;
        vm.deleteAccount = onDeleteAccount;
        vm.resendInvite = onResendInvite;

        activate();

        ////////////////

        function activate() {
            getAdmins();
        }


        function getAdmins() {
            UserService.getAdminsBySurveyId(survey.id).then(function (res) {
                vm.admins = res;
            });
        }


        function onClose() {

            $uibModalInstance.close();
        }

        function onResendInvite(id) {
            UserService.resendInvitation(id).then(function (res) {
                toastr.success('Resent invite successfully', 'Success');
                getAdmins();
            }, function (err) {
                toastr.error('Error while re-sending invite. Try later', 'Error');
                console.log(err);
            });
        }

        function onAddInviteField() {
            vm.invite.push({ firstName: '', lastName: '', email: '', surveyAdmin: survey.id });
        }

        function onRemoveInviteField(index) {
            vm.invite.splice(index, 1);
        }

        function onDeleteAccount(userId) {
            if (confirm('Are you sure you want to delete the user ?')) {
                UserService.deleteUserAccount(userId).then(function (res) {
                    toastr.success('User account deleted', 'Success');
                    getAdmins();
                }, function (err) {
                    console.log(err);
                    toastr.error('Error while delete user account deleted. Try later', 'Error!');
                });
            }
        }

        function onSendMails() {
            UserService.invitePersons(vm.invite)
                .then(function (userArray) {
                    toastr.success('Invite Sent Successfully', 'Success');
                    for (var user = 0; user < userArray.length; user++) {
                        if (userArray[user][1]) {
                            vm.isMailSent[user] = true;
                        }
                        else {
                            vm.isMailSent[user] = false;
                        }
                    }
                })
                .catch(function (e) {
                    console.error(e);
                });
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .controller(
      'AssistLite.Controller',
      function (
        $q,
        $state,
        $window,
        config,
        AssistLiteService,
        $scope
      ) {
        var vm = this;

        vm.currentTestIndex = 0;
        vm.readyPercentage = 0;
        vm.videoView = false;
        vm.isFeedback = false;
        vm.isBriefOpen = false;
        vm.isModerateOpen = false;
        vm.isReferralOpen = false;
        vm.tests = angular.copy(AssistLiteService.tests);
        vm.hospitalCodes = AssistLiteService.hospitalCodes;
        vm.feedback = [];
        vm.isError = false;
        vm.phone = '';
        vm.phoneError = false;
        vm.codeError = false;
        vm.loading = false;
        vm.trialCode = AssistLiteService.trialCode;
        vm.comparison = null;
        vm.isSendingEmail = false;
        vm.isEmailSent = false;

        function updatePercentage() {
          vm.readyPercentage =
            Math.ceil(vm.currentTestIndex / vm.tests.length * 100);
        }

        function setAdvice() {
          var currentTest = vm.tests[vm.currentTestIndex];
          if (!currentTest.isTest) return;

          var score = vm.getTestScore(currentTest);

          currentTest.advice = '';

          if (score >= currentTest.feedbackParams.briefAdvice) {
            currentTest.advice = 'briefAdvice';
          }

          if (score >= currentTest.feedbackParams.moderateAdvice) {
            currentTest.advice = 'moderateAdvice';
          }

          if (score >= currentTest.feedbackParams.referralAdvice) {
            currentTest.advice = 'referralAdvice';
          }
        }

        vm.isTest = function () {
          return !vm.videoView && !vm.isError && !vm.isFeedback;
        };

        vm.changeTestState = function (test, question) {
          test.testQuestions.forEach(function (questionOfTest, index) {
            if (index === 0) return;
            questionOfTest.isDisabled = question.value === 'No';
            questionOfTest.value = question.value === 'No' ? '' : test.value;
          });
        };

        vm.saveAnswers = function () {
          vm.tests[0].testQuestions.clientId = vm.introParams.clientId;

          var promise = vm.introParams.isTrial
            ? AssistLiteService.getLastTrial(vm.introParams.clientId)
            : $q.when();

          promise.then(function (lastTrial) {
            AssistLiteService.save(
              vm.tests,
              vm.phone,
              function (survey) {
                vm.isFeedback = false;
                vm.videoView = true;
                vm.survey = survey;
                if (vm.introParams.isTrial) {
                  vm.comparison = vm.getComparisonTable(lastTrial.data.results, vm.tests);
                }
              },
              function (err) {
                vm.videoView = false;
                vm.isError = true;
              }
            );
          });
        };

        vm.getComparisonTable = function (previousResults, currentResults) {
          var comparison = [];

          var tests = _.filter(currentResults, "isTest");

          _.each(tests, function (test) {
            var currentScore = vm.getTestScore(test);

            var previousTest = _.find(previousResults, {
              name: test.name
            });

            var previousScore = vm.getTestScore(previousTest);

            comparison.push({
              substance: test.name,
              previousScore: previousScore,
              currentScore: currentScore
            });
          });

          return comparison;
        };

        vm.getTestScore = function (test) {
          return test.testQuestions.filter(function (test) {
            return test.value === 'Yes';
          }).length;
        };

        vm.finish = function () {
          $state.reload();
          $window.scrollTo(0, 0);
        };

        vm.nextTest = function () {
          setAdvice();

          if (vm.currentTestIndex < vm.tests.length - 1) {
            vm.currentTestIndex++;
            updatePercentage();
          } else {
            vm.isFeedback = true;
            vm.feedback = AssistLiteService.getFeedback(vm.tests);
          }

          $scope.surveyForm.$setPristine();
          $window.scrollTo(0, 0);
        };

        vm.previousTest = function () {
          if (vm.currentTestIndex > 0) {
            vm.currentTestIndex--;
            updatePercentage();
          }
        };

        vm.backToTest = function () {
          vm.isFeedback = false;
          vm.currentTestIndex = vm.tests.length;
          vm.previousTest();
        };

        vm.isRequiredNext = function (formValid) {
          if (
            vm.tests[vm.currentTestIndex].isTest &&
            (vm.tests[vm.currentTestIndex].testQuestions[0].value == 'No')
          ) {
            return false;
          }
          else {
            return formValid;
          }
        };

        vm.introParams = {
          clientId: '',
          isTrial: false
        };

        function onSuccessSendId(data) {
          vm.loading = false;

          vm.errors = {};
          if (data.errorMessage == 'ID_EXISTS') {
            vm.errors.clientId = 'Someone already has that Trial Code. Try another?';
            return;
          }

          if (data.errorMessage == 'ID_NOT_FOUND') {
            vm.errors.clientId = 'Trial code is not found.';
            return;
          }

          if (data.success) {
            var intro = _.find(data.success.data.results, { name: "Introduction" });
            var currentIntro = _.find(vm.tests, { name: "Introduction" });

            currentIntro.testQuestions = intro.testQuestions;
          }

          vm.nextTest();
        }

        function onErrorSendId(error) {
          vm.loading = false;
        }

        vm.sendID = function () {
          vm.loading = true;
          vm.errors = {};

          AssistLiteService.saveID(
            vm.introParams,
            onSuccessSendId,
            onErrorSendId
          );
        };

        vm.submit = function () {
          if (vm.currentTestIndex == 0) {
            vm.sendID();
          } else {
            vm.nextTest();
          }
        };

        vm.validateHospitalCode = function (form) {
          var codeToSearch = [form.hospital.$modelValue, form.department.$modelValue].join(':');
          var codeFound = vm.hospitalCodes[codeToSearch];

          if (form.hospitalCode.$modelValue !== codeFound) {
            form.hospitalCode.$setValidity('hospitalError', false);
            form.hospitalCode.$error.hospitalError = true;
          } else {
            form.hospitalCode.$setValidity('hospitalError', true);
            form.hospitalCode.$error.hospitalError = false;
          }
        };

        vm.validateHospitalCodeReport = function (form) {
          var intro = _.find(vm.tests, { name: "Introduction" });

          var code = form.hospitalCodeReport.$modelValue;
          var validCode = intro.testQuestions.hospitalCode.value;

          form.hospitalCodeReport.$setValidity('hospitalError', code === validCode);
          form.hospitalCodeReport.$error.hospitalError = code !== validCode;
        };

        vm.downloadParticipantReportCSV = function () {
          var url =
            config.appBaseUrl
            + '/api/AssistSurveys/downloadParticipantReportCSV?clientId='
            + vm.introParams.clientId;

          $window.open(url, "_blank");
        };

        vm.emailParticipantReport = function (email) {
          var clientId = vm.introParams.clientId;

          var results = {
            comparison: vm.comparison,
            feedback: vm.feedback,
            isTrial: vm.introParams.isTrial
          };

          vm.isSendingEmail = true;
          AssistLiteService.emailParticipantReport(email, vm.survey.id, clientId, results)
            .then(function () {
              vm.isEmailSent = true;
            })
            .finally(function () {
              vm.isSendingEmail = false;
            });
        };

        vm.dropdownSelected = function (form) {
          return form && form.hospital && !form.hospital.$error.required && form.department && !form.department.$error.required;
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'UserService',
      function (
        WineUser,
        LoopBackAuth,
        $cookies,
        $rootScope,
        Authentication,
        $http,
        $q,
        config,
        $state,
        $window,
        $sce
      ) {
        var vm = this;

        vm.checkEmail = function (email) {
          return WineUser.checkEmail({ email: email }).$promise;
        };

        vm.sendConfirmationEmail = function (email) {
          return WineUser.sendConfirmationEmail({ email: email }).$promise;
        };

        vm.updateOne = function (user, successCb, errorCb) {
          WineUser.prototype$updateAttributes(
            { id: user.id },
            user,
            successCb,
            errorCb
          );
        };

        vm.create = function (user, successCb, errorCb) {
          WineUser.createAccount(user, successCb, errorCb);
        };

        vm.logout = function () {
          $cookies.remove('access_token');
          $cookies.remove('userId');

          return WineUser.logout().$promise;
        };

        vm.profile = function (id, successCb, errorCb) {
          WineUser.profile({ id: id }, successCb, errorCb);
        };

        vm.updateMainAttributes = function (attributes, successCb, errorCb) {
          WineUser.updateMainAttributes(
            { attributes: attributes },
            successCb,
            errorCb
          );
        };

        vm.updateProfileOverview = function (overview, successCb, errorCb) {
          WineUser.updateProfileOverview(
            { overview: overview },
            successCb,
            errorCb
          );
        };

        vm.updateProfileSkills = function (skills, successCb, errorCb) {
          WineUser.updateProfileSkills({ skills: skills }, successCb, errorCb);
        };

        vm.updateProfileEducation = function (education, successCb, errorCb) {
          WineUser.updateProfileEducation(
            { education: education },
            successCb,
            errorCb
          );
        };

        vm.updateProfileExperience = function (experience, successCb, errorCb) {
          WineUser.updateProfileExperience(
            { experience: experience },
            successCb,
            errorCb
          );
        };

        vm.updateProfileBackground = function (background, successCb, errorCb) {
          WineUser.updateProfileBackground(
            { background: background },
            successCb,
            errorCb
          );
        };

        vm.searchExperts = function (params, successCb, errorCb) {
          WineUser.searchExperts({ params: params }, successCb, errorCb);
        };

        vm.searchPeople = function (params) {
          return WineUser.searchPeople({ params: params }).$promise;
        };

        vm.getCurrentId = function () {
          return WineUser.getCurrentId();
        };

        vm.getUserAvatarUrl = function (user, next) {
          var defaultPath = '/assets/images/shared/default-avatar.png';
          var path = defaultPath;
          if (user && user.avatarUrl) {
            path = user.avatarUrl;
          }
          if (next && typeof next === 'function') {
            next(path);
          } else {
            return path;
          }
        };

        vm.getQRCode = function (id) {
          return WineUser.getQRCode(id).$promise;
        }

        vm.deleteAccount = function (successCb, errorCb) {
          WineUser.deleteAccount(function () {

            vm.logout();
            var logoutUrl = $sce.trustAsResourceUrl(
              config.appBaseUrl + '/auth/logout'
            );
            $window.location.href = logoutUrl;
            successCb();
          }, errorCb);
        };

        vm.deleteUserAccount = function (id) {
          return WineUser.deleteUserAccount({ id: id }).$promise;
        };

        vm.verifyPolicy = function (id) {
          return WineUser.verifyPolicy({ id: id }).$promise;
        };

        vm.updateNotification = function (notification, successCb, errorCb) {
          WineUser.updateNotification(
            { notification: notification },
            successCb,
            errorCb
          );
        };

        vm.changeEmail = function (email, successCb, errorCb) {
          WineUser.changeEmail(
            { email: email },
            successCb,
            errorCb
          );
        };

        vm.getResumeLink = function (user, cb) {
          var path = $state.href('user.profileIndex', { id: user.id }, { absolute: true });
          if (cb) {
            cb(null, path);
          } else {
            return path;
          }
        };

        vm.getFullName = function (user) {
          var fullName = '';
          if (user.firstName || user.lastName) {
            fullName = user.firstName;
            fullName += (user.firstName && user.lastName) ? ' ' : '';
            fullName += (user.lastName) ? user.lastName : '';
          } else if (user.email) {
            fullName = user.email;
          } else {
            fullName = ''
          }
          if (user.isDeleted) {
            fullName += (fullName) ? ' ' : '';
            fullName += '[Deleted]'
          }

          return fullName;
        };

        vm.setAdmin = function (id, successCb, errorCb) {
          return WineUser.setAdmin({ id: id }, successCb, errorCb);
        };


        vm.getAdmins = function () {
          return WineUser.find({ filter: { where: { isAdmin: true } } }).$promise;
        };

        vm.getAccessToken = function () {
          return LoopBackAuth.accessTokenId;
        };

        vm.verify2Fa = function (id, token) {
          return WineUser.verify2Fa({ id: id, otp: token }).$promise;
        };

        vm.getAdminsBySurveyId = function (surveyId) {
          var regex = '(,|^)' + surveyId + '(,|$)';
          return WineUser.find({ filter: { where: { surveyAdmin: { regexp: regex }, isDeleted: false } } }).$promise;
        };

        vm.getAdmin = function () {
          return $http.get(config.apiBaseUrl + '/WineUsers/findOne?filter={"where":{"isAdmin": true}}');
        };

        vm.invitePersons = function (personsArray) {
          return WineUser.invitePersons({
            personsArray: personsArray
          }).$promise;
        };

        vm.confirmRegistration = function (user) {
          return WineUser.confirmRegistration({ data: user }).$promise;
        };

        vm.getByConfirmationToken = function (token) {
          return WineUser.getByConfirmationToken({ token: token }).$promise;
        };


        vm.resendInvitation = function (id) {
          return WineUser.resendInvitation({ id: id }).$promise;
        };


      });
})();



(function () {
  'use strict';

  angular.module('assistApp').service(
    'ReportService',
    function (
      EAssistSurvey,
      EAssistLiteSurvey,
      AssistSurvey,
      AssistSurveySA,
      EAssistSurveyKnowYourOption,
      AssistAboriginal,
      AssistAboriginalFeedback,
      AssistAboriginalPilot,
      AssistAboriginalPilotFeedback
    ) {
      this.eAssistReport = function (params) {
        return EAssistSurvey.report({ params: params }).$promise;
      };

      this.eAssistKnowYourOptionReport = function (params) {
        return EAssistSurveyKnowYourOption.report({ params: params }).$promise;
      };

      this.assistAboriginalFeedbackReport = function (params) {
        return AssistAboriginalFeedback.report({ params: params }).$promise;
      };

      this.assistAboriginalPilotFeedbackReport = function (params) {
        return AssistAboriginalPilotFeedback.report({ params: params }).$promise;
      };

      this.eAssistLiteReport = function (params) {
        return EAssistLiteSurvey.report({ params: params }).$promise;
      };

      this.eAssistLiteResearchReport = function (params) {
        delete params.practiceName;
        return AssistSurvey.report({ params: params }).$promise;
      };

      this.eAssistSAReport = function (params) {
        delete params.clinicName;
        return AssistSurveySA.report({ params: params }).$promise;
      };

      this.assistAboriginalsReport = function (params) {
        return AssistAboriginal.report({ params: params }).$promise;
      };

      this.assistAboriginalPilotsReport = function (params) {
        return AssistAboriginalPilot.report({ params: params }).$promise;
      };

      this.findSurveys = function (params) {
        return EAssistSurvey.findSurveys({ params: params }).$promise;
      }
    }
  );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service('RedirectService', function ($location, $state, UserService, WineUser, portalText) {
      this.redirectStrategies = {
        'user': function (state, params) {
          $state.go(
            'guest.home',
            { returnTo: state.name, params: JSON.stringify(params) }
          );
        },
        'guest': function (state, params) {
          $state.go('user.report');
        },
        'guest.login-success': function (state, params) {
          if (!params.accessToken) {
            return $state.go('user.settings');
          }

          if (params.userExists) {
            return $state.go('guest.user-exists', params);
          }

          if (params.is2Fa) {
            localStorage.setItem('is2FARequired', true);
            return $state.go('guest.2fa', params);
          }

          if (!params.verifiedPolicy) {
            return $state.go('guest.policy', params);
          }

          if (params.returnTo) {
            return $state.go(params.returnTo, params.params);
          }
          if (portalText.hostName === 'myeassist') {
            $state.go('user.eAssist');
          } else {
            $state.go('user.report');
          }
        },
        'guest.verified': function () {
          $state.go('guest.home');
        }
      };

      this.checkStrategies = {
        'user': function () {
          return WineUser.isAuthenticated();
        },
        'guest': function () {
          return !WineUser.isAuthenticated();
        },
        'guest.verified': function () {
          return true;
        },
        'guest.eassist': function () {
          return true;
        },
        'guest.login-success': function () {
          return false;
        }
      };

      this.authorized = function (state, params) {
        if (state.data && state.data.redirectStrategy) {
          var res = this.checkStrategies[state.data.redirectStrategy](state, params);
          return !res;
        }

        return false;
      };

      this.redirect = function (state, params) {
        if (state.data && state.data.redirectStrategy) {
          this.redirectStrategies[state.data.redirectStrategy](
            state,
            params
          );
        }
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'PortalSettingsService',
      function (PortalSettings) {
        this.getSettings = function() {
          return PortalSettings.getSettings().$promise;
        };

        this.updateSettings = function(settings) {
          return PortalSettings.updateSettings({ settings: settings }).$promise;
        };

        this.updateHelpContent = function(settings, helpContentName) {
          beforeHelpContentSave(settings, helpContentName);
          return this.updateSettings(settings);
        };

        function beforeHelpContentSave(settings, name) {
          var helpContent = settings.helpContent[name];

          var fields = ['text', 'title'];
          fields.forEach(function (field) {
            if (helpContent[field] && _.isString(helpContent[field])) {
              helpContent[field] = helpContent[field].trim();
            }
          });
        }
      }
    );
})();

angular
  .module('assistApp')
  .service('NotificationService', function(config) {
    this.notifications = [];

    this.load = function() {
      return this.notifications;
    };

    this.notify = function(type, text) {
      this.notifications.push({ type: type, text: text });
    };

    this.error = function(text, error) {
      var msg = text;
      if (config.debug && error) {
        msg += '\n' + JSON.stringify(error);
      }
      this.notifications.push({ type: 'error', text: msg });
    };

    this.info = function(text) {
      this.notifications.push({ type: 'info', text: text });
    };

    this.warning = function(text) {
      this.notifications.push({ type: 'warning', text: text });
    };

    this.success = function(text) {
      this.notifications.push({ type: 'success', text: text });
    };

    this.close = function(notification) {
      _.remove(this.notifications, function(n) {
        return n === notification;
      });
    };
  });

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'MydiaryService',
      function (
        Diary
        ) {

        var vm = this;

        vm.saveSliderValue = function (startDate, endDate, data, date) {
          return Diary.saveSliderValue({ startDate: startDate, endDate: endDate, data: data, date: date }).$promise;
        };

        vm.findDiary = function (startDate, endDate) {
          return Diary.findDiary({startDate: startDate, endDate: endDate}).$promise;
        };
      }
    );
})();
angular.module('assistApp').factory('LanguageService', LanguageService);

function LanguageService(PortalSettingsService, UserPreference, $translate) {
  var AVAILABLE_LANGUAGES = ['en', 'fr', 'ru'];
  var DEFAULT_LANGUAGE = 'en';

  var userLanguage = localStorage.getItem('userLanguage');
  var portalLanguage = localStorage.getItem('portalLanguage');

  applyLanguage(getLanguage());

  function refreshPortalLanguage(forceRefresh) {
    if (!portalLanguage || forceRefresh) {
      PortalSettingsService.getSettings().then(function (settings) {
        setPortalLanguage(settings.language);
      });
    }
  }

  function refreshUserLanguage(forceRefresh) {
    if (!userLanguage || forceRefresh) {
      UserPreference.findPreferences({ keys: ['language'] }).$promise.then(function (preference) {
        if (preference.language) {
          setUserLanguage(preference.language.value);
        }
      });
    }
  }

  function setUserLanguage(language) {
    if (AVAILABLE_LANGUAGES.indexOf(language) < 0) {
      return;
    }

    userLanguage = language;
    localStorage.setItem('userLanguage', language);

    applyLanguage(language);
  }

  function setPortalLanguage(language) {
    if (AVAILABLE_LANGUAGES.indexOf(language) < 0) {
      return;
    }

    portalLanguage = language;
    localStorage.setItem('portalLanguage', language);

    if (!userLanguage) {
      applyLanguage(language);
    }
  }

  function applyLanguage(language) {
    if (AVAILABLE_LANGUAGES.indexOf(language) < 0) {
      language = DEFAULT_LANGUAGE;
    }

    $translate.use(language);
    moment.locale(language);
  }

  function getLanguage() {
    var language = userLanguage || portalLanguage;

    if (AVAILABLE_LANGUAGES.indexOf(language) < 0) {
      language = DEFAULT_LANGUAGE;
    }

    return language;
  }

  return {
    getLanguage: getLanguage,
    setUserLanguage: setUserLanguage,
    setPortalLanguage: setPortalLanguage,
    refreshPortalLanguage: refreshPortalLanguage,
    refreshUserLanguage: refreshUserLanguage
  };
}

angular.module('assistApp').service('HistoryService', function ($state) {
  var history = [];

  angular.extend(this, {
    push: function (state, params) {
      if (!state.abstract) {
        history.push({state: state, params: params});
      }
    },
    go: function (step) {
      var prev = this.previous(step || -1);
      return $state.go(prev.state, prev.params);
    },
    previous: function (step) {
      return history[history.length - Math.abs(step || 1)];
    },
    back: function () {
      return this.go(-1);
    }
  });
});

(function () {
  'use strict';

  angular.module('assistApp')
    .factory('fileDownloadService', fileDownloadService);

  fileDownloadService.inject = ['$http', '$q', 'config'];

  function fileDownloadService($http, $q, config) {
    var service = {
      fileDownload: fileDownload,
      fileDownloadWithPost: fileDownloadWithPost
    };

    return service;


    ////////////////
    function fileDownload(endPoint, type, name) {
      var deferred = $q.defer();
      $http.get(config.appBaseUrl + endPoint, {
        responseType: 'arraybuffer'
      }).success(function (data) {
        var file = new Blob([data], {
          type: type
        });
        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = name;
        document.body.appendChild(a);
        a.click();
        deferred.resolve(data);
      }).error(function (err) {
        deferred.reject(err);
        console.log(err);
      });

      return deferred.promise;
    }


    function fileDownloadWithPost(endPoint, body, type, name) {
      var deferred = $q.defer();
      $http.post(config.appBaseUrl + endPoint, body, {
        responseType: 'arraybuffer'
      }).success(function (data) {
        var file = new Blob([data], {
          type: type
        });
        var fileURL = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = name;
        document.body.appendChild(a);
        a.click();
        deferred.resolve(data);
      }).error(function (err) {
        deferred.reject(err);
        console.log(err);
      });
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'EAssistSAService',
      function (
        $q,
        config,
        AssistSurveySA,
        AssistLiteService,
        NotificationService
      ) {
        var vm = this;
        var ASSIST_PARTIALS_PATH = 'app/components/assistLite/partials';
        var ASSIST_PARTIALS_FEEDBACK_PATH = config.ASSIST_PARTIALS_FEEDBACK_PATH;

        vm.TEST_TEMPLATE_PATH = 'app/components/assistLite/eAssistSA/template';
        vm.language = 'English';

        this.saveID = function (params, successCb, errorCb) {
          AssistSurveySA.intro({ params: params }, successCb, errorCb);
        };

        vm.emailParticipantReport = function (email, id, results) {
          return AssistSurveySA.emailParticipantReport({
            email: email,
            id: id,
            results: results,
            comparison: vm.comparison.data,
            intro: vm.tests.intro.form
          }).$promise;
        };

        this.facilityCodes = {
          'COSUP site': 'COSUP site',
          'Primary health care facility': 'Primary health care facility',
          'Hospital': 'Hospital', 'Other': 'Other'
        };

        this.trialCode = 12345;
        vm.results = {
          criteria: {}
        };

        vm.getLastTrial = function (clientId, successCb, errorCb) {
          return AssistSurveySA.findByClientId({ params: { clientId: clientId } }).$promise;
        };
        vm.comparison = {
          data: {}
        };
        vm.questions1 = [];
        vm.questions345 = [];
        vm.questions2678 = [];

        vm.tests = {
          intro: {
            template: vm.TEST_TEMPLATE_PATH + '/intro.template.html',
            readyPercentage: 0,
            questions: [],
            practice: {
              text: 'Practice:',
              type: 'select',
              value: '',
              options: ['COSUP Mamelodi East', 'COSUP Mamelodi West', 'COSUP Sunnyside', 'COSUP Bosman Street',
                'COSUP TDH', 'COSUP Atttridgeville', 'COSUP Daspoort', 'COSUP Garankuwa', 'COSUP M17',
                'COSUP North Church', 'COSUP Laudium', 'COSUP Oliewen', 'COSUP Eersterust', 'BHS Hospital',
                'TDH Casualty', 'TDH OPD', 'SBAH Casualty', 'Pretoria West Hospital Casualty',
                'Pretoria West Hospital Mental Health', 'Pretoria West OPD', 'Kalafong Casualty',
                'Kalafong Family Medicine Clinic', 'Kalafong Mental Health Ward', 'Mamelodi Hospital Casualty',
                'Mamelodi Hospital OPD', 'SIC Family Medicine', 'SIC District Health',
                'SIC Anaestetics', 'SIC Surgery', 'SIC Internal Medicine', 'SIC Orthopeadics',
                'SIC Neurology', 'SIC O&G', 'LCAS', 'Block 16', 'BCMP Mamelodi',
                'BCMP TDH', 'BCMP Pretoria West Hospital', 'BCMP Kalafong', 'BCMP 1 Military Hospital']
            },
            hospital: {
              options: ['Royal Adelaide Hospital', 'Flinders Hospital']
            },
            department: {
              options: ['Emergency Department', 'Ante-natal']
            },
            language: {
              options: ['English']
            },
            isNextDisabled: function (form, formAngular) {
              if (formAngular.$valid) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question9);
            },
            isPrev: false,
            isNext: true
          },
          question9: {
            name: 'A Bit About You',
            template: vm.TEST_TEMPLATE_PATH + '/question9.template.html',
            readyPercentage: 0,
            questions: [],
            isNextDisabled: function (form) {
              if (form && form.gender && form.age && form.employed) {
                return false;
              }
              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question1);
            },
            prev: function (cb) {
              cb(vm.tests.intro);
            },
            isPrev: false,
            isNext: true
          },
          question1: {
            template: vm.TEST_TEMPLATE_PATH + '/question1.template.html',
            readyPercentage: 12,
            questions: vm.questions1,
            isNextDisabled: function (form, angularForm) {
              if (angularForm.$invalid) return true;

              return false;
            },
            next: function (form, cb) {
              vm.questions2678.length = 0;

              for (var key in form) {
                if (form[key] === 1) {
                  vm.questions2678.push(key);
                }
              }

              if (vm.questions2678.length === 0) {
                vm.finish(cb);
              } else {
                cb(vm.tests.question2);
              }
            },
            prev: function (cb) {
              cb(vm.tests.question9);
            },
            isPrev: true,
            isNext: true
          },
          question2: {
            name: 'question2',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 12,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions2678.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              vm.questions345.length = 0;

              for (var key in form) {
                if (form[key] > 0) {
                  vm.questions345.push(key);
                }
              }

              if (vm.questions345.length === 0) {
                cb(vm.tests.question6);
              } else {
                cb(vm.tests.question3);
              }
            },
            prev: function (cb) {
              cb(vm.tests.question1);
            },
            isPrev: true,
            isNext: true
          },
          question3: {
            name: 'question3',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 25,
            questions: vm.questions345,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions345.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question4);
            },
            prev: function (cb) {
              cb(vm.tests.question2);
            },
            isPrev: true,
            isNext: true
          },
          question4: {
            name: 'question4',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 37,
            questions: vm.questions345,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions345.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question5);
            },
            prev: function (cb) {
              cb(vm.tests.question3);
            },
            isPrev: true,
            isNext: true
          },
          question5: {
            name: 'question5',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 50,
            questions: vm.questions345,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions345.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question6);
            },
            prev: function (cb) {
              cb(vm.tests.question4);
            },
            isPrev: true,
            isNext: true
          },
          question6: {
            name: 'question6',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 62,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions2678.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question7);
            },
            prev: function (cb) {
              if (vm.questions345.length === 0) {
                cb(vm.tests.question2);
              } else {
                cb(vm.tests.question5);
              }
            },
            isPrev: true,
            isNext: true
          },
          question7: {
            name: 'question7',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 75,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions2678.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question8);
            },
            prev: function (cb) {
              cb(vm.tests.question6);
            },
            isPrev: true,
            isNext: true
          },
          question8: {
            template: vm.TEST_TEMPLATE_PATH + '/question8.template.html',
            readyPercentage: 87,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              vm.save(cb);
            },
            prev: function (cb) {
              cb(vm.tests.question7);
            },
            isPrev: true,
            isNext: true
          },
          feedback: {
            template: vm.TEST_TEMPLATE_PATH + '/feedback.template.html',
            readyPercentage: 100,
            questions: [],
            isNextDisabled: function (form) {
              if (form) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              vm.finish(cb);
            },
            prev: function (cb) {
              if (vm.questions2678.length === 0) {
                cb(vm.tests.question1);
              } else {
                cb(vm.tests.question8);
              }
            },
            isPrev: true,
            isNext: true
          },
          end: {
            template: vm.TEST_TEMPLATE_PATH + '/end.template.html',
            readyPercentage: 100,
            questions: [],
            isPrev: false,
            isNext: false
          }
        };

        vm.firstTest = vm.tests.intro;
        vm.secondTest = vm.tests.question1;

        vm.save = function (cb) {
          var data = {
            tests: {},
            otherText: vm.secondTest.form.otherText ? vm.secondTest.form.otherText : ''
          };
          for (var key in vm.tests) {
            if (vm.tests[key].form) {
              data.tests[key] = { form: vm.tests[key].form };
            }
          }
          var promise = vm.tests.intro.form.isTrial ? vm.getLastTrial(vm.tests.intro.form.clientId) : $q.when();
          promise.then(function (lastTrial) {
            AssistSurveySA.saveData(
              { data: data },
              function (survey) {
                var criteria = survey.result;
                vm.savedSurvey = survey;
                vm.results.criteria = criteria;
                vm.results.feedback = {
                  briefAdvice: [],
                  referralAdvice: [],
                  moderateAdvice: []
                };

                if (vm.tests.intro.form.isTrial) {
                  vm.comparison.data = vm.getComparisonTable(lastTrial.result, criteria);
                }

                for (var c in criteria) {
                  var drugName = c;
                  if (drugName === 'alcoholic') {
                    drugName = 'alcohol';
                  }

                  var feedback = AssistLiteService.feedback[drugName];
                  if (!feedback) continue;

                  var advice, content;

                  if (c === 'alcoholic') {
                    if (criteria[c] < 11 && criteria[c] > 0) {
                      advice = 'briefAdvice';
                    } else if (criteria[c] >= 11 && criteria[c] <= 26) {
                      advice = 'moderateAdvice';
                    }
                  } else {
                    if (criteria[c] < 4 && criteria[c] > 0) {
                      advice = 'briefAdvice';
                    } else if (criteria[c] >= 4 && criteria[c] <= 26) {
                      advice = 'moderateAdvice';
                    }
                  }

                  if (criteria[c] > 26) {
                    advice = 'referralAdvice';
                  }

                  if (advice) {
                    var result = {
                      drugName: drugName,
                      advice: advice.replace('Advice', '')
                    };

                    if (c === 'other') {
                      result.substance = vm.secondTest.form.otherText;
                    }

                    if (c === 'alcoholic' || c === 'tobacco') {
                      var gender = survey.result.info.gender;

                      result.content = feedback[advice][gender];
                      result.gender = gender;
                    } else {
                      result.content = feedback[advice];
                    }

                    vm.results.feedback[advice].push(result);
                  }

                  advice = undefined;
                }

                cb(vm.tests.feedback);
              },
              function (error) {
                NotificationService.error('Data acccess error', error);
              }
            );
          });
        };


        vm.getComparisonTable = function (previousResults, currentResults) {
          var comparison = {};

          for (var c in currentResults) {
            var currentScore = currentResults[c];
            var previousScore = previousResults[c];
            comparison[c] = {
              previousScore: previousScore,
              currentScore: currentScore
            };
          }
          return comparison;
        };


        this.feedback = {
          'tobacco': {
            'briefAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.brief.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.brief.partial.html'
            },
            'referralAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.referral.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.referral.partial.html'
            }
          },
          'alcohol': {
            'briefAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.brief.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.brief.partial.html'
            },
            'referralAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.referral.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.referral.partial.html'
            }
          },
          'cannabis': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.referral.partial.html'
          },
          'amphetamine': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/amphetamine.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/amphetamine.referral.partial.html'
          },
          'cocaine': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.referral.partial.html'
          },
          'inhalants': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/inhalants.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/inhalants.referral.partial.html'
          },
          'hallucinogens': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/hallucinogens.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/hallucinogens.referral.partial.html'
          },
          'sedatives': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.referral.partial.html'
          },
          'opioids': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.referral.partial.html'
          },
          'other': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.referral.partial.html'
          }
        };


        vm.finish = function (cb) {
          // for (var key in vm.tests) {
          //   delete vm.tests[key].form;
          // }

          cb(vm.tests.end);
        }
      });
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'EAssistLiteService',
      function (config, $stateParams, EAssistLiteSurvey) {
        var ASSIST_PARTIALS_PATH = 'app/components/assistLite/partials';

        var ASSIST_PARTIALS_FEEDBACK_PATH = config.ASSIST_PARTIALS_FEEDBACK_PATH;

        this.save = function (testData, successCb, errorCb) {
          return EAssistLiteSurvey.saveData({
            data: { results: testData, otherText: this.otherText, location: $stateParams.location || '' }
          }).$promise;
        };

        this.emailParticipantReport = function (email, id, results) {
          return EAssistLiteSurvey.emailParticipantReport({
            email: email,
            id: id,
            results: results
          }).$promise;
        };

        this.tests = [
          {
            name: 'A Bit About You',
            userInfo: true,
            isTest: false,
            testQuestions: [
              {
                text: 'What is your gender?',
                type: 'radio',
                gender: true,
                otherGender: '',
                value: '',
                options: [{ text: 'Male', value: 'Male' }, { text: 'Female', value: 'Female' },
                { text: 'Non-binary', value: 'X' }, { text: '[I/They] use a different term (please specify:)', value: 'T' }, { text: 'Prefer not to answer', value: 'Z' }]
              },
              {
                text: 'What is your age?',
                type: 'number-min',
                value: ''
              },
              {
                text: 'How are you mainly employed at the moment?',
                type: 'radio',
                value: '',
                options: [
                  'Not employed',
                  'Full time',
                  'Part time/casual',
                  'Student',
                  'Home duties'
                ]
              }
            ]
          },
          {
            name: 'Tobacco',
            isTest: true,
            feedbackParams: {
              'gender': true,
              'briefAdvice': 0,
              'moderateAdvice': 1,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '1. Did you smoke a cigarette containing tobacco?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '1a. Did you usually smoke more than 10 cigarettes each day?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '1b. Did you usually smoke within 30 minutes after waking?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Alcohol',
            isTest: true,
            feedbackParams: {
              'gender': true,
              'briefAdvice': 1,
              'moderateAdvice': 2,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '2. Did you have a drink containing alcohol? ',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '2a. On any occasion, did you drink more than 4 standard drinks of alcohol? *',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '2b. Have you tried and failed to control, cut down or stop drinking?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '2c. Has anyone expressed concern about your drinking?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Cannabis',
            isTest: true,
            feedbackParams: {
              'gender': false,
              'briefAdvice': 0,
              'moderateAdvice': 1,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '3. Did you use cannabis?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '3a. Have you had a strong desire or urge to use cannabis at least once a week or more often?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '3b. Has anyone expressed concern about your use of cannabis?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Stimulants',
            isTest: true,
            feedbackParams: {
              'gender': false,
              'subquestion': ['amphetamine', 'cocaine'],
              'briefAdvice': 0,
              'moderateAdvice': 1,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '4. Did you use an amphetamine-type stimulant, or cocaine, or a stimulant medication not as prescribed?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '4a. Did you use a stimulant at least once each week or more often?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '4b. Has anyone expressed concern about your use of a stimulant?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Sedatives',
            feedbackParams: {
              'gender': false,
              'briefAdvice': 0,
              'moderateAdvice': 1,
              'referralAdvice': 3
            },
            advice: '',
            isTest: true,
            testQuestions: [
              {
                text: '5. Did you use a sedative or sleeping medication not as prescribed?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '5a. Have you had a strong desire or urge to use a sedative or sleeping medication at least once a week or more often?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '5b. Has anyone expressed concern about your use of a sedative or sleeping medication?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Opioids',
            isTest: true,
            feedbackParams: {
              'gender': false,
              'briefAdvice': 0,
              'moderateAdvice': 1,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                name: 'heroin',
                text: '6. Did you use a street opioid (e.g. heroin), or an opioid-containing medication not as prescribed?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '6a. Have you tried and failed to control, cut down or stop using an opioid?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '6b. Has anyone expressed concern about your use of an opioid?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Other',
            isTest: true,
            feedbackParams: {
              'gender': false,
              'briefAdvice': 0,
              'moderateAdvice': 1,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: 'Did you use any other psychoactive substance?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                doNotCount: false,
                toggleOtherQuestions: true
              },
              {
                text: 'What did you take?',
                type: 'text',
                value: '',
                isDisabled: true,
                doNotCount: true
              },
              {
                text: 'Have you had a strong desire or urge to use the drug at least once a week or more often?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: 'Has anyone expressed concern about your use of the drug?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          }
        ];

        this.feedback = {
          'tobacco': {
            'briefAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.brief.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.brief.partial.html'
            },
            'referralAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.referral.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.referral.partial.html'
            },
            'moderateAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.moderate.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.moderate.partial.html'
            }
          },
          'alcohol': {
            'briefAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.brief.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.brief.partial.html'
            },
            'referralAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.referral.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.referral.partial.html'
            },
            'moderateAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.moderate.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.moderate.partial.html'
            }
          },
          'cannabis': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.moderate.partial.html'
          },
          'amphetamine': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/stimulants.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/stimulants.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/stimulants.moderate.partial.html'
          },
          'cocaine': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.moderate.partial.html'
          },
          'sedatives': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.moderate.partial.html'
          },
          'opioids': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.moderate.partial.html'
          },
          'other': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.moderate.partial.html'
          }
        };

        this.otherText = '';

        this.getFeedback = function (tests) {
          var feedbacks = {
            briefAdvice: [],
            referralAdvice: [],
            moderateAdvice: []
          };
          var userInfo = _.find(tests, function (test) {
            return test.userInfo;
          }).testQuestions;

          var gender = 'male';//userInfo[0].value.toLowerCase();

          tests.forEach(function (test) {
            if (!test.isTest || !test.advice) return;

            if (test.feedbackParams.subquestion) {
              test.feedbackParams.subquestion.forEach(function (question) {
                if (question !== 'cocaine') {
                  var feedback = {};
                  feedback.name = question.toLowerCase();
                  feedback.drugName = question.toLowerCase();
                  feedback.displayDrugName = question.toLowerCase() == 'amphetamine' ? 'Stimulants' : question.toLowerCase();
                  feedback.content = this.feedback[feedback.name][test.advice];
                  feedbacks[test.advice].push(feedback);
                }
              }, this);
              return;
            }
            var feedback = {};
            feedback.name = test.name.toLowerCase();
            feedback.drugName = test.name.toLowerCase();

            if (test.name === 'Other') {
              var substance = _.find(test.testQuestions, {
                text: 'What did you take?'
              }).value;

              feedback.substance = substance;
              this.otherText = substance;
            }

            if (test.feedbackParams.gender) {
              feedback.content = this.feedback[feedback.name][test.advice][gender];
            } else {
              feedback.content = this.feedback[feedback.name][test.advice];
            }

            feedbacks[test.advice].push(feedback);
          }, this);

          return feedbacks;
        };
      });
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'EAssistService',
      function (
        portalText,
        $stateParams,
        EAssistSurvey,
        EAssistSurveyKnowYourOption,
        NotificationService,
        AssistLiteService
      ) {
        var vm = this;

        vm.TEST_TEMPLATE_PATH = 'app/components/assistLite/eAssist/template';
        vm.language = 'English';
        vm.savedSurvey = null;
        vm.results = {
          criteria: {}
        };

        vm.questions1 = [];
        vm.questions345 = [];
        vm.questions2678 = [];

        vm.emailParticipantReport = function (email, id, results) {
          return EAssistSurvey.emailParticipantReport({
            email: email,
            id: id,
            results: results
          }).$promise;
        };

        vm.tests = {
          // intro: {
          //   template: vm.TEST_TEMPLATE_PATH + '/intro.template.html',
          //   readyPercentage: 0,
          //   questions: [],
          //   hospital: {
          //     options: ['Royal Adelaide Hospital', 'Flinders Hospital']
          //   },
          //   department: {
          //     options: ['Emergency Department', 'Ante-natal']
          //   },
          //   language: {
          //     options: ['English']
          //   },
          //   isNextDisabled: function (form, formAngular) {
          //     if (formAngular.$valid) {
          //       return false;
          //     }
          //
          //     return true;
          //   },
          //   next: function (form, cb) {
          //     cb(vm.tests.question9);
          //   },
          //   isPrev: false,
          //   isNext: true
          // },
          question9: {
            template: vm.TEST_TEMPLATE_PATH + '/question9.template.html',
            readyPercentage: 0,
            questions: [],
            name: 'intro',
            isNextDisabled: function (form) {
              if (form && form.gender && form.age && form.employed) {
                return false;
              }
              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question1);
            },
            prev: function (cb) {
              cb(vm.tests.intro);
            },
            isPrev: false,
            isNext: true
          },
          question1: {
            template: vm.TEST_TEMPLATE_PATH + '/question1.template.html',
            readyPercentage: 12,
            questions: vm.questions1,
            isNextDisabled: function (form, angularForm) {
              if (angularForm.$invalid) return true;

              return false;
            },
            next: function (form, cb) {
              vm.questions2678.length = 0;

              for (var key in form) {
                if (form[key] === 1) {
                  vm.questions2678.push(key);
                }
              }

              if (vm.questions2678.length === 0) {
                vm.finish(cb);
              } else {
                cb(vm.tests.question2);
              }
            },
            prev: function (cb) {
              cb(vm.tests.question9);
            },
            isPrev: true,
            isNext: true
          },
          question2: {
            name: 'question2',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 12,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions2678.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              vm.questions345.length = 0;

              for (var key in form) {
                if (form[key] > 0) {
                  vm.questions345.push(key);
                }
              }

              if (vm.questions345.length === 0) {
                cb(vm.tests.question6);
              } else {
                cb(vm.tests.question3);
              }
            },
            prev: function (cb) {
              cb(vm.tests.question1);
            },
            isPrev: true,
            isNext: true
          },
          question3: {
            name: 'question3',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 25,
            questions: vm.questions345,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions345.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question4);
            },
            prev: function (cb) {
              cb(vm.tests.question2);
            },
            isPrev: true,
            isNext: true
          },
          question4: {
            name: 'question4',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 37,
            questions: vm.questions345,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions345.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question5);
            },
            prev: function (cb) {
              cb(vm.tests.question3);
            },
            isPrev: true,
            isNext: true
          },
          question5: {
            name: 'question5',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 50,
            questions: vm.questions345,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions345.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question6);
            },
            prev: function (cb) {
              cb(vm.tests.question4);
            },
            isPrev: true,
            isNext: true
          },
          question6: {
            name: 'question6',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 62,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions2678.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question7);
            },
            prev: function (cb) {
              if (vm.questions345.length === 0) {
                cb(vm.tests.question2);
              } else {
                cb(vm.tests.question5);
              }
            },
            isPrev: true,
            isNext: true
          },
          question7: {
            name: 'question7',
            template: vm.TEST_TEMPLATE_PATH + '/question2-7.template.html',
            readyPercentage: 75,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form && Object.keys(form).length === vm.questions2678.length) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              cb(vm.tests.question8);
            },
            prev: function (cb) {
              cb(vm.tests.question6);
            },
            isPrev: true,
            isNext: true
          },
          question8: {
            template: vm.TEST_TEMPLATE_PATH + '/question8.template.html',
            readyPercentage: 87,
            questions: vm.questions2678,
            isNextDisabled: function (form) {
              if (form) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              vm.save(cb);
            },
            prev: function (cb) {
              cb(vm.tests.question7);
            },
            isPrev: true,
            isNext: true
          },
          feedback: {
            template: vm.TEST_TEMPLATE_PATH + '/feedback.template.html',
            readyPercentage: 100,
            questions: [],
            isNextDisabled: function (form) {
              if (form) {
                return false;
              }

              return true;
            },
            next: function (form, cb) {
              vm.finish(cb);
            },
            prev: function (cb) {
              if (vm.questions2678.length === 0) {
                cb(vm.tests.question1);
              } else {
                cb(vm.tests.question8);
              }
            },
            nextEnabled: true,
            isPrev: true,
            isNext: true
          },
          end: {
            template: vm.TEST_TEMPLATE_PATH + '/end.template.html',
            readyPercentage: 100,
            questions: [],
            isPrev: false,
            isNext: false
          }
        };

        vm.firstTest = vm.tests.question9;
        vm.secondTest = vm.tests.question1;

        vm.save = function (cb) {
          var data = {
            tests: {},
            otherText: vm.secondTest.form.otherText ? vm.secondTest.form.otherText : '',
            location: $stateParams.location || ''
          };
          for (var key in vm.tests) {
            if (vm.tests[key].form) {
              data.tests[key] = { form: vm.tests[key].form };
            }
          }
          if (portalText.hostName == 'assist-knowyouroptions' || portalText.hostName == 'myeassist-knowyouroptions') {
            EAssistSurveyKnowYourOption.saveData(
              { data: data, portalName: portalText.hostName },
              saveDataCallBack,
              function (error) {
                NotificationService.error('Data acccess error', error);
              }
            );
          } else {
            EAssistSurvey.saveData(
              { data: data, portalName: portalText.hostName },
              saveDataCallBack,
              function (error) {
                NotificationService.error('Data acccess error', error);
              }
            );
          }


          function saveDataCallBack(survey) {
            var criteria = survey.result;
            vm.savedSurvey = survey;
            vm.results.criteria = criteria;
            vm.results.feedback = {
              briefAdvice: [],
              referralAdvice: [],
              moderateAdvice: []
            };

            for (var c in criteria) {
              var drugName = c,
                displayDrugName = (portalText.hostName == 'myeassist' || portalText.hostName == 'assist') && drugName == 'amphetamine' ? 'Amphetamine Type Stimulants' : drugName;

              if (drugName === 'alcoholic') {
                drugName = 'alcohol';
                displayDrugName = 'Alcoholic beverages';
              }
              if (drugName === 'tobacco') {
                displayDrugName = 'Tobacco products';
              }

              var feedback = AssistLiteService.feedback[drugName];
              if (!feedback) continue;

              var advice, content;


              if (c === 'alcoholic') {
                if (criteria[c] < 11 && criteria[c] > 0) {
                  advice = 'briefAdvice';
                } else if (criteria[c] >= 11 && criteria[c] <= 26) {
                  advice = 'moderateAdvice';
                }
              } else {
                if (criteria[c] < 4 && criteria[c] > 0) {
                  advice = 'briefAdvice';
                } else if (criteria[c] >= 4 && criteria[c] <= 26) {
                  advice = 'moderateAdvice';
                }
              }

              if (criteria[c] > 26) {
                advice = 'referralAdvice';
              }

              if (advice) {
                var result = {
                  drugName: drugName,
                  displayDrugName: displayDrugName,
                  advice: advice.replace('Advice', '')
                };

                if (c === 'other') {
                  result.substance = vm.secondTest.form.otherText;
                }

                if (c === 'alcoholic' || c === 'tobacco') {
                  var gender = 'male';//survey.result.info.gender;

                  result.content = feedback[advice][gender];
                  result.gender = gender;
                } else {
                  result.content = feedback[advice];
                }

                vm.results.feedback[advice].push(result);
              }

              advice = undefined;
            }
            cb(vm.tests.feedback);
          }
        }

        vm.finish = function (cb) {
          // for (var key in vm.tests) {
          //   delete vm.tests[key].form;
          // }

          cb(vm.tests.end);
        }
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'DeviceDetectService',
      function () {
        this.isTouch = function () {
          return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        }
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'AuthService',
      function (
        Authentication,
        $http, $stateParams, config) {

        this.resetPassword = function (email, successCb, errorCb) {
          Authentication.forgotPassword({email: email}, successCb, errorCb);
        };

        this.newPassword = function (password, token, successCb, errorCb) {
          $http.defaults.headers.common.authorization = token;
          Authentication.newPassword(
            { password: password },
            successCb,
            errorCb
          );
        };

        this.changePassword = function (oldPassword,
          newPassword,
          token,
          successCb,
          errorCb) {
          $http.defaults.headers.common.authorization = token;
          Authentication.changePassword(
            { oldPassword: oldPassword, newPassword: newPassword },
            successCb,
            errorCb
          );
        };

        this.setSocialLinks = function (social) {
          var queryString = '';

          if ($stateParams.returnTo && $stateParams.params) {
            queryString = '?returnTo=' + $stateParams.returnTo +
              '&params=' + $stateParams.params;
          }

          social.googleLoginLink = config.appBaseUrl + '/auth/google' + queryString;
          social.facebookLoginLink = config.appBaseUrl + '/auth/facebook' + queryString;
          social.linkedinLoginLink = config.appBaseUrl + '/auth/linkedin' + queryString;
        };

        this.linkedinAuth = function () {
          window.location.href = 'https://www.linkedin.com/oauth/v2/authorization'
            + '?response_type=code'
            + '&client_id=77bkixqhqz12lu'
            + '&redirect_uri=' + config.appBaseUrl + '/auth/linkedin/callback'
            + '&state=987654321'
            + '&scope=r_liteprofile%20r_emailaddress';
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .service(
      'AssistLiteService',
      function (
        config,
        AssistSurvey
      ) {
        var ASSIST_PARTIALS_PATH = 'app/components/assistLite/partials';

        var ASSIST_PARTIALS_FEEDBACK_PATH = config.ASSIST_PARTIALS_FEEDBACK_PATH;

        this.save = function (testData, phone, successCb, errorCb) {
          AssistSurvey.saveData(
            { data: { results: testData, phone: phone } },
            successCb,
            errorCb
          );
        };

        this.getLastTrial = function (clientId, successCb, errorCb) {
          return AssistSurvey.findOne({
            filter: {
              where: { clientId: clientId },
              order: "createdAt DESC"
            }
          }).$promise;
        };

        this.saveID = function (params, successCb, errorCb) {
          AssistSurvey.intro({ params: params }, successCb, errorCb);
        };

        this.emailParticipantReport = function (email, id, clientId, results) {
          return AssistSurvey.emailParticipantReport({
            email: email,
            id: id,
            clientId: clientId,
            results: results
          }).$promise;
        };

        this.hospitalCodes = {
          'Royal Adelaide Hospital:Emergency Department': 'nRAH321#@!',
          'Royal Adelaide Hospital:Ante-natal': 'nRAH321#@!',
          'Flinders Hospital:Emergency Department': 'Flinders321#@!',
          'Flinders Hospital:Ante-natal': 'Flinders321#@!'
        };

        this.trialCode = 12345;

        this.tests = [
          {
            name: 'Introduction',
            type: 'intro',
            isTest: false,
            testQuestions: {
              'hospital': {
                text: 'Hospital:',
                type: 'select',
                value: '',
                options: ['Royal Adelaide Hospital', 'Flinders Hospital']
              },
              'department': {
                text: 'Department:',
                type: 'select',
                value: '',
                options: ['Emergency Department', 'Ante-natal']
              },
              'hospitalCode': {
                text: 'Enter you hospital code:',
                type: 'text',
                value: ''
              },
              'userAgreement': {
                value: ''
              },
              'trialCode': {
                value: ''
              }
            }
          },
          {
            name: 'A Bit About You',
            userInfo: true,
            isTest: false,
            testQuestions: [
              {
                text: 'What is your gender?',
                type: 'radio',
                value: '',
                options: ['Male', 'Female']
              },
              {
                text: 'What is your age?',
                type: 'number-min',
                value: ''
              },
              {
                text: 'How are you mainly employed at the moment?',
                type: 'radio',
                value: '',
                options: [
                  'Not employed',
                  'Full time',
                  'Part time/casual',
                  'Student',
                  'Home duties'
                ]
              }
            ]
          },
          {
            name: 'Tobacco',
            isTest: true,
            feedbackParams: {
              'gender': true,
              'briefAdvice': 1,
              'moderateAdvice': 2,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '1. Did you smoke a cigarette containing tobacco?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '1a. Did you usually smoke more than 10 cigarettes each day?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '1b. Did you usually smoke within 30 minutes after waking?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Alcohol',
            isTest: true,
            feedbackParams: {
              'gender': true,
              'briefAdvice': 1,
              'moderateAdvice': 2,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '2. Did you have a drink containing alcohol? ',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '2a. On any occasion, did you drink more than 4 standard drinks of alcohol? *',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '2b. Have you tried and failed to control, cut down or stop drinking?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '2c. Has anyone expressed concern about your drinking?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Cannabis',
            isTest: true,
            feedbackParams: {
              'gender': false,
              'briefAdvice': 1,
              'moderateAdvice': 2,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '3. Did you use cannabis?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '3a. Have you had a strong desire or urge to use cannabis at least once a week or more often?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '3b. Has anyone expressed concern about your use of cannabis?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Stimulants',
            isTest: true,
            feedbackParams: {
              'gender': false,
              'subquestion': ['amphetamine', 'cocaine'],
              'briefAdvice': 1,
              'moderateAdvice': 2,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                text: '4. Did you use an amphetamine-type stimulant, or cocaine, or a stimulant medication not as prescribed?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '4a. Did you use a stimulant at least once each week or more often?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '4b. Has anyone expressed concern about your use of a stimulant?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Sedatives',
            feedbackParams: {
              'gender': false,
              'briefAdvice': 1,
              'moderateAdvice': 2,
              'referralAdvice': 3
            },
            advice: '',
            isTest: true,
            testQuestions: [
              {
                text: '5. Did you use a sedative or sleeping medication not as prescribed?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '5a. Have you had a strong desire or urge to use a sedative or sleeping medication at least once a week or more often?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '5b. Has anyone expressed concern about your use of a sedative or sleeping medication?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Opioids',
            isTest: true,
            feedbackParams: {
              'gender': false,
              'briefAdvice': 1,
              'moderateAdvice': 2,
              'referralAdvice': 3
            },
            advice: '',
            testQuestions: [
              {
                name: 'heroin',
                text: '6. Did you use a street opioid (e.g. heroin), or an opioid-containing medication not as prescribed?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: '6a. Have you tried and failed to control, cut down or stop using an opioid?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              },
              {
                text: '6b. Has anyone expressed concern about your use of an opioid?',
                type: 'radio',
                isDisabled: true,
                value: '',
                options: ['Yes', 'No']
              }
            ]
          },
          {
            name: 'Other',
            isTest: false,
            testQuestions: [
              {
                text: 'Did you use any other psychoactive altering substance?',
                type: 'radio',
                value: '',
                options: ['Yes', 'No'],
                toggleOtherQuestions: true
              },
              {
                text: 'What did you take?',
                type: 'text',
                isDisabled: true,
                value: ''
              }
            ]
          }
        ];

        this.feedback = {
          'tobacco': {
            'briefAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.brief.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.brief.partial.html'
            },
            'referralAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.referral.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.referral.partial.html'
            },
            'moderateAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.male.moderate.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/tobacco.female.moderate.partial.html'
            }
          },
          'alcohol': {
            'briefAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.brief.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.brief.partial.html'
            },
            'referralAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.referral.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.referral.partial.html'
            },
            'moderateAdvice': {
              'male': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.male.moderate.partial.html',
              'female': ASSIST_PARTIALS_FEEDBACK_PATH + '/alcohol.female.moderate.partial.html'
            }
          },
          'cannabis': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cannabis.moderate.partial.html'
          },
          'amphetamine': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/amphetamine.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/amphetamine.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/amphetamine.moderate.partial.html'
          },
          'cocaine': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/cocaine.moderate.partial.html'
          },
          'inhalants': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/inhalants.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/inhalants.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/inhalants.moderate.partial.html'
          },
          'hallucinogens': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/hallucinogens.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/hallucinogens.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/hallucinogens.moderate.partial.html'
          },
          'sedatives': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/sedatives.moderate.partial.html'
          },
          'opioids': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/opioids.moderate.partial.html'
          },
          'other': {
            'briefAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.brief.partial.html',
            'referralAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.referral.partial.html',
            'moderateAdvice': ASSIST_PARTIALS_FEEDBACK_PATH + '/other.moderate.partial.html'
          }
        };

        this.getFeedback = function (tests) {
          var feedbacks = {
            briefAdvice: [],
            referralAdvice: [],
            moderateAdvice: []
          };
          var userInfo = _.find(tests, function (test) {
            return test.userInfo;
          }).testQuestions;

          var gender = userInfo[0].value.toLowerCase();

          tests.forEach(function (test) {
            if (!test.isTest || !test.advice) return;

            if (test.feedbackParams.subquestion) {
              test.feedbackParams.subquestion.forEach(function (question) {
                var feedback = {};
                feedback.name = question.toLowerCase();
                feedback.drugName = question.toLowerCase();
                feedback.content = this.feedback[feedback.name][test.advice];
                feedbacks[test.advice].push(feedback);
              }, this);
              return;
            }

            var feedback = {};
            feedback.name = test.name.toLowerCase();
            feedback.drugName = test.name.toLowerCase();
            feedback.displayDrugName = test.name.toLowerCase() == 'amphetamine' ? 'Stimulants' : test.name.toLowerCase();

            if (test.feedbackParams.gender) {
              feedback.content = this.feedback[feedback.name][test.advice][gender];
            } else {
              feedback.content = this.feedback[feedback.name][test.advice];
            }

            feedbacks[test.advice].push(feedback);
          }, this);

          return feedbacks;
        };
      });
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(userExistsRoute);

  function userExistsRoute($stateProvider, $urlRouterProvider) {
    var USER_EXISTS_PATH = 'app/components/auth/user-exists';

    $stateProvider
      .state('guest.user-exists', {
        url: '/user-exists?returnTo&{params:json}',
        templateUrl: USER_EXISTS_PATH + '/userExists.template.html',
        controller: 'UserExists.Controller',
        controllerAs: 'vm',
        data: {
          redirectStrategy: 'user'
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(settingsRoute);

  function settingsRoute($stateProvider, $urlRouterProvider) {
    var SETTINGS_PATH = 'app/components/settings';

    $stateProvider
      .state('user.settings', {
        url: '/settings?error&mfa',
        templateUrl: SETTINGS_PATH + '/index/settings.index.template.html',
        controller: 'Settings.Index.Controller',
        controllerAs: 'settingsCtrl',
        data: {
          redirectStrategy: 'user'
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(authRoute);

  function authRoute($stateProvider, $urlRouterProvider) {
    var REPORT_PATH = 'app/components/report';

    $stateProvider
      .state('user.report', {
        url: '/report',
        templateUrl: REPORT_PATH + '/report.template.html',
        controller: 'Report.Controller',
        controllerAs: 'reportCtrl',
        resolve: {
          User: ['WineUser', function (WineUser) {
            return WineUser.findById({ id: WineUser.getCurrentId() }).$promise;
          }]
        },
        data: {
          redirectStrategy: 'user'
        }
      })
      .state('user.learningReport', {
        url: '/report-learning',
        templateUrl: REPORT_PATH + '/report-learning.template.html',
        controller: 'ReportLearning.Controller',
        controllerAs: 'reportCtrl',
        data: {
          redirectStrategy: 'user'
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(policyRoute);

  function policyRoute($stateProvider, $urlRouterProvider) {
    var POLICY_PATH = 'app/components/auth/policy';

    $stateProvider
      .state('guest.policy', {
        url: '/policy?returnTo&{params:json}',
        templateUrl: POLICY_PATH + '/policy.template.html',
        controller: 'Policy.Controller',
        controllerAs: 'policyCtrl',
        data: {
          redirectStrategy: 'user'
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(mydiaryRoute);

  function mydiaryRoute($stateProvider, $urlRouterProvider) {
    var MYDIARY_PATH = 'app/components/mydiary';

    $stateProvider
      .state('user.mydiary', {
        url: '/mydiary',
        templateUrl: MYDIARY_PATH + '/mydiary.template.html',
        controller: 'Mydiary.Controller',
        controllerAs: 'mydiaryCtrl',
        data: {
          redirectStrategy: 'user'
        }
      });
  }
})();
(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(dashboardRoute);

  function dashboardRoute($stateProvider, $urlRouterProvider) {
    var LAYOUT_PATH = 'app/components/layout';

    $stateProvider
      .state('guest', {
        templateUrl: LAYOUT_PATH + '/guest/guest.layout.template.html',
        controller: 'Guest.Layout.Controller',
        controllerAs: 'layoutCtrl',
        data: {
          redirectStrategy: 'guest'
        }
      })
      .state('user', {
        templateUrl: LAYOUT_PATH + '/user/user.layout.template.html',
        controller: 'User.Layout.Controller',
        controllerAs: 'layoutCtrl',
        data: {
          redirectStrategy: 'user'
        },
        resolve: {
          settings: function ($rootScope, PortalSettingsService) {
            return PortalSettingsService.getSettings()
              .then(function(settings) {
                $rootScope.settings = settings;
                return settings;
              });
          }
        }
      });
  }
})();

(function () {
	'use strict';

	angular
		.module('assistApp')
		.config(eASSISTRoute);

	function eASSISTRoute($stateProvider, $urlRouterProvider) {
		var eASSIST_PATH = 'app/components/eASSIST';

		$stateProvider
			.state('user.eAssist', {
				url: '/eassist',
				templateUrl: eASSIST_PATH + '/eASSIST.template.html',
        controller: 'EAssist.Controller',
				controllerAs: 'assistCtrl'
			});
	}
})();
(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(authRoute);

  function authRoute($stateProvider, $urlRouterProvider) {
    var AUTH_PATH = 'app/components/auth';

    $stateProvider
      .state('guest.home', {
        url: '/?returnTo&params&error',
        templateUrl: AUTH_PATH + '/login/login.template.html',
        controller: 'Login.Controller',
        controllerAs: 'loginCtrl',
        data: {
          redirectStrategy: 'guest'
        }
      })
      .state('guest.password-reset', {
        url: '/password-reset',
        templateUrl: AUTH_PATH +
          '/password/reset/password.reset.template.html',
        controller: 'Password.Reset.Controller',
        controllerAs: 'passwordCtrl'
      })
      .state('guest.password-reset-info', {
        url: '/password-reset-info',
        templateUrl: AUTH_PATH +
          '/password/reset/password.reset.info.template.html'
      })
      .state('guest.password-new', {
        url: '/password-new?uid&accessToken',
        templateUrl: AUTH_PATH +
          '/password/new/password.new.template.html',
        controller: 'Password.New.Controller',
        controllerAs: 'passwordCtrl'
      })
      .state('guest.password-new-info', {
        url: '/password-new-info',
        templateUrl: AUTH_PATH +
          '/password/new/password.new.info.template.html'
      })
      .state('guest.login', {
        url: '/login?returnTo&params',
        templateUrl: AUTH_PATH + '/login/login.template.html',
        controller: 'Login.Controller',
        controllerAs: 'loginCtrl'
      })
      .state('guest.login-success', {
        url: '/login-success?{userId:int}&accessToken&{userExists:bool}&{verifiedPolicy:bool}&{is2Fa:bool}&returnTo&{params:json}',
        data: {
          redirectStrategy: 'guest.login-success'
        }
      })
      .state('guest.confirm-registration', {
        url: '/confirm-registration?token',
        controller: 'Confirm.Registration.Controller',
        controllerAs: 'vm',
        templateUrl: AUTH_PATH + '/confirm-registration/confirm-registration.template.html'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(assistLiteRoute);

  function assistLiteRoute($stateProvider, $urlRouterProvider) {
    var ASSIST_LITE__PATH = 'app/components/assistLite';

    $stateProvider
      .state('guest.assistLite', {
        url: '/eassist-lite-research',
        templateUrl: ASSIST_LITE__PATH + '/assistLite.template.html',
        controller: 'AssistLite.Controller',
        controllerAs: 'vm',
        data: {
          redirectStrategy: 'guest.eassist'
        }
      })
      .state('guest.assistSA', {
        url: '/e-assist-SA',
        templateUrl: ASSIST_LITE__PATH + '/eAssistSA/eAssistSA.template.html',
        controller: 'eAssistSA.Controller',
        controllerAs: 'assistSACtrl',
        data: {
          redirectStrategy: 'guest.eassist'
        }
      })
      .state('guest.eAssistLite', {
        url: '/eassist-lite?location',
        templateUrl: ASSIST_LITE__PATH + '/eAssistLite/eAssistLite.template.html',
        controller: 'eAssistLite.Controller',
        controllerAs: 'vm',
        data: {
          redirectStrategy: 'guest.eassist'
        }
      })
      .state('guest.eAssist', {
        url: '/e-assist?location',
        templateUrl: ASSIST_LITE__PATH + '/eAssist/eAssist.template.html',
        controller: 'EAssist.Controller',
        controllerAs: 'assistCtrl',
        data: {
          redirectStrategy: 'guest.eassist'
        }
      })
      .state('guest.myeAssist-signup', {
        url: '/mye-assist-signup',
        templateUrl: ASSIST_LITE__PATH + '/myeAssist/myeAssist-signup/myeAssist.signup.template.html',
        controller: 'MyeAssist.Signup.Controller',
        controllerAs: 'signupCtrl'
      })
      .state('guest.myeAssist-verified', {
        url: '/verified',
        templateUrl: ASSIST_LITE__PATH +
          '/myeAssist/myeAssist-signup/myeAssist.signup.verified.template.html',
        data: {
          redirectStrategy: 'guest.verified'
        }
      })
      .state('guest.myeAssist-confirm-email', {
        url: '/confirm-email',
        templateUrl: ASSIST_LITE__PATH +
          '/myeAssist/myeAssist-signup/myeAssist.signup.confirm-email.template.html'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(twoFaRoute);

  function twoFaRoute($stateProvider, $urlRouterProvider) {
    var TWO_FA_PATH = 'app/components/auth/2fa';

    $stateProvider
      .state('guest.2fa', {
        url: '/2fa?returnTo&{params:json}',
        templateUrl: TWO_FA_PATH + '/2fa.template.html',
        controller: '2FA.Controller',
        controllerAs: 'twofaCtrl',
        data: {
          redirectStrategy: 'user'
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .filter('formatText', function() {
      var URL_REGEX = /(https?:\/\/[^\s^<^\u00A0]+)/g;

      return function (input) {
        var filteredText = _.toString(input);

        if (!filteredText) {
          return '';
        }

        filteredText = filteredText.replace(/\n/g, function () {
          return ' <br />';
        });

        return filteredText.replace(URL_REGEX, function (url) {
          return '<a href="' + url + '" target=_blank>' + url + '</a>';
        });
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .filter('capitalize', function () {
      return function(input) {
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
      };
    });
})();
(function () {
  'use strict';

  angular
    .module('assistApp')
    .directive('slideToggle', function() {
      return {
        restrict: 'A',
        scope:{
          isOpen: "=slideToggle"
        },
        link: function(scope, element, attr) {
          var slideDuration = parseInt(attr.slideToggleDuration, 10) || 200;
          scope.$watch('isOpen', function(newVal,oldVal){
            if(newVal !== oldVal){
              element.stop().slideToggle(slideDuration);
            }
          });
        }
      };
    });
})();

(function () {
  'use strict';

  /**
   * Makes the `uib-accordion-group` element scroll to top on the
   * `shown.bs.collapse` event. We use it in bootstrap accordions, when the
   * user opens one of the accordion items this directive will scroll the
   * item to the top of the screen.
   */
  angular.module('assistApp')
    .directive('scrollTop', scrollTop);

  function scrollTop() {
    return {
      restrict: 'A',
      link: link
    };
  }

  function link(scope, element) {
    scope.collapsing = false;
    var jqElement = $(element);
    scope.$watch(function () {
      return jqElement.find('.panel-collapse').hasClass('collapsing');
    }, function (status) {
      if (scope.collapsing && !status) {
        if (jqElement.hasClass('panel-open')) {
          $('html,body').animate({
            scrollTop: jqElement.offset().top - 20
          }, 500);
        }
      }
      scope.collapsing = status;
    });
  }

})();
(function () {
    'use strict';

    angular
        .module('assistApp')
        .directive('ngConfirmMessage', [function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    element.on('click', function (e) {
                        var message = attrs.ngConfirmMessage || "Are you sure ?";
                        if (!confirm(message)) {
                            e.stopImmediatePropagation();
                        }
                    });
                }
            }
        }]);
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .directive('limitToMax', function () {
      return {
        link: function (scope, element, attributes) {
          element.on("keydown keyup", function (e) {
            if (Number(element.val()) > Number(attributes.max) &&
              e.keyCode != 46 // delete
              &&
              e.keyCode != 8 // backspace
            ) {
              e.preventDefault();
              element.val(attributes.max);
            }
          });
        }
      };
    });
})();
(function () {
  'use strict';

  angular.module('assistApp')
    .directive('wineContenteditable', function ($window) {
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {

          function read() {
            ngModel.$setViewValue(element.html());
          }

          ngModel.$render = function() {
            element.html(ngModel.$viewValue || "");
          };

          element.bind("blur keyup change", function() {
            scope.$apply(read);
          });

          element.bind('paste', function (e) {
            e.preventDefault();
            var content;

            if (window.clipboardData) {
              content = $window.clipboardData.getData('Text');
            }

            if (e.originalEvent.clipboardData) {
              content = e.originalEvent.clipboardData.getData('text/plain');
            }

            document.execCommand("insertText", false, content);
            ngModel.$setViewValue(content)
          })
        }
      };
    });
})();
(function () {
  'use strict';

  // TODO: move html to directive
  angular
    .module('assistApp')
    .directive('collapseContent', function($timeout) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var collapseOverview = parseInt(attrs.collapseOverview);
          var collapseSkills = parseInt(attrs.collapseSkills);
          var overviewContainer = element.find('.overview-container');
          var overviewSkills = element.find('.skills-container');

          $timeout(function () {
            if (overviewContainer.innerHeight() > collapseOverview) {
              element.addClass('is-collapsible is-collapsed text');
              overviewContainer.addClass('is-collapsed');
            }

            if (overviewSkills.innerHeight() > collapseSkills) {
              element.addClass('is-collapsible is-collapsed skills');
              overviewSkills.addClass('is-collapsed');
            }
          }, 0, false);

          angular.element('.read-more').on('click', function () {
            if(element.hasClass('text')) overviewContainer.toggleClass('is-collapsed');
            if(element.hasClass('skills')) overviewSkills.toggleClass('is-collapsed');
            if(element.hasClass('skills') || element.hasClass('text'))
              element.toggleClass('is-collapsed');
          });
        }
      };
    });
})();

angular
  .module('assistApp')
  .directive('clickOutside', function($document){
  return {
    restrict: 'A',
    link: function(scope, elem, attr) {
      $document.on('click', function (e) {
        if (elem !== e.target && !elem[0].contains(e.target)) {
          scope.$apply(function () {
            scope.$eval(attr.clickOutside);
          });
        }
      });
    }
  }
});
angular.module("config", [])

.constant("config", {
	"apiBaseUrl": "https://dev.eassist.opentute.com/api",
	"appBaseUrl": "https://dev.eassist.opentute.com",
	"gRecaptchaPublicKey": "6LfqbiATAAAAAGajZUyZ4BrDoXEQ8hOcVpCF_XDc",
	"debug": true,
	"ASSIST_PARTIALS_FEEDBACK_PATH": "app/components/assistLite/partials/assist-feedback"
})

;
// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.AppSetting
 * @header lbServices.AppSetting
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AppSetting` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AppSetting",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AppSettings/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.AppSetting#getAppConfig
             * @methodOf lbServices.AppSetting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `appName` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppSetting` object.)
             * </em>
             */
            "getAppConfig": {
              url: urlBase + "/AppSettings/getAppConfig",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppSetting#getEmploymentTypes
             * @methodOf lbServices.AppSetting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `appName` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppSetting` object.)
             * </em>
             */
            "getEmploymentTypes": {
              isArray: true,
              url: urlBase + "/AppSettings/getEmploymentTypes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppSetting#getGenderOptions
             * @methodOf lbServices.AppSetting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `appName` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppSetting` object.)
             * </em>
             */
            "getGenderOptions": {
              isArray: true,
              url: urlBase + "/AppSettings/getGenderOptions",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AppSetting#modelName
        * @propertyOf lbServices.AppSetting
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AppSetting`.
        */
        R.modelName = "AppSetting";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.WineUser
 * @header lbServices.WineUser
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `WineUser` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "WineUser",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/WineUsers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.WineUser#create
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/WineUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#upsert
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/WineUsers",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#replaceOrCreate
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/WineUsers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#upsertWithWhere
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/WineUsers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#exists
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/WineUsers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#findById
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/WineUsers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#replaceById
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/WineUsers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#find
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/WineUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#findOne
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/WineUsers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#updateAll
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/WineUsers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#deleteById
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/WineUsers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#count
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/WineUsers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#prototype$updateAttributes
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - WineUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/WineUsers/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#createChangeStream
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/WineUsers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#login
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/WineUsers/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#logout
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/WineUsers/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#confirm
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/WineUsers/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#resetPassword
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/WineUsers/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#verify2Fa
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * User to verify 2FA.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - User id
             *
             *  - `otp` – `{string}` - otp code
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "verify2Fa": {
              url: urlBase + "/WineUsers/verify2Fa/:id/:otp",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#updateMainAttributes
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Updates current user properties.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number=}` -
             *
             *  - `attributes` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "updateMainAttributes": {
              url: urlBase + "/WineUsers/updateMainAttributes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#deleteAccount
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "deleteAccount": {
              url: urlBase + "/WineUsers/deleteAccount",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#deleteUserAccount
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "deleteUserAccount": {
              url: urlBase + "/WineUsers/deleteUserAccount",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#createAccount
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `user` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "createAccount": {
              url: urlBase + "/WineUsers/createAccount",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#sendConfirmationEmail
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "sendConfirmationEmail": {
              url: urlBase + "/WineUsers/sendConfirmationEmail",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#changeEmail
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "changeEmail": {
              url: urlBase + "/WineUsers/changeEmail",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#confirmNewEmail
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `token` – `{string}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "confirmNewEmail": {
              url: urlBase + "/WineUsers/confirmNewEmail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#invitePersons
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `personsArray` – `{*}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "invitePersons": {
              isArray: true,
              url: urlBase + "/WineUsers/invitePersons",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#confirmRegistration
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Completes registration of invited user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "confirmRegistration": {
              url: urlBase + "/WineUsers/confirmRegistration",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#getByConfirmationToken
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Returns user by confirmation token if exists.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `token` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "getByConfirmationToken": {
              url: urlBase + "/WineUsers/getByConfirmationToken",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#getAdmin
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "getAdmin": {
              url: urlBase + "/WineUsers/getAdmin",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#checkEmail
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Checks if email is available.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "checkEmail": {
              url: urlBase + "/WineUsers/checkEmail",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#verifyPolicy
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "verifyPolicy": {
              url: urlBase + "/WineUsers/verifyPolicy",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#resendInvitation
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Resend invite to unconfirmed user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "resendInvitation": {
              url: urlBase + "/WineUsers/resendInvitation",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#resendInvitations
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Resends invitations to unconfirmed users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "resendInvitations": {
              url: urlBase + "/WineUsers/resendInvitations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#getQRCode
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * User to get 2FA QR code.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "getQRCode": {
              url: urlBase + "/WineUsers/getQRCode/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#validateOTP
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * User to validate OTP for 2FA.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` - user id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "validateOTP": {
              url: urlBase + "/WineUsers/validateOTP/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#createMany
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/WineUsers",
              method: "POST",
            },

            // INTERNAL. Use EAssistSurvey.user() instead.
            "::get::EAssistSurvey::user": {
              url: urlBase + "/EAssistSurveys/:id/user",
              method: "GET",
            },

            // INTERNAL. Use EAssistSurveyKnowYourOption.user() instead.
            "::get::EAssistSurveyKnowYourOption::user": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use EAssistLiteSurvey.user() instead.
            "::get::EAssistLiteSurvey::user": {
              url: urlBase + "/EAssistLiteSurveys/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.WineUser#getCurrent
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/WineUsers" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.WineUser#patchOrCreate
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.WineUser#updateOrCreate
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.WineUser#patchOrCreateWithWhere
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.WineUser#update
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.WineUser#destroyById
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.WineUser#removeById
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.WineUser#prototype$patchAttributes
             * @methodOf lbServices.WineUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - WineUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.WineUser#getCachedCurrent
         * @methodOf lbServices.WineUser
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.WineUser#login} or
         * {@link lbServices.WineUser#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A WineUser instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.WineUser#isAuthenticated
         * @methodOf lbServices.WineUser
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.WineUser#getCurrentId
         * @methodOf lbServices.WineUser
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.WineUser#modelName
        * @propertyOf lbServices.WineUser
        * @description
        * The name of the model represented by this $resource,
        * i.e. `WineUser`.
        */
        R.modelName = "WineUser";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PushToken
 * @header lbServices.PushToken
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PushToken` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PushToken",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/PushTokens/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PushToken#deleteToken
             * @methodOf lbServices.PushToken
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `type` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PushToken` object.)
             * </em>
             */
            "deleteToken": {
              url: urlBase + "/PushTokens/:type",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PushToken#createToken
             * @methodOf lbServices.PushToken
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `type` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PushToken` object.)
             * </em>
             */
            "createToken": {
              url: urlBase + "/PushTokens/:type",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.PushToken#modelName
        * @propertyOf lbServices.PushToken
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PushToken`.
        */
        R.modelName = "PushToken";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Reminder
 * @header lbServices.Reminder
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Reminder` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Reminder",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Reminders/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Reminder#getList
             * @methodOf lbServices.Reminder
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Reminder` object.)
             * </em>
             */
            "getList": {
              isArray: true,
              url: urlBase + "/Reminders",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Reminder#deleteReminder
             * @methodOf lbServices.Reminder
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `type` – `{string}` - possible values "assistcheckup" or "dairy"
             *
             *  - `appName` – `{string}` - possible values "eassist" or "eassistlite"
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Reminder` object.)
             * </em>
             */
            "deleteReminder": {
              url: urlBase + "/Reminders",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Reminder#createReminder
             * @methodOf lbServices.Reminder
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `type` – `{string}` - possible values "assistcheckup" or "dairy"
             *
             *  - `appName` – `{string}` - possible values "eassist" or "eassistlite"
             *
             *  - `isActive` – `{boolean}` -
             *
             *  - `time` – `{string}` -
             *
             *  - `timezone` – `{string}` -
             *
             *  - `frequency` – `{object}` - Filter defining fields and include - must be a JSON-encoded string ({"units":"minute/hour/days/month/year"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Reminder` object.)
             * </em>
             */
            "createReminder": {
              url: urlBase + "/Reminders",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Reminder#modelName
        * @propertyOf lbServices.Reminder
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Reminder`.
        */
        R.modelName = "Reminder";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Authentication
 * @header lbServices.Authentication
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Authentication` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Authentication",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Authentications/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Authentication#forgotPassword
             * @methodOf lbServices.Authentication
             *
             * @description
             *
             * Sends password reset email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "forgotPassword": {
              url: urlBase + "/Authentications/forgotPassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Authentication#newPassword
             * @methodOf lbServices.Authentication
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `password` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` -
             */
            "newPassword": {
              url: urlBase + "/Authentications/new-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Authentication#changePassword
             * @methodOf lbServices.Authentication
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{object=}` -
             */
            "changePassword": {
              url: urlBase + "/Authentications/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Authentication#currentUser
             * @methodOf lbServices.Authentication
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` -
             */
            "currentUser": {
              url: urlBase + "/Authentications/current-user",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Authentication#modelName
        * @propertyOf lbServices.Authentication
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Authentication`.
        */
        R.modelName = "Authentication";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AssistSurvey
 * @header lbServices.AssistSurvey
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AssistSurvey` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AssistSurvey",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AssistSurveys/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.AssistSurvey#saveData
             * @methodOf lbServices.AssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistSurvey` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/AssistSurveys/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurvey#report
             * @methodOf lbServices.AssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistSurvey` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/AssistSurveys/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurvey#downloadParticipantReportCSV
             * @methodOf lbServices.AssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `clientId` – `{string}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportCSV": {
              url: urlBase + "/AssistSurveys/downloadParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurvey#emailParticipantReport
             * @methodOf lbServices.AssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `clientId` – `{string}` -
             *
             *  - `results` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "emailParticipantReport": {
              url: urlBase + "/AssistSurveys/emailParticipantReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurvey#getSummaryResultsCSV
             * @methodOf lbServices.AssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getSummaryResultsCSV": {
              url: urlBase + "/AssistSurveys/summaryResultsCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurvey#getIndividualAnswersCSV
             * @methodOf lbServices.AssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/AssistSurveys/individualAnswersCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurvey#intro
             * @methodOf lbServices.AssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             *
             *  - `errorMessage` – `{string=}` -
             */
            "intro": {
              url: urlBase + "/AssistSurveys/intro",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AssistSurvey#modelName
        * @propertyOf lbServices.AssistSurvey
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AssistSurvey`.
        */
        R.modelName = "AssistSurvey";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EAssistSurvey
 * @header lbServices.EAssistSurvey
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EAssistSurvey` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EAssistSurvey",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/EAssistSurveys/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use EAssistSurvey.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/EAssistSurveys/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#saveData
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `portalName` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurvey` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/EAssistSurveys/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#saveAppData
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `portalName` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurvey` object.)
             * </em>
             */
            "saveAppData": {
              url: urlBase + "/EAssistSurveys/saveAppData",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#findSurveys
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurvey` object.)
             * </em>
             */
            "findSurveys": {
              isArray: true,
              url: urlBase + "/EAssistSurveys/find_surveys",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#findAppSurveys
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurvey` object.)
             * </em>
             */
            "findAppSurveys": {
              isArray: true,
              url: urlBase + "/EAssistSurveys/findAppSurveys",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#report
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurvey` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/EAssistSurveys/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#downloadParticipantReportCSV
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportCSV": {
              url: urlBase + "/EAssistSurveys/downloadParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#downloadAllParticipantReportCSV
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadAllParticipantReportCSV": {
              url: urlBase + "/EAssistSurveys/downloadAllParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#downloadFeedbackPdf
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `results` – `{object}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadFeedbackPdf": {
              url: urlBase + "/EAssistSurveys/downloadFeedbackPdf",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#downloadAppFeedbackPdf
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadAppFeedbackPdf": {
              url: urlBase + "/EAssistSurveys/downloadAppFeedbackPdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#downloadParticipantReportPdf
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `results` – `{object}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportPdf": {
              url: urlBase + "/EAssistSurveys/downloadParticipantReportPdf",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#downloadAppParticipantReportPdf
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadAppParticipantReportPdf": {
              url: urlBase + "/EAssistSurveys/downloadAppParticipantReportPdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#emailParticipantReport
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `results` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "emailParticipantReport": {
              url: urlBase + "/EAssistSurveys/emailParticipantReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#appEmailParticipantReport
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "appEmailParticipantReport": {
              url: urlBase + "/EAssistSurveys/appEmailParticipantReport",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#getSummaryResultsCSV
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getSummaryResultsCSV": {
              url: urlBase + "/EAssistSurveys/summaryResultsCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#getIndividualAnswersCSV
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/EAssistSurveys/individualAnswersCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#getSurveyQuestions
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurvey` object.)
             * </em>
             */
            "getSurveyQuestions": {
              url: urlBase + "/EAssistSurveys/getSurveyQuestions",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.EAssistSurvey#modelName
        * @propertyOf lbServices.EAssistSurvey
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EAssistSurvey`.
        */
        R.modelName = "EAssistSurvey";


            /**
             * @ngdoc method
             * @name lbServices.EAssistSurvey#user
             * @methodOf lbServices.EAssistSurvey
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EAssistSurvey id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("WineUser");
          var action = TargetResource["::get::EAssistSurvey::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EAssistSurveyKnowYourOption
 * @header lbServices.EAssistSurveyKnowYourOption
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EAssistSurveyKnowYourOption` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EAssistSurveyKnowYourOption",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/EAssistSurveyKnowYourOptions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use EAssistSurveyKnowYourOption.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#saveData
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `portalName` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurveyKnowYourOption` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#findSurveys
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurveyKnowYourOption` object.)
             * </em>
             */
            "findSurveys": {
              isArray: true,
              url: urlBase + "/EAssistSurveyKnowYourOptions/find_surveys",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#report
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistSurveyKnowYourOption` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#downloadParticipantReportCSV
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportCSV": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/downloadParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#downloadAllParticipantReportCSV
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadAllParticipantReportCSV": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/downloadAllParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#downloadFeedbackPdf
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `results` – `{object}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadFeedbackPdf": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/downloadFeedbackPdf",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#downloadParticipantReportPdf
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `results` – `{object}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportPdf": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/downloadParticipantReportPdf",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#emailParticipantReport
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `results` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "emailParticipantReport": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/emailParticipantReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#getSummaryResultsCSV
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getSummaryResultsCSV": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/summaryResultsCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#getIndividualAnswersCSV
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/EAssistSurveyKnowYourOptions/individualAnswersCSV",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.EAssistSurveyKnowYourOption#modelName
        * @propertyOf lbServices.EAssistSurveyKnowYourOption
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EAssistSurveyKnowYourOption`.
        */
        R.modelName = "EAssistSurveyKnowYourOption";


            /**
             * @ngdoc method
             * @name lbServices.EAssistSurveyKnowYourOption#user
             * @methodOf lbServices.EAssistSurveyKnowYourOption
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EAssistSurveyKnowYourOption id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("WineUser");
          var action = TargetResource["::get::EAssistSurveyKnowYourOption::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AssistSurveySA
 * @header lbServices.AssistSurveySA
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AssistSurveySA` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AssistSurveySA",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AssistSurveySAs/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#saveData
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistSurveySA` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/AssistSurveySAs/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#findSurveys
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistSurveySA` object.)
             * </em>
             */
            "findSurveys": {
              isArray: true,
              url: urlBase + "/AssistSurveySAs/find_surveys",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#report
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistSurveySA` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/AssistSurveySAs/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#downloadParticipantReportCSV
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportCSV": {
              url: urlBase + "/AssistSurveySAs/downloadParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#downloadAllParticipantReportCSV
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadAllParticipantReportCSV": {
              url: urlBase + "/AssistSurveySAs/downloadAllParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#emailParticipantReport
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `results` – `{object}` -
             *
             *  - `comparison` – `{object}` -
             *
             *  - `intro` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "emailParticipantReport": {
              url: urlBase + "/AssistSurveySAs/emailParticipantReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#getSummaryResultsCSV
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getSummaryResultsCSV": {
              url: urlBase + "/AssistSurveySAs/summaryResultsCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistSurveySA#getIndividualAnswersCSV
             * @methodOf lbServices.AssistSurveySA
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/AssistSurveySAs/individualAnswersCSV",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AssistSurveySA#modelName
        * @propertyOf lbServices.AssistSurveySA
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AssistSurveySA`.
        */
        R.modelName = "AssistSurveySA";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AssistAboriginal
 * @header lbServices.AssistAboriginal
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AssistAboriginal` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AssistAboriginal",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AssistAboriginals/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#saveData
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `uuid` – `{string}` -
             *
             *  - `duration` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginal` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/AssistAboriginals/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#findSurvey
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uuid` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginal` object.)
             * </em>
             */
            "findSurvey": {
              url: urlBase + "/AssistAboriginals/find_survey",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#report
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginal` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/AssistAboriginals/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#downloadParticipantReportCSV
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportCSV": {
              url: urlBase + "/AssistAboriginals/downloadParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#downloadFeedbackPdf
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadFeedbackPdf": {
              url: urlBase + "/AssistAboriginals/downloadFeedbackPdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#isEnabledPilot
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginal` object.)
             * </em>
             */
            "isEnabledPilot": {
              url: urlBase + "/AssistAboriginals/isEnabledPilot",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#downloadParticipantReportPdf
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportPdf": {
              url: urlBase + "/AssistAboriginals/downloadParticipantReportPdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#emailParticipantReport
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "emailParticipantReport": {
              url: urlBase + "/AssistAboriginals/emailParticipantReport",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#getSummaryResultsCSV
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getSummaryResultsCSV": {
              url: urlBase + "/AssistAboriginals/summaryResultsCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginal#getIndividualAnswersCSV
             * @methodOf lbServices.AssistAboriginal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/AssistAboriginals/individualAnswersCSV",
              method: "GET",
            },

            // INTERNAL. Use AssistAboriginalFeedback.assistAboriginal() instead.
            "::get::AssistAboriginalFeedback::assistAboriginal": {
              url: urlBase + "/AssistAboriginalFeedbacks/:id/assistAboriginal",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AssistAboriginal#modelName
        * @propertyOf lbServices.AssistAboriginal
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AssistAboriginal`.
        */
        R.modelName = "AssistAboriginal";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AssistAboriginalFeedback
 * @header lbServices.AssistAboriginalFeedback
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AssistAboriginalFeedback` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AssistAboriginalFeedback",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AssistAboriginalFeedbacks/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AssistAboriginalFeedback.assistAboriginal() instead.
            "prototype$__get__assistAboriginal": {
              url: urlBase + "/AssistAboriginalFeedbacks/:id/assistAboriginal",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalFeedback#saveData
             * @methodOf lbServices.AssistAboriginalFeedback
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `uuid` – `{string}` -
             *
             *  - `duration` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalFeedback` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/AssistAboriginalFeedbacks/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalFeedback#report
             * @methodOf lbServices.AssistAboriginalFeedback
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalFeedback` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/AssistAboriginalFeedbacks/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalFeedback#getIndividualAnswersCSV
             * @methodOf lbServices.AssistAboriginalFeedback
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/AssistAboriginalFeedbacks/individualAnswersCSV",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AssistAboriginalFeedback#modelName
        * @propertyOf lbServices.AssistAboriginalFeedback
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AssistAboriginalFeedback`.
        */
        R.modelName = "AssistAboriginalFeedback";


            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalFeedback#assistAboriginal
             * @methodOf lbServices.AssistAboriginalFeedback
             *
             * @description
             *
             * Fetches belongsTo relation assistAboriginal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AssistAboriginalFeedback id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginal` object.)
             * </em>
             */
        R.assistAboriginal = function() {
          var TargetResource = $injector.get("AssistAboriginal");
          var action = TargetResource["::get::AssistAboriginalFeedback::assistAboriginal"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AssistAboriginalPilot
 * @header lbServices.AssistAboriginalPilot
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AssistAboriginalPilot` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AssistAboriginalPilot",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AssistAboriginalPilots/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#findByParticipantId
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `participantId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalPilot` object.)
             * </em>
             */
            "findByParticipantId": {
              url: urlBase + "/AssistAboriginalPilots/findByParticipantId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#saveData
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `uuid` – `{string}` -
             *
             *  - `duration` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalPilot` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/AssistAboriginalPilots/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#findSurvey
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uuid` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalPilot` object.)
             * </em>
             */
            "findSurvey": {
              url: urlBase + "/AssistAboriginalPilots/find_survey",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#report
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalPilot` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/AssistAboriginalPilots/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#downloadParticipantReportCSV
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportCSV": {
              url: urlBase + "/AssistAboriginalPilots/downloadParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#downloadFeedbackPdf
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadFeedbackPdf": {
              url: urlBase + "/AssistAboriginalPilots/downloadFeedbackPdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#downloadParticipantReportPdf
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportPdf": {
              url: urlBase + "/AssistAboriginalPilots/downloadParticipantReportPdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#emailParticipantReport
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "emailParticipantReport": {
              url: urlBase + "/AssistAboriginalPilots/emailParticipantReport",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#getSummaryResultsCSV
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getSummaryResultsCSV": {
              url: urlBase + "/AssistAboriginalPilots/summaryResultsCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilot#getIndividualAnswersCSV
             * @methodOf lbServices.AssistAboriginalPilot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/AssistAboriginalPilots/individualAnswersCSV",
              method: "GET",
            },

            // INTERNAL. Use AssistAboriginalPilotFeedback.assistAboriginalPilot() instead.
            "::get::AssistAboriginalPilotFeedback::assistAboriginalPilot": {
              url: urlBase + "/AssistAboriginalPilotFeedbacks/:id/assistAboriginalPilot",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AssistAboriginalPilot#modelName
        * @propertyOf lbServices.AssistAboriginalPilot
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AssistAboriginalPilot`.
        */
        R.modelName = "AssistAboriginalPilot";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AssistAboriginalPilotFeedback
 * @header lbServices.AssistAboriginalPilotFeedback
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AssistAboriginalPilotFeedback` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AssistAboriginalPilotFeedback",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AssistAboriginalPilotFeedbacks/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AssistAboriginalPilotFeedback.assistAboriginalPilot() instead.
            "prototype$__get__assistAboriginalPilot": {
              url: urlBase + "/AssistAboriginalPilotFeedbacks/:id/assistAboriginalPilot",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilotFeedback#saveData
             * @methodOf lbServices.AssistAboriginalPilotFeedback
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `uuid` – `{string}` -
             *
             *  - `duration` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalPilotFeedback` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/AssistAboriginalPilotFeedbacks/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilotFeedback#report
             * @methodOf lbServices.AssistAboriginalPilotFeedback
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalPilotFeedback` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/AssistAboriginalPilotFeedbacks/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilotFeedback#getIndividualAnswersCSV
             * @methodOf lbServices.AssistAboriginalPilotFeedback
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/AssistAboriginalPilotFeedbacks/individualAnswersCSV",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AssistAboriginalPilotFeedback#modelName
        * @propertyOf lbServices.AssistAboriginalPilotFeedback
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AssistAboriginalPilotFeedback`.
        */
        R.modelName = "AssistAboriginalPilotFeedback";


            /**
             * @ngdoc method
             * @name lbServices.AssistAboriginalPilotFeedback#assistAboriginalPilot
             * @methodOf lbServices.AssistAboriginalPilotFeedback
             *
             * @description
             *
             * Fetches belongsTo relation assistAboriginalPilot.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AssistAboriginalPilotFeedback id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AssistAboriginalPilot` object.)
             * </em>
             */
        R.assistAboriginalPilot = function() {
          var TargetResource = $injector.get("AssistAboriginalPilot");
          var action = TargetResource["::get::AssistAboriginalPilotFeedback::assistAboriginalPilot"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EAssistLiteSurvey
 * @header lbServices.EAssistLiteSurvey
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EAssistLiteSurvey` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EAssistLiteSurvey",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/EAssistLiteSurveys/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use EAssistLiteSurvey.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/EAssistLiteSurveys/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#saveData
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistLiteSurvey` object.)
             * </em>
             */
            "saveData": {
              url: urlBase + "/EAssistLiteSurveys/save_data",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#saveAppData
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `portalName` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistLiteSurvey` object.)
             * </em>
             */
            "saveAppData": {
              url: urlBase + "/EAssistLiteSurveys/saveAppData",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#report
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistLiteSurvey` object.)
             * </em>
             */
            "report": {
              url: urlBase + "/EAssistLiteSurveys/report",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#downloadParticipantReportCSV
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportCSV": {
              url: urlBase + "/EAssistLiteSurveys/downloadParticipantReportCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#emailParticipantReport
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `results` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "emailParticipantReport": {
              url: urlBase + "/EAssistLiteSurveys/emailParticipantReport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#getSummaryResultsCSV
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getSummaryResultsCSV": {
              url: urlBase + "/EAssistLiteSurveys/summaryResultsCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#getIndividualAnswersCSV
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "getIndividualAnswersCSV": {
              url: urlBase + "/EAssistLiteSurveys/individualAnswersCSV",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#downloadFeedbackPdf
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `results` – `{object}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadFeedbackPdf": {
              url: urlBase + "/EAssistLiteSurveys/downloadFeedbackPdf",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#downloadParticipantReportPdf
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `results` – `{object}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "downloadParticipantReportPdf": {
              url: urlBase + "/EAssistLiteSurveys/downloadParticipantReportPdf",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#findAppSurveys
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistLiteSurvey` object.)
             * </em>
             */
            "findAppSurveys": {
              isArray: true,
              url: urlBase + "/EAssistLiteSurveys/findAppSurveys",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#getSurveyQuestions
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EAssistLiteSurvey` object.)
             * </em>
             */
            "getSurveyQuestions": {
              url: urlBase + "/EAssistLiteSurveys/getSurveyQuestions",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.EAssistLiteSurvey#modelName
        * @propertyOf lbServices.EAssistLiteSurvey
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EAssistLiteSurvey`.
        */
        R.modelName = "EAssistLiteSurvey";


            /**
             * @ngdoc method
             * @name lbServices.EAssistLiteSurvey#user
             * @methodOf lbServices.EAssistLiteSurvey
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EAssistLiteSurvey id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `WineUser` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("WineUser");
          var action = TargetResource["::get::EAssistLiteSurvey::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Diary
 * @header lbServices.Diary
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Diary` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Diary",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Diaries/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Diary#saveSliderValue
             * @methodOf lbServices.Diary
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `startDate` – `{string}` -
             *
             *  - `endDate` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `date` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "saveSliderValue": {
              url: urlBase + "/Diaries/save_sliderValue",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diary#getSubstancesWithCode
             * @methodOf lbServices.Diary
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diary` object.)
             * </em>
             */
            "getSubstancesWithCode": {
              isArray: true,
              url: urlBase + "/Diaries/getSubstancesWithCode",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diary#saveAppSliderValue
             * @methodOf lbServices.Diary
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `startDate` – `{string}` -
             *
             *  - `endDate` – `{string}` -
             *
             *  - `date` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diary` object.)
             * </em>
             */
            "saveAppSliderValue": {
              url: urlBase + "/Diaries/saveAppSliderValue",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diary#findDiary
             * @methodOf lbServices.Diary
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `startDate` – `{string=}` -
             *
             *  - `endDate` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diary` object.)
             * </em>
             */
            "findDiary": {
              isArray: true,
              url: urlBase + "/Diaries/find_diary",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Diary#modelName
        * @propertyOf lbServices.Diary
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Diary`.
        */
        R.modelName = "Diary";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.IpCounterPublic
 * @header lbServices.IpCounterPublic
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `IpCounterPublic` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "IpCounterPublic",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/IpCounterPublics/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.IpCounterPublic#recaptcha
             * @methodOf lbServices.IpCounterPublic
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `success` – `{boolean=}` -
             */
            "recaptcha": {
              url: urlBase + "/IpCounterPublics/recaptcha",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.IpCounterPublic#modelName
        * @propertyOf lbServices.IpCounterPublic
        * @description
        * The name of the model represented by this $resource,
        * i.e. `IpCounterPublic`.
        */
        R.modelName = "IpCounterPublic";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PortalSettings
 * @header lbServices.PortalSettings
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PortalSettings` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PortalSettings",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/PortalSettings/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PortalSettings#getSettings
             * @methodOf lbServices.PortalSettings
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalSettings` object.)
             * </em>
             */
            "getSettings": {
              url: urlBase + "/PortalSettings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalSettings#updateSettings
             * @methodOf lbServices.PortalSettings
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `settings` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalSettings` object.)
             * </em>
             */
            "updateSettings": {
              url: urlBase + "/PortalSettings",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.PortalSettings#modelName
        * @propertyOf lbServices.PortalSettings
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PortalSettings`.
        */
        R.modelName = "PortalSettings";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserPreference
 * @header lbServices.UserPreference
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserPreference` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserPreference",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/UserPreferences/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#setPreference
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "setPreference": {
              url: urlBase + "/UserPreferences",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserPreference#findPreferences
             * @methodOf lbServices.UserPreference
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `keys` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserPreference` object.)
             * </em>
             */
            "findPreferences": {
              url: urlBase + "/UserPreferences",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.UserPreference#modelName
        * @propertyOf lbServices.UserPreference
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserPreference`.
        */
        R.modelName = "UserPreference";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Migration
 * @header lbServices.Migration
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Migration` model.
 *
 * **Details**
 *
 * View and run pending migrations.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Migration",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Migrations/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Migration#create
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Migrations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#upsert
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Migrations",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#replaceOrCreate
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Migrations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#upsertWithWhere
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Migrations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#exists
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Migrations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#findById
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Migrations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#replaceById
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Migrations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#find
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Migrations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#findOne
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Migrations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#updateAll
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Migrations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#deleteById
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Migrations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#count
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Migrations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#prototype$updateAttributes
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Migration id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Migrations/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#createChangeStream
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Migrations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#migrateByName
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Run specific migration by name
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `name` – `{String}` - Name of the migration script to run.
             *
             *  - `record` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "migrateByName": {
              url: urlBase + "/Migrations/migrateByName",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Migration#createMany
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Migrations",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Migration#patchOrCreate
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Migration#updateOrCreate
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Migration#patchOrCreateWithWhere
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Migration#update
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Migration#destroyById
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Migration#removeById
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Migration#prototype$patchAttributes
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Migration id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Migration#modelName
        * @propertyOf lbServices.Migration
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Migration`.
        */
        R.modelName = "Migration";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.MigrationMap
 * @header lbServices.MigrationMap
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `MigrationMap` model.
 *
 * **Details**
 *
 * Migration Mappings.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "MigrationMap",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/MigrationMaps/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#create
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/MigrationMaps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#upsert
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/MigrationMaps",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#replaceOrCreate
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/MigrationMaps/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#upsertWithWhere
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/MigrationMaps/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#exists
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/MigrationMaps/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#findById
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/MigrationMaps/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#replaceById
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/MigrationMaps/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#find
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/MigrationMaps",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#findOne
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/MigrationMaps/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#updateAll
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/MigrationMaps/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#deleteById
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/MigrationMaps/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#count
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/MigrationMaps/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#prototype$updateAttributes
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - MigrationMap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/MigrationMaps/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#createChangeStream
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/MigrationMaps/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#createMany
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/MigrationMaps",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#patchOrCreate
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#updateOrCreate
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#patchOrCreateWithWhere
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#update
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#destroyById
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#removeById
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#prototype$patchAttributes
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - MigrationMap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
        R["prototype$patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.MigrationMap#modelName
        * @propertyOf lbServices.MigrationMap
        * @description
        * The name of the model represented by this $resource,
        * i.e. `MigrationMap`.
        */
        R.modelName = "MigrationMap";



        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

(function () {
  'use strict';

  angular
    .module('assistApp')
    .run(checkAuth)
    .run(initRootState)
    .run(authRedirection)
    .run(portalConfig)
    .run(detectBrowser)
    .run(detectTimezone)
    .run(initTranslate)
    .run(googleAnalytics);

  function checkAuth($cookies, LoopBackAuth) {
    var accessToken = $cookies.get('access_token');
    var userId = $cookies.get('userId');

    if (accessToken || userId) {
      LoopBackAuth.setUser(accessToken, userId, null);
      LoopBackAuth.rememberMe = true;
      LoopBackAuth.save();
    }
  }

  function initRootState($rootScope, $state) {
    $rootScope.$state = $state;
  }

  function portalConfig($rootScope, portalText) {
    $rootScope.portalText = portalText;
  }

  function authRedirection($cookies, $rootScope, RedirectService, WineUser, LoopBackAuth, $state, portalText) {
    $rootScope.$on(
      "$stateChangeStart",
      function (event, toState, toParams) {
        if (WineUser.isAuthenticated()) {
          $rootScope.User = WineUser.getCurrent();
          $rootScope.User.$promise.then(function () {
            var is2FARequired = localStorage.getItem('is2FARequired');
            if ($rootScope.User.$resolved && ($rootScope.User.is2FAEnable) &&
              is2FARequired && toState.name !== 'guest.2fa') {
              $state.go('guest.2fa', toParams);
            }
            if (
              $rootScope.User.$resolved && !$rootScope.User.verifiedPolicy &&
              toState.name !== 'guest.policy'
            ) {
              $state.go('guest.policy', toParams);
            } else if (
              $rootScope.User.verifiedPolicy &&
              toState.name === 'guest.policy'
            ) {
              if (portalText.hostName === 'myeassist') {
                $state.go('user.eAssist');
              } else {
                $state.go('user.report');
              }
            } else {
              if (RedirectService.authorized(toState, toParams)) {
                event.preventDefault();
                RedirectService.redirect(toState, toParams);
              }
            }
          }).catch(function (err) {
            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            $cookies.remove('access_token');
            $cookies.remove('userId');

            if (toState.name !== 'guest.verified') {
              $state.go('guest.home');
            }
          });
        } else {
          if ((portalText.hostName === 'assist-knowyouroptions' || portalText.hostName === 'myeassist-knowyouroptions') && toState.name !== 'guest.eAssist') {
            event.preventDefault();
            $state.go('guest.eAssist');
          }
          if (RedirectService.authorized(toState, toParams)) {
            event.preventDefault();
            RedirectService.redirect(toState, toParams);
          }

        }
      });
  }

  function detectBrowser(bowser, $rootScope) {
    $rootScope.unsupportedBrowser =
      (bowser.msie && bowser.version <= 10) ||
      (bowser.chrome && bowser.version <= 20) ||
      (bowser.chromium && bowser.version <= 20) ||
      (bowser.safari && bowser.version <= 5) ||
      (bowser.firefox && bowser.version <= 20) ||
      (bowser.opera && bowser.version < 10.0) ||
      (bowser.ios && bowser.osversion && bowser.osversion.split(".")[0] < 6);
  }

  function detectTimezone($cookies, moment) {
    var timezone = moment.tz.guess();

    $cookies.put("timezone", timezone);
  }
  function initTranslate(LanguageService) {
    LanguageService.refreshPortalLanguage();
  }

  function googleAnalytics(Analytics) { }
})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('assistApp')
    .constant('moment', moment)
    .constant(
      'passwordRegex',
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@$!%*?&])[A-Za-z\d#$@$!%*?&]{12,}$/
    )
    .constant(
      'passwordErrorMessage',
      'The minimum requirement is 6 characters, but we recommend a combination of uppercase and lowercase letters, with a number and a symbol.'
    );
})();

(function () {
  'use strict';

  angular
    .module('assistApp')
    .config(debug)
    .config(googleRecaptcha)
    .config(ngAnimateDisabled)
    .config(baseConfig)
    .config(fileUploader)
    .config(googleTagManager)
    .config(googleAnalytics);

  function googleRecaptcha(vcRecaptchaServiceProvider, config) {
    vcRecaptchaServiceProvider.setSiteKey(config.gRecaptchaPublicKey);
  }

  function debug($logProvider) {
    $logProvider.debugEnabled(false);
  }

  function fileUploader($provide) {
    $provide.decorator('FileSelect', function ($delegate) {
      $delegate.prototype.isEmptyAfterSelection = function () {
        return true;
      };

      return $delegate;
    });
  }

  function baseConfig(
    config,
    $urlRouterProvider,
    $logProvider,
    LoopBackResourceProvider,
    toastrConfig
  ) {
    $logProvider.debugEnabled(true);
    LoopBackResourceProvider.setAuthHeader('X-Access-Token');
    LoopBackResourceProvider.setUrlBase(config.apiBaseUrl);
    angular.extend(toastrConfig, {
      positionClass: 'toast-top-right',
      closeButton: true
    });
    $urlRouterProvider.otherwise('/');
  }

  function ngAnimateDisabled($animateProvider) {
    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
  }

  function googleTagManager($analyticsProvider) {
    $analyticsProvider.firstPageview(true); /* Records pages that don't use $state or $route */
    $analyticsProvider.withAutoBase(true);  /* Records full path */
  }

  function googleAnalytics(AnalyticsProvider, config) {
    var accountConfig = {
      tracker: config.googleAnalyticsCode,
      trackEvent: true
    };

    if (config.debug) {
      accountConfig.fields = {
        cookieDomain: 'none'
      };
    }

    AnalyticsProvider
      .setAccount(accountConfig)
      .trackPages(true)
      .trackUrlParams(true)
      .setCurrency('AUD')
      .setPageEvent('$stateChangeSuccess');
  }
})();

angular.module("assistApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/assistLite/assistLite.template.html","<div class=\"assistLite-content\"><div class=\"row\"><div class=\"col-md-8\"><form name=\"surveyForm\" class=\"survey-form\" novalidate=\"\" ng-submit=\"surveyForm.$valid && vm.submit(surveyForm)\"><div class=\"lite-popup\"><div ng-if=\"vm.isTest()\"><div class=\"assistTest\" ng-repeat=\"test in vm.tests\" ng-if=\"$index == vm.currentTestIndex\"><div ng-if=\"test.type == \'intro\'\"><div class=\"assist-section\"><h1 class=\"assist-title\">eASSIST Lite Research Project</h1></div><h2 class=\"assist-title\">PRINCIPAL INVESTIGATORS: Robert Ali, Linda Gowing</h2><div class=\"assist-section\"><p>Dear Participant,<br>You are invited to participate in the research project described below.</p><p><strong>What is the ASSIST - Lite project about?</strong><br>Questions will be asked about your experience of using alcohol, tobacco and other drugs in the past three months. We will give you some feedback on your scores and information that may help you to decide what (if any) action you may need to take. We will also ask you to re do the survey in three months time. All responses are confidential, and your honest responses are appreciated.</p><p><strong>Who is undertaking the project?</strong><br>This project is being conducted by University of Adelaide.</p><p><strong>Why am I being invited to participate?</strong><br>This research will form the basis for ongoing improvements to drug and alcohol interventions and support for people who attend the Emergency Department. We are seeking Australian residents aged over 18 to participate.</p><p><strong>What will I be asked to do?</strong><br>To participate, complete the survey on a computer tablet.</p><p><strong>How much time will the project take?</strong><br>The survey is expected to take between 5 and 10 minutes to complete.</p><p><strong>Are there any risks associated with participating in this project?</strong><br>Other than the inconvenience of giving up your time, it is not expected that participating in this survey will cause any discomfort or distress. If you do find that completing the survey brings up worries or concerns, we recommend utilising one of the following excellent resources:</p><ul><li><strong>BeyondBlue</strong>, 1300 22 4636 or <a href=\"www.beyondblue.org.au\">www.beyondblue.org.au</a>: advice and support for anxiety and depression</li><li><strong>Lifeline</strong>, 13 11 14 or <a href=\"www.lifeline.org.au\">www.lifeline.org.au</a>: crisis support and suicide prevention</li><li><strong>Alcohol and Drug Information Service</strong> 1300 131 340</li></ul><p>If you have any health-specific worries or questions, the best person to speak to is your doctor.</p><p><strong>What are the benefits of the research project?</strong><br>While participation provides no immediate benefit to you, it is our hope that this research will aid in the understanding of the ways people think about healthy behaviours.</p><p><strong>Can I withdraw from the project?</strong><br>Participation in this project is completely voluntary. You can stop completing the survey at any time by closing the browser window or tab. If you want to ensure that data you have already entered is deleted from our server, please contact Linda Gowing on (08) 8313 8055.</p><p><strong>Can I review my information?</strong><br>You can review the information you have entered and correct any information with which you disagree before you finally complete the questionnaire and submit your data.</p><p><strong>What will happen to my information?</strong><br>Survey data will be stored on the University of Adelaide secure server and only the researchers will have access. Contact details, i.e. your mobile number and/or email address will be stored in a separate database on the University of Adelaide secure server. We will not collect your name. The separate databases will be linked only by a common identification number. Only the researchers will have access to the data. Contact details will be accessed only for the purpose of follow-up. No individual participants or data will be identified in research articles and conference presentations arising from this research. Data will be destroyed after 7 years.</p><p>Researchers are not obliged to report unlawful behaviour that does not pose a threat to human safety. Occasionally, research data may be subpoenaed for scrutiny in criminal, common law, family court, coronial proceedings, professional disciplinary, or other legal investigations. As we will not record your name your data will be anonymous although there is a small risk that you could be identified from your mobile number or email address.</p><p><strong>Who do I contact if I have questions about the project?</strong><br>In the first instance, please contact: Linda Gowing on (08) 8313 8055.</p><p><strong>What if I have a complaint or any concerns?</strong><br>The study has been approved by the RAH Human Research Ethics committee. The study will be conducted according to the NHMRC National Statement on Ethical Conduct in Human Research, a document written to protect the rights of participants in research studies.</p><p>If you have questions or problems associated with the practical aspects of your participation in the project, or wish to raise a concern or complaint about the project, then you should consult Linda Gowing on 08 83138055.</p><p>If you wish to speak with an independent person regarding concerns or a complaint, the RAH policy on research involving human participants, or your rights as a participant contact A/Prof Andrew Thornton (Chair of the Human Research Ethics Committee) or Ms Heather O’Dea (Executive Officer) on phone 61 8 8222 4139 or by email to <a href=\"mailto:Health.CALHNResearchEthics@sa.gov.au\">Health.CALHNResearchEthics@sa.gov.au</a>. Any complaint or concern will be treated in confidence and fully investigated. You will be informed of the outcome.</p><p><strong>If I want to participate, what do I do?</strong><br>By ticking the box and clicking the \'Next\' button below, you indicate your consent to be included in our study, and the survey will begin.</p><p>Thank you for your participation.</p><p>Yours sincerely,</p><p>Assoc Professor Robert Ali & Assoc Professor Linda Gowing.<br>Discipline of Pharmacology<br>School of Medicine<br>University of Adelaide<br></p></div><div class=\"assist-section\"><h4>Instructions</h4><p>Please note this first screen should be completed in the presence of a hospital administrator, doctor or nurse. To complete the eASSIST Lite you will need to:</p><ol><li>Select the appropriate hospital (or location) and department from the dropdown options</li><li>Read and agree to the terms and conditions of the User Agreement</li><li>Select the box beside the agreement note</li><li>Enter the hospital code</li><li>Click the \'Next\' button to start</li></ol></div><div class=\"assist-section assist-form-fields form-group row\"><div class=\"col-md-12\"><input id=\"liteRepeat\" type=\"checkbox\" ng-change=\"vm.errors = {}\" ng-model=\"vm.introParams.isTrial\"> <label class=\"label-checkbox\" for=\"liteRepeat\"><span class=\"icon icon-checkbox\"></span>I participated in the RAH Trial and have a code.</label></div></div><div class=\"assist-section assist-form-fields form-group row\" ng-if=\"!vm.introParams.isTrial\"><div class=\"col-md-4\"><label>{{test.testQuestions.hospital.text}}</label></div><div class=\"col-md-5\"><ui-select theme=\"bootstrap\" class=\"assist-select\" name=\"hospital\" required=\"\" ng-change=\"vm.validateHospitalCode(surveyForm)\" ng-model=\"test.testQuestions.hospital.value\"><ui-select-match placeholder=\"Select hospital\"><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"hospital in test.testQuestions.hospital.options\"><span ng-bind=\"hospital\"></span></ui-select-choices></ui-select></div></div><div class=\"assist-section assist-form-fields form-group row\" ng-if=\"!vm.introParams.isTrial\"><div class=\"col-md-4\"><label>{{test.testQuestions.department.text}}</label></div><div class=\"col-md-5\"><ui-select theme=\"bootstrap\" class=\"assist-select\" name=\"department\" required=\"\" ng-change=\"vm.validateHospitalCode(surveyForm)\" ng-model=\"test.testQuestions.department.value\"><ui-select-match placeholder=\"Select department\"><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"department in test.testQuestions.department.options\"><span ng-bind=\"department\"></span></ui-select-choices></ui-select></div></div><div class=\"assist-section assist-form-fields form-group row\" ng-if=\"!vm.introParams.isTrial\" ng-class=\"{ \'has-error\': !surveyForm.hospitalCode.$valid && surveyForm.hospitalCode.$touched }\"><div class=\"col-md-4\"><label>Enter your hospital code:</label></div><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" name=\"hospitalCode\" placeholder=\"XXXXXXXXXX\" ng-change=\"vm.validateHospitalCode(surveyForm)\" ng-model=\"test.testQuestions.hospitalCode.value\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.hospitalCode.$valid && surveyForm.hospitalCode.$touched\"><span ng-show=\"surveyForm.hospitalCode.$error.required\">Field is required.</span> <span ng-show=\"!vm.dropdownSelected(surveyForm) && surveyForm.hospitalCode.$error.hospitalError && !surveyForm.hospitalCode.$error.required\">Please select from the dropdowns options above.</span> <span ng-show=\"vm.dropdownSelected(surveyForm) && surveyForm.hospitalCode.$error.hospitalError && !surveyForm.hospitalCode.$error.required\">Wrong code.</span></p></div></div><div class=\"assist-section assist-form-fields form-group row\" ng-class=\"{ \'has-error\': (!surveyForm.trialCode.$valid && surveyForm.trialCode.$touched) || vm.errors.clientId }\"><div class=\"col-md-4\"><label>Your RAH Trial code:</label></div><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" name=\"trialCode\" placeholder=\"Add your Unique ID\" ng-model=\"vm.introParams.clientId\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.trialCode.$valid && surveyForm.trialCode.$touched\"><span ng-show=\"surveyForm.trialCode.$error.required\">Field is required.</span></p><p class=\"text-danger error-message\" ng-show=\"vm.errors.clientId\">{{vm.errors.clientId}}</p></div></div><div class=\"assist-section assist-license\"><p><strong>Conditions of use of ASSIST Portal</strong></p><p><a href=\"http://assistportal.com.au\">ASSIST Portal</a> provides access to ASSIST and associated materials. In addition to the OpenTute User Agreement, the following terms and conditions (Terms of Use) apply to the use and access to <a href=\"http://assistportal.com.au\">ASSIST Portal</a>. In these Terms of Use, we or us means Adelaide Research & Innovation Pty Ltd, the commercialisation arm of the University of Adelaide and you means you, as an end user of <a href=\"http://assistportal.com.au\">ASSIST Portal</a>.</p><p>You acknowledge that you have read, understand, and agree to be legally bound by these Terms of Use together with the OpenTute User Agreement. We may amend these Terms of Use from time to time with the most updated version being provided on <a href=\"http://assistportal.com.au\">ASSIST Portal</a>. By continuing to use ASSIST Online you accept the amended Terms or Use.</p><ol><li><a href=\"http://assistportal.com.au\">ASSIST Portal</a> provides access to ASSIST and associated materials. ASSIST is a screening tool only and not a diagnostic tool. ASSIST has not been validated for use in people under 18 years of age. ASSIST provides a general indicator of risk due to substance use. You are responsible for determining the suitability or otherwise of ASSIST.</li><li>While \'low\', \'moderate\' and \'high\' risk scores give an indication of the appropriate level of intervention, they should be used in conjunction with clinical judgement. We take no responsibility for the outcome or consequences of using this tool.</li><li>Neither we nor any third party will be liable for any errors in ASSIST and information made available via <a href=\"http://assistportal.com.au\">ASSIST Portal</a>, or for any actions you take in reliance on ASSIST or information in <a href=\"http://assistportal.com.au\">ASSIST Portal</a>. Neither you nor any other person may hold us liable for any delays, inaccuracies, errors or omissions in respect of ASSIST Portal or the transmission or delivery of ASSIST via ASSIST Portal, or for any liability, loss or damage arising from any of them.</li><li>We may, at our discretion, remove, modify or update ASSIST or information in ASSIST Portal from time to time and without notice to you. Such updates include any modifications, enhancements, improvements, or revisions to ASSIST or information, including any updates to correct errors or to comply with changes to law or industry guidelines.</li><li>We grant you a limited, non-exclusive, non-transferrable licence to access and use ASSIST Portal subject to these Terms of Use.</li><li>You must not collect, use, duplicate, license, sublicense, publish, distribute, rebrand, sell or otherwise make available to any third party, in whole or in part the ASSIST Portal and any information, publications or other content published on or made available via ASSIST Portal except as permitted in these Terms of Use or as expressly authorised by us.</li><li>You agree that we may access, preserve, use and disclose your personal information if required to do so by law (or by any judicial or regulatory body), where expressly authorised by you, or where in good faith we believe that such access, preservation, use or disclosure is reasonably necessary in our opinion to:<ol><li>provide the Member Service;</li><li>respond to your enquiries;</li><li>enforce these Terms of Use;</li><li>comply with legal process, including but not limited to civil and criminal subpoenas, court orders or other compulsory disclosures; or</li><li>comply with required or commercially prudent record keeping practices.</li></ol></li><li>The University of Adelaide\'s Privacy Policy governs how we collect, use, handle and disclose any personal information you provide or disclose to us and forms part of these Terms of Use. You should carefully read and review our Privacy Policy in full before disclosing to us any personal information. Our Privacy Policy can be accessed at <a href=\"http://www.adelaide.edu.au/policies/62/\" target=\"_blank\">http://www.adelaide.edu.au/policies/62/</a>.</li></ol><p>Should you have any questions or queries regarding appropriate use of the ASSIST and associated tools please contact Professor Robert Ali via the <a href=\"http://assistportal.com.au\">ASSIST Portal</a>.</p></div><div class=\"assist-section\"><input id=\"license\" type=\"checkbox\" name=\"agree\" required=\"\" ng-model=\"test.testQuestions.license\"> <label class=\"label-checkbox\" for=\"license\"><span class=\"icon icon-checkbox assist\"></span>I agree to the above terms and conditions.</label></div></div><div ng-if=\"!test.type\"><div><span class=\"question-title\">{{test.name}}</span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"vm.currentTestIndex != 0\" value=\"vm.readyPercentage\"><span ng-show=\"vm.readyPercentage\">{{vm.readyPercentage}}%</span></uib-progressbar></div><p class=\"question-note\">These questions ask about psychoactive substances in the <span class=\"question-not-big\">past 3 months only</span>.</p><div class=\"questions\"><div class=\"question\" ng-class=\"{ \'is-disabled\' : question.isDisabled }\" ng-repeat=\"question in test.testQuestions\"><p class=\"question-text\">{{question.text}}</p><div ng-switch=\"question.type\"><div ng-switch-when=\"radio\"><div class=\"form-group radio-group\" ng-repeat=\"option in question.options\"><input id=\"question-{{test.name}}-{{question.text}}-{{$index}}\" name=\"{{$parent.$index + option + $index}}\" type=\"radio\" ng-change=\"question.toggleOtherQuestions && vm.changeTestState(test, question)\" ng-model=\"question.value\" ng-value=\"option\" ng-disabled=\"question.isDisabled\" ng-required=\"!question.isDisabled\"> <label class=\"label-radioBtn\" for=\"question-{{test.name}}-{{question.text}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{option}}</label></div></div></div><div ng-switch=\"question.type\"><div ng-switch-when=\"number\"><div class=\"form-group\"><input type=\"number\" ng-model=\"question.value\" required=\"\"></div></div></div><div ng-switch=\"question.type\"><div ng-switch-when=\"number-min\"><div class=\"form-group\"><input type=\"number\" ng-min=\"18\" name=\"age\" ng-model=\"question.value\" required=\"\"><br><br><span class=\"error-message\" ng-if=\"surveyForm.age.$touched && surveyForm.age.$invalid\">An age of 18+ is required to complete this survey.</span></div></div></div><div ng-switch=\"question.type\"><div ng-switch-when=\"text\"><div class=\"form-group\"><input type=\"text\" ng-model=\"question.value\" ng-disabled=\"question.isDisabled\" ng-required=\"!question.isDisabled\"></div></div></div></div></div><p class=\"question-note\" ng-if=\"vm.currentTestIndex == 2\">* A standard drink contains 10 grams of alcohol (approximately 285mls full strength beer, 375mls mid strength beer, 425mls low strength beer, 100mls wine, 30mls spirits, 60mls fortified wine)</p></div></div><div class=\"btns-move\"><div ng-if=\"surveyForm.$submitted && surveyForm.$invalid && vm.currentTestIndex > 0\" class=\"error-message\">Please complete all questions on the page to continue.</div><div><button class=\"btn btn-purple next-btn\" type=\"submit\" ng-disabled=\"surveyForm.$submitted && vm.isRequiredNext(surveyForm.$invalid) || vm.loading || surveyForm.agree.$error.required\">Next <i class=\"fa fa-angle-right\"></i></button></div><div><button class=\"btn btn-bordered-purple btn-purple\" type=\"button\" ng-if=\"vm.currentTestIndex > 1\" ng-click=\"vm.previousTest()\"><i class=\"fa fa-angle-left\"></i> Changed my mind</button></div></div></div><div class=\"videoWindow\" ng-if=\"vm.isFeedback\"><div class=\"assist-section text-center\"><h1 class=\"assist-title\">What\'s next?</h1></div><div class=\"assist-section\" ng-if=\"!vm.feedback.briefAdvice.length &&!vm.feedback.moderateAdvice.length && !vm.feedback.referralAdvice.length\">Thank you for completing the questions. Based on your answers, you are not at any risk of harms from drug or alcohol use at this time.</div><div class=\"assist-section\" ng-if=\"vm.feedback.briefAdvice.length ||vm.feedback.moderateAdvice.length || vm.feedback.referralAdvice.length\">Click each section below to view brief, moderate and referral advice.</div><div class=\"assist-section assist-section-feedback\" ng-if=\"vm.feedback.briefAdvice.length\"><h2 class=\"assist-title\">Brief Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" heading=\"{{vm.feedback.briefAdvice[0].name | capitalize}}\" is-open=\"vm.isBriefOpen\"><div ng-include=\"\" src=\"vm.feedback.briefAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"advice in vm.feedback.briefAdvice\" ng-if=\"$index > 0\" heading=\"{{advice.name | capitalize}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"vm.feedback.moderateAdvice.length\"><h2 class=\"assist-title\">Moderate Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" heading=\"{{vm.feedback.moderateAdvice[0].name | capitalize}}\" is-open=\"vm.isModerateOpen\"><div ng-include=\"\" src=\"vm.feedback.moderateAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"advice in vm.feedback.moderateAdvice\" ng-if=\"$index > 0\" heading=\"{{advice.name | capitalize}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"vm.feedback.referralAdvice.length\"><h2 class=\"assist-title\">Referral Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" heading=\"{{vm.feedback.referralAdvice[0].name | capitalize}}\" is-open=\"vm.isReferralOpen\"><div ng-include=\"\" src=\"vm.feedback.referralAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"advice in vm.feedback.referralAdvice\" ng-if=\"$index > 0\" heading=\"{{advice.name | capitalize}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"btns-move\"><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-disabled=\"vm.loading\" ng-click=\"vm.saveAnswers()\">Next</button></div><div><button class=\"btn btn-bordered-purple btn-purple\" type=\"button\" ng-if=\"vm.currentTestIndex !== 0\" ng-click=\"vm.backToTest()\"><i class=\"fa fa-angle-left\"></i> Changed my mind</button></div></div></div><div class=\"videoWindow\" ng-if=\"vm.videoView\"><div class=\"assist-section text-center\"><h1 class=\"assist-title\">What\'s next?</h1><div ng-if=\"vm.introParams.isTrial\"><p>Thank you for completing the ASSIST-Lite again. Your results have been automatically compared with the last time you completed the ASSIST-Lite (see table below).</p><div class=\"comparison-table-container\"><table class=\"normal-comparison-table\"><thead class=\"comparison-table-head\"><tr class=\"normal-table-row normal-table-row-head\"><th class=\"normal-table-cell\">Substance</th><th class=\"normal-table-cell\">Change</th></tr></thead><tr class=\"normal-table-row\" ng-repeat=\"item in vm.comparison\"><td class=\"normal-table-cell\" ng-bind=\"item.substance\"></td><td class=\"normal-table-cell\" ng-class=\"{ \'improved\': item.currentScore < item.previousScore, \'worse\': item.currentScore > item.previousScore }\"><span ng-if=\"item.currentScore < item.previousScore\">Improved</span> <span ng-if=\"item.currentScore > item.previousScore\">Worse</span> <span ng-if=\"item.currentScore === item.previousScore\">No Change</span></td></tr></table></div></div><p ng-if=\"!vm.introParams.isTrial\">Thanks for completing the eASSIST Lite, where we hope you have found some improved results. Either way, you can download our \'My ASSIST\' App and find a range of resources any time by visiting <a href=\"http://assistportal.com.au/\" target=\"_blank\">ASSISTportal.com.au</a>.</p><div class=\"btns-move\"><div class=\"assist-section assist-form-fields form-group row\" ng-if=\"!vm.introParams.isTrial\" ng-class=\"{ \'has-error\': !surveyForm.hospitalCodeReport.$valid && surveyForm.hospitalCodeReport.$touched && !surveyForm.hospitalCodeReport.$error.required }\"><div class=\"col-md-4\"><label>Enter your hospital code:</label></div><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" name=\"hospitalCodeReport\" placeholder=\"XXXXXXXXXX\" ng-change=\"vm.validateHospitalCodeReport(surveyForm)\" ng-model=\"hospitalCodeReport.value\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.hospitalCodeReport.$valid && surveyForm.hospitalCodeReport.$touched\"><span ng-show=\"surveyForm.hospitalCodeReport.$error.hospitalError && !surveyForm.hospitalCodeReport.$error.required\">Please enter a valid code.</span></p></div></div><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-disabled=\"!vm.introParams.isTrial && !surveyForm.hospitalCodeReport.$valid\" ng-click=\"vm.downloadParticipantReportCSV()\">Download Report (CSV)</button></div><div class=\"assist-section assist-form-fields form-group\" ng-class=\"{ \'has-error\': !surveyForm.email.$valid && surveyForm.email.$touched && !surveyForm.email.$error.required }\" ng-hide=\"vm.isEmailSent\"><div class=\"form-input\"><input type=\"email\" class=\"form-control\" name=\"email\" placeholder=\"Enter your eMail\" ng-model=\"email.value\" ng-disabled=\"vm.isSendingEmail\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.email.$valid && surveyForm.email.$touched\">Please enter a valid email address.</p></div></div><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-disabled=\"!surveyForm.email.$valid || vm.isSendingEmail || vm.isEmailSent\" ng-click=\"vm.emailParticipantReport(email.value)\"><span ng-if=\"!vm.isSendingEmail && !vm.isEmailSent\">*eMail me my results</span> <span ng-if=\"vm.isSendingEmail\">Sending email...</span> <span ng-if=\"vm.isEmailSent\">eMail has been sent</span></button></div><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-click=\"vm.finish()\">Return to the instructions page</button></div></div></div><div class=\"assist-section\"><p>*Optional - we will not store your eMail address.</p></div></div><div class=\"videoWindow\" ng-if=\"vm.isError\">Sorry, error.</div></div></form></div><div class=\"col-md-4\"><div class=\"lite-popup\"><h1 class=\"assist-title\">What is eASSIST Lite?</h1><p>The eASSIST-Lite is an ultra rapid screening tool based on the Alcohol, Smoking and Substance Involvement Test (ASSIST). The questions are designed to identify the risks associated with alcohol and drug use. The personalised feedback presents a range options for you to explore and consider.</p><h1 class=\"assist-title\">More help?</h1><p>If answering these questions has raised any concerns for you, you are encouraged to talk to the study coordinator or a health professional in the hospital or in your local area. Doctors, nurses, psychologists and social workers are able to help you explore what services and supports are available in your area.</p></div></div></div></div>");
$templateCache.put("app/components/eASSIST/eASSIST.template.html","<div class=\"page-content\"><div class=\"page-content-inner\"><div class=\"assistLite-content\"><div class=\"row\"><div class=\"col-md-12\"><div><form name=\"surveyForm\" novalidate=\"\" ng-submit=\"surveyForm.$valid && assistCtrl.next(surveyForm)\"><div class=\"lite-popup\"><div class=\"assistTest\" ng-include=\"assistCtrl.currentTest.template\"></div><div class=\"btns-move\"><div class=\"error-message\" ng-if=\"surveyForm.$submitted && surveyForm.$invalid\">Please complete all questions on the page to continue.</div><div><button class=\"btn btn-purple next-btn\" type=\"submit\" ng-if=\"assistCtrl.currentTest.isNext\" ng-disabled=\"surveyForm.$submitted && assistCtrl.isNextDisabled()\">Next <i class=\"fa fa-angle-right\"></i></button></div><div><button class=\"btn btn-bordered-purple btn-purple\" ng-if=\"assistCtrl.currentTest.isPrev\" type=\"button\" ng-click=\"assistCtrl.prev()\"><i class=\"fa fa-angle-left\"></i> Changed my mind</button></div></div></div></form></div></div></div></div></div></div><div class=\"page-supplements\" ng-class=\"{ \'is-active\': assistCtrl.isRightActive }\"><div class=\"page-supplements-scroll\"><a class=\"page-supplements-close\" ng-click=\"assistCtrl.toggleNavRight()\"><span class=\"fa fa-angle-double-right\"></span></a><help-content name=\"eASSIST-myeassist\" settings=\"$root.settings\"></help-content></div></div>");
$templateCache.put("app/components/invite/invite.html","<div class=\"modal-header\"><button type=\"button\" data-ng-click=\"inviteCtrl.close()\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button><h4 class=\"modal-title text-bold text-center\">Manage Admins</h4></div><div class=\"modal-body\"><div class=\"form-group row\" ng-repeat=\"admin in inviteCtrl.admins\"><div class=\"col-lg-2 col-md-2 col-sm-2\"><img class=\"img-avatar\" src=\"/assets/images/shared/default-avatar.png\"></div><label class=\"col-lg-6 col-md-6 col-sm-6 text-left\">{{admin.fullName}}</label><div class=\"col-lg-4 col-md-4 col-sm-4\"><button data-ng-click=\"inviteCtrl.deleteAccount(admin.id)\" type=\"button\" class=\"btn btn-gray pull-right\" ng-if=\"admin.emailVerified&&inviteCtrl.User.id!= admin.id\"><i class=\"fas fa-close\"></i></button> <button data-ng-click=\"inviteCtrl.resendInvite(admin.id)\" type=\"button\" class=\"btn btn-gray pull-right\" ng-if=\"!admin.emailVerified\"><i class=\"fas fa-paper-plane\"></i></button></div></div><ng-container ng-if=\"inviteCtrl.admins.length\"><hr></ng-container><form class=\"form\" role=\"form\" ng-submit=\"inviteCtrl.sendMails()\"><div ng-repeat=\"inviteRow in inviteCtrl.invite\"><div class=\"form-group row\"><div class=\"col-lg-2 col-md-2 col-sm-2\"><i class=\"font-24 fa fa-plus\"></i></div><div class=\"col-lg-8 col-md-8 col-sm-8 text-left no-padding\"><div class=\"col-lg-3 col-md-3 col-sm-3 padding-right\"><input type=\"text\" class=\"form-control\" name=\"firstName\" id=\"firstName\" ng-model=\"inviteCtrl.invite[$index].firstName\" placeholder=\"First\" required=\"\"></div><div class=\"col-lg-3 col-md-3 col-sm-3 padding-right\"><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"lastName\" ng-model=\"inviteCtrl.invite[$index].lastName\" placeholder=\"Last\" required=\"\"></div><div class=\"col-lg-6 col-md-6 col-sm-6 padding-right\"><input type=\"email\" class=\"form-control email\" name=\"email\" id=\"email\" ng-model=\"inviteCtrl.invite[$index].email\" placeholder=\"Email\" required=\"\"></div></div><div class=\"col-lg-2 col-md-2 col-sm-2 padding-right\"><div class=\"suggestion-invite-confirmation\"><button ng-if=\"inviteCtrl.isMailSent[$index]\" type=\"button\" class=\"btn btn-grey\"><span class=\"fas fa-check\"></span></button> <button ng-if=\"inviteCtrl.isMailSent[$index] === undefined && $index > 0\" type=\"button\" class=\"btn btn-grey\"><span ng-if=\"inviteCtrl.isMailSent[$index] === undefined && $index > 0\" ng-click=\"inviteCtrl.removeInviteField($index)\" class=\"fas fa-minus-circle\"></span></button></div></div></div></div><div><button type=\"button\" class=\"btn btn-grey\" ng-if=\"inviteCtrl.invite.length < 10\" ng-click=\"inviteCtrl.addInviteField()\">Invite More</button> <button type=\"submit\" class=\"btn btn-grey\"><span class=\"fas fa-paper-plane\"></span> invite</button></div></form></div><div class=\"modal-footer\"><button data-ng-click=\"inviteCtrl.close()\" class=\"btn btn-gray border-radius-none\" type=\"button\">Close</button></div>");
$templateCache.put("app/components/mydiary/mydiary.template.html","<div class=\"page-content\"><div class=\"page-content-inner\"><div class=\"feed-block\"><h2 class=\"mydiary-head\">Welcome to My Diary</h2><div class=\"mydiary-section\"><div class=\"mydiary-calendar\"><div uib-datepicker=\"\" ng-model=\"mydiaryCtrl.date\" class=\"well well-sm\" datepicker-options=\"mydiaryCtrl.calendarOptions\"></div></div><div class=\"mydiary-selections\"><uib-accordion close-others=\"true\"><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"alcohol.isOpen\"><uib-accordion-heading>Alcohol <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': alcohol.isOpen, \'fa-angle-right\': !alcohol.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.alcoholValue\" ng-model=\"mydiaryCtrl.slider.alcoholValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.alcoholValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"amphetamines.isOpen\"><uib-accordion-heading>Amphetamines <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': amphetamines.isOpen, \'fa-angle-right\': !amphetamines.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.amphetaminesValue\" ng-model=\"mydiaryCtrl.slider.amphetaminesValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.amphetaminesValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"cannabis.isOpen\"><uib-accordion-heading>Cannabis <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': cannabis.isOpen, \'fa-angle-right\': !cannabis.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.cannabisValue\" ng-model=\"mydiaryCtrl.slider.cannabisValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.cannabisValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"cocaine.isOpen\"><uib-accordion-heading>Cocaine <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': cocaine.isOpen, \'fa-angle-right\': !cocaine.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.cocaineValue\" ng-model=\"mydiaryCtrl.slider.cocaineValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.cocaineValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"ecstasy.isOpen\"><uib-accordion-heading>Ecstasy <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': ecstasy.isOpen, \'fa-angle-right\': !ecstasy.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.ecstasyValue\" ng-model=\"mydiaryCtrl.slider.ecstasyValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.ecstasyValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"inhalants.isOpen\"><uib-accordion-heading>Inhalants <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': inhalants.isOpen, \'fa-angle-right\': !inhalants.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.inhalantsValue\" ng-model=\"mydiaryCtrl.slider.inhalantsValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.inhalantsValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"opioids.isOpen\"><uib-accordion-heading>Opioids <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': opioids.isOpen, \'fa-angle-right\': !opioids.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.opioidsValue\" ng-model=\"mydiaryCtrl.slider.opioidsValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.opioidsValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"meds.isOpen\"><uib-accordion-heading>Prescription Meds <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': meds.isOpen, \'fa-angle-right\': !meds.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.prescriptionMedsValue\" ng-model=\"mydiaryCtrl.slider.prescriptionMedsValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.prescriptionMedsValue\"></div><div class=\"mydiary-selections-item\"><div uib-accordion-group=\"\" class=\"panel-default-mydiary\" is-open=\"tobacco.isOpen\"><uib-accordion-heading>Tobacco <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-down\': tobacco.isOpen, \'fa-angle-right\': !tobacco.isOpen}\"></i></uib-accordion-heading><div class=\"mydiary-slider\"><rzslider class=\"mydiary-slider\" rz-slider-model=\"mydiaryCtrl.slider.tobaccoValue\" ng-model=\"mydiaryCtrl.slider.tobaccoValue\" rz-slider-options=\"mydiaryCtrl.sliderOptions.options\"></rzslider></div></div><input class=\"mydiary-inputs\" type=\"number\" ng-model=\"mydiaryCtrl.slider.tobaccoValue\"></div></uib-accordion></div><div class=\"row save-button\"><button class=\"btn btn-top btn-primary\" ng-click=\"mydiaryCtrl.saveSliderValue(mydiaryCtrl.date)\">Save</button> <button class=\"btn btn-top btn-gray\" ng-click=\"mydiaryCtrl.resetValue()\">Reset</button></div></div><div class=\"mydiary-chart\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Today\" ng-click=\"mydiaryCtrl.findTodayData()\"><span class=\"mydiary-chart-date\">Date: {{mydiaryCtrl.today}}</span><canvas id=\"chart-today\" class=\"chart chart-doughnut\" chart-data=\"mydiaryCtrl.dataToday\" chart-labels=\"mydiaryCtrl.labels\" colours=\"mydiaryCtrl.colors\" ng-if=\"mydiaryCtrl.dataToday.length\"></canvas><div class=\"feed-block-section\" ng-if=\"!mydiaryCtrl.dataToday.length\"><p class=\"mydiary-nothing\">No data to show.</p></div></uib-tab><uib-tab index=\"1\" heading=\"Week\" ng-click=\"mydiaryCtrl.findWeekData()\"><span class=\"mydiary-chart-date\">In last 7 days</span><canvas id=\"chart-week\" class=\"chart chart-doughnut\" chart-data=\"mydiaryCtrl.dataWeek\" chart-labels=\"mydiaryCtrl.labels\" colours=\"mydiaryCtrl.colors\" ng-if=\"mydiaryCtrl.dataWeek.length\"></canvas><div class=\"feed-block-section\" ng-if=\"!mydiaryCtrl.dataWeek.length\"><p class=\"mydiary-nothing\">No data to show.</p></div></uib-tab><uib-tab index=\"2\" heading=\"Month\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"wine-datepicker start-date\"><input class=\"form-control\" type=\"text\" name=\"month\" ng-model=\"mydiaryCtrl.filters.month\" uib-datepicker-popup=\"MM.yyyy\" placeholder=\"Select Month\" datepicker-options=\"mydiaryCtrl.monthOptions\" is-open=\"mydiaryCtrl.monthpickerPopup.month\" ng-click=\"mydiaryCtrl.openMonthpickerPopup()\" readonly=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default btn-datepicker\" type=\"button\" ng-click=\"mydiaryCtrl.openMonthpickerPopup()\"><i class=\"fa fa-calendar\"></i></button></span></div></div><button class=\"btn-payment btn btn-gray\" ng-click=\"mydiaryCtrl.findMonthData(mydiaryCtrl.filters.month)\">Apply filter</button></div><canvas id=\"chart-month\" class=\"chart chart-doughnut\" chart-data=\"mydiaryCtrl.dataMonth\" chart-labels=\"mydiaryCtrl.labels\" colours=\"mydiaryCtrl.colors\" ng-if=\"mydiaryCtrl.dataMonth.length\"></canvas><div class=\"feed-block-section\" ng-if=\"!mydiaryCtrl.dataMonth.length\"><p class=\"mydiary-nothing\">No data to show.</p></div></uib-tab><uib-tab index=\"3\" heading=\"All Time\" ng-click=\"mydiaryCtrl.findAllTimeData()\"><canvas id=\"chart-allTime\" class=\"chart chart-doughnut\" chart-data=\"mydiaryCtrl.dataAllTime\" chart-labels=\"mydiaryCtrl.labels\" colours=\"mydiaryCtrl.colors\" ng-if=\"mydiaryCtrl.dataAllTime.length\"></canvas><div class=\"feed-block-section\" ng-if=\"!mydiaryCtrl.dataAllTime.length\"><p class=\"mydiary-nothing\">No data to show.</p></div></uib-tab></uib-tabset></div></div></div></div><div class=\"page-supplements\" ng-class=\"{ \'is-active\': mydiaryCtrl.isRightActive }\"><div class=\"page-supplements-scroll\"><a class=\"page-supplements-close\" ng-click=\"mydiaryCtrl.toggleNavRight()\"><span class=\"fa fa-angle-double-right\"></span></a><help-content name=\"mydiary-myeassist\" settings=\"$root.settings\"></help-content></div></div>");
$templateCache.put("app/components/report/report.template.html","<div class=\"dashboard-content page-content report-page\"><div class=\"page-content-inner\"><div class=\"feed-block\"><div class=\"text-center\" ng-if=\"reportCtrl.loading\"><span class=\"spinner-loader\"></span></div><div ng-if=\"!reportCtrl.loading\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"profile-headline\">Reports</h3><div class=\"row\"><div class=\"col-lg-4\"><div class=\"dropdown-wine\"><span ng-if=\"reportCtrl.User.isAdmin\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"dropdown-wine-link\" href=\"\" uib-dropdown-toggle=\"\">{{reportCtrl.report.id}} <i class=\"fa fa-angle-down\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li ng-repeat=\"report in reportCtrl.reports\" class=\"report-invite\"><a href=\"\" ng-click=\"reportCtrl.setReport(report)\">{{report.id}}</a> <button ng-if=\"report.id!=\'ASSIST App Indigenous Adaptation Feedback\'&&report.id!=\'ASSIST App Indigenous Adaptation Pilot Feedback\'\" ng-click=\"reportCtrl.openInviteModal(report)\" class=\"btn btn-default\"><i class=\"fa fa-user-plus\" aria-hidden=\"true\"></i></button></li></ul></span> <span ng-if=\"!reportCtrl.User.isAdmin\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"dropdown-wine-link\" href=\"\" uib-dropdown-toggle=\"\">My eASSIST <i class=\"fa fa-angle-down\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li ng-repeat=\"report in reportCtrl.userReport\"><a>{{report.id}}</a></li></ul></span></div></div><div class=\"col-lg-4\" ng-if=\"reportCtrl.User.isAdmin&&(reportCtrl.report.id!=\'ASSIST App Indigenous Adaptation Feedback\' && reportCtrl.report.id!=\'ASSIST App Indigenous Adaptation Pilot Feedback\')\"><div class=\"dropdown-wine\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"dropdown-wine-link\" href=\"\" uib-dropdown-toggle=\"\">By {{reportCtrl.filter.id}} <i class=\"fa fa-angle-down\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li ng-repeat=\"order in reportCtrl.orders\"><a href=\"\" ng-click=\"reportCtrl.setFilter(order)\">{{order.label}}</a></li></ul></span></div></div><div class=\"col-lg-4\" ng-if=\"reportCtrl.filter.id==\'gender\'&&reportCtrl.User.isAdmin&&(reportCtrl.report.id==\'eASSIST\' || reportCtrl.report.id==\'eASSIST Lite\'|| reportCtrl.report.id==\'My eASSIST\')\"><div class=\"dropdown-wine\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"dropdown-wine-link\" href=\"\" uib-dropdown-toggle=\"\">By {{reportCtrl.orderFilter.text}} <i class=\"fa fa-angle-down\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li ng-repeat=\"orderFilter in reportCtrl.orderFilters\"><a href=\"\" ng-click=\"reportCtrl.setOrderFilter(orderFilter)\">{{orderFilter.text}}</a></li></ul></span></div></div></div></div></div><form class=\"report-form\" ng-submit=\"reportFiltersForm.$valid && reportCtrl.getReport()\" name=\"reportFiltersForm\" ng-if=\"reportCtrl.User.isAdmin\"><div class=\"form-group row\"><div class=\"col-lg-8\"><label>Dates range:</label><div class=\"row\"><div class=\"col-md-6\"><div class=\"wine-datepicker start-date\"><input class=\"form-control\" type=\"text\" name=\"beginDate\" ng-model=\"reportCtrl.filters.beginDate\" uib-datepicker-popup=\"dd.MM.yyyy\" placeholder=\"Start date\" datepicker-options=\"reportCtrl.dateOptions\" is-open=\"reportCtrl.datepickerPopup.beginDate\" ng-click=\"reportCtrl.openDatepickerPopup(\'beginDate\')\" ng-change=\"reportCtrl.validateDates(reportFiltersForm)\" readonly=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default btn-datepicker\" type=\"button\" ng-click=\"reportCtrl.openDatepickerPopup(\'beginDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-md-6\"><div class=\"wine-datepicker\"><input class=\"form-control\" type=\"text\" name=\"endDate\" placeholder=\"End date\" ng-model=\"reportCtrl.filters.endDate\" uib-datepicker-popup=\"dd.MM.yyyy\" datepicker-options=\"reportCtrl.dateOptions\" is-open=\"reportCtrl.datepickerPopup.endDate\" ng-click=\"reportCtrl.openDatepickerPopup(\'endDate\')\" ng-change=\"reportCtrl.validateDates(reportFiltersForm)\" readonly=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default btn-datepicker\" type=\"button\" ng-click=\"reportCtrl.openDatepickerPopup(\'endDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"row text-danger error-message\" ng-show=\"reportFiltersForm.$submitted && reportFiltersForm.$invalid\"><div class=\"col-md-12\"><span ng-show=\"reportFiltersForm.endDate.$error.dateError\">Start date must be less than End date.</span></div></div></div><div class=\"col-lg-4\" ng-show=\"reportCtrl.report.id === \'eASSIST\'||reportCtrl.report.id === \'eASSIST Lite\'\"><label>Location name</label><ui-select theme=\"bootstrap\" class=\"form-control form-select\" ng-model=\"reportCtrl.filters.location\"><ui-select-match><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"location in reportCtrl.locations\"><span ng-bind=\"location\"></span></ui-select-choices></ui-select></div><div class=\"col-lg-4\" ng-show=\"reportCtrl.report.id === \'eASSIST Lite Research Project\'\"><label>Сlinic name</label><ui-select theme=\"bootstrap\" class=\"form-control form-select\" ng-model=\"reportCtrl.filters.clinicName\"><ui-select-match><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"clinic in reportCtrl.clinics\"><span ng-bind=\"clinic\"></span></ui-select-choices></ui-select></div><div class=\"col-lg-4\" ng-show=\"reportCtrl.report.id === \'eASSIST SA Research Project\'\"><label>Practice name</label><ui-select theme=\"bootstrap\" class=\"form-control form-select\" ng-model=\"reportCtrl.filters.practiceName\"><ui-select-match><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"practice in reportCtrl.practices\"><span ng-bind-html=\"practice\"></span></ui-select-choices></ui-select></div><div class=\"col-lg-4\" ng-show=\"reportCtrl.report.id === \'ASSIST App Indigenous Adaptation Pilot\'||reportCtrl.report.id === \'ASSIST App Indigenous Adaptation Pilot Feedback\'\"><label>Site name</label><ui-select theme=\"bootstrap\" class=\"form-control form-select\" ng-model=\"reportCtrl.filters.practiceName\"><ui-select-match><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"practice in reportCtrl.sites\"><span ng-bind-html=\"practice\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=\"col-xs-8\"><button class=\"btn-payment btn btn-gray\" type=\"submit\">Apply filters</button> <button class=\"btn-payment btn btn-gray\" type=\"button\" ng-click=\"reportCtrl.resetTable()\">Reset</button></div><div class=\"col-xs-4\" ng-if=\"reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Feedback\'|| reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Pilot Feedback\'|| reportCtrl.report.id==\'ASSIST App Indigenous Adaptation\'||reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Pilot\'\">Pilot<div class=\"btn tg-list-item\"><input ng-model=\"reportCtrl.isActiveAssistAboriginalPilot\" ng-change=\"reportCtrl.onChangePilotProject()\" class=\"tgl tgl-light\" id=\"cb1\" type=\"checkbox\"> <label class=\"tgl-btn\" for=\"cb1\"></label></div></div></div><div class=\"form-group row\" ng-if=\"reportCtrl.User.isAdmin\"><div class=\"col-xs-12\"><a class=\"btn btn-primary\" ng-if=\"reportCtrl.report.id!=\'ASSIST App Indigenous Adaptation Feedback\'&& reportCtrl.report.id!=\'ASSIST App Indigenous Adaptation Pilot Feedback\'\" ng-href=\"{{reportCtrl.downloadCsvSummaryURL}}\" ng-mousedown=\"\" target=\"_blank\" ng-disabled=\"!reportCtrl.data\" type=\"button\">Summary Results CSV</a> <a class=\"btn btn-primary\" ng-href=\"{{reportCtrl.downloadCsvIndividualURL}}\" ng-mousedown=\"\" target=\"_blank\" ng-disabled=\"!reportCtrl.data\" type=\"button\">Individual Answers CSV</a></div></div></form><form class=\"report-form\" ng-submit=\"reportFiltersForm.$valid && reportCtrl.findSurveys()\" name=\"reportFiltersForm\" ng-if=\"!reportCtrl.User.isAdmin\"><div class=\"form-group row\"><div class=\"col-lg-8\"><label>Dates range:</label><div class=\"row\"><div class=\"col-md-6\"><div class=\"wine-datepicker start-date\"><input class=\"form-control\" type=\"text\" name=\"beginDate\" ng-model=\"reportCtrl.filters.beginDate\" uib-datepicker-popup=\"dd.MM.yyyy\" placeholder=\"Start date\" datepicker-options=\"reportCtrl.dateOptions\" is-open=\"reportCtrl.datepickerPopup.beginDate\" ng-click=\"reportCtrl.openDatepickerPopup(\'beginDate\')\" ng-change=\"reportCtrl.validateDates(reportFiltersForm)\" readonly=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default btn-datepicker\" type=\"button\" ng-click=\"reportCtrl.openDatepickerPopup(\'beginDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-md-6\"><div class=\"wine-datepicker\"><input class=\"form-control\" type=\"text\" name=\"endDate\" placeholder=\"End date\" ng-model=\"reportCtrl.filters.endDate\" uib-datepicker-popup=\"dd.MM.yyyy\" datepicker-options=\"reportCtrl.dateOptions\" is-open=\"reportCtrl.datepickerPopup.endDate\" ng-click=\"reportCtrl.openDatepickerPopup(\'endDate\')\" ng-change=\"reportCtrl.validateDates(reportFiltersForm)\" readonly=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default btn-datepicker\" type=\"button\" ng-click=\"reportCtrl.openDatepickerPopup(\'endDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"row text-danger error-message\" ng-show=\"reportFiltersForm.$submitted && reportFiltersForm.$invalid\"><div class=\"col-md-12\"><span ng-show=\"reportFiltersForm.endDate.$error.dateError\">Start date must be less than End date.</span></div></div></div></div><div class=\"form-group row\"><div class=\"col-xs-12\"><button class=\"btn-payment btn btn-gray\" type=\"submit\">Apply filters</button> <button class=\"btn-payment btn btn-gray\" type=\"button\" ng-click=\"reportCtrl.resetTable()\">Reset</button> <button class=\"btn-payment btn btn-gray\" type=\"button\" ng-click=\"reportCtrl.changeView()\" ng-if=\"!reportCtrl.User.isAdmin && reportCtrl.isList\" uib-popover=\"Change to list view\" popover-trigger=\"\'mouseenter\'\" popover-placement=\"bottom\"><i class=\"fa fa-list-ul\"></i></button> <button class=\"btn-payment btn btn-gray\" type=\"button\" ng-click=\"reportCtrl.changeView(); reportCtrl.setGraph(reportCtrl.initGraph)\" ng-if=\"!reportCtrl.User.isAdmin && reportCtrl.isChart\" uib-popover=\"Change to line chart view\" popover-trigger=\"\'mouseenter\'\" popover-placement=\"bottom\"><i class=\"fa fa-line-chart\"></i></button> <button class=\"btn-payment btn btn-gray\" type=\"button\" ng-if=\"reportCtrl.isList\" ng-click=\"reportCtrl.downloadAllResultsCSV()\" uib-popover=\"Download all results\" popover-trigger=\"\'mouseenter\'\" popover-placement=\"bottom\"><i class=\"fa fa-download\"></i></button></div></div></form><div ng-if=\"reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Feedback\'||reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Pilot Feedback\'\"><div class=\"report-table-container\"><div class=\"report-table\" ng-if=\"reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Pilot Feedback\'\"><div class=\"report-table-row report-table-head clearfix\"><div class=\"cell report-table-body-col empty-cell col col-first\" ng-class=\"{ \'mobile\': $index != 0 }\">&nbsp;</div><div class=\"report-table-row report-table-days-body clearfix\"><div style=\"width: 11%;\" class=\"cell\">Id</div><div style=\"width: 11%;\" class=\"cell\">Participant</div><div style=\"width: 11%;\" class=\"cell\">Question 1</div><div style=\"width: 11%;\" class=\"cell\">Question 2</div><div style=\"width: 11%;\" class=\"cell\">Question 3</div><div style=\"width: 11%;\" class=\"cell\">Question 4</div><div style=\"width: 34%;\" class=\"cell\">Question 5</div></div></div><div class=\"report-table-days-body clearfix\" ng-repeat=\"data in reportCtrl.data.questionsTable\"><div style=\"width: 11%;text-transform: capitalize;\" class=\"cell\">{{data.assistAboriginalPilotId}}</div><div style=\"width: 11%;text-transform: capitalize;\" class=\"cell\">{{data.clientId}}</div><div style=\"width: 11%;\" class=\"cell\">{{data.question1}}</div><div style=\"width: 11%;\" class=\"cell\">{{data.question2}}</div><div style=\"width: 11%;\" class=\"cell\">{{data.question3}}</div><div style=\"width: 11%;\" class=\"cell\">{{data.question4}}</div><div style=\"width: 34%;\" class=\"cell\">{{data.question5}}</div></div><div class=\"report-table-row report-table-days-body clearfix\"><div style=\"width: 11%;text-transform: capitalize;\" class=\"cell\">Total</div><div style=\"width: 11%;text-transform: capitalize;\" class=\"cell\"></div><div style=\"width: 11%;\" class=\"cell\">{{reportCtrl.data.total.question1}}</div><div style=\"width: 11%;\" class=\"cell\">{{reportCtrl.data.total.question2}}</div><div style=\"width: 11%;\" class=\"cell\">{{reportCtrl.data.total.question3}}</div><div style=\"width: 11%;\" class=\"cell\">{{reportCtrl.data.total.question4}}</div><div style=\"width: 34%;\" class=\"cell\"></div></div></div><div class=\"report-table\" ng-if=\"reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Feedback\'\"><div class=\"report-table-row report-table-head clearfix\"><div class=\"cell report-table-body-col empty-cell col col-first\" ng-class=\"{ \'mobile\': $index != 0 }\">&nbsp;</div><div class=\"report-table-row report-table-days-body clearfix\"><div style=\"width: 13%;\" class=\"cell\">Id</div><div style=\"width: 13%;\" class=\"cell\">Question 1</div><div style=\"width: 13%;\" class=\"cell\">Question 2</div><div style=\"width: 13%;\" class=\"cell\">Question 3</div><div style=\"width: 13%;\" class=\"cell\">Question 4</div><div style=\"width: 35%;\" class=\"cell\">Question 5</div></div></div><div class=\"report-table-days-body clearfix\" ng-repeat=\"data in reportCtrl.data.questionsTable\"><div style=\"width: 13%;text-transform: capitalize;\" class=\"cell\">{{data.assistAboriginalId}}</div><div style=\"width: 13%;\" class=\"cell\">{{data.question1}}</div><div style=\"width: 13%;\" class=\"cell\">{{data.question2}}</div><div style=\"width: 13%;\" class=\"cell\">{{data.question3}}</div><div style=\"width: 13%;\" class=\"cell\">{{data.question4}}</div><div style=\"width: 35%;\" class=\"cell\">{{data.question5}}</div></div><div class=\"report-table-row report-table-days-body clearfix\"><div style=\"width: 13%;text-transform: capitalize;\" class=\"cell\">Total</div><div style=\"width: 13%;\" class=\"cell\">{{reportCtrl.data.total.question1}}</div><div style=\"width: 13%;\" class=\"cell\">{{reportCtrl.data.total.question2}}</div><div style=\"width: 13%;\" class=\"cell\">{{reportCtrl.data.total.question3}}</div><div style=\"width: 13%;\" class=\"cell\">{{reportCtrl.data.total.question4}}</div><div style=\"width: 35%;\" class=\"cell\"></div></div></div></div></div></div><div ng-if=\"reportCtrl.report.id!=\'ASSIST App Indigenous Adaptation Pilot Feedback\'\"><div class=\"report-table-container\" ng-if=\"(reportCtrl.filter.id == \'gender\' || reportCtrl.filter.id == \'age\') && reportCtrl.User.isAdmin\"><div class=\"report-table\" ng-class=\"{\'criteria-count-2\': reportCtrl.filter.id == \'gender\', \'criteria-count-3\': reportCtrl.filter.id == \'age\'}\"><div class=\"report-table-body clearfix\"><div class=\"report-table-row report-table-head clearfix\" ng-if=\"reportCtrl.filter.id == \'age\'\"><div class=\"cell cell-label report-table-body-col col col-tip\">*To view the full table you might need to scroll sideways.</div></div><div class=\"report-table-body-col\" style=\"width: 100%;\" ng-class=\"{\'col-first\': $index == 0, \'col\': $index != 0}\" ng-repeat=\"(key, value) in reportCtrl.displayData\"><div class=\"report-table-row report-table-head clearfix\"><div class=\"cell report-table-body-col empty-cell col col-first\" ng-class=\"{ \'mobile\': $index != 0 }\">&nbsp;</div><div class=\"cell report-table-body-col\">{{key|capitalize}}</div></div><div class=\"report-table-row report-table-head clearfix\"><div class=\"cell report-table-body-col empty-cell col col-first\" ng-class=\"{ \'mobile\': $index != 0 }\">&nbsp;</div><div class=\"cell report-table-body-col\"><div class=\"cell cell-inner\">Low</div><div class=\"cell cell-inner\">Moderate</div><div class=\"cell cell-inner\">High</div></div></div><div class=\"report-table-row\" ng-repeat=\"(substanceName, substanceValue) in value\"><div class=\"cell cell-label\" ng-class=\"{ \'mobile\': $parent.$index != 0 }\"><span ng-if=\"reportCtrl.report.id==\'ASSIST App Indigenous Adaptation\'||reportCtrl.report.id==\'ASSIST App Indigenous Adaptation Pilot\'\">{{substanceName===\'amphetamine\' ? \'ice\' : (substanceName===\'cannabis\'?\'Marijuana\':substanceName)}}</span> <span ng-if=\"reportCtrl.report.id!==\'ASSIST App Indigenous Adaptation\'&&reportCtrl.report.id!==\'ASSIST App Indigenous Adaptation Pilot\'\">{{substanceName}}</span></div><div class=\"cell\"><div class=\"cell cell-inner\">{{substanceValue.low}}</div><div class=\"cell cell-inner\">{{substanceValue.moderate}}</div><div class=\"cell cell-inner\">{{substanceValue.high}}</div></div></div></div></div></div></div><div class=\"report-table-container\" ng-if=\"reportCtrl.filter.id == \'risk\' && reportCtrl.User.isAdmin\"><div class=\"report-table report-table-days\"><div class=\"report-table-row report-table-head clearfix\"><div class=\"cell cell-label report-table-body-col col col-tip\">*To view the full table you might need to scroll sideways.</div></div><div class=\"report-table-row report-table-head report-table-head-days clearfix\"><div class=\"cell cell-8 empty-cell\">&nbsp;</div><div class=\"cell\">High risk individuals - <strong>{{reportCtrl.data.weekTable.highTotal}}</strong></div><div class=\"cell\">Moderate risk individuals - <strong>{{reportCtrl.data.weekTable.moderateTotal}}</strong></div><div class=\"cell cell-25 empty-cell\">&nbsp;</div></div><div class=\"report-table-row report-table-days-body clearfix\"><div class=\"cell empty-cell\">&nbsp;</div><div class=\"cell\">Morning</div><div class=\"cell\">Afternoon</div><div class=\"cell\">Evening</div><div class=\"cell\">Night</div><div class=\"cell\">Morning</div><div class=\"cell\">Afternoon</div><div class=\"cell\">Evening</div><div class=\"cell\">Night</div><div class=\"cell\">Day high</div><div class=\"cell\">Day moderate</div><div class=\"cell\">Day total</div></div><div class=\"report-table-row report-table-days-body clearfix\" ng-if=\"key != \'highTotal\' && key!= \'moderateTotal\'\" ng-repeat=\"(key, value) in reportCtrl.data.weekTable\"><div class=\"cell cell-label\">{{key}}</div><div class=\"cell\">{{value.high.morning}}</div><div class=\"cell\">{{value.high.afternoon}}</div><div class=\"cell\">{{value.high.evening}}</div><div class=\"cell\">{{value.high.night}}</div><div class=\"cell\">{{value.moderate.morning}}</div><div class=\"cell\">{{value.moderate.afternoon}}</div><div class=\"cell\">{{value.moderate.evening}}</div><div class=\"cell\">{{value.moderate.night}}</div><div class=\"cell\">{{value.high.day}}</div><div class=\"cell\">{{value.moderate.day}}</div><div class=\"cell\">{{value.total.day}}</div></div></div></div><div class=\"report-table-container\" ng-if=\"reportCtrl.filter.id == \'substances\' && reportCtrl.User.isAdmin\"><div class=\"report-table report-table-substances\"><div class=\"report-table-row report-table-head report-table-head-substances clearfix\"><div class=\"cell empty-cell\">&nbsp;</div><div class=\"cell\">Number of people with</div></div><div class=\"report-table-row report-table-substances-body clearfix\"><div class=\"cell\">Number of substances</div><div class=\"cell\">Moderate risk</div><div class=\"cell\">High risk</div></div><div class=\"report-table-row report-table-substances-body clearfix\" ng-repeat=\"data in reportCtrl.data.substancesTable\"><div class=\"cell\" ng-if=\"!$last\">{{$index + 1}}</div><div class=\"cell\" ng-if=\"$last\">>5</div><div class=\"cell\">{{data.moderate}}</div><div class=\"cell\">{{data.high}}</div></div></div></div><div class=\"report-history-container\" ng-if=\"!reportCtrl.User.isAdmin && reportCtrl.isChart\"><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" ng-repeat=\"survey in reportCtrl.surveys\" class=\"panel-default\" is-open=\"survey.isFirstOpen\"><uib-accordion-heading>eASSIST <span>{{survey.createdAt | date:\'yyyy-MM-dd HH:mm:ss\'}}</span> <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-up\': survey.isFirstOpen, \'fa-angle-down\': !survey.isFirstOpen}\"></i> <i class=\"pull-right fa fa-download\" ng-click=\"reportCtrl.downloadCSV(survey.id)\" aria-hidden=\"true\"></i></uib-accordion-heading><div class=\"assist-section assist-section-feedback\" ng-if=\"survey.results.feedback.briefAdvice.length\"><h2 class=\"assist-title\">Brief Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" heading=\"{{(survey.results.feedback.briefAdvice[0].drugName | capitalize) + (survey.results.feedback.briefAdvice[0].substance ? \' - \' + survey.results.feedback.briefAdvice[0].substance : \'\')}}\" is-open=\"survey.isBriefOpen\"><div ng-include=\"\" src=\"survey.results.feedback.briefAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"advice in survey.results.feedback.briefAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.drugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"survey.results.feedback.referralAdvice.length\"><h2 class=\"assist-title\">Referral Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" heading=\"{{(survey.results.feedback.referralAdvice[0].drugName | capitalize) + (survey.results.feedback.referralAdvice[0].substance ? \' - \' + survey.results.feedback.referralAdvice[0].substance : \'\')}}\" is-open=\"survey.isReferralOpen\"><div ng-include=\"\" src=\"survey.results.feedback.referralAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"advice in survey.results.feedback.referralAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.drugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><form name=\"emailForm\" novalidate=\"\" ng-submit=\"emailForm.$valid\"><div class=\"report-form-input\"><input type=\"email\" class=\"form-control\" name=\"email\" placeholder=\"Enter your eMail\" ng-model=\"survey.email\" ng-disabled=\"reportCtrl.isSendingEmail\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!emailForm.email.$valid && emailForm.email.$touched\">Please enter a valid email address.</p></div><span ng-click=\"reportCtrl.emailParticipantReport(survey.email, survey.id, survey.results, survey)\"><i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i></span><spinner class=\"spinner\" ng-if=\"survey.isSendingEmail\"></spinner><span ng-if=\"survey.isEmailSent\"><i class=\"fa fa-check-circle-o\" aria-hidden=\"true\"></i></span></form></div></uib-accordion><div class=\"feed-block-section\" ng-if=\"!reportCtrl.surveys.length\"><p class=\"mydiary-nothing\">No data to show.</p></div></div><div class=\"report-history-container\" ng-if=\"!reportCtrl.User.isAdmin && reportCtrl.isList\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"dropdown-wine\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"dropdown-wine-link\" href=\"\" uib-dropdown-toggle=\"\"><b>Risk over time:</b> {{reportCtrl.graph.label}} <i class=\"fa fa-angle-down\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li ng-repeat=\"graph in reportCtrl.graphs\"><a href=\"\" ng-click=\"reportCtrl.setGraph(graph)\">{{graph.label}}</a></li></ul></span></div></div></div><canvas id=\"line\" ng-if=\"reportCtrl.surveys.length\" class=\"chart chart-line\" chart-data=\"graphData\" chart-labels=\"labels\" chart-series=\"series\" chart-options=\"options\" chart-colors=\"colors\"></canvas><div class=\"feed-block-section\" ng-if=\"!reportCtrl.surveys.length\"><p class=\"mydiary-nothing\">No data to show.</p></div></div></div></div></div></div><div class=\"page-supplements\" ng-class=\"{ \'is-active\': reportCtrl.isRightActive }\"><div class=\"page-supplements-scroll\"><a class=\"page-supplements-close\" ng-click=\"reportCtrl.toggleNavRight()\"><span class=\"fa fa-angle-double-right\"></span></a><help-content name=\"reports-learning\" settings=\"$root.settings\"></help-content></div></div>");
$templateCache.put("app/directives/help-content/help-content.template.html","<ng-include src=\"vm.defaultContentTemplate\" onload=\"vm.init()\"></ng-include><div class=\"help-content-loader\" ng-if=\"!vm.componentLoaded && !vm.userLoaded\"><div class=\"spinner-loader\"></div></div><div class=\"page-supplements-item page-supplements-item-support\" ng-if=\"vm.componentLoaded && vm.userLoaded && !vm.editMode\"><div class=\"hr search-filter-name\"><span class=\"hr-text search-filter-collapse\"><i class=\"fa fa-angle-down\"></i> {{vm.content.title}}</span> <span class=\"search-filter-icon fa fa-question-circle\" uib-popover=\"View support notes.\" popover-trigger=\"mouseenter\" popover-toggle=\"popover\" popover-placement=\"bottom-right\"></span> <i class=\"search-filter-icon search-filter-icon-edit fa fa-pencil\" ng-click=\"vm.edit()\" ng-if=\"vm.isAdmin\"></i></div><div class=\"page-supplements-inner\"><div class=\"help-content-text\" ng-if=\"vm.content.text.length\" ng-bind-html=\"vm.content.text | formatText\"></div><div class=\"help-content-show-more\" ng-if=\"vm.showMoreButton\"><a role=\"button\" ng-click=\"vm.toggleTextContent()\"><span ng-show=\"!vm.contentVisible\">show more</span> <span ng-show=\"vm.contentVisible\">hide</span></a></div></div></div><form ng-if=\"vm.editMode\" class=\"page-supplements-item\" novalidate=\"\" ng-submit=\"form.$valid && vm.save()\" name=\"form\"><div class=\"form-group\"><input class=\"form-control\" name=\"title\" input-autofocus=\"vm.editMode\" ng-model=\"vm.content.title\" placeholder=\"Title\" required=\"\"><p class=\"error-message text-danger\" ng-show=\"form.$submitted\"><span ng-show=\"form.title.$error.required\">Title is required.<br></span></p></div><div class=\"form-group omnibox bordered\"><div id=\"post-text-edit\" name=\"text\" class=\"form-control\" ng-model=\"vm.content.text\" placeholder=\"Enter a video URL(Vimeo/Youtube) below, enter support text (including links) and click \'Add\' to include images and files.\" contenteditable=\"true\" wine-contenteditable=\"\"></div></div><div class=\"form-group form-group-btns\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.isDisabled(form)\"><span ng-if=\"!vm.loading\">Save</span> <span ng-if=\"vm.loading\">Saving...</span></button> <button type=\"button\" class=\"btn btn-gray\" ng-disabled=\"vm.isDisabled(form)\" ng-click=\"vm.cancelEdit($event)\">Cancel</button></div></form>");
$templateCache.put("app/components/assistLite/eAssist/eAssist.template.html","<div class=\"assistLite-content\"><div class=\"row\"><div ng-class=\"{\'col-md-8\':portalText.hostName!==\'assist-knowyouroptions\'&&portalText.hostName!==\'myeassist-knowyouroptions\', \'col-md-12\':(portalText.hostName==\'assist-knowyouroptions\'||portalText.hostName==\'myeassist-knowyouroptions\')}\"><div><form name=\"surveyForm\" class=\"survey-form\" novalidate=\"\" ng-submit=\"(surveyForm.$valid||assistCtrl.currentTest.nextEnabled) && assistCtrl.next(surveyForm)\" ng-style=\"(portalText.hostName==\'assist-knowyouroptions\'||portalText.hostName==\'myeassist-knowyouroptions\')&&{\'padding\':\'0 18%\'}\"><div class=\"lite-popup\"><div class=\"assistTest\" ng-include=\"assistCtrl.currentTest.template\"></div><div class=\"btns-move\"><div class=\"error-message\" ng-if=\"surveyForm.$submitted && surveyForm.$invalid\">Please complete all questions on the page to continue.</div><div><button class=\"btn btn-purple next-btn\" type=\"submit\" ng-if=\"assistCtrl.currentTest.isNext\" ng-disabled=\"surveyForm.$submitted && assistCtrl.isNextDisabled()\">Next <i class=\"fa fa-angle-right\"></i></button></div><div><button class=\"btn btn-bordered-purple btn-purple\" ng-if=\"assistCtrl.currentTest.isPrev\" type=\"button\" ng-click=\"assistCtrl.prev()\"><i class=\"fa fa-angle-left\"></i> Changed my mind</button></div></div></div></form></div></div><div class=\"col-md-4\" ng-if=\"(portalText.hostName!==\'assist-knowyouroptions\'&&portalText.hostName!==\'myeassist-knowyouroptions\')\"><div class=\"lite-popup\"><h1 class=\"assist-title\">What is the eASSIST?</h1><p>The eASSIST is an electronic version of the Alcohol, Smoking and Substance Involvement Screening Test (ASSIST) which was developed by the World Health Organization. The ASSIST has eight questions and takes approximately 5-10 minutes to complete. The ASSIST helps identify the risks associated with substance use and the personalised feedback helps explore options for change.</p><h1 class=\"assist-title\">Need Help?</h1><p>The Alcohol and Drug Information Service (ADIS) are State and Territory based phone services that offer information, advice and support. They provide services for health professionals, individuals, business and community groups. Phone 1800 250 015 to be linked to your nearest service.</p></div></div></div></div>");
$templateCache.put("app/components/assistLite/eAssistLite/eAssistLite.template.html","<div class=\"assistLite-content\"><div class=\"row\"><div class=\"col-md-8\"><form name=\"surveyForm\" class=\"survey-form\" novalidate=\"\" ng-submit=\"surveyForm.$valid && vm.nextTest(surveyForm)\"><div class=\"lite-popup\"><div ng-if=\"vm.isTest()\"><div class=\"assistTest\" ng-repeat=\"test in vm.tests\" ng-if=\"$index == vm.currentTestIndex\"><div ng-if=\"!test.type\"><div><span class=\"question-title\">{{test.name}}</span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"vm.currentTestIndex != 0\" value=\"vm.readyPercentage\"><span ng-show=\"vm.readyPercentage\">{{vm.readyPercentage}}%</span></uib-progressbar></div><p class=\"question-note\">These questions ask about psychoactive substances in the <span class=\"question-not-big\">past 3 months only</span>.</p><div class=\"questions\"><div class=\"question\" ng-class=\"{ \'is-disabled\' : question.isDisabled }\" ng-repeat=\"question in test.testQuestions\"><p class=\"question-text\">{{question.text}}</p><div ng-switch=\"question.type\"><div ng-switch-when=\"radio\"><ng-container ng-if=\"question.gender\"><div class=\"form-group radio-group\" ng-repeat=\"option in question.options\"><input id=\"question-{{test.name}}-{{question.text}}-{{$index}}\" name=\"{{$parent.$index + option.value + $index}}\" type=\"radio\" ng-change=\"vm.changeGenderTestState(test, question)\" ng-model=\"question.value\" ng-value=\"option.value\" ng-disabled=\"question.isDisabled\" ng-required=\"!question.isDisabled\"> <label class=\"label-radioBtn\" for=\"question-{{test.name}}-{{question.text}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{option.text}}</label></div><input type=\"text\" required=\"\" ng-model=\"question.otherGender\" ng-if=\"question.value==\'T\'\"></ng-container><ng-container ng-if=\"!question.gender\"><div class=\"form-group radio-group\" ng-repeat=\"option in question.options\"><input id=\"question-{{test.name}}-{{question.text}}-{{$index}}\" name=\"{{$parent.$index + option + $index}}\" type=\"radio\" ng-change=\"question.toggleOtherQuestions && vm.changeTestState(test, question)\" ng-model=\"question.value\" ng-value=\"option\" ng-disabled=\"question.isDisabled\" ng-required=\"!question.isDisabled\"> <label class=\"label-radioBtn\" for=\"question-{{test.name}}-{{question.text}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{option}}</label></div></ng-container></div></div><div ng-switch=\"question.type\"><div ng-switch-when=\"number\"><div class=\"form-group\"><input type=\"number\" ng-model=\"question.value\" required=\"\"></div></div></div><div ng-switch=\"question.type\"><div ng-switch-when=\"number-min\"><div class=\"form-group\"><input type=\"number\" ng-min=\"18\" name=\"age\" ng-model=\"question.value\" required=\"\"><br><br><span class=\"error-message\" ng-if=\"surveyForm.age.$touched && surveyForm.age.$invalid\">An age of 18+ is required to complete this survey.</span></div></div></div><div ng-switch=\"question.type\"><div ng-switch-when=\"text\"><div class=\"form-group\"><input type=\"text\" ng-model=\"question.value\" ng-disabled=\"question.isDisabled\" ng-required=\"!question.isDisabled\"></div></div></div></div></div><p class=\"question-note\" ng-if=\"vm.currentTestIndex == 2\">* A standard drink contains 10 grams of alcohol (approximately 285mls full strength beer, 375mls mid strength beer, 425mls low strength beer, 100mls wine, 30mls spirits, 60mls fortified wine)</p></div></div><div class=\"btns-move\"><div ng-if=\"surveyForm.$submitted && surveyForm.$invalid\" class=\"error-message\">Please complete all questions on the page to continue.</div><div><button class=\"btn btn-purple next-btn\" type=\"submit\" ng-disabled=\"surveyForm.$submitted && vm.isRequiredNext(surveyForm.$invalid)\">Next <i class=\"fa fa-angle-right\"></i></button></div><div><button class=\"btn btn-bordered-purple btn-purple\" type=\"button\" ng-if=\"vm.currentTestIndex > 0\" ng-click=\"vm.previousTest()\"><i class=\"fa fa-angle-left\"></i> Changed my mind</button></div></div></div><div class=\"videoWindow\" ng-if=\"vm.isFeedback\"><div class=\"assist-section text-center\"><h1 class=\"assist-title\">What\'s next?</h1></div><div class=\"assist-section\" ng-if=\"!vm.feedback.briefAdvice.length&&!vm.feedback.moderateAdvice.length && !vm.feedback.referralAdvice.length\">Thank you for completing the questions. Based on your answers, you are not at any risk of harms from drug or alcohol use at this time.</div><div class=\"assist-section\" ng-if=\"vm.feedback.briefAdvice.length||vm.feedback.moderateAdvice.length || vm.feedback.referralAdvice.length\">Click each section below to view brief, moderate and referral advice.</div><div class=\"assist-section assist-section-feedback\" ng-if=\"vm.feedback.briefAdvice.length\"><h2 class=\"assist-title\">Brief Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{((vm.feedback.briefAdvice[0].displayDrugName?vm.feedback.briefAdvice[0].displayDrugName:vm.feedback.briefAdvice[0].name)| capitalize) + (vm.feedback.briefAdvice[0].substance ? \' - \' + vm.feedback.briefAdvice[0].substance : \'\')}}\" is-open=\"vm.isBriefOpen\"><div ng-include=\"\" src=\"vm.feedback.briefAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in vm.feedback.briefAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.name | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"vm.feedback.moderateAdvice.length\"><h2 class=\"assist-title\">Moderate Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{((vm.feedback.moderateAdvice[0].displayDrugName?vm.feedback.moderateAdvice[0].displayDrugName:vm.feedback.moderateAdvice[0].name)| capitalize) + (vm.feedback.moderateAdvice[0].substance ? \' - \' + vm.feedback.moderateAdvice[0].substance : \'\')}}\" is-open=\"vm.isModerateOpen\"><div ng-include=\"\" src=\"vm.feedback.moderateAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in vm.feedback.moderateAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.name | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"vm.feedback.referralAdvice.length\"><h2 class=\"assist-title\">Referral Advice</h2><uib-accordion close-others=\"true\"><div data-name=\"{{vm.feedback.referralAdvice[0].name}}\" uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{((vm.feedback.referralAdvice[0].displayDrugName?vm.feedback.referralAdvice[0].displayDrugName:vm.feedback.referralAdvice[0].name) | capitalize) + (vm.feedback.referralAdvice[0].substance ? \' - \' + vm.feedback.referralAdvice[0].substance : \'\')}}\" is-open=\"vm.isReferralOpen\"><div ng-include=\"\" src=\"vm.feedback.referralAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in vm.feedback.referralAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.name | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><ng-include ng-if=\"vm.feedback.briefAdvice.length || vm.feedback.moderateAdvice.length || vm.feedback.referralAdvice.length\" src=\"\'app/components/assistLite/eAssistLite/pdf-download.html\'\"></ng-include><div class=\"btns-move\"><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-disabled=\"vm.loading\" ng-click=\"vm.saveAnswers()\">Next</button></div><div><button class=\"btn btn-bordered-purple btn-purple\" type=\"button\" ng-if=\"vm.currentTestIndex !== 0\" ng-click=\"vm.backToTest()\"><i class=\"fa fa-angle-left\"></i> Changed my mind</button></div></div></div><div class=\"videoWindow\" ng-if=\"vm.videoView\"><div class=\"assist-section text-center\"><h1 class=\"assist-title\">What\'s next?</h1><p>Thanks for completing the eASSIST Lite, where we hope you have found some improved results. Either way, you can download our \'My ASSIST\' App and find a range of resources any time by visiting <a href=\"http://assistportal.com.au/\" target=\"_blank\">ASSISTportal.com.au</a>.</p><div class=\"assist-section\" ng-if=\"vm.feedback.briefAdvice.length || vm.feedback.moderateAdvice.length || vm.feedback.referralAdvice.length\"><table class=\"table-eAssist table-bordered\"><thead><tr><th>Substance</th><th>Score</th><th>Risk</th><th>Criteria</th></tr></thead><tbody><tr><td>a. Tobacco</td><td>{{ vm.savedSurvey.criteria.tobacco}}</td><td><span class=\"text-success\" ng-if=\"vm.savedSurvey.criteria.tobacco < 1\">Low</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.tobacco >= 1 && vm.savedSurvey.criteria.tobacco <= 2\">Moderate</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.tobacco >= 3\">High</span></td><td><p>0 Low</p><p>1-2 Moderate</p><p>3 High</p></td></tr><tr><td>b. Alcohol</td><td>{{ vm.savedSurvey.criteria.alcohol}}</td><td><span class=\"text-success\" ng-if=\"vm.savedSurvey.criteria.alcohol <= 1\">Low</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.alcohol == 2\">Moderate</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.alcohol >= 3\">High</span></td><td><p>0-1 Low</p><p>2 Moderate</p><p>3-4 High</p></td></tr><tr><td>c. Cannabis</td><td>{{ vm.savedSurvey.criteria.cannabis}}</td><td><span class=\"text-success\" ng-if=\"vm.savedSurvey.criteria.cannabis < 1\">Low</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.cannabis >= 1 && vm.savedSurvey.criteria.cannabis <= 2\">Moderate</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.cannabis >= 3\">High</span></td><td><p>0 Low</p><p>1-2 Moderate</p><p>3 High</p></td></tr><tr><td>d. Stimulants</td><td>{{ vm.savedSurvey.criteria.stimulants}}</td><td><span class=\"text-success\" ng-if=\"vm.savedSurvey.criteria.stimulants < 1\">Low</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.stimulants >= 1 && vm.savedSurvey.criteria.stimulants <= 2\">Moderate</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.stimulants >= 3\">High</span></td><td><p>0 Low</p><p>1-2 Moderate</p><p>3 High</p></td></tr><tr><td>e. Sedatives</td><td>{{ vm.savedSurvey.criteria.sedatives}}</td><td><span class=\"text-success\" ng-if=\"vm.savedSurvey.criteria.sedatives < 1\">Low</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.sedatives >= 1 && vm.savedSurvey.criteria.sedatives <= 2\">Moderate</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.sedatives >= 3\">High</span></td><td><p>0 Low</p><p>1-2 Moderate</p><p>3 High</p></td></tr><tr><td>f. Opioids</td><td>{{ vm.savedSurvey.criteria.opioids}}</td><td><span class=\"text-success\" ng-if=\"vm.savedSurvey.criteria.opioids < 1\">Low</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.opioids >= 1 && vm.savedSurvey.criteria.opioids <= 2\">Moderate</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.opioids >= 3\">High</span></td><td><p>0 Low</p><p>1-2 Moderate</p><p>3 High</p></td></tr><tr><td>g. Other <span ng-if=\"vm.savedSurvey.criteria.otherText\">- {{ vm.savedSurvey.criteria.otherText}}</span></td><td>{{ vm.savedSurvey.criteria.other}}</td><td><span class=\"text-success\" ng-if=\"vm.savedSurvey.criteria.other < 1\">Low</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.other >= 1 && vm.savedSurvey.criteria.other <=2\">Moderate</span> <span class=\"text-danger\" ng-if=\"vm.savedSurvey.criteria.other >= 3\">High</span></td><td><p>0 Low</p><p>1-2 Moderate</p><p>3 High</p></td></tr></tbody></table><div class=\"row\"><h3 class=\"col-md-12 text-center\">What do your scores mean?</h3></div><div class=\"row\"><div class=\"col-md-2\"><strong>Low:</strong></div><div class=\"col-md-9\">You are at low risk of health and other problems from your current pattern of use.</div></div><div class=\"row\"><div class=\"col-md-2\"><strong>Moderate:</strong></div><div class=\"col-md-9\">You are at risk of health and other problems from your current pattern of substance use.</div></div><div class=\"row\"><div class=\"col-md-2\"><strong>High:</strong></div><div class=\"col-md-9\">You are at high risk of experiencing severe problems (health, social, financial, legal, relationship) as a result of your current pattern of use and are likely to be dependant.</div></div><p>* <strong>Referral</strong> only REQUIRED for \'High\' scores, but can be offered to anyone upon their request.</p></div><ng-include ng-if=\"vm.feedback.briefAdvice.length || vm.feedback.moderateAdvice.length || vm.feedback.referralAdvice.length\" src=\"\'app/components/assistLite/eAssistLite/pdf-download.html\'\"></ng-include><div class=\"btns-move\"><div class=\"assist-section assist-form-fields form-group\" ng-class=\"{ \'has-error\': !surveyForm.email.$valid && surveyForm.email.$touched && !surveyForm.email.$error.required }\" ng-hide=\"vm.isEmailSent\"><div class=\"form-input\"><input type=\"email\" class=\"form-control\" name=\"email\" placeholder=\"Enter your eMail\" ng-model=\"email.value\" ng-disabled=\"vm.isSendingEmail\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.email.$valid && surveyForm.email.$touched\">Please enter a valid email address.</p></div></div><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-disabled=\"!surveyForm.email.$valid || vm.isSendingEmail || vm.isEmailSent\" ng-click=\"vm.emailParticipantReport(email.value)\"><span ng-if=\"!vm.isSendingEmail && !vm.isEmailSent\">*eMail me my results</span> <span ng-if=\"vm.isSendingEmail\">Sending email...</span> <span ng-if=\"vm.isEmailSent\">eMail has been sent</span></button></div><div><a class=\"btn btn-purple next-btn\" ng-click=\"vm.backToFeedback()\"><i class=\"fa fa-angle-left\"></i> Go back to results</a></div></div></div><div class=\"assist-section\"><p>*Optional - we will not store your eMail address.</p></div></div><div class=\"videoWindow\" ng-if=\"vm.isError\">Sorry, error.</div></div></form></div><div class=\"col-md-4\"><div class=\"lite-popup\"><h1 class=\"assist-title\">What is eASSIST Lite?</h1><p>The eASSIST-Lite is an ultra-rapid screening tool based on the Alcohol, Smoking and Substance Involvement Screening Test (ASSIST) which was developed by the World Health Organization. Designed for time pressured environments, the ASSIST-Lite takes approximately 3-5 minutes to complete. The ASSIST-Lite helps identify the risks associated with substance use and the personalised feedback helps explore options for change.</p><h1 class=\"assist-title\">Need Help?</h1><p>The Alcohol and Drug Information Service (ADIS) are State and Territory based phone services that offer information, advice and support. They provide services for health professionals, individuals, business and community groups. Phone 1800 250 015 to be linked to your nearest service.</p></div></div></div></div>");
$templateCache.put("app/components/assistLite/eAssistLite/pdf-download.html","<div class=\"btns-move\"><span ng-if=\"vm.feedback.briefAdvice.length ||vm.feedback.moderateAdvice.length ||vm.feedback.referralAdvice.length\"><div ng-if=\"vm.videoView\" class=\"assist-section assist-form-fields form-group\" ng-show=\"vm.reportType === \'pdf\'\" ng-class=\"{ \'has-error\': !surveyForm.downloadingReportFileName.$valid && surveyForm.downloadingReportFileName.$touched && !surveyForm.downloadingReportFileName.$error.required }\"><div class=\"form-input\"><input type=\"text\" class=\"form-control\" name=\"downloadingReportFileName\" placeholder=\"Enter report filename\" ng-model=\"vm.downloadingReportFileName\" ng-disabled=\"vm.downloadingReportPdf\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.downloadingReportFileName.$valid && surveyForm.downloadingReportFileName.$touched\">Please enter a valid file name</p></div></div><div ng-if=\"vm.videoView\"><span class=\"btn-group\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a style=\"width: 90%;padding: 0;\" ng-click=\"vm.downloadReportPdf(vm.downloadingReportFileName)\" ng-disabled=\"(vm.reportType === \'pdf\'&& !vm.downloadingReportFileName)||vm.downloadingReportPdf||vm.downloadingFeedbackPdf\" class=\"btn btn-purple next-btn\">Download Report <span style=\"text-transform: uppercase;\">({{vm.reportType}})</span></a> <a style=\"width: 10%;padding: 0; border-bottom-left-radius: 0;border-top-left-radius: 0;\" class=\"btn btn-purple next-btn\" uib-dropdown-toggle=\"\" ng-click=\"$event.stopPropagation()\"><i class=\"fa fa-angle-down\"></i></a><ul style=\"width: 100%;\" class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li class=\"report-invite\"><a ng-click=\"vm.setReport(\'csv\')\">CSV</a></li><li class=\"report-invite\"><a ng-click=\"vm.setReport(\'pdf\')\">PDF</a></li></ul></span></div><div><button class=\"btn btn-purple next-btn\" ng-disabled=\"vm.downloadingReportPdf||vm.downloadingFeedbackPdf\" type=\"button\" ng-click=\"vm.downloadFeedbackPdf()\">Download Feedback (PDF)</button></div></span></div>");
$templateCache.put("app/components/auth/2fa/2fa.template.html","<div class=\"form-signin-wrap text-center\" style=\"padding-top: 20px;\"><div class=\"form-signin\"><form name=\"twofaForm\" style=\"margin-bottom: 0px !important;\" class=\"form-horizontal\" data-ng-submit=\"twofaCtrl.validateOtp(twofaCtrl.token)\"><div class=\"content\"><h4 class=\"title\">Validate Two-Factor Authentication (2FA)</h4><h6>Open the two-step verification app on your mobile device to get your verification code.</h6><div class=\"form-group row\"><div class=\"col-sm-12\"><input type=\"text\" placeholder=\"Enter Authentication Code\" name=\"token\" id=\"token\" class=\"form-control\" data-ng-model=\"twofaCtrl.token\" required=\"\"></div></div></div><div class=\"col-sm-12\" data-ng-show=\"twofaCtrl.error\"><alert class=\"alert alert-white-alt rounded no-close text-danger\" type=\"danger\"><div data-ng-click=\"twofaCtrl.clearError()\" class=\"icon\"><i class=\"fa fa-times-circle\"></i></div><strong>Error</strong> {{twofaCtrl.error.message}}</alert></div><div class=\"col-sm-12\" data-ng-show=\"twofaCtrl.inActiveError\"><alert class=\"alert alert-white-alt rounded no-close text-danger\" type=\"danger\"><div data-ng-click=\"twofaCtrl.clearError()\" class=\"icon\"><i class=\"fa fa-times-circle\"></i></div><strong>InActive Account.</strong> Please contact with your admin. Your account is Not Active/Disable by admin yet.</alert></div><div class=\"foot\"><button type=\"submit\" class=\"btn btn-primary\" data-dismiss=\"modal\" data-ng-disabled=\"twofaCtrl.loggingIn\"><i class=\"fa fa-spinner fa-spin\" data-ng-show=\"twofaCtrl.loggingIn\"></i> <i class=\"fa fa-sign-in\" data-ng-hide=\"twofaCtrl.loggingIn\"></i> Validate Code</button></div></form></div></div>");
$templateCache.put("app/components/auth/confirm-registration/confirm-registration.template.html","<div class=\"row\"><div class=\"col-md-4 auth-form-equal-col\"><div class=\"form-signin-wrap\"><form class=\"form-signin\" name=\"formSignup\" ng-submit=\"formSignup.$valid && vm.signup($event)\" novalidate=\"\"><div ng-if=\"!vm.isUserExist\"><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && !formSignup.password.$valid }\"><a uib-popover=\"{{vm.passwordErrorMessage}}\" class=\"far fa-question-circle password-explanation uib-popover\" ng-class=\"portalText.hostName\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter\'\" popover-toggle=\"popover\" popover-placement=\"top\"></a><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.password.$error.required\">Password is required.<br></span></p><input type=\"password\" class=\"form-control\" name=\"passwordData\" placeholder=\"Create a password\" required=\"\" ng-keyup=\"vm.checkPassword(formSignup.passwordData)\" ng-model=\"vm.user.passwordData\"> <input style=\"display: none;\" type=\"password\" class=\"form-control\" name=\"password\" placeholder=\"Create a password\" required=\"\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[ !@#$%^&*(),.?\':{}|<>]).{12,}$/\" ng-minlength=\"12\" ng-model=\"vm.user.password\"></div><div class=\"password-strength\" ng-class=\"vm.passwordStrength\"><span class=\"password-strength-label\"><span ng-if=\"vm.passwordStrength === \'weak\'\">Too short</span> <span ng-if=\"vm.passwordStrength === \'moderate\'\">Moderate</span> <span ng-if=\"vm.passwordStrength === \'strong\'\">Strong</span> <span ng-if=\"vm.passwordStrength === \'strength\'\">Strength</span></span> <span class=\"password-strength-graph\"></span></div><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && !formSignup.passwordConfirmation.$valid }\"><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.passwordConfirmation.$error.required\">Password confirmation is required.<br></span> <span ng-show=\"!formSignup.passwordConfirmation.$error.required && formSignup.passwordConfirmation.$error.passwordMatch\">Passwords do not match<br></span></p><input type=\"password\" class=\"form-control\" placeholder=\"Repeat Password\" name=\"passwordConfirmation\" required=\"\" match-password=\"password\" ng-model=\"vm.passwordConfirmation\"></div><div class=\"form-group checkbox-group\"><input id=\"userAgreement\" name=\"userAgreement\" type=\"checkbox\" required=\"\" ng-model=\"vm.params.userAgreement\"> <label class=\"label-checkbox\" for=\"userAgreement\"><span class=\"icon icon-checkbox\"></span> *I have read and agree to the terms of the <a ng-href=\"{{$root.settings.userAgreementLink}}\" target=\"_blank\">User Agreement</a> and <a ng-href=\"{{$root.settings.privacyAgreementLink}}\" target=\"_blank\">Privacy Policy</a>.</label><p class=\"error-message text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.userAgreement.$error.required\">You must agree to the terms and conditions before registering.</span></p><input id=\"emailNotifications\" name=\"emailNotifications\" type=\"checkbox\" required=\"\" ng-model=\"vm.params.emailNotifications\"> <label class=\"label-checkbox\" for=\"emailNotifications\"><span class=\"icon icon-checkbox\"></span> *I understand I may receive email notifications relating to portal activity. <span class=\"far fa-question-circle\" uib-popover-template=\"\'authPop1\'\" popover-placement=\"bottom auto\" popover-trigger=\"\'mouseenter\'\"></span><script type=\"text/ng-template\" id=\"authPop1\"><div class=\"people-popover\"> You can change your email notification settings. </div></script></label><p class=\"error-message text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.emailNotifications.$error.required\">You must agree to receive email notifications before registering.</span></p><input id=\"dateOfBirthTick\" name=\"dateOfBirthTick\" type=\"checkbox\" required=\"\" ng-model=\"vm.params.dateOfBirthTick\"> <label class=\"label-checkbox\" for=\"dateOfBirthTick\"><span class=\"icon icon-checkbox\"></span> *I\'m over 16 years old</label><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted && !vm.isDateOfBirthValid\"><span>Sorry, you must be over 16 years of age to use this service.<br></span></p><label class=\"label-checkbox\"><input class=\"form-dob-day\" type=\"text\" placeholder=\"dd\" ng-model=\"vm.birthDay\" ng-change=\"vm.checkDateOfBirth()\" ng-class=\"{ \'has-error\': formSignup.$submitted && !vm.isDateOfBirthValid}\" maxlength=\"2\" limit-to-max=\"\" max=\"31\"> <input class=\"form-dob-day\" type=\"text\" placeholder=\"mm\" ng-model=\"vm.birthMonth\" ng-change=\"vm.checkDateOfBirth\" ng-class=\"{ \'has-error\': formSignup.$submitted && !vm.isDateOfBirthValid}\" maxlength=\"2\" limit-to-max=\"\" max=\"12\"> <input class=\"form-dob-year\" type=\"text\" placeholder=\"yyyy\" ng-model=\"vm.birthYear\" ng-change=\"vm.checkDateOfBirth()\" ng-class=\"{ \'has-error\': formSignup.$submitted && !vm.isDateOfBirthValid}\" maxlength=\"4\"> <a uib-popover=\"You must confirm you are over 16 years old to user this service. Entering your date of birth is optional.\" class=\"far fa-question-circle uib-popover\" ng-class=\"portalText.hostName\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter\'\" popover-toggle=\"popover\" popover-placement=\"top\"></a></label> <input id=\"marketingEmails\" name=\"marketingEmails\" type=\"checkbox\" ng-model=\"vm.marketingEmails\"> <label class=\"label-checkbox\" for=\"marketingEmails\"><span class=\"icon icon-checkbox\"></span> I would like to receive marketing emails from time to time.</label></div><div class=\"form-group\"><button class=\"btn btn-signin btn-login btn-block\" type=\"submit\" ng-class=\"portalText.hostName\" ng-disabled=\"vm.isDisabled(formSignup)\"><span ng-if=\"!vm.loading\">Submit</span> <span ng-if=\"vm.loading\">Saving...</span></button></div></div><div ng-if=\"vm.isUserExist\"><p></p><h2 class=\"form-signin-heading form-signin-heading-info text-center\">This email address has already been registered, either here or via the Assist Portal.</h2><p></p><p></p><h2 class=\"form-signin-heading form-signin-heading-info text-center\" y=\"\">This email address has already been registered.</h2><p></p><p></p><h2 class=\"form-signin-heading form-signin-heading-info text-center\">If you were recently sent an invitation to register, please disregard and we apologise for any inconvenience.</h2><p></p><div class=\"btn btn-signin btn-login btn-block\" ng-class=\"portalText.hostName\" ui-sref=\"guest.login\">Log in</div></div></form></div></div><div class=\"col-md-8 auth-form-equal-col\"><div class=\"login-instructions text-center\"><h1 class=\"login-instructions-heading portal-text\">Welcome to {{portalText.hostName}} portal</h1><p>To complete registration on {{portalText.hostName}}, please read and accept the terms and conditions, then create a password and log in.</p></div></div></div>");
$templateCache.put("app/components/auth/login/login.template.html","<div class=\"auth-form-equal row\" ng-if=\"portalText.hostName===\'assist\'||portalText.hostName===\'assist-knowyouroptions\'\"><div class=\"col-md-4 auth-form-equal-col\"><div class=\"form-signin-wrap\"><form class=\"form-signin\" id=\"formLogin\" name=\"formLogin\" action=\"{{loginCtrl.loginUrl}}\" method=\"post\" novalidate=\"\"><h2 class=\"form-signin-heading text-center\"><span ng-bind-html=\"portalText.subtitlePortal\"></span></h2><p class=\"error-message text-center text-danger\" ng-if=\"loginCtrl.error\">{{loginCtrl.error}}</p><div class=\"form-group\" ng-class=\"{ \'has-error\': loginCtrl.hasError(formLogin) }\"><input type=\"email\" id=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email Address\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': loginCtrl.hasError(formLogin) }\"><input type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\"></div><div class=\"form-signin-forgot text-center\"><a ui-sref=\"guest.password-reset\">Forgot password?</a></div><div ng-if=\"loginCtrl.emailNotVerified\"><p class=\"portal-text text-center\">The eMail address entered has not yet been confirmed. Please click the link provided or click to resend a confirmation eMail below.</p><button type=\"button\" class=\"btn btn-signin btn-login btn-block\" ng-class=\"{\'disabled\': loginCtrl.resendingConfirmationEmail || loginCtrl.confirmationEmailResent}\" ng-click=\"loginCtrl.resendConfirmationEmail()\"><span ng-if=\"!loginCtrl.resendingConfirmationEmail && !loginCtrl.confirmationEmailResent\">Resend</span> <span ng-if=\"loginCtrl.resendingConfirmationEmail\">Sending email...</span> <span ng-if=\"loginCtrl.confirmationEmailResent\">eMail has been sent</span></button></div><button ng-if=\"!loginCtrl.emailNotVerified\" class=\"btn btn-signin btn-login btn-block\" ng-click=\"loginCtrl.loginFormSubmit($event)\" type=\"button\" ng-disabled=\"loginCtrl.isDisabled(formLogin)\">Log in</button><div ng-if=\"!loginCtrl.emailNotVerified\" class=\"form-group checkbox-group text-center\"><input id=\"signinRemmber\" type=\"checkbox\" ng-model=\"loginCtrl.params.rememberMe\"> <label class=\"label-checkbox\" for=\"signinRemmber\"><span class=\"icon icon-checkbox\"></span>Remember me</label></div></form></div></div><div class=\"col-md-8 auth-form-equal-col\"><div class=\"login-instructions text-center portal-color\"><h1 class=\"login-instructions-heading portal-color\">Welcome to eASSIST Administration</h1><p>Log in to view reports on the eASSIST, eASSIST Lite and eASSIST Lite (Research Project).</p></div></div></div><div class=\"myeassist-content\" ng-if=\"portalText.hostName===\'myeassist\'||portalText.hostName===\'myeassist-knowyouroptions\'\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-signin-wrap\"><form class=\"form-signin\" id=\"formLogin\" name=\"formLogin\" action=\"{{loginCtrl.loginUrl}}\" method=\"post\" novalidate=\"\"><h2 class=\"form-signin-heading text-center\"><span ng-bind-html=\"portalText.subtitlePortal\"></span></h2><p class=\"error-message text-center text-danger\" ng-if=\"loginCtrl.error\">{{loginCtrl.error}}</p><p class=\"error-message text-center text-danger\" ng-if=\"loginCtrl.errors.credentials\">Incorrect email or password.</p><div ng-if=\"loginCtrl.emailNotVerified\"><p class=\"portal-text text-center\">The eMail address entered has not yet been confirmed. Please click the link provided or click to resend a confirmation eMail below.</p><button type=\"button\" class=\"btn btn-signin btn-login btn-block\" ng-class=\"{\'disabled\': loginCtrl.resendingConfirmationEmail || loginCtrl.confirmationEmailResent}\" ng-click=\"loginCtrl.resendConfirmationEmail()\"><span ng-if=\"!loginCtrl.resendingConfirmationEmail && !loginCtrl.confirmationEmailResent\">Resend</span> <span ng-if=\"loginCtrl.resendingConfirmationEmail\">Sending email...</span> <span ng-if=\"loginCtrl.confirmationEmailResent\">eMail has been sent</span></button></div><div class=\"form-group\" ng-class=\"{ \'has-error\': loginCtrl.hasError(formLogin) }\"><input type=\"email\" id=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email Address\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': loginCtrl.hasError(formLogin) }\"><input type=\"password\" id=\"password\" name=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\"></div><div class=\"form-signin-forgot text-center\"><a ui-sref=\"guest.password-reset\">Forgot password?</a></div><button class=\"btn btn-signin btn-login btn-block\" ng-click=\"loginCtrl.loginFormSubmit($event)\" type=\"button\" ng-disabled=\"loginCtrl.isDisabled(formLogin)\"><span ng-if=\"!loginCtrl.loading\">Log in</span> <span ng-if=\"loginCtrl.loading\">Logging in...</span></button> <button ui-sref=\"guest.eAssist\" class=\"btn btn-skip btn-block\"><span>Skip this Step</span> <i class=\"fa fa-angle-double-right\"></i></button><div class=\"form-group checkbox-group text-center\"><input id=\"signinRemember\" type=\"checkbox\" ng-model=\"loginCtrl.params.rememberMe\"> <label class=\"label-checkbox\" for=\"signinRemember\"><span class=\"icon icon-checkbox\"></span>Remember me</label></div><div class=\"signup-text\">Don\'t have an account? <a ui-sref=\"guest.myeAssist-signup({\'returnTo\': loginCtrl.returnTo, \'params\': loginCtrl.returnToParams})\"><b>Sign Up</b></a></div></form></div></div><div class=\"col-md-8 myeassist-content-right\"><div class=\"myeassist-content-wrapper\"><h2 class=\"myeassist-content-header text-center\">Welcome to The eASSIST</h2><p class=\"myeassist-content-header-text text-center\">Register or log in to the eASSIST to keep a record of your results.</p><div class=\"myeassist-content-btnwrapper\"><button class=\"myeassist-content-button\" ui-sref=\"guest.home\" ui-sref-active=\"active\">Log in</button> <button class=\"myeassist-content-button\" ui-sref=\"guest.myeAssist-signup\" ui-sref-active=\"active\">Register</button></div><h3 class=\"myeassist-content-subheader text-center\">What is the eASSIST?</h3><span class=\"myeassist-content-text text-center\"><p>The eASSIST is an electronic version of the Alcohol, Smoking and Substance Involvement Screening Test (ASSIST).</p><p>The ASSIST was developed for the World Health Organisation (WHO), by an international group of specialists, as a tool that is easy to use to detect substance use and related problems. The ASSIST is an eight-item questionnaire and takes approximately 5-10 minutes to complete. The ASSIST helps identify the risks associated with substance use.</p><p>The eASSIST provides feedback on any risks and can help you explore options for addressing those risks.</p></span></div></div></div></div>");
$templateCache.put("app/components/auth/policy/policy.template.html","<div class=\"form-signin-wrap text-center\"><div class=\"form-signin\"><div>I have read and agree to the terms of the <a href=\"https://about.opentute.com/user-agreement/\" target=\"_blank\">User Agreement</a> and <a href=\"https://about.opentute.com/privacy-policy/\" target=\"_blank\">Privacy Policy</a>.</div><div class=\"policy-buttons\"><button class=\"btn btn-gray btn-wide\" type=\"button\" ng-click=\"policyCtrl.accept()\">Accept</button> <button class=\"btn btn-purple btn-wide\" type=\"button\" ng-click=\"policyCtrl.logout()\">Reject</button></div></div></div>");
$templateCache.put("app/components/auth/user-exists/userExists.template.html","<div class=\"form-signin-wrap text-center\"><div class=\"form-signin\"><h1 class=\"logo logo-colored text-hide\"><a ui-sref=\"guest.login\" class=\"logo-link\">{{portalText.hostName}} portal</a></h1><div>This email has already been registered on this Portal. Would you like to proceed with the existing account?</div><div class=\"policy-buttons\"><a class=\"btn btn-gray btn-wide\" ng-click=\"vm.accept()\">Accept</a> <a class=\"btn btn-purple btn-wide\" ng-click=\"vm.logout()\">Reject</a></div></div></div>");
$templateCache.put("app/components/layout/guest/guest.layout.template.html","<div class=\"row\" ng-include=\"\" ng-if=\"portalText.hostName == \'assist\'\" src=\"layoutCtrl.HEADER_PATH\"></div><div class=\"row\" ng-include=\"\" ng-if=\"portalText.hostName == \'myeassist\'\" src=\"layoutCtrl.HEADER_PATH\"></div><div class=\"row\" ng-include=\"\" ng-if=\"portalText.hostName == \'assist-knowyouroptions\'\" src=\"layoutCtrl.HEADER_PATH\"></div><div class=\"row\" ng-include=\"\" ng-if=\"portalText.hostName == \'myeassist-knowyouroptions\'\" src=\"layoutCtrl.HEADER_PATH\"></div><div class=\"guest-wrap\"><div class=\"guest-bg\"></div><div class=\"container-fluid\" ng-class=\"{\'container\': portalText.hostName == \'assist\' || portalText.hostName == \'myeassist-knowyouroptions\'|| portalText.hostName == \'myeassist\'|| portalText.hostName == \'assist-knowyouroptions\' }\"><div class=\"row\"><div class=\"login-container\" ui-view=\"\"></div></div></div><footer ng-include=\"\" ng-if=\"portalText.hostName == \'assist\'\" src=\"layoutCtrl.FOOTER_ASSIST_PATH\" class=\"page-footer\"></footer><footer ng-include=\"\" ng-if=\"portalText.hostName == \'myeassist\'\" src=\"layoutCtrl.FOOTER_ASSIST_PATH\" class=\"page-footer\"></footer><footer ng-include=\"\" ng-if=\"portalText.hostName == \'assist-knowyouroptions\'\" src=\"layoutCtrl.FOOTER_ASSIST_PATH\" class=\"page-footer\"></footer><footer ng-include=\"\" ng-if=\"portalText.hostName == \'myeassist-knowyouroptions\'\" src=\"layoutCtrl.FOOTER_ASSIST_PATH\" class=\"page-footer\"></footer><footer ng-include=\"\" ng-if=\"portalText.hostName != \'myeassist-knowyouroptions\'&& portalText.hostName != \'assist-knowyouroptions\'&& portalText.hostName != \'assist\' && portalText.hostName != \'myeassist\'\" src=\"layoutCtrl.FOOTER_PATH\" class=\"page-footer\"></footer></div>");
$templateCache.put("app/components/layout/partials/footer-landing.assist-knowyouroptions.partial.html","<footer class=\"footer\" style=\"position: relative;\"><div class=\"container\"><div class=\"row\"><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"footer__quote-bg\"></div><div class=\"footer__quote\"><blockquote class=\"quote\"><svg class=\"svg-icon quote-marks\" viewbox=\"0 0 32 32\" fill=\"#7d9ef0\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.488,7.016c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.79,3.665,6.79,9.255 c0,3.574-2.046,5.865-5.767,5.865C2.605,28,0,23.693,0,18.928C0,11.323,5.581,5,13.302,5h0.651l0.372,2.016H13.488z M31.163,7.016 c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.791,3.665,6.791,9.255c0,3.574-2.047,5.865-5.768,5.865 c-4.651,0-7.256-4.307-7.256-9.072C17.675,11.323,23.256,5,30.977,5h0.651L32,7.016H31.163z\"></path></svg><p>Sometimes you try to get help and you hit a dead end. You’ve got to keep trying, eventually you will find something that works.<br></p><svg class=\"svg-icon quote-marks quote-marks--reversed\" viewbox=\"0 0 32 32\" fill=\"#7d9ef0\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.488,7.016c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.79,3.665,6.79,9.255 c0,3.574-2.046,5.865-5.767,5.865C2.605,28,0,23.693,0,18.928C0,11.323,5.581,5,13.302,5h0.651l0.372,2.016H13.488z M31.163,7.016 c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.791,3.665,6.791,9.255c0,3.574-2.047,5.865-5.768,5.865 c-4.651,0-7.256-4.307-7.256-9.072C17.675,11.323,23.256,5,30.977,5h0.651L32,7.016H31.163z\"></path></svg></blockquote></div></div><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"footer__contact-bg\"></div><div class=\"footer__contact\"><p>Call the Alcohol and Drug Information Service for confidential telephone counselling, information and referral.</p><p><strong>Telephone 1300 13 1340</strong><br>(any day 8:30am – 10:00pm SA callers only)</p><hr><p><a href=\"https://counsellingonline.org.au\" target=\"_blank\" rel=\"noopener noreferrer\">Click here for free online counselling</a> for yourself or concerned family and friends.</p><img src=\"https://knowyouroptions.sa.gov.au/assets/img/counselling-online-logo.svg\" alt=\"Counselling Online\"></div></div></div></div><div class=\"container sub-footer\"><div class=\"row\"><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"sub-footer__quote-bg\"></div><div class=\"sub-footer__quote\"><p>Find out more about what the South Australian Government is doing to address alcohol and other drug issues. <a style=\"color: #7d9ef0;\" target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/south-australian-alcohol-and-other-drug-strategy\">Click here to view strategy&nbsp;documents</a>.</p></div></div><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"sub-footer__contact-bg\"></div><div class=\"sub-footer__contact\"><p>© 2020 Drug and Alcohol Services South Australia</p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/privacy-policy\">Privacy Policy</a></p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/copyright\">Copyright</a></p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/disclaimer\">Disclaimer</a></p><p>–&nbsp;&nbsp;<a href=\"https://knowyouroptions.sa.gov.au/policies/apply-to-list-service-provider-on-know-your-options\">Service Providers - Update or List your service on Know Your Options</a></p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/sitemap\">Sitemap</a></p><div class=\"sub-footer__logo-wrapper\"><a class=\"sub-footer__logo\" href=\"http://www.sahealth.sa.gov.au/\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"https://knowyouroptions.sa.gov.au/assets/img/sa-health-logo.svg\" alt=\"Government of South Australia\"></a> <a class=\"sub-footer__logo\" href=\"http://sandas.org.au/\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"https://knowyouroptions.sa.gov.au/assets/img/sandas-logo.svg\" alt=\"South Australian Network of Drug and Alcohol Services (SANDAS)\"></a></div></div></div></div><svg width=\"100\" height=\"99\" viewbox=\"0 0 100 99\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"squiggle-arc squiggle-arc--footer-1\"><path d=\"M2 96.8302C34 98.903 98 82.8389 98 1.99999\" stroke=\"currentColor\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><svg width=\"100\" height=\"99\" viewbox=\"0 0 100 99\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"squiggle-arc squiggle-arc--footer-2\"><path d=\"M2 96.8302C34 98.903 98 82.8389 98 1.99999\" stroke=\"currentColor\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div></footer>");
$templateCache.put("app/components/layout/partials/footer-landing.assist.partial.html","<footer><div class=\"container\"><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-3\"><div id=\"custom_html-5\" class=\"widget_text widget widget_custom_html\"><div class=\"textwidget custom-html-widget\"><div><a href=\"https://assistportal.com.au/\" target=\"_blank\" class=\"\"><img alt=\"\" data-src=\"https://assistportal.com.au/wp-content/themes/assistportal/images/footer-logo-ap.jpg\" class=\"ls-is-cached lazyloaded\" src=\"https://assistportal.com.au/wp-content/themes/assistportal/images/footer-logo-ap.jpg\"></a></div></div></div></div><div class=\"col-lg-5 col-md-5 col-sm-5\"><div id=\"custom_html-2\" class=\"widget_text widget widget_custom_html\"><div class=\"textwidget custom-html-widget\"><ul><li>The University of Adelaide,</li><li>Adelaide,</li><li>South Australia 5005</li><li>Australia</li></ul></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4\"><ul><li><a href=\"https://www.assistportal.com.au/user-agreement/\" rel=\"nofollow\">User Agreements</a></li><li><a href=\"https://opentute.com/privacy-policy-2/\" rel=\"nofollow\">Privacy Policy</a></li><li><a href=\"https://opentute.com/gdpr-compliance/\" rel=\"nofollow\">GPDR</a></li><li><a href=\"https://webdesigncafe.com.au\" rel=\"nofollow\">Developed by Web Design Cafe</a></li><li><a href=\"https://opentute.com.au\" rel=\"nofollow\">Learning Experience Platform by Opentute</a></li></ul></div></div></div></footer>");
$templateCache.put("app/components/layout/partials/footer-landing.myeassist-knowyouroptions.partial.html","<footer class=\"footer\" style=\"position: relative;\"><div class=\"container\"><div class=\"row\"><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"footer__quote-bg\"></div><div class=\"footer__quote\"><blockquote class=\"quote\"><svg class=\"svg-icon quote-marks\" viewbox=\"0 0 32 32\" fill=\"#7d9ef0\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.488,7.016c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.79,3.665,6.79,9.255 c0,3.574-2.046,5.865-5.767,5.865C2.605,28,0,23.693,0,18.928C0,11.323,5.581,5,13.302,5h0.651l0.372,2.016H13.488z M31.163,7.016 c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.791,3.665,6.791,9.255c0,3.574-2.047,5.865-5.768,5.865 c-4.651,0-7.256-4.307-7.256-9.072C17.675,11.323,23.256,5,30.977,5h0.651L32,7.016H31.163z\"></path></svg><p>Sometimes you try to get help and you hit a dead end. You’ve got to keep trying, eventually you will find something that works.<br></p><svg class=\"svg-icon quote-marks quote-marks--reversed\" viewbox=\"0 0 32 32\" fill=\"#7d9ef0\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.488,7.016c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.79,3.665,6.79,9.255 c0,3.574-2.046,5.865-5.767,5.865C2.605,28,0,23.693,0,18.928C0,11.323,5.581,5,13.302,5h0.651l0.372,2.016H13.488z M31.163,7.016 c-2.791,0-7.256,1.833-7.256,5.865c0,4.765,6.791,3.665,6.791,9.255c0,3.574-2.047,5.865-5.768,5.865 c-4.651,0-7.256-4.307-7.256-9.072C17.675,11.323,23.256,5,30.977,5h0.651L32,7.016H31.163z\"></path></svg></blockquote></div></div><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"footer__contact-bg\"></div><div class=\"footer__contact\"><p>Call the Alcohol and Drug Information Service for confidential telephone counselling, information and referral.</p><p><strong>Telephone 1300 13 1340</strong><br>(any day 8:30am – 10:00pm SA callers only)</p><hr><p><a href=\"https://counsellingonline.org.au\" target=\"_blank\" rel=\"noopener noreferrer\">Click here for free online counselling</a> for yourself or concerned family and friends.</p><img src=\"https://knowyouroptions.sa.gov.au/assets/img/counselling-online-logo.svg\" alt=\"Counselling Online\"></div></div></div></div><div class=\"container sub-footer\"><div class=\"row\"><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"sub-footer__quote-bg\"></div><div class=\"sub-footer__quote\"><p>Find out more about what the South Australian Government is doing to address alcohol and other drug issues. <a target=\"_blank\" style=\"color: #7d9ef0;\" href=\"https://knowyouroptions.sa.gov.au/policies/south-australian-alcohol-and-other-drug-strategy\">Click here to view strategy&nbsp;documents</a>.</p></div></div><div class=\"split-cols col-xs-12 col-md-6\"><div class=\"sub-footer__contact-bg\"></div><div class=\"sub-footer__contact\"><p>© 2020 Drug and Alcohol Services South Australia</p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/privacy-policy\">Privacy Policy</a></p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/copyright\">Copyright</a></p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/disclaimer\">Disclaimer</a></p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/policies/apply-to-list-service-provider-on-know-your-options\">Service Providers - Update or List your service on Know Your Options</a></p><p>–&nbsp;&nbsp;<a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/sitemap\">Sitemap</a></p><div class=\"sub-footer__logo-wrapper\"><a class=\"sub-footer__logo\" href=\"http://www.sahealth.sa.gov.au/\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"https://knowyouroptions.sa.gov.au/assets/img/sa-health-logo.svg\" alt=\"Government of South Australia\"></a> <a class=\"sub-footer__logo\" href=\"http://sandas.org.au/\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"https://knowyouroptions.sa.gov.au/assets/img/sandas-logo.svg\" alt=\"South Australian Network of Drug and Alcohol Services (SANDAS)\"></a></div></div></div></div><svg width=\"100\" height=\"99\" viewbox=\"0 0 100 99\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"squiggle-arc squiggle-arc--footer-1\"><path d=\"M2 96.8302C34 98.903 98 82.8389 98 1.99999\" stroke=\"currentColor\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><svg width=\"100\" height=\"99\" viewbox=\"0 0 100 99\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"squiggle-arc squiggle-arc--footer-2\"><path d=\"M2 96.8302C34 98.903 98 82.8389 98 1.99999\" stroke=\"currentColor\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div></footer>");
$templateCache.put("app/components/layout/partials/footer-landing.myeassist.partial.html","<footer><div class=\"container\"><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-3\"><div id=\"custom_html-5\" class=\"widget_text widget widget_custom_html\"><div class=\"textwidget custom-html-widget\"><div><a href=\"https://assistplus.com.au/\" target=\"_blank\" class=\"\"><img alt=\"\" data-src=\"https://assistplus.com.au/wp-content/themes/assistportal/images/footer-logo-new.png\" class=\"ls-is-cached lazyloaded\" src=\"https://assistplus.com.au/wp-content/themes/assistportal/images/footer-logo-new.png\"></a></div></div></div></div><div class=\"col-lg-5 col-md-5 col-sm-5\"><div id=\"custom_html-2\" class=\"widget_text widget widget_custom_html\"><div class=\"textwidget custom-html-widget\"><ul><li>The University of Adelaide,</li><li>Adelaide,</li><li>South Australia 5005</li><li>Australia</li></ul></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4\"><ul><li><a href=\"https://assistplus.com.au/user-agreement/\" rel=\"nofollow\">User Agreements</a></li><li><a href=\"https://opentute.com/privacy-policy-2/\" rel=\"nofollow\">Privacy Policy</a></li><li><a href=\"https://opentute.com/gdpr-compliance/\" rel=\"nofollow\">GPDR</a></li><li><a href=\"https://webdesigncafe.com.au\" rel=\"nofollow\">Developed by Web Design Cafe</a></li><li><a href=\"https://opentute.com.au\" rel=\"nofollow\">Learning Experience Platform by Opentute</a></li></ul></div></div></div></footer>");
$templateCache.put("app/components/layout/partials/footer.assist-knowyouroptions.partial.html","<ul class=\"list-inline\"><li><a href=\"https://lms.opentute.com/support/\" target=\"_blank\" class=\"page-footer-link\">IT Support</a></li><li><a href=\"http://assistportal.com.au/about/\" target=\"_blank\" class=\"page-footer-link\">About</a></li><li><a href=\"http://assistportal.com.au/contact-us/\" target=\"_blank\" class=\"page-footer-link\">Contact Us</a></li><li><a href=\"http://assistportal.com.au/\" target=\"_blank\" class=\"page-footer-link\">Public Portal</a></li><li><a href=\"http://assistportal.com.au/user-agreement/\" target=\"_blank\" class=\"page-footer-link\">User Agreement</a></li><li><a href=\"https://lms.opentute.com/privacy-policy/\" target=\"_blank\" class=\"page-footer-link\">Privacy</a></li></ul><div class=\"page-footer-cp text-center\">Copyright &copy; <a href=\"http://assistportal.com.au\" target=\"_blank\">DASSA WHO Collaborating Centre, University of Adelaide</a>.<br>Powered by <a href=\"https://LMS.opentute.com\" target=\"_blank\">OpenTute LMS</a> and <a href=\"http://webdesigncafe.com.au\" target=\"_blank\">Web Design Cafe</a>.</div><div class=\"page-footer-fake-bg\"></div>");
$templateCache.put("app/components/layout/partials/footer.assist.partial.html","<ul class=\"list-inline\"><li><a href=\"https://lms.opentute.com/support/\" target=\"_blank\" class=\"page-footer-link\">IT Support</a></li><li><a href=\"http://assistportal.com.au/about/\" target=\"_blank\" class=\"page-footer-link\">About</a></li><li><a href=\"http://assistportal.com.au/contact-us/\" target=\"_blank\" class=\"page-footer-link\">Contact Us</a></li><li><a href=\"http://assistportal.com.au/\" target=\"_blank\" class=\"page-footer-link\">Public Portal</a></li><li><a href=\"http://assistportal.com.au/user-agreement/\" target=\"_blank\" class=\"page-footer-link\">User Agreement</a></li><li><a href=\"https://lms.opentute.com/privacy-policy/\" target=\"_blank\" class=\"page-footer-link\">Privacy</a></li></ul><div class=\"page-footer-cp text-center\">Copyright &copy; <a href=\"http://assistportal.com.au\" target=\"_blank\">DASSA WHO Collaborating Centre, University of Adelaide</a>.<br>Powered by <a href=\"https://LMS.opentute.com\" target=\"_blank\">OpenTute LMS</a> and <a href=\"http://webdesigncafe.com.au\" target=\"_blank\">Web Design Cafe</a>.</div><div class=\"page-footer-fake-bg\"></div>");
$templateCache.put("app/components/layout/partials/footer.myeassist-knowyouroptions.partial.html","<ul class=\"list-inline\"><li><a href=\"https://lms.opentute.com/support/\" target=\"_blank\" class=\"page-footer-link\">IT Support</a></li><li><a href=\"http://assistportal.com.au/about/\" target=\"_blank\" class=\"page-footer-link\">About</a></li><li><a href=\"http://assistportal.com.au/contact-us/\" target=\"_blank\" class=\"page-footer-link\">Contact Us</a></li><li><a href=\"http://assistportal.com.au/\" target=\"_blank\" class=\"page-footer-link\">Public Portal</a></li><li><a href=\"http://assistportal.com.au/user-agreement/\" target=\"_blank\" class=\"page-footer-link\">User Agreement</a></li><li><a href=\"https://lms.opentute.com/privacy-policy/\" target=\"_blank\" class=\"page-footer-link\">Privacy</a></li></ul><div class=\"page-footer-cp text-center\">Copyright &copy; <a href=\"http://assistportal.com.au\" target=\"_blank\">DASSA WHO Collaborating Centre, University of Adelaide</a>.<br>Powered by <a href=\"https://LMS.opentute.com\" target=\"_blank\">OpenTute LMS</a> and <a href=\"http://webdesigncafe.com.au\" target=\"_blank\">Web Design Cafe</a>.</div><div class=\"page-footer-fake-bg\"></div>");
$templateCache.put("app/components/layout/partials/footer.myeassist.partial.html","<ul class=\"list-inline\"><li><a href=\"https://lms.opentute.com/support/\" target=\"_blank\" class=\"page-footer-link\">IT Support</a></li><li><a href=\"http://assistportal.com.au/about/\" target=\"_blank\" class=\"page-footer-link\">About</a></li><li><a href=\"http://assistportal.com.au/contact-us/\" target=\"_blank\" class=\"page-footer-link\">Contact Us</a></li><li><a href=\"http://assistportal.com.au/\" target=\"_blank\" class=\"page-footer-link\">Public Portal</a></li><li><a href=\"http://assistportal.com.au/user-agreement/\" target=\"_blank\" class=\"page-footer-link\">User Agreement</a></li><li><a href=\"https://lms.opentute.com/privacy-policy/\" target=\"_blank\" class=\"page-footer-link\">Privacy</a></li></ul><div class=\"page-footer-cp text-center\">Copyright &copy; <a href=\"http://assistportal.com.au\" target=\"_blank\">DASSA WHO Collaborating Centre, University of Adelaide</a>.<br>Powered by <a href=\"https://LMS.opentute.com\" target=\"_blank\">OpenTute LMS</a> and <a href=\"http://webdesigncafe.com.au\" target=\"_blank\">Web Design Cafe</a>.</div><div class=\"page-footer-fake-bg\"></div>");
$templateCache.put("app/components/layout/partials/header.assist-knowyouroptions.partial.html","<svg style=\"position: absolute; width: 0; height: 0; overflow: hidden;\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><symbol id=\"icon-arrow\" viewbox=\"0 0 25 33\"><path fill=\"#7d9ef0\" d=\"M1.16,33c-0.251,0-0.502-0.077-0.711-0.23c-0.406-0.298-0.556-0.813-0.369-1.265L6.294,16.5 L0.08,1.496C-0.108,1.043,0.043,0.528,0.449,0.23S1.42-0.078,1.837,0.206l22.668,15.396c0.038,0.025,0.074,0.052,0.109,0.081 c0.036,0.031,0.07,0.063,0.101,0.097c0.176,0.191,0.283,0.44,0.285,0.714l0,0c0,0.001,0,0.001,0,0.002l0,0c0,0.001,0,0.001,0,0.002 c-0.001,0,0,0.002,0,0.002c0,0.001-0.001,0.002,0,0.002c0,0.001,0,0.001,0,0.002l0,0c0,0.001,0,0.001,0,0.002l0,0 c-0.002,0.273-0.109,0.522-0.285,0.714c-0.031,0.034-0.065,0.067-0.101,0.097c-0.035,0.029-0.071,0.056-0.109,0.081L1.837,32.794 C1.634,32.931,1.397,33,1.16,33z M8.331,17.596l-4.66,11.253L20.24,17.596H8.331z M8.331,15.404h11.908L3.671,4.151L8.331,15.404z\"></path></symbol></defs></svg><div class=\"wrapper\"><div class=\"logo-bar\"><a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/\" class=\"logo-bar__logo-link\"><h1 class=\"logo-bar__logo-text\">Know Your Options</h1></a> <a href=\"javascript:;\" data-fancybox=\"\" data-src=\"#js-change-language\" class=\"logo-bar__translate\"></a> <a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/help\" class=\"logo-bar__speak\"><p>Contact someone now</p><svg class=\"svg-icon icon-arrow\"><use xlink:href=\"#icon-arrow\"></use></svg></a></div><header class=\"header bg--white\"><a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/\" class=\"header__back-button\">– home</a></header></div>");
$templateCache.put("app/components/layout/partials/header.assist.partial.html","<header><div class=\"top-part\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 src-but text-right\"><ul class=\"social_sec\"><li><a href=\"https://www.facebook.com/assistprogram\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i></a></li><li><a href=\"https://www.youtube.com/channel/UCc0RRjRDruVQjRMst8y1Opg\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-youtube\" aria-hidden=\"true\"></i></a></li><li><a href=\"https://www.linkedin.com/in/robert-ali-93753511/\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-linkedin-square\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div><div class=\"mobile-head-sec\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-4 mob-logo\"><a href=\"https://assistportal.com.au/\"><img style=\"position:absolute;height:92px;left:32px;\" src=\"https://www.assistportal.com.au/wp-content/themes/assistportal/images/logo-ap.png\" alt=\"\"></a></div><div class=\"col-md-8 col-8 mob-menu text-right\"><ul class=\"src-tab\"><li><a ng-click=\"toggleMenu()\" class=\"mob-menu-icon\"><span></span> <span></span> <span></span></a></li></ul><div class=\"mobile-menu-open\" ng-class=\"{\'slide-menu\':openMobileMenu }\"><div class=\"relative-boxes src-tab\"><a ng-click=\"toggleMenu()\" class=\"mob-menu-icon position-absoluteing\" ng-class=\"{\'open-menu\':openMobileMenu }\"><i class=\"fa fa-close\"></i></a></div><a href=\"https://assistportal.com.au/\" class=\"logo-mob\"><img src=\"https://www.assistportal.com.au/wp-content/themes/assistportal/images/logo-ap.png\" alt=\"\"></a><ul class=\"menus\"><a href=\"#\"></a><li id=\"menu-item-119\" class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-119\"><a href=\"https://www.assistportal.com.au/\">HOME</a></li><li id=\"menu-item-120\" class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-120\"><a href=\"https://www.assistportal.com.au/#screening\">SCREENING</a></li><li id=\"menu-item-120\" class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-120\"><a href=\"https://www.assistportal.com.au/#resources\">RESOURCES</a></li><li id=\"menu-item-82\" class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-82\"><a href=\"https://www.assistportal.com.au/#elearning\">eLEARNING</a></li><li id=\"menu-item-22\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-22\"><a href=\"https://www.assistportal.com.au/contact-us/\">Contact Us</a></li></ul></div></div></div></div></div><div class=\"menu-part\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-3 logo-sec\"><a href=\"https://assistportal.com.au/\"><img style=\"position:absolute;\" src=\"https://www.assistportal.com.au/wp-content/themes/assistportal/images/logo-ap.png\" alt=\"\"></a></div><div class=\"col-md-9 menu-sec text-right\" style=\"float: right;\"><div id=\"navigation\"><nav><ul><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-119\"><a href=\"https://www.assistportal.com.au/\">HOME</a></li><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-120\"><a href=\"https://www.assistportal.com.au/#screening\">SCREENING</a></li><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-120\"><a href=\"https://www.assistportal.com.au/#resources\">RESOURCES</a></li><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-82\"><a href=\"https://www.assistportal.com.au/#elearning\">eLEARNING</a></li><li class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-22\"><a href=\"https://www.assistportal.com.au/contact-us/\">Contact Us</a></li></ul></nav></div></div></div></div></div></header>");
$templateCache.put("app/components/layout/partials/header.myeassist-knowyouroptions.partial.html","<svg style=\"position: absolute; width: 0; height: 0; overflow: hidden;\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><symbol id=\"icon-arrow\" viewbox=\"0 0 25 33\"><path fill=\"#7d9ef0\" d=\"M1.16,33c-0.251,0-0.502-0.077-0.711-0.23c-0.406-0.298-0.556-0.813-0.369-1.265L6.294,16.5 L0.08,1.496C-0.108,1.043,0.043,0.528,0.449,0.23S1.42-0.078,1.837,0.206l22.668,15.396c0.038,0.025,0.074,0.052,0.109,0.081 c0.036,0.031,0.07,0.063,0.101,0.097c0.176,0.191,0.283,0.44,0.285,0.714l0,0c0,0.001,0,0.001,0,0.002l0,0c0,0.001,0,0.001,0,0.002 c-0.001,0,0,0.002,0,0.002c0,0.001-0.001,0.002,0,0.002c0,0.001,0,0.001,0,0.002l0,0c0,0.001,0,0.001,0,0.002l0,0 c-0.002,0.273-0.109,0.522-0.285,0.714c-0.031,0.034-0.065,0.067-0.101,0.097c-0.035,0.029-0.071,0.056-0.109,0.081L1.837,32.794 C1.634,32.931,1.397,33,1.16,33z M8.331,17.596l-4.66,11.253L20.24,17.596H8.331z M8.331,15.404h11.908L3.671,4.151L8.331,15.404z\"></path></symbol></defs></svg><div class=\"wrapper\"><div class=\"logo-bar\"><a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/\" class=\"logo-bar__logo-link\"><h1 class=\"logo-bar__logo-text\">Know Your Options</h1></a> <a href=\"javascript:;\" data-fancybox=\"\" data-src=\"#js-change-language\" class=\"logo-bar__translate\"></a> <a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/help\" class=\"logo-bar__speak\"><p>Contact someone now</p><svg class=\"svg-icon icon-arrow\"><use xlink:href=\"#icon-arrow\"></use></svg></a></div><header class=\"header bg--white\"><a target=\"_blank\" href=\"https://knowyouroptions.sa.gov.au/\" class=\"header__back-button\">– home</a></header></div>");
$templateCache.put("app/components/layout/partials/header.myeassist.partial.html","<header><div class=\"top-part\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 src-but text-right\"><ul class=\"social_sec\"><li><a href=\"https://www.facebook.com/assistprogram\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i></a></li><li><a href=\"https://www.youtube.com/channel/UCc0RRjRDruVQjRMst8y1Opg\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-youtube\" aria-hidden=\"true\"></i></a></li><li><a href=\"https://www.linkedin.com/in/robert-ali-93753511/\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-linkedin-square\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div><div class=\"mobile-head-sec\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-4 mob-logo\"><a href=\"https://assistplus.com.au/\"><img style=\"position:absolute;height:92px;left:32px;\" src=\"/assets/images/shared/logo.png\" alt=\"\"></a></div><div class=\"col-md-8 col-8 mob-menu text-right\"><ul class=\"src-tab\"><li><a ng-click=\"toggleMenu()\" class=\"mob-menu-icon\"><span></span> <span></span> <span></span></a></li></ul><div class=\"mobile-menu-open\" ng-class=\"{\'slide-menu\':openMobileMenu }\"><div class=\"relative-boxes src-tab\"><a ng-click=\"toggleMenu()\" class=\"mob-menu-icon position-absoluteing\" ng-class=\"{\'open-menu\':openMobileMenu }\"><i class=\"fa fa-close\"></i></a></div><a href=\"https://assistplus.com.au/\" class=\"logo-mob\"><img src=\"/assets/images/shared/logo.png\" alt=\"\"></a><ul class=\"menus\"><a href=\"#\"></a><li id=\"menu-item-119\" class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-119\"><a href=\"https://assistplus.com.au/\" aria-current=\"page\">Home</a></li><li id=\"menu-item-120\" class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-120\"><a href=\"https://myeassist.assistplus.com.au/#/\" aria-current=\"page\">Do My ASSIST</a></li><li id=\"menu-item-82\" class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-82\"><a href=\"https://assistplus.com.au/resources/\" aria-current=\"page\">Resources</a></li><li id=\"menu-item-22\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-22\"><a href=\"https://assistplus.com.au/drug-information/\" aria-current=\"page\">Drug Information</a></li><li id=\"menu-item-22\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-22\"><a href=\"https://assistplus.com.au/contact-us/\">CONTACT US</a></li><li id=\"menu-item-22\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-22\"><a href=\"https://assistplus.com.au/blog/\">News</a></li></ul></div></div></div></div></div><div class=\"menu-part\" style=\"border-bottom: 6px solid #ff7e00;\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-3 logo-sec\"><a href=\"https://assistplus.com.au/\"><img style=\"position:absolute;\" src=\"/assets/images/shared/logo.png\" alt=\"\"></a></div><div class=\"col-md-9 menu-sec text-right\" style=\"float: right;\"><div id=\"navigation\"><nav><ul><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-119\"><a href=\"https://assistplus.com.au/\" aria-current=\"page\">Home</a></li><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-119\"><a href=\"https://myeassist.assistplus.com.au/#/\" aria-current=\"page\">Do My ASSIST</a></li><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-120\"><a href=\"https://assistplus.com.au/resources/\" aria-current=\"page\">Resources</a></li><li class=\"menu-item menu-item-type-custom menu-item-object-custom current_page_item menu-item-home menu-item-82\"><a href=\"https://assistplus.com.au/drug-information/\" aria-current=\"page\">Drug Information</a></li><li class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-22\"><a href=\"https://assistplus.com.au/contact-us/\">CONTACT US</a></li><li class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-22\"><a href=\"https://assistplus.com.au/blog/\">News</a></li></ul></nav></div></div></div></div></div></header>");
$templateCache.put("app/components/assistLite/eAssistSA/eAssistSA.template.html","<div class=\"assistLite-content\"><div class=\"row\"><div class=\"col-md-8\"><div><form name=\"surveyForm\" class=\"survey-form\" novalidate=\"\" ng-submit=\"surveyForm.$valid && assistSACtrl.next(surveyForm)\"><div class=\"lite-popup\"><div class=\"assistTest\" ng-include=\"assistSACtrl.currentTest.template\"></div><div class=\"btns-move\"><div class=\"error-message\" ng-if=\"surveyForm.$submitted && surveyForm.$invalid\">Please complete all questions on the page to continue.</div><div><button class=\"btn btn-purple next-btn\" type=\"submit\" ng-if=\"assistSACtrl.currentTest.isNext\" ng-disabled=\"surveyForm.$submitted && assistSACtrl.isNextDisabled()\">Next <i class=\"fa fa-angle-right\"></i></button></div><div><button class=\"btn btn-bordered-purple btn-purple\" ng-if=\"assistSACtrl.currentTest.isPrev\" type=\"button\" ng-click=\"assistSACtrl.prev()\"><i class=\"fa fa-angle-left\"></i> Changed my mind</button></div></div></div></form></div></div><div class=\"col-md-4\"><div class=\"lite-popup\"><h1 class=\"assist-title\">What is eASSIST SA?</h1><p>The eASSIST SA is a rapid screening tool based on the Alcohol, Smoking and Substance Involvement Test (ASSIST). The questions are designed to identify the risks associated with alcohol and drug use. The personalised feedback presents a range of options for you to explore and consider.</p><h1 class=\"assist-title\">More help?</h1><p>If answering these questions has raised any concerns for you, you are encouraged to talk to the study coordinator or a health professional in the health facility or in your local area. Doctors, nurses, psychologists and social workers are able to help you explore what services and supports are available in your area.</p></div></div></div></div>");
$templateCache.put("app/components/layout/user/user.layout.template.html","<div class=\"header\"><h1 class=\"header-logo text-hide\"><a ui-sref=\"user.report\" class=\"logo logo-link\">WINE portal</a></h1><a class=\"menu-toggle\" ng-click=\"layoutCtrl.toggleNavLeft()\" ng-class=\"{ \'is-active\': layoutCtrl.isLeftActive }\"><span class=\"icon icon-menu\"></span></a><div class=\"header-search-wrap\" ng-class=\"{ \'is-active\': layoutCtrl.isSearchActive }\"><form class=\"header-search\"><div class=\"form-group\"><i class=\"fa fa-search\"></i> <input class=\"form-control\" type=\"text\" placeholder=\"Search...\"></div></form></div><div class=\"header-controls\"><a ng-click=\"layoutCtrl.adminLogout()\" class=\"btn btn-transparent\" ng-if=\"layoutCtrl.User.isAdmin\"><span class=\"fa fa-power-off\"></span></a> <a ng-click=\"layoutCtrl.userLogout()\" class=\"btn btn-transparent\" ng-if=\"!layoutCtrl.User.isAdmin\"><span class=\"fa fa-power-off\"></span></a> <a class=\"supplements-toggle btn btn-transparent\" ng-click=\"layoutCtrl.toggleNavRight()\" ng-class=\"{ \'is-active\': layoutCtrl.isRightActive, \'search-is-active\': layoutCtrl.isSearchActive }\"><span class=\"fa fa-angle-double-left\"></span> <span class=\"fa fa-angle-double-right\"></span></a></div></div><div class=\"menu\" ng-if=\"portalText.hostName===\'eassist\'\" ng-class=\"{\'is-active\': layoutCtrl.isLeftActive, \'expanded\': layoutCtrl.isLeftExpanded}\"><a class=\"menu-expand-toggle\" ng-click=\"layoutCtrl.toggleExpandLeft()\"><span class=\"fa fa-angle-double-right\"></span> <span class=\"fa fa-angle-double-left\"></span></a><div class=\"menu-logo\"><span class=\"logo\"></span></div><div class=\"menu-scroll\"><div class=\"menu-user\"><div class=\"avatar\" ui-sref=\"user.profileIndex.profile({ id: layoutCtrl.User.id })\" ng-style=\"layoutCtrl.User.avatarUrl && { \'background-image\': \'url(\'+ layoutCtrl.User.avatarUrl + \')\' }\"></div></div><nav class=\"menu-nav\"><ul class=\"dashboard-side-nav-list list-unstyled\"><li class=\"menu-item\"><a class=\"menu-link\" ui-sref-active=\"is-active\" ui-sref=\"user.report\"><span class=\"icon\"></span> <span class=\"menu-label\">Reports</span></a></li><li class=\"menu-item\"><a class=\"menu-link\" ui-sref-active=\"is-active\" ui-sref=\"user.settings\"><span class=\"icon icon-settings\"></span> <span class=\"menu-label\">Settings</span></a></li></ul></nav></div></div><div class=\"menu\" ng-if=\"portalText.hostName===\'myeassist\'\" ng-class=\"{\'is-active\': layoutCtrl.isLeftActive, \'expanded\': layoutCtrl.isLeftExpanded}\"><a class=\"menu-expand-toggle\" ng-click=\"layoutCtrl.toggleExpandLeft()\"><span class=\"fa fa-angle-double-right\"></span> <span class=\"fa fa-angle-double-left\"></span></a><div class=\"menu-logo\"><span class=\"logo\"></span></div><div class=\"menu-scroll\"><div class=\"menu-user\"><div class=\"avatar\" ui-sref=\"user.profileIndex.profile({ id: layoutCtrl.User.id })\" ng-style=\"layoutCtrl.User.avatarUrl && { \'background-image\': \'url(\'+ layoutCtrl.User.avatarUrl + \')\' }\"></div></div><nav class=\"menu-nav\"><ul class=\"dashboard-side-nav-list list-unstyled\"><li class=\"menu-item\"><a class=\"menu-link\" ui-sref-active=\"is-active\" ui-sref=\"user.eAssist\"><span class=\"myeassist-menu-icon\"><i class=\"fa fa-book\" aria-hidden=\"true\"></i></span> <span class=\"menu-label\">eASSIST</span></a></li><li class=\"menu-item\"><a class=\"menu-link\" ui-sref-active=\"is-active\" ui-sref=\"user.mydiary\"><span class=\"myeassist-menu-icon\"><i class=\"fa fa-pie-chart\" aria-hidden=\"true\"></i></span> <span class=\"menu-label\">My Diary</span></a></li><li class=\"menu-item\"><a class=\"menu-link\" ui-sref-active=\"is-active\" ui-sref=\"user.report\"><span class=\"myeassist-menu-icon\"><i class=\"fa fa-cloud-download\" aria-hidden=\"true\"></i></span> <span class=\"menu-label\">Reports</span></a></li><li class=\"menu-item\"><a class=\"menu-link\" ui-sref-active=\"is-active\" ui-sref=\"user.settings\"><span class=\"myeassist-menu-icon\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></span> <span class=\"menu-label\">Settings</span></a></li></ul></nav></div></div><div class=\"page-content-wrap\" ui-view=\"\"></div><footer ng-include=\"\" src=\"layoutCtrl.FOOTER_PATH\" class=\"page-footer\"></footer><div class=\"mobile-overlay\" ng-class=\"{ \'is-right-active\': layoutCtrl.isRightActive, \'is-left-active\': layoutCtrl.isLeftActive }\" ng-click=\"layoutCtrl.resetOverlays()\"></div>");
$templateCache.put("app/components/settings/index/settings.index.template.html","<div class=\"page-content dashboard-content settings-content\"><div class=\"page-content-inner\"><div class=\"feed-block\"><uib-tabset active=\"settingsCtrl.activeTab\" justified=\"true\"><uib-tab index=\"0\" heading=\"Manage account\"><h2 class=\"settings-head\">Manage account</h2><div><div ng-if=\"!settingsCtrl.user.isAdmin\"><button class=\"btn btn-top btn-primary\" ng-if=\"!settingsCtrl.deleteAccountMode\" ng-click=\"settingsCtrl.showDeleteForm()\">Delete Account</button><div ng-if=\"settingsCtrl.deleteAccountMode\">Do you really want to delete your account?<div class=\"delete-dialog\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"settingsCtrl.deleteAccount()\">Delete</button> <a class=\"btn btn-default\" type=\"button\" ng-click=\"settingsCtrl.cancelDeleteAccount()\">Cancel</a></div></div></div><button class=\"btn btn-top btn-primary\" ng-if=\"!settingsCtrl.changePasswordMode\" ng-click=\"settingsCtrl.showPasswordForm()\">Change password</button><div ng-if=\"settingsCtrl.changePasswordMode\"><p>Your password must contain at minumum 12 characters and must include an upper case letter, a lower case letter, a number and sybmol</p><form class=\"settings-form\" name=\"settingsForm\" ng-submit=\"settingsCtrl.changePassword()\"><div class=\"form-group\"><label>Old password:</label> <input class=\"form-control\" type=\"password\" ng-model=\"settingsCtrl.credentials.oldPassword\"><p class=\"text-danger\" ng-if=\"settingsCtrl.errorPassword\">{{settingsCtrl.errorPassword}}</p></div><div class=\"form-group\"><label>New password:</label> <input type=\"password\" class=\"form-control\" name=\"passwordData\" placeholder=\"Create a password\" required=\"\" ng-keyup=\"settingsCtrl.checkPassword(settingsForm.passwordData)\" ng-model=\"settingsCtrl.credentials.passwordData\"> <input style=\"display: none;\" type=\"password\" class=\"form-control\" name=\"password\" placeholder=\"Create a password\" required=\"\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[ !@#$%^&*(),.?\':{}|<>]).{12,}$/\" ng-minlength=\"12\" ng-model=\"settingsCtrl.credentials.newPassword\"><p class=\"error-message text-danger\" ng-if=\"settingsCtrl.credentials.newPassword != settingsCtrl.credentials.confirmNewPassword\" ng-model=\"loginCtrl.error\">Your new passwords is not equal</p></div><div class=\"password-strength\" ng-class=\"settingsCtrl.passwordStrength\"><span class=\"password-strength-label\"><span ng-if=\"settingsCtrl.passwordStrength === \'weak\'\">Too short</span> <span ng-if=\"settingsCtrl.passwordStrength === \'moderate\'\">Moderate</span> <span ng-if=\"settingsCtrl.passwordStrength === \'strong\'\">Strong</span> <span ng-if=\"settingsCtrl.passwordStrength === \'strength\'\">Strength</span></span> <span class=\"password-strength-graph\"></span></div><div class=\"form-group\"><label>Confirm new password:</label> <input class=\"form-control\" type=\"password\" ng-model=\"settingsCtrl.credentials.confirmNewPassword\"></div><div class=\"form-group form-buttons\"><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"!settingsCtrl.isValidPasswordForm() || !settingsCtrl.isPasswordValid()\"><span ng-if=\"settingsCtrl.loading\">Saving...</span> <span ng-if=\"!settingsCtrl.loading\">Save</span></button> <a class=\"btn btn-transparent\" type=\"buttоn\" ng-click=\"settingsCtrl.cancelPasswordForm()\">Cancel</a></div><div class=\"form-group\"><a class=\"settings-forgot\" ng-click=\"settingsCtrl.forgot()\">Forgot password?</a></div></form></div></div><div ng-if=\"!settingsCtrl.emailChanged\"><button class=\"btn btn-top btn-primary\" ng-if=\"!settingsCtrl.changeEmailMode\" ng-click=\"settingsCtrl.showEmailForm()\">Change email</button><div ng-if=\"settingsCtrl.changeEmailMode\"><form class=\"settings-form\" name=\"emailForm\" ng-submit=\"settingsCtrl.changeEmail()\"><div class=\"form-group\"><label>Current email:</label> <input class=\"form-control\" type=\"email\" ng-model=\"settingsCtrl.user.email\" disabled=\"\"></div><div class=\"form-group\"><label>Enter new email:</label> <input class=\"form-control\" type=\"email\" name=\"newEmail\" ng-model=\"settingsCtrl.newEmail\" ng-change=\"settingsCtrl.errorEmail = \'\'\" required=\"\"><p class=\"error-message text-danger\" ng-if=\"settingsCtrl.errorEmail\" ng-bind=\"settingsCtrl.errorEmail\"></p><p class=\"error-message text-danger\" ng-if=\"settingsCtrl.newEmail === settingsCtrl.user.email\">New email equals your current email</p><p class=\"error-message text-danger\" ng-if=\"emailForm.newEmail.$touched && emailForm.newEmail.$error.email\">Email is invalid.</p></div><div class=\"form-group form-buttons\"><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"!settingsCtrl.isValidEmailForm() || emailForm.$invalid\"><span ng-if=\"settingsCtrl.loading\">Saving...</span> <span ng-if=\"!settingsCtrl.loading\">Save</span></button> <a class=\"btn btn-transparent\" type=\"buttоn\" ng-click=\"settingsCtrl.cancelEmailForm()\">Cancel</a></div></form></div></div><div ng-if=\"settingsCtrl.emailChanged\"><p class=\"text-success\">Your email has been successfully changed. Please check your new email to complete the changes.</p></div></uib-tab><uib-tab index=\"1\" heading=\"Two-Factor Authentication\" ng-if=\"!settingsCtrl.user.is2FAEnable\"><h2 class=\"settings-head\">Two-Factor Authentication</h2><form role=\"form\" name=\"authChangeForm\" data-ng-submit=\"settingsCtrl.change2FASetting()\" novalidate=\"\" class=\"form-horizontal\"><ng-container ng-if=\"!settingsCtrl.user.is2FAVerified\"><div class=\"form-group spacer2\"><div class=\"col-sm-3\"></div><label class=\"col-sm-9\" for=\"inputPassword3\">Two-Factor Authentication (2FA) Setup</label></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" for=\"inputEmail3\">Configuring Google Authenticator or Authy</label><div class=\"col-sm-9\"><ol class=\"list-group list-group-numbered\"><li class=\"list-group-item\">1. Install Google Authenticator (IOS - Android) or Authy (IOS - Android).</li><li class=\"list-group-item\">2. In the authenticator app, select \"+\" icon.</li><li class=\"list-group-item\">3. Select \"Scan a barcode (or QR code)\" and use the phone\'s camera to scan this barcode.</li></ol></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" for=\"inputPassword3\">Scan QR Code</label><div class=\"col-sm-9\"><img style=\"width: 300px;\" ng-src=\"{{settingsCtrl.qrCode}}\" alt=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 controls-label\" for=\"inputEmail3\"></label> <label class=\"col-sm-9 controls-label\" for=\"inputEmail3\">Or Enter Code Into Your App.</label></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" for=\"inputEmail3\">SecretKey:</label><div class=\"col-sm-9\"><label class=\"control-label\" for=\"inputEmail3\"><b>{{settingsCtrl.user.otpBase32}}</b> (Base32 encoded)</label></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" for=\"inputEmail3\">Verify:</label><div class=\"col-sm-9\"><input type=\"number\" placeholder=\"Enter Authentication Code\" ng-change=\"settingsCtrl.invalidToken = false;\" name=\"token\" id=\"token\" class=\"form-control\" data-ng-model=\"settingsCtrl.otpToken\" required=\"\"><p class=\"error-message text-center text-danger\"><span ng-show=\"settingsCtrl.invalidToken\">Invalid OTP code. Please try again.</span></p></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><button class=\"btn btn-primary\" ng-click=\"settingsCtrl.verifyOtp()\" data-ng-disabled=\"!settingsCtrl.otpToken\" type=\"button\">Verify</button></div></div></ng-container><div class=\"form-group checkbox-group\"><label class=\"col-sm-2 control-label\" for=\"is2FAEnable1\"></label><div class=\"col-sm-8\"><input type=\"checkbox\" id=\"is2FAEnable\" name=\"is2FAEnable\" data-ng-model=\"settingsCtrl.is2FAEnable\"> <label class=\"label-checkbox\" for=\"is2FAEnable\"><span class=\"icon icon-checkbox\"></span> Enable 2FA Authentication</label></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><button class=\"btn btn-primary\" data-ng-disabled=\"authChangeForm.$invalid||!settingsCtrl.user.is2FAVerified\" type=\"submit\">Update 2FA Setting</button></div></div></form></uib-tab></uib-tabset></div></div></div><div class=\"page-supplements\" ng-class=\"{ \'is-active\': settingsCtrl.isRightActive }\"><div class=\"page-supplements-scroll\"><a class=\"page-supplements-close\" ng-click=\"settingsCtrl.toggleNavRight()\"><span class=\"fa fa-angle-double-right\"></span></a><help-content name=\"settings\" settings=\"$root.settings\"></help-content></div></div>");
$templateCache.put("app/directives/help-content/partials/eASSIST-myeassist.html","<script type=\"“text/template”\" help-content-default-title=\"eASSIST-myeassist\">eASSIST</script><script type=\"“text/template”\" help-content-default-text=\"eASSIST-myeassist\"><p>The eASSIST is an electronic version of The Alcohol, Smoking and Substance Indolent Screening Test (ASSIST) which was developed by the World Health Organization. The ASSIST has eight questions and takes approximately 5-10 minutes to complete. The ASSIST helps identify the risks associated with substance use and the personalized feedback helps explore options for change.</p></script>");
$templateCache.put("app/directives/help-content/partials/mydiary-myeassist.html","<script type=\"“text/template”\" help-content-default-title=\"mydiary-myeassist\">eASSIST</script><script type=\"“text/template”\" help-content-default-text=\"mydiary-myeassist\"><p>My Diary is just that. It records when you take drugs and how much you spend. It can answer questions such as: </p> <ul><li>how much will I spend in a year?</li><li>what is my most common day for taking drugs?</li><li>when have I taken what, how often, and how much did it cost? (if I paid)</li></ul> <p>To get started, click Add Substance, select the date and add the substance used. You can repeat this as many time as you like.</p> <p>Click Your Analysis for a summary of your personal substance use and spend.</p></script>");
$templateCache.put("app/directives/help-content/partials/reports-learning.html","<script type=\"“text/template”\" help-content-default-title=\"reports-learning\">Reports</script><script type=\"“text/template”\" help-content-default-text=\"reports-learning\"><p>The \'My Learning\' reports show all data related to the Learning you create.</p> <p>Click \'Download CSV\' for a full XL-compatible report of your Learning, including registered users, completions and quiz results.</p></script>");
$templateCache.put("app/directives/help-content/partials/settings.html","<script type=\"“text/template”\" help-content-default-title=\"settings\">Settings</script><script type=\"“text/template”\" help-content-default-text=\"settings\"><p>On this page, you can change your password and click \'Change notifications\' to manage which email updates you receive.</p> <p>We suggest you synchronise your social media accounts by clicking each \'Link\' button, making it easier to log in each time.</p></script>");
$templateCache.put("app/components/assistLite/eAssist/template/end.template.html","<div class=\"videoWindow\"><div class=\"assist-section\"><h1 class=\"assist-title\">eASSIST results</h1></div><div class=\"assist-section\" ng-if=\"!assistCtrl.results.feedback.briefAdvice.length && !assistCtrl.results.feedback.moderateAdvice.length && !assistCtrl.results.feedback.referralAdvice.length\">Thank you for completing the questions. Based on your answers, you are not at any risk of harms from Tobacco, Alcohol, Cannabis, Cocaine, Inhalants, Hallucinogens, Sedatives, Opioids, Other use at this time.</div><div class=\"assist-section\" ng-if=\"assistCtrl.results.feedback.briefAdvice.length ||assistCtrl.results.feedback.moderateAdvice.length || assistCtrl.results.feedback.referralAdvice.length\"><table class=\"table-eAssist table-bordered\"><thead><tr><th>Substance</th><th>Score</th><th>Risk</th><th>Criteria</th></tr></thead><tbody><tr><td>a. Tobacco products</td><td>{{assistCtrl.results.criteria.tobacco}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.tobacco <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.tobacco >= 4 && assistCtrl.results.criteria.tobacco <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.tobacco >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>b. Alcoholic beverages</td><td>{{assistCtrl.results.criteria.alcoholic}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.alcoholic <= 10\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.alcoholic >= 11 && assistCtrl.results.criteria.alcoholic <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.alcoholic >= 27\">High</span></td><td><p>1-10 Low</p><p>11-26 Moderate</p><p>27+ High</p></td></tr><tr><td>c. Cannabis</td><td>{{assistCtrl.results.criteria.cannabis}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.cannabis <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.cannabis >= 4 && assistCtrl.results.criteria.cannabis <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.cannabis >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>d. Cocaine</td><td>{{assistCtrl.results.criteria.cocaine}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.cocaine <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.cocaine >= 4 && assistCtrl.results.criteria.cocaine <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.cocaine >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>e. Amphetamine type stimulants</td><td>{{assistCtrl.results.criteria.amphetamine}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.amphetamine <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.amphetamine >= 4 && assistCtrl.results.criteria.amphetamine <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.amphetamine >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>f. Inhalants</td><td>{{assistCtrl.results.criteria.inhalants}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.inhalants <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.inhalants >= 4 && assistCtrl.results.criteria.inhalants <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.inhalants >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>g. Sedatives</td><td>{{assistCtrl.results.criteria.sedatives}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.sedatives <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.sedatives >= 4 && assistCtrl.results.criteria.sedatives <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.sedatives >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>h. Hallucinogens</td><td>{{assistCtrl.results.criteria.hallucinogens}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.hallucinogens <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.hallucinogens >= 4 && assistCtrl.results.criteria.hallucinogens <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.hallucinogens >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>i. Opioids</td><td>{{assistCtrl.results.criteria.opioids}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.opioids <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.opioids >= 4 && assistCtrl.results.criteria.opioids <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.opioids >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr><tr><td>j. Other <span ng-if=\"assistCtrl.secondTest.form.otherText\">- {{assistCtrl.secondTest.form.otherText}}</span></td><td>{{assistCtrl.results.criteria.other}}</td><td><span class=\"text-success\" ng-if=\"assistCtrl.results.criteria.other <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.other >= 4 && assistCtrl.results.criteria.other <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistCtrl.results.criteria.other >= 27\">High</span></td><td><p>1-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td></tr></tbody></table><div class=\"row\"><h3 class=\"col-md-12 text-center\">What do your scores mean?</h3></div><div class=\"row\"><div class=\"col-md-2\"><strong>Low:</strong></div><div class=\"col-md-9\">You are at low risk of health and other problems from your current pattern of use.</div></div><div class=\"row\"><div class=\"col-md-2\"><strong>Moderate:</strong></div><div class=\"col-md-9\">You are at risk of health and other problems from your current pattern of substance use.</div></div><div class=\"row\"><div class=\"col-md-2\"><strong>High:</strong></div><div class=\"col-md-9\">You are at high risk of experiencing severe problems (health, social, financial, legal, relationship) as a result of your current pattern of use and are likely to be dependant.</div></div><p>* <strong>Referral</strong> only REQUIRED for \'High\' scores, but can be offered to anyone upon their request.</p></div><div class=\"btns-move\"><span ng-if=\"assistCtrl.results.feedback.briefAdvice.length ||assistCtrl.results.feedback.moderateAdvice.length ||assistCtrl.results.feedback.referralAdvice.length\"><div class=\"assist-section assist-form-fields form-group\" ng-show=\"assistCtrl.reportType === \'pdf\'\" ng-class=\"{ \'has-error\': !surveyForm.downloadingReportFileName.$valid && surveyForm.downloadingReportFileName.$touched && !surveyForm.downloadingReportFileName.$error.required }\"><div class=\"form-input\"><input type=\"text\" class=\"form-control\" name=\"downloadingReportFileName\" placeholder=\"Enter report filename\" ng-model=\"downloadingReportFileName\" ng-disabled=\"assistCtrl.downloadingReportPdf\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.downloadingReportFileName.$valid && surveyForm.downloadingReportFileName.$touched\">Please enter a valid file name</p></div></div><div><span class=\"btn-group\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a style=\"width: 90%;padding: 0;\" ng-click=\"assistCtrl.downloadReportPdf(downloadingReportFileName)\" ng-disabled=\"(assistCtrl.reportType === \'pdf\'&& !downloadingReportFileName)||assistCtrl.downloadingReportPdf||assistCtrl.downloadingFeedbackPdf\" class=\"btn btn-purple next-btn\">Download Report <span style=\"text-transform: uppercase;\">({{assistCtrl.reportType}})</span></a> <a style=\"width: 10%;padding: 0; border-bottom-left-radius: 0;border-top-left-radius: 0;\" class=\"btn btn-purple next-btn\" uib-dropdown-toggle=\"\" ng-click=\"$event.stopPropagation()\"><i class=\"fa fa-angle-down\"></i></a><ul style=\"width: 100%;\" class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li class=\"report-invite\"><a ng-click=\"assistCtrl.setReport(\'csv\')\">CSV</a></li><li class=\"report-invite\"><a ng-click=\"assistCtrl.setReport(\'pdf\')\">PDF</a></li></ul></span></div><div><button class=\"btn btn-purple next-btn\" ng-disabled=\"assistCtrl.downloadingReportPdf||assistCtrl.downloadingFeedbackPdf\" type=\"button\" ng-click=\"assistCtrl.downloadFeedbackPdf()\">Download Feedback (PDF)</button></div><div class=\"assist-section assist-form-fields form-group\" ng-class=\"{ \'has-error\': !surveyForm.email.$valid && surveyForm.email.$touched && !surveyForm.email.$error.required }\" ng-hide=\"assistCtrl.isEmailSent\"><div class=\"form-input\"><input type=\"email\" class=\"form-control\" name=\"email\" placeholder=\"Enter your eMail\" ng-model=\"email.value\" ng-disabled=\"assistCtrl.isSendingEmail\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.email.$valid && surveyForm.email.$touched\">Please enter a valid email address.</p></div></div><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-disabled=\"!surveyForm.email.$valid || assistCtrl.isSendingEmail || assistCtrl.isEmailSent\" ng-click=\"assistCtrl.emailParticipantReport(email.value)\"><span ng-if=\"!assistCtrl.isSendingEmail && !assistCtrl.isEmailSent\">*eMail me my results</span> <span ng-if=\"assistCtrl.isSendingEmail\">Sending email...</span> <span ng-if=\"assistCtrl.isEmailSent\">eMail has been sent</span></button></div></span><div ng-if=\"portalText.hostName===\'assist\'||portalText.hostName===\'myeassist\'\"><a class=\"btn btn-purple next-btn\" ng-click=\"assistCtrl.backToFeedback()\"><i class=\"fa fa-angle-left\"></i> Go back to results</a></div></div><div ng-if=\"assistCtrl.results.feedback.briefAdvice.length ||assistCtrl.results.feedback.moderateAdvice.length ||assistCtrl.results.feedback.referralAdvice.length\" class=\"assist-section\"><p>*Optional - we will not store your eMail address.</p></div><div class=\"btns-move\" ng-if=\"portalText.hostName===\'myeassist-knowyouroptions\'||portalText.hostName===\'assist-knowyouroptions\'\"><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-click=\"assistCtrl.backToFeedback()\"><i class=\"fa fa-angle-left\"></i> Go back to results</button></div></div></div>");
$templateCache.put("app/components/assistLite/eAssist/template/feedback.template.html","<div class=\"videoWindow\"><div class=\"assist-section text-center\"><h1 class=\"assist-title\">What\'s next?</h1></div><div class=\"assist-section\" ng-if=\"!assistCtrl.results.feedback.briefAdvice.length && !assistCtrl.results.feedback.moderateAdvice.length && !assistCtrl.results.feedback.referralAdvice.length\">Thank you for completing the questions. Based on your answers, you are not at any risk of harms from Tobacco, Alcohol, Cannabis, Cocaine, Inhalants, Hallucinogens, Sedatives, Opioids, Other use at this time.</div><div class=\"assist-section\" ng-if=\"assistCtrl.results.feedback.briefAdvice.length || assistCtrl.results.feedback.moderateAdvice.length||assistCtrl.results.feedback.referralAdvice.length\">Thanks for completing the questions. Click each section below to view further information and advice.</div><div class=\"assist-section assist-section-feedback\" ng-if=\"assistCtrl.results.feedback.briefAdvice.length\"><h2 class=\"assist-title\">Brief Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{(assistCtrl.results.feedback.briefAdvice[0].displayDrugName | capitalize) + (assistCtrl.results.feedback.briefAdvice[0].substance ? \' - \' + assistCtrl.results.feedback.briefAdvice[0].substance : \'\')}}\" is-open=\"assistCtrl.isBriefOpen\"><div ng-include=\"\" src=\"assistCtrl.results.feedback.briefAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in assistCtrl.results.feedback.briefAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.displayDrugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"assistCtrl.results.feedback.moderateAdvice.length\"><h2 class=\"assist-title\">Moderate Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{(assistCtrl.results.feedback.moderateAdvice[0].displayDrugName | capitalize) + (assistCtrl.results.feedback.moderateAdvice[0].substance ? \' - \' + assistCtrl.results.feedback.moderateAdvice[0].substance : \'\')}}\" is-open=\"assistCtrl.isBriefOpen\"><div ng-include=\"\" src=\"assistCtrl.results.feedback.moderateAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in assistCtrl.results.feedback.moderateAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.displayDrugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"assistCtrl.results.feedback.referralAdvice.length\"><h2 class=\"assist-title\">Referral Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{(assistCtrl.results.feedback.referralAdvice[0].displayDrugName | capitalize) + (assistCtrl.results.feedback.referralAdvice[0].substance ? \' - \' + assistCtrl.results.feedback.referralAdvice[0].substance : \'\')}}\" is-open=\"assistCtrl.isReferralOpen\"><div ng-include=\"\" src=\"assistCtrl.results.feedback.referralAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in assistCtrl.results.feedback.referralAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.displayDrugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"btns-move\" ng-if=\"assistCtrl.results.feedback.briefAdvice.length || assistCtrl.results.feedback.moderateAdvice.length||assistCtrl.results.feedback.referralAdvice.length\"><div class=\"assist-section assist-form-fields form-group\" ng-show=\"assistCtrl.reportType === \'pdf\'\" ng-class=\"{ \'has-error\': !surveyForm.downloadingReportFileName.$valid && surveyForm.downloadingReportFileName.$touched && !surveyForm.downloadingReportFileName.$error.required }\"><div class=\"form-input\"><input type=\"text\" class=\"form-control\" name=\"downloadingReportFileName\" placeholder=\"Enter report filename\" ng-model=\"downloadingReportFileName\" ng-disabled=\"assistCtrl.downloadingReportPdf\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.downloadingReportFileName.$valid && surveyForm.downloadingReportFileName.$touched\">Please enter a valid file name</p></div></div><div><span class=\"btn-group\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a style=\"width: 90%;padding: 0;\" ng-click=\"assistCtrl.downloadReportPdf(downloadingReportFileName)\" ng-disabled=\"(assistCtrl.reportType === \'pdf\'&& !downloadingReportFileName)||assistCtrl.downloadingReportPdf||assistCtrl.downloadingFeedbackPdf\" class=\"btn btn-purple next-btn\">Download Report <span style=\"text-transform: uppercase;\">({{assistCtrl.reportType}})</span></a> <a style=\"width: 10%;padding: 0; border-bottom-left-radius: 0;border-top-left-radius: 0;\" class=\"btn btn-purple next-btn\" uib-dropdown-toggle=\"\" ng-click=\"$event.stopPropagation()\"><i class=\"fa fa-angle-down\"></i></a><ul style=\"width: 100%;\" class=\"dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li class=\"report-invite\"><a ng-click=\"assistCtrl.setReport(\'csv\')\">CSV</a></li><li class=\"report-invite\"><a ng-click=\"assistCtrl.setReport(\'pdf\')\">PDF</a></li></ul></span></div><div><button class=\"btn btn-purple next-btn\" ng-disabled=\"assistCtrl.downloadingReportPdf||assistCtrl.downloadingFeedbackPdf\" type=\"button\" ng-click=\"assistCtrl.downloadFeedbackPdf()\">Download Feedback (PDF)</button></div></div></div>");
$templateCache.put("app/components/assistLite/eAssist/template/intro.template.html","<div class=\"assistTest\"><div class=\"assist-section\"><h1 class=\"assist-title\">eASSIST Research Project</h1></div><div class=\"assist-section\"><h2 class=\"assist-title\">PRINCIPAL INVESTIGATOR: Dr Robert Ali</h2><p>Dear Participant,<br>You are invited to participate in the research project described below.</p><p>What is the eASSIST project about? Questions will focus on your thoughts about, and participation in, various health behaviours. There will also be some questions about ways of thinking and personality. All responses are completely confidential, and your honest responses are appreciated.</p><p>Who is undertaking the project? This project is being conducted by The World Health Organisation. This research will form the basis for ongoing improvements to drug and alcohol interventions and support.</p><p>Why am I being invited to participate? We are seeking Australian residents aged over 18 to participate.</p><p>What will I be asked to do? To participate, complete the survey on the following pages.</p><p>How much time will the project take? The survey is expected to take between 10 and 20 minutes to complete.</p><p>Are there any risks associated with participating in this project? Other than the inconvenience of giving up your time, it is not expected that participating in this survey will cause any discomfort or distress.</p><p>If you do find that completing the survey brings up worries or concerns, we recommend utilising one of the following excellent resources: BeyondBlue, 1300 22 4636 <a href=\"www.beyondblue.org.au\" target=\"_blank\">www.beyondblue.org.au</a>: advice and support for anxiety and depression Lifeline, 13 11 14 or <a href=\"www.lifeline.org.au\" target=\"_blank\">www.lifeline.org.au</a>: crisis support and suicide prevention The Cancer Council helpline, 13 11 20: a free, confidential telephone informationand support service run by your state\'s Cancer Council If you have any health-specific worries or questions, the best person to speak to is your doctor.</p><p>What are the benefits of the research project? While participation provides no immediate benefit to you, it is our hope that this research will aid in the understanding of the ways people think about healthy behaviours.</p><p>Can I withdraw from the project? Participation in this project is completely voluntary. You can stop completing the survey at any time by closing the browser window or tab. If you want to ensure that data you have already entered is deleted from our servers, please contact Clare McGuiness on (08) 8313 3850.</p><p>Can I withdraw from the project? Participation in this project is completely voluntary. You can stop completing the survey at any time by closing the browser window or tab. If you want to ensure that data you have already entered is deleted from our servers, please contact Clare McGuiness on (08) 8313 3850.</p><p>Who do I contact if I have questions about the project?</p><p>In the first instance, please contact: Clare McGuiness on (08) 8313 3850.</p><p>What if I have a complaint or any concerns? The study has been approved by the Human Research Subcommittee in the School of Psychology, University of Adelaide. If you have questions or problems associated with the practical aspects of your participation in the project, or wish to raise a concern or complaint about the project, then you should consult the Principal Investigator. Contact Paul Delfabbro (Chair of the Human Research Subcommittee) on phone +61 8 8313 4936 or by email to <a href=\"paul.delfabbro@adelaide.edu.au\" target=\"_blank\">paul.delfabbro@adelaide.edu.au</a> if you wish to speak with an independent person regarding concerns or a complaint, the University\'s policy on research involving human participants, or your rights as a participant. Any complaint or concern will be treated in confidence and fully investigated. You will be informed of the outcome.</p><p>If I want to participate, what do I do? By clicking the \'Next\' button below, you indicate your consent to be included in our study, and the survey will begin.</p><p>Yours sincerely, Mrs Clare McGuiness, Prof Deborah Turnbull, Prof Carlene Wilson, and Dr Ian Zajac.</p><p>To participate, please read the statements below and indicate whether you give your consent. I have been informed of, and understand, the proposed research. I have been informed that information provided will be kept confidential. I understand that I am free to withdraw consent at any time (I can stop filling out the survey and/or contact the researchers to request my data be deleted). If you have read and understood the information above, and give your consent to be included in this research, please click \'Next\' to begin.</p></div><div class=\"assist-section\"><h4>Instructions</h4><p>Please note this first screen should be completed in the presence of a hospital administrator, doctor or nurse. To complete the ASSIST Lite you will need to:</p><ol><li>Select the appropriate hospital (or location) and department from the dropdown options</li><li>Read and agree to the terms and conditions of the User Agreement</li><li>Select the box beside the agreement note</li><li>Enter the hospital code</li><li>Click the \'Next\' button to start</li></ol></div><div class=\"assist-section assist-form-fields form-group row\"><div class=\"col-md-4\"><label>Language:</label></div><div class=\"col-md-5\"><ui-select theme=\"bootstrap\" class=\"assist-select\" name=\"language\" required=\"\" ng-model=\"assistCtrl.language\"><ui-select-match placeholder=\"Select language\"><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"language in assistCtrl.currentTest.language.options\"><span ng-bind=\"language\"></span></ui-select-choices></ui-select></div></div><div class=\"assist-section assist-form-fields form-group row\"><div class=\"col-md-4\"><label>Hospital:</label></div><div class=\"col-md-5\"><ui-select theme=\"bootstrap\" class=\"assist-select\" name=\"hospital\" required=\"\" ng-change=\"assistCtrl.validateCode(surveyForm)\" ng-model=\"assistCtrl.currentTest.form.hospital\"><ui-select-match placeholder=\"Select hospital\"><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"hospital in assistCtrl.currentTest.hospital.options\"><span ng-bind=\"hospital\"></span></ui-select-choices></ui-select></div></div><div class=\"assist-section assist-form-fields form-group row\"><div class=\"col-md-4\"><label>Departament:</label></div><div class=\"col-md-5\"><ui-select theme=\"bootstrap\" class=\"assist-select\" name=\"department\" required=\"\" ng-change=\"assistCtrl.validateCode(surveyForm)\" ng-model=\"assistCtrl.currentTest.form.department\"><ui-select-match placeholder=\"Select department\"><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"department in assistCtrl.currentTest.department.options\"><span ng-bind=\"department\"></span></ui-select-choices></ui-select></div></div><div class=\"assist-section assist-form-fields form-group row\" ng-class=\"{ \'has-error\': !surveyForm.hospitalCode.$valid && surveyForm.hospitalCode.$touched }\"><div class=\"col-md-4\"><label>Enter your hospital code:</label></div><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" name=\"hospitalCode\" placeholder=\"XXXXXXXXXX\" ng-model=\"assistCtrl.currentTest.form.hospitalCode\" ng-change=\"assistCtrl.validateCode(surveyForm)\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.hospitalCode.$valid && surveyForm.hospitalCode.$touched\"><span ng-show=\"surveyForm.hospitalCode.$error.required\">Field is required.</span> <span ng-show=\"!assistCtrl.dropdownSelected(surveyForm) && surveyForm.hospitalCode.$error.hospitalError && !surveyForm.hospitalCode.$error.required\">Please select from the dropdowns options above.</span> <span ng-show=\"assistCtrl.dropdownSelected(surveyForm) && surveyForm.hospitalCode.$error.hospitalError && !surveyForm.hospitalCode.$error.required\">Wrong code.</span></p></div></div><div class=\"assist-section assist-form-fields form-group row\"><div class=\"col-md-12\"><div vc-recaptcha=\"\" on-create=\"assistCtrl.setRecaptchaWidgetId(widgetId)\"></div><p class=\"error-message text-danger\" ng-if=\"assistCtrl.errors.captcha\">{{assistCtrl.errors.captcha}}</p></div></div><div class=\"assist-section assist-license\"><p><strong>Conditions of use of ASSIST Online</strong></p><p><a ui-sref=\"guest.home\">ASSIST Online</a> provides access to ASSIST and associated materials. In addition to the OpenTute User Agreement, the following terms and conditions (Terms of Use) apply to the use and access to <a ui-sref=\"guest.home\">ASSIST Online</a>. In these Terms of Use, we or us means Adelaide Research & Innovation Pty Ltd, the commercialisation arm of the University of Adelaide and you means you, as an end user of <a ui-sref=\"guest.home\">ASSIST Online</a>.</p><p>You acknowledge that you have read, understand, and agree to be legally bound by these Terms of Use together with the OpenTute User Agreement. We may amend these Terms of Use from time to time with the most updated version being provided on <a ui-sref=\"guest.home\">ASSIST Online</a>. By continuing to use ASSIST Online you accept the amended Terms or Use.</p><ol><li><a ui-sref=\"guest.home\">ASSIST Online</a> provides access to ASSIST and associated materials. ASSIST is a screening tool only and not a diagnostic tool. ASSIST has not been validated for use in people under 18 years of age. ASSIST provides a general indicator of risk due to substance use. You are responsible for determining the suitability or otherwise of ASSIST.</li><li>While \'low\', \'moderate\' and \'high\' risk scores give an indication of the appropriate level of intervention, they should be used in conjunction with clinical judgement. We take no responsibility for the outcome or consequences of using this tool.</li><li>Neither we nor any third party will be liable for any errors in ASSIST and information made available via <a ui-sref=\"guest.home\">ASSIST Online</a>, or for any actions you take in reliance on ASSIST or information in <a ui-sref=\"guest.home\">ASSIST Online</a>. Neither you nor any other person may hold us liable for any delays, inaccuracies, errors or omissions in respect of ASSIST Online or the transmission or delivery of ASSIST via ASSIST Online, or for any liability, loss or damage arising from any of them.</li><li>We may, at our discretion, remove, modify or update ASSIST or information in ASSIST Online from time to time and without notice to you. Such updates include any modifications, enhancements, improvements, or revisions to ASSIST or information, including any updates to correct errors or to comply with changes to law or industry guidelines.</li><li>We grant you a limited, non-exclusive, non-transferrable licence to access and use ASSIST Online subject to these Terms of Use.</li><li>You must not collect, use, duplicate, license, sublicense, publish, distribute, rebrand, sell or otherwise make available to any third party, in whole or in part the ASSIST Online and any information, publications or other content published on or made available via ASSIST Online except as permitted in these Terms of Use or as expressly authorised by us.</li><li>You agree that we may access, preserve, use and disclose your personal information if required to do so by law (or by any judicial or regulatory body), where expressly authorised by you, or where in good faith we believe that such access, preservation, use or disclosure is reasonably necessary in our opinion to:<ol><li>provide the Member Service;</li><li>respond to your enquiries;</li><li>enforce these Terms of Use;</li><li>comply with legal process, including but not limited to civil and criminal subpoenas, court orders or other compulsory disclosures; or</li><li>comply with required or commercially prudent record keeping practices.</li></ol></li><li>The University of Adelaide\'s Privacy Policy governs how we collect, use, handle and disclose any personal information you provide or disclose to us and forms part of these Terms of Use. You should carefully read and review our Privacy Policy in full before disclosing to us any personal information. Our Privacy Policy can be accessed at <a href=\"http://www.adelaide.edu.au/policies/62/\" target=\"_blank\">http://www.adelaide.edu.au/policies/62/</a>.</li></ol><p>Should you have any questions or queries regarding appropriate use of the ASSIST and associated tools please contact Professor Robert Ali via the <a ui-sref=\"guest.home\">ASSIST portal</a>.</p></div><div class=\"assist-section\"><input id=\"license\" type=\"checkbox\" required=\"\" ng-model=\"assistCtrl.currentTest.form.userAgreement\"> <label class=\"label-checkbox\" for=\"license\"><span class=\"icon icon-checkbox assist\"></span>I agree to the above terms and conditions.</label></div></div>");
$templateCache.put("app/components/assistLite/eAssist/template/question1.template.html","<span class=\"question-title\" ng-bind-html=\"portalText.eAssist[assistCtrl.language].question1.title\"></span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"assistCtrl.currentTestIndex != 0\" value=\"assistCtrl.readyPercentage\"><span ng-show=\"assistCtrl.readyPercentage\">{{assistCtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\" ng-repeat=\"question in portalText.eAssist[assistCtrl.language].question1.questions\"><p class=\"question-text\">{{ portalText.eAssist[assistCtrl.language].questionTitle[question] }} <span ng-if=\"question == \'other\'\">- specify</span></p><div class=\"form-group radio-group\" ng-repeat=\"answer in portalText.eAssist[assistCtrl.language].question1.answers\"><input id=\"question-{{$parent.$index}}-{{$index}}\" name=\"{{$parent.$index + answer}}\" type=\"radio\" required=\"\" ng-model=\"assistCtrl.currentTest.form[question]\" ng-value=\"answer.value\"> <label class=\"label-radioBtn\" for=\"question-{{$parent.$index}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{answer.label}}</label></div><input type=\"text\" required=\"\" ng-model=\"assistCtrl.currentTest.form.otherText\" ng-if=\"question == \'other\' && assistCtrl.currentTest.form[question]\"></div></div>");
$templateCache.put("app/components/assistLite/eAssist/template/question2-7.template.html","<span class=\"question-title\" ng-bind-html=\"portalText.eAssist[assistCtrl.language][assistCtrl.currentTest.name].title\"></span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"assistCtrl.currentTestIndex != 0\" value=\"assistCtrl.readyPercentage\"><span ng-show=\"assistCtrl.readyPercentage\">{{assistCtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\" ng-repeat=\"question in assistCtrl.questions\"><p class=\"question-text\">{{portalText.eAssist[assistCtrl.language].questionTitle[question]}} <span ng-if=\"question === \'other\' && assistCtrl.secondTest.form.otherText\">- {{assistCtrl.secondTest.form.otherText}}</span></p><div class=\"form-group radio-group\" ng-repeat=\"answer in portalText.eAssist[assistCtrl.language][assistCtrl.currentTest.name].answers\"><input id=\"question-{{$parent.$index}}-{{$index}}\" name=\"{{$parent.$index + answer + $index}}\" type=\"radio\" required=\"\" ng-model=\"assistCtrl.currentTest.form[question]\" ng-value=\"answer.value\"> <label class=\"label-radioBtn\" for=\"question-{{$parent.$index}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{answer.label}}</label></div></div></div>");
$templateCache.put("app/components/assistLite/eAssist/template/question8.template.html","<span class=\"question-title\" ng-bind-html=\"portalText.eAssist[assistCtrl.language].question8.title\"></span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"assistCtrl.currentTestIndex != 0\" value=\"assistCtrl.readyPercentage\"><span ng-show=\"assistCtrl.readyPercentage\">{{assistCtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\"><div class=\"form-group radio-group\" ng-repeat=\"answer in portalText.eAssist[assistCtrl.language].question8.answers\"><input id=\"question-{{$parent.$index}}-{{$index}}\" name=\"{{$parent.$index + answer + $index}}\" type=\"radio\" required=\"\" ng-model=\"assistCtrl.currentTest.form.answer\" ng-value=\"answer.value\"> <label class=\"label-radioBtn\" for=\"question-{{$parent.$index}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{answer.label}}</label></div></div></div>");
$templateCache.put("app/components/assistLite/eAssist/template/question9.template.html","<span class=\"question-title\" ng-if=\"portalText.hostName!==\'assist-knowyouroptions\'&&portalText.hostName!==\'myeassist-knowyouroptions\'\" ng-bind-html=\"portalText.eAssist[assistCtrl.language][assistCtrl.currentTest.name].title\"></span> <span ng-if=\"portalText.hostName==\'assist-knowyouroptions\'||portalText.hostName==\'myeassist-knowyouroptions\'\"><div class=\"assist-section text-center\"><h1 class=\"assist-title\" ng-bind-html=\"portalText.eAssist[assistCtrl.language][assistCtrl.currentTest.name].title\"></h1></div></span><uib-progressbar ng-if=\"portalText.hostName==\'assist-knowyouroptions\'&&!portalText.hostName==\'myeassist-knowyouroptions\'\" max=\"100\" class=\"percentage-container\" value=\"assistCtrl.readyPercentage\"><span ng-show=\"assistCtrl.readyPercentage\">{{assistCtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\"><p class=\"question-text\">What is your gender?</p><div class=\"form-group radio-group\"><input id=\"question-0-0\" name=\"0answer0\" ng-change=\"assistCtrl.changeGenderTestState(assistCtrl.currentTest.form)\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.gender\" value=\"Male\"> <label class=\"label-radioBtn\" for=\"question-0-0\"><span class=\"icon icon-radioBtn\"></span>Male</label></div><div class=\"form-group radio-group\"><input id=\"question-0-1\" name=\"0answer1\" ng-change=\"assistCtrl.changeGenderTestState(assistCtrl.currentTest.form)\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.gender\" value=\"Female\"> <label class=\"label-radioBtn\" for=\"question-0-1\"><span class=\"icon icon-radioBtn\"></span>Female</label></div><ng-container ng-if=\"assistCtrl.surveyName==\'eassist\'||assistCtrl.surveyName==\'eassist-lite\'\"><div class=\"form-group radio-group\"><input id=\"question-0-2\" name=\"0answer1\" ng-change=\"assistCtrl.changeGenderTestState(assistCtrl.currentTest.form)\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.gender\" value=\"X\"> <label class=\"label-radioBtn\" for=\"question-0-2\"><span class=\"icon icon-radioBtn\"></span>Non-binary</label></div><div class=\"form-group radio-group\"><input id=\"question-0-3\" name=\"0answer1\" ng-change=\"assistCtrl.changeGenderTestState(assistCtrl.currentTest.form)\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.gender\" value=\"T\"> <label class=\"label-radioBtn\" for=\"question-0-3\"><span class=\"icon icon-radioBtn\"></span>[I/They] use a different term (please specify:)</label></div><input type=\"text\" required=\"\" ng-model=\"assistCtrl.currentTest.form.otherGender\" ng-if=\"assistCtrl.currentTest.form.gender==\'T\'\"><div class=\"form-group radio-group\"><input id=\"question-0-4\" name=\"0answer1\" ng-change=\"assistCtrl.changeGenderTestState(assistCtrl.currentTest.form)\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.gender\" value=\"Z\"> <label class=\"label-radioBtn\" for=\"question-0-4\"><span class=\"icon icon-radioBtn\"></span>Prefer not to answer</label></div></ng-container></div><div class=\"question\"><p class=\"question-text\">What is your age?</p><div class=\"form-group radio-group\"><input id=\"question-1-0\" name=\"1answer0\" type=\"number\" ng-change=\"assistCtrl.validateAge(assistCtrl.currentTest.form.age)\" required=\"\" ng-model=\"assistCtrl.currentTest.form.age\" value=\"\"><br><br><span class=\"error-message\" ng-if=\"(assistCtrl.currentTest.form.age<18)||surveyForm[\'1answer0\'].$touched && surveyForm[\'1answer0\'].$invalid\">An age of 18+ is required to complete this survey.</span></div></div><div class=\"question\"><p class=\"question-text\">How are you mainly employed at the moment?</p><div class=\"form-group radio-group\"><input id=\"question-2-0\" name=\"2answer0\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.employed\" required=\"\" value=\"Not employed\"> <label class=\"label-radioBtn\" for=\"question-2-0\"><span class=\"icon icon-radioBtn\"></span>Not employed</label></div><div class=\"form-group radio-group\"><input id=\"question-2-1\" name=\"2answer1\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.employed\" required=\"\" value=\"Full time\"> <label class=\"label-radioBtn\" for=\"question-2-1\"><span class=\"icon icon-radioBtn\"></span>Full time</label></div><div class=\"form-group radio-group\"><input id=\"question-2-2\" name=\"2answer2\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.employed\" required=\"\" value=\"Part time/casual\"> <label class=\"label-radioBtn\" for=\"question-2-2\"><span class=\"icon icon-radioBtn\"></span>Part time/casual</label></div><div class=\"form-group radio-group\"><input id=\"question-2-3\" name=\"2answer3\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.employed\" required=\"\" value=\"Student\"> <label class=\"label-radioBtn\" for=\"question-2-3\"><span class=\"icon icon-radioBtn\"></span>Student</label></div><div class=\"form-group radio-group\"><input id=\"question-2-4\" name=\"2answer4\" type=\"radio\" ng-model=\"assistCtrl.currentTest.form.employed\" required=\"\" value=\"Home duties\"> <label class=\"label-radioBtn\" for=\"question-2-4\"><span class=\"icon icon-radioBtn\"></span>Home duties</label></div></div></div>");
$templateCache.put("app/components/assistLite/myeAssist/myeAssist-signup/myeAssist.signup.confirm-email.template.html","<div class=\"form-signin-wrap\"><div class=\"form-signin\"><h1 class=\"logo logo-colored text-hide\"><a ui-sref=\"guest.home\" class=\"logo-link\">{{portalText.hostName}} portal</a></h1><h2 class=\"form-signin-heading form-signin-heading-info text-center\">Please check your email<br>and complete registration.</h2></div></div>");
$templateCache.put("app/components/assistLite/myeAssist/myeAssist-signup/myeAssist.signup.template.html","<div class=\"myeassist-content\"><div class=\"row\"><div class=\"col-md-4\"><span class=\"myeassist-content-skip-mobile\" ui-sref=\"guest.eAssist\">Skip <i class=\"fa fa-times\"></i></span><div class=\"form-signin-wrap\"><form class=\"form-signin\" id=\"form-signup\" name=\"formSignup\" ng-submit=\"formSignup.$valid && signupCtrl.signup($event)\" novalidate=\"\"><h2 class=\"form-signin-heading text-center\"><span ng-bind-html=\"portalText.subtitlePortal\"></span></h2><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && !formSignup.firstName.$valid }\"><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.firstName.$error.required\">First Name is required.<br></span></p><input type=\"text\" name=\"firstName\" class=\"form-control\" maxlength=\"15\" placeholder=\"First Name\" ng-model=\"signupCtrl.user.firstName\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && !formSignup.lastName.$valid }\"><a class=\"fa fa-refresh password-explanation uib-popover\" ng-class=\"portalText.hostName\" ng-click=\"signupCtrl.makeId()\"></a><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.lastName.$error.required\">Last Name is required.<br></span></p><input type=\"text\" name=\"lastName\" placeholder=\"Last Name\" class=\"form-control\" maxlength=\"15\" ng-model=\"signupCtrl.user.lastName\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && (!formSignup.email.$valid || formSignup.email.$error.required || signupCtrl.emailExistError)}\"><p class=\"error-message text-danger\"><span ng-if=\"formSignup.email.$error.required && formSignup.$submitted\">Email is required.</span> <span ng-if=\"!formSignup.email.$valid && !formSignup.email.$error.required && formSignup.$submitted\">Email is invalid.</span> <span ng-model=\"signupCtrl.emailExistError\" ng-if=\"formSignup.email.$valid && !formSignup.email.$error.required && formSignup.$submitted && signupCtrl.emailExistError\">Email has been registered already.</span></p><input type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email Address\" ng-model=\"signupCtrl.user.email\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && !formSignup.password.$valid }\"><a uib-popover=\"{{signupCtrl.passwordErrorMessage}}\" class=\"fa fa-question-circle password-explanation uib-popover\" ng-class=\"portalText.hostName\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter\'\" popover-toggle=\"popover\" popover-placement=\"top\"></a><p class=\"error-message text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.password.$error.required\">Password is required.<br></span> <span ng-show=\"formSignup.password.$error.pattern\">{{ signupCtrl.passwordErrorMessage }}<br></span></p><input type=\"password\" class=\"form-control\" name=\"passwordData\" placeholder=\"Create a password\" required=\"\" ng-keyup=\"signupCtrl.checkPassword(formSignup.passwordData)\" ng-model=\"signupCtrl.user.passwordData\"> <input type=\"password\" style=\"display: none;\" class=\"form-control\" name=\"password\" placeholder=\"Create a password\" required=\"\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[ !@#$%^&*(),.?\':{}|<>]).{12,}$/\" ng-minlength=\"12\" ng-model=\"signupCtrl.user.password\"></div><div class=\"password-strength\" ng-class=\"signupCtrl.passwordStrength\"><span class=\"password-strength-label\" ng-bind=\"signupCtrl.getPasswordStrengthLabel(signupCtrl.passwordStrength)\"></span> <span class=\"password-strength-graph\"></span></div><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && !formSignup.passwordConfirmation.$valid }\"><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.passwordConfirmation.$error.required\">Password confirmation is required.<br></span> <span ng-show=\"!formSignup.passwordConfirmation.$error.required && (signupCtrl.passwordConfirmation !== signupCtrl.user.password)\">Passwords do not match<br></span></p><input type=\"password\" class=\"form-control\" placeholder=\"Repeat password\" name=\"passwordConfirmation\" required=\"\" ng-pattern=\"signupCtrl.user.password\" ng-model=\"signupCtrl.passwordConfirmation\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && (!formSignup.birthDate.$valid || !signupCtrl.isYearOfBirthValid(signupCtrl.user.birthDate)) }\"><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.birthDate.$error.required\">Valid year of birth is required<br></span> <span ng-show=\"!formSignup.birthDate.$error.required && !signupCtrl.isYearOfBirthValid(signupCtrl.user.birthDate)\">An age of 18+ is required to complete this survey.<br></span></p><input type=\"number\" class=\"form-control\" placeholder=\"Year of Birth: YYYY\" name=\"birthDate\" required=\"\" ng-model=\"signupCtrl.user.birthDate\" min=\"1900\" max=\"2019\" onkeydown=\"return event.keyCode !== 69 && event.keyCode !== 189\" limit-to-max=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': formSignup.$submitted && signupCtrl.user.gender===\'\'}\"><p class=\"error-message text-center text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.$submitted && signupCtrl.user.gender===\'\'\">Gender is required<br></span></p><select name=\"gender\" class=\"form-control mycheckup-select\" ng-model=\"signupCtrl.user.gender\"><option value=\"\" disabled=\"disabled\" selected=\"selected\" style=\"display:none\">Select Gender:</option><option value=\"Male\">Male</option><option value=\"Female\">Female</option><option value=\"X\">Non-binary</option><option value=\"T\">[I/They] use a different term (please specify:)</option><option value=\"Z\">Prefer not to answer</option></select></div><div class=\"form-group\" ng-if=\"signupCtrl.user.gender==\'T\'\"><input type=\"text\" class=\"form-control\" required=\"\" ng-model=\"signupCtrl.user.otherGender\"></div><div class=\"form-group\"><select class=\"form-control mycheckup-select\" ng-model=\"signupCtrl.user.employment\"><option value=\"\" disabled=\"disabled\" selected=\"selected\" style=\"display:none\">Select Employment:</option><option value=\"Not employed\">Not employed</option><option value=\"Full time\">Full time</option><option value=\"Part time/casual\">Part time/casual</option><option value=\"Student\">Student</option><option value=\"Home duties\">Home duties</option></select></div><div class=\"form-group checkbox-group mycheckup-checkbox text-center\"><input id=\"userAgreement\" name=\"userAgreement\" type=\"checkbox\" required=\"\" ng-model=\"signupCtrl.params.userAgreement\"> <label class=\"checkbox-text label-checkbox\" for=\"userAgreement\"><span class=\"icon icon-checkbox\"></span> I have read and agree to the terms of the <a href=\"http://assistportal.com.au/user-agreement/\" ng-if=\"portalText.hostName === \'myeassist\'\" target=\"_blank\">User Agreement</a> and <a href=\"https://www.adelaide.edu.au/legals/privacy\" target=\"_blank\">Privacy Policy</a>.</label><p class=\"error-message text-danger\" ng-show=\"formSignup.$submitted\"><span ng-show=\"formSignup.userAgreement.$error.required\">You must agree to the terms and conditions before registering.</span></p></div><div class=\"form-group\"><button class=\"btn btn-signin btn-login btn-block\" type=\"submit\" ng-class=\"portalText.hostName\" ng-disabled=\"signupCtrl.isDisabled(formSignup)\"><span ng-if=\"!signupCtrl.loading\">Register</span> <span ng-if=\"signupCtrl.loading\">Saving...</span></button></div><div class=\"signup-text\">Already have an account? <a ui-sref=\"guest.home({\'returnTo\': signupCtrl.returnTo, \'params\': signupCtrl.returnToParams})\"><b>Log In</b></a></div></form></div></div><div class=\"col-md-8 myeassist-content-right\"><div class=\"myeassist-content-wrapper\"><span class=\"myeassist-content-skip-pc\" ui-sref=\"guest.eAssist\">Skip <i class=\"fa fa-times\"></i></span><h2 class=\"myeassist-content-header text-center\">Welcome to The eASSIST</h2><p class=\"myeassist-content-header-text text-center\">Register or log in to the eASSIST to keep a record of your results.</p><div class=\"myeassist-content-btnwrapper\"><button class=\"myeassist-content-button\" ui-sref=\"guest.home\" ui-sref-active=\"active\">Log in</button> <button class=\"myeassist-content-button\" ui-sref=\"guest.myeAssist-signup\" ui-sref-active=\"active\">Register</button></div><h3 class=\"myeassist-content-subheader text-center\">What is the eASSIST?</h3><span class=\"myeassist-content-text text-center\"><p>The eASSIST is an electronic version of the Alcohol, Smoking and Substance Involvement Screening Test (ASSIST).</p><p>The ASSIST was developed for the World Health Organisation (WHO), by an international group of specialists, as a tool that is easy to use to detect substance use and related problems. The ASSIST is an eight-item questionnaire and takes approximately 5-10 minutes to complete. The ASSIST helps identify the risks associated with substance use.</p><p>The eASSIST provides feedback on any risks and can help you explore options for addressing those risks.</p></span></div></div></div></div>");
$templateCache.put("app/components/assistLite/myeAssist/myeAssist-signup/myeAssist.signup.verified.template.html","<div class=\"form-signin-wrap\"><div class=\"form-signin\"><h1 class=\"logo logo-colored text-hide\"><a ui-sref=\"guest.home\" class=\"logo-link\">{{portalText.hostName}} portal</a></h1><h2 class=\"form-signin-heading form-signin-heading-info text-center\">Your email was verified successfully. You can <a ui-sref=\"guest.home\"><b>Log In</b></a> now.</h2></div></div>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/alcohol.female.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HARM FROM YOUR CURRENT PATTERN OF ALCOHOL USE.</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with a range of health, social, financial and legal problems.<br>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\">alcohol click here</a></p><p><span style=\"color:#005b9c;\">Are you aware of the low-risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.</p><p>If you would like to make sure that you continue to be at low risk of alcohol related problems in the future you can use My Diary to track how often and how much you drink, and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/alcohol.female.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR ALCOHOL CONSUMPTION IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>hangovers</li><li>accidents and injuries</li><li>unsafe or unwise sex</li><li>aggressive or violent behaviour</li><li>relationship problems</li><li>reduced sexual performance</li><li>missing work, failing to fulfil obligations</li><li>memory blackouts</li><li>financial problems</li><li>drink driving charges</li></ul><p>In the long term alcohol use may be associated with weight gain, anxiety and depression high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers. If you drink when pregnant or breastfeeding your baby may be at risk of Foetal Alcohol Spectrum Disorders.If you would like more information about <a href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\" target=\"_blank\" rel=\"noopener noreferrer\">alcohol click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more alcohol related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down your alcohol use? If you are not sure it can be helpful to list all the good things and the not so good things about your drinking as well as the benefits and costs of cutting down. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here.</a><br>You can find some useful tips to <a href=\"https://www.betterhealth.vic.gov.au/health/ten-tips/10-tips-to-cut-down-on-alcohol\">cut down your alcohol use here.</a><br>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800 250 015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p><span style=\"color:#005b9c;\">Do I drink too much? What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To avoid increasing your risk of alcohol related problems in the future you can use My Diary to track how often and how much you drink and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/alcohol.female.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF ALCOHOL USE</span><br>Alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>Accidents and injury</li><li>Financial and work problems</li><li>Aggressive and violent behaviour</li><li>Drink driving charges</li><li>Relationship problems</li><li>Premature ageing</li><li>Reduced sexual performance</li><li>Difficulty remembering things and solving problems</li><li>High blood pressure</li><li>Anxiety and depression</li><li>Digestive problems, ulcers</li><li>For pregnant women, risk of Foetal Alcohol Spectrum Disorder.</li></ul><p>In the long term alcohol use may be associated with, muscle and nerve damage, permanent brain injury, stroke, heart disease, kidney disease, pancreatitis, liver disease, and cancers.</p><p>The best way to reduce your risk is to cut down or stop drinking alcohol. People in the high risk range often show signs of dependence on alcohol, meaning if they stop or significantly reduce their alcohol intake they show physical and psychological signs of alcohol withdrawal. It is strongly advised that you seek medical advice when planning to reduce or stop your alcohol use. If you would like more information about <a href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\" target=\"_blank\" rel=\"noopener noreferrer\">alcohol click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your alcohol use.</p><p style=\"color:#005b9c;\">How concerned are you about these problems? If you are unsure, answer the following questions:</p><ul><li>Do you think you need help to cut down or stop drinking alcohol?</li><li>Do you experience physical withdrawal symptoms such as anxiety, nausea, or tremor when you haven’t had any alcohol?</li><li>Have you been unable to reduce or stop drinking alcohol even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by drinking alcohol?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a health care professional for further assessment and assistance.<br>There are other services and resources that can help you:</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800 250 015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours.</li></ul><p><span style=\"color:#005b9c;\">What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week 2 standard drinks per day and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To help reduce your risk of alcohol related problems in the future you can use My Diary to track how often and how much you drink, and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/alcohol.male.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HARM FROM YOUR CURRENT PATTERN OF ALCOHOL USE.</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with a range of health, social, financial and legal problems.<br>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\">alcohol click here</a></p><p><span style=\"color:#005b9c;\">Are you aware of the low-risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.</p><p>If you would like to make sure that you continue to be at low risk of alcohol related problems in the future you can use My Diary to track how often and how much you drink, and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/alcohol.male.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR ALCOHOL CONSUMPTION IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>hangovers</li><li>accidents and injuries</li><li>unsafe or unwise sex</li><li>aggressive or violent behaviour</li><li>relationship problems</li><li>reduced sexual performance</li><li>missing work, failing to fulfil obligations</li><li>memory blackouts</li><li>financial problems</li><li>drink driving charges</li></ul><p>In the long term alcohol use may be associated with weight gain, anxiety and depression high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers. If you drink when pregnant or breastfeeding your baby may be at risk of Foetal Alcohol Spectrum Disorders.If you would like more information about <a href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\" target=\"_blank\" rel=\"noopener noreferrer\">alcohol click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more alcohol related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down your alcohol use? If you are not sure it can be helpful to list all the good things and the not so good things about your drinking as well as the benefits and costs of cutting down. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here.</a><br>You can find some useful tips to <a href=\"https://www.betterhealth.vic.gov.au/health/ten-tips/10-tips-to-cut-down-on-alcohol\">cut down your alcohol use here.</a><br>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800 250 015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p><span style=\"color:#005b9c;\">Do I drink too much? What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To avoid increasing your risk of alcohol related problems in the future you can use My Diary to track how often and how much you drink and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/alcohol.male.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF ALCOHOL USE</span><br>Alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>Accidents and injury</li><li>Financial and work problems</li><li>Aggressive and violent behaviour</li><li>Drink driving charges</li><li>Relationship problems</li><li>Premature ageing</li><li>Reduced sexual performance</li><li>Difficulty remembering things and solving problems</li><li>High blood pressure</li><li>Anxiety and depression</li><li>Digestive problems, ulcers</li><li>For pregnant women, risk of Foetal Alcohol Spectrum Disorder.</li></ul><p>In the long term alcohol use may be associated with, muscle and nerve damage, permanent brain injury, stroke, heart disease, kidney disease, pancreatitis, liver disease, and cancers.</p><p>The best way to reduce your risk is to cut down or stop drinking alcohol. People in the high risk range often show signs of dependence on alcohol, meaning if they stop or significantly reduce their alcohol intake they show physical and psychological signs of alcohol withdrawal. It is strongly advised that you seek medical advice when planning to reduce or stop your alcohol use. If you would like more information about <a href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\" target=\"_blank\" rel=\"noopener noreferrer\">alcohol click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your alcohol use.</p><p style=\"color:#005b9c;\">How concerned are you about these problems? If you are unsure, answer the following questions:</p><ul><li>Do you think you need help to cut down or stop drinking alcohol?</li><li>Do you experience physical withdrawal symptoms such as anxiety, nausea, or tremor when you haven’t had any alcohol?</li><li>Have you been unable to reduce or stop drinking alcohol even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by drinking alcohol?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a health care professional for further assessment and assistance.<br>There are other services and resources that can help you:</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800 250 015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours.</li></ul><p><span style=\"color:#005b9c;\">What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week 2 standard drinks per day and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To help reduce your risk of alcohol related problems in the future you can use My Diary to track how often and how much you drink, and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/amphetamine.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF AMPHETAMINE USE.</span><br>There is no safe level of amphetamine use. There are a variety of Amphetamine Type Stimulants that includes methamphetamine and ecstasy. It is important to be very careful when taking any type of drug or combination of drugs. Also be aware that drugs sold as ecstasy may not contain any MDMA. They can be a mix of other substances including amphetamine, methamphetamine and paramethoxyamphetamine (PMA).<br><br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration,</li><li>Jaw clenching, headaches, muscle pain,</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia,</li><li>Tremors, irregular heartbeat, shortness of breath,</li><li>Aggressive and violent behaviour,</li><li>Drug driving charges, arrests for possession or supply,</li><li>Psychosis after repeated use of high doses,</li><li>Permanent damage to brain cells,</li><li>Stroke or heart attack,</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances.</li></ul><p>Ecstasy use can be associated with a range of health, social, financial and legal problems including:<ul><li>Drug driving charges, arrests for possession or supply</li><li>Reduced energy, colds, flu and infections</li><li>Loss of appetite, nausea, vomiting</li><li>Jaw clenching and teeth grinding</li><li>Muscle aches and stiffness</li><li>Increased blood pressure and heart rate</li><li>Anxiety, depression, paranoia</li><li>Increased body temperature and sweating</li><li>Damage to brain cells and memory problems</li><li>Convulsions, heart attack and brain haemorrhage</li></ul></p><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/amphetamine/\">methamphetamine</a> or <a href=\"https://assistplus.com.au/drug-information/ecstasy/\" target=\"_blank\">Ecstasy click here.</a></p><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.<p></p><p>By not using ecstasy, or keeping your use very low, you will find that you will have more energy, your memory will improve, you will eat and sleep better, your physical and mental health will improve and you will be less likely to get infections and feel anxious or depressed.</p><p>To avoid increasing your risk of Amphetamine Type Stimulant related problems in the future you can use My Diary in the <a href=\"https://assistplus.com.au\" target=\"_blank\" rel=\"noopener noreferrer\">ASSIST Checkup App</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject amphetamines you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using methamphetamine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/amphetamine.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR USE OF AMPHETAMINESIS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>There is no safe level of amphetamine use. There are a variety of Amphetamine Type Stimulants that includes methamphetamine and ecstasy. It is important to be very careful when taking any type of drug or combination of drugs. Also be aware that drugs sold as ecstasy may not contain any MDMA. They can be a mix of other substances including amphetamine, methamphetamine and paramethoxyamphetamine (PMA).<br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration</li><li>Jaw clenching, headaches, muscle pain</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia</li><li>Tremors, irregular heartbeat, shortness of breath</li><li>Aggressive and violent behaviour</li><li>Drug driving charges, arrests for possession or supply</li><li>Psychosis after repeated use of high doses</li><li>Permanent damage to brain cells,</li><li>Stroke or heart attack</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances.</li></ul><p>Ecstasy use can be associated with a range of health, social, financial and legal problems including:<ul><li>Drug driving charges, arrests for possession or supply</li><li>Reduced energy, colds, flu and infections</li><li>Loss of appetite, nausea, vomiting</li><li>Jaw clenching and teeth grinding</li><li>Muscle aches and stiffness</li><li>Increased blood pressure and heart rate</li><li>Anxiety, depression, paranoia</li><li>Increased body temperature and sweating</li><li>Damage to brain cells and memory problems</li><li>Convulsions, heart attack and brain haemorrhage</li></ul></p><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/amphetamine/\">methamphetamine</a> or <a href=\"https://assistplus.com.au/drug-information/ecstasy/\" target=\"_blank\">Ecstasy click here.</a></p><p style=\"color:#005b9c;\">Based on your answers itseems that you may have experienced one or more problems related to your Amphetamine Type Stimulant use in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>If any of these things have happened to you and you are concerned you may want to consider cutting down or stopping your Amphetamine Type Stimulant use. If you are not sure it can be helpful to list all the good things and the not so good things about your Amphetamine Type Stimulant use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.<br>By not using ecstasy, or keeping your use very low, you will find that you will have more energy, your memory will improve, you will eat and sleep better, your physical and mental health will improve and you will be less likely to get infections and feel anxious or depressed.<br><span style=\"color: #005b9c;\">If you would like to cut down or stop using Amphetamine Type Stimulants,here are some strategies to help you.</span><br><br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using Amphetamine Type Stimulants.</li><li>Keep a record of the times when you had a strong urge to use Amphetamine Type Stimulants. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a target=\"_blank\" href=\"https://smartrecoveryaustralia.com.au/resources/smart-%20worksheets/\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call <a target=\"_blank\" href=\"https://headspace.org.au/headspace-centres/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of Amphetamine Type Stimulant related problems in the future you can use My Diary in the <a href=\"https://assistplus.com.au\" target=\"_blank\" rel=\"noopener noreferrer\">ASSIST Checkup App</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p style=\"color:#005b9c;\">Injecting</p><p>If you inject methamphetamine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected methamphetamine we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using methamphetamine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/amphetamine.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT HIGH RISK OF EXPERIENCING HEATH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF USE.</span><br>There is no safe level of methamphetamine use. There are a variety of Amphetamine Type Stimulants that includes methamphetamine and ecstasy. It is important to be very careful when taking any type of drug or combination of drugs. Also be aware that drugs sold as ecstasy may not contain any MDMA. They can be a mix of other substances including amphetamine, methamphetamine and paramethoxyamphetamine (PMA).<br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration</li><li>Jaw clenching, headaches, muscle pain</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia</li><li>Tremors, irregular heartbeat, shortness of breath</li><li>Aggressive and violent behaviour</li><li>Drug driving charges, arrests for possession or supply</li><li>Psychosis after repeated use of high doses</li><li>Permanent damage to brain cells</li><li>Stroke or heart attack</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances</li></ul><p>Ecstasy use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Drug driving charges, arrests for possession or supply</li><li>Reduced energy, colds, flu and infections</li><li>Loss of appetite, nausea, vomiting</li><li>Jaw clenching and teeth grinding</li><li>Muscle aches and stiffness</li><li>Increased blood pressure and heart rate</li><li>Anxiety, depression, paranoia</li><li>Increased body temperature and sweating</li><li>Damage to brain cells and memory problems</li><li>Convulsions, heart attack and brain haemorrhage</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/amphetamine/\">methamphetamine</a> or <a href=\"https://assistplus.com.au/drug-information/ecstasy/\" target=\"_blank\">Ecstasy click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your Amphetamine Type Stimulant use.</p><p><span style=\"color:#005b9c;\">How concerned are you about your Amphetamine Type Stimulant use?</span><br>The best way to reduce your risk is to cut down or stop using Amphetamine Type Stimulants.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your AmphetamineType Stimulantuse as well as the benefits and costs of cutting down or stopping.<br>You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here.</a><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.<br><br>By not using ecstasy, or keeping your use very low, youwill find that you will have more energy, your memory will improve, you will eat and sleep better, your physical and mental health will improve and you will be less likely to get infections and feel anxious or depressed.<br><br><span style=\"color:#005b9c;\">If you would like to cut down or stop using Amphetamine Type Stimulants,here are some strategies to help you.</span><br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using methamphetamine</li><li>Keep a record of the times when you had a strong urge to use methamphetamine. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using methamphetamine? Answer the following questions:</p><ul><li>Do you experience physical withdrawal symptoms such as cravings, aches and pains exhaustion, confusion and irritability, restless sleep and nightmares, anxiety, depression and paranoia when you haven’t had any methamphetamine?</li><li>Have you been unable to reduce or stop using methamphetamine even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using methamphetamine?</li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using ecstasy? Answer the following questions:</p><ul><li>Do you experience physical withdrawal symptoms such as aches and pains, loss of concentration, sleepiness or insomnia, anxiety, agitation, restlessness, or depression when you haven’t had any ecstasy?</li><li>Have you been unable to reduce or stop using ecstasy even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using ecstasy?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a health care professional for further assessment and assistance. There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call <a target=\"_blank\" href=\"https://headspace.org.au/headspace-centres/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of Amphetamine Type Stimulant related problems in the future you can use My Diary in the <a href=\"https://assistplus.com.au\" target=\"_blank\" rel=\"noopener noreferrer\">ASSIST Checkup App</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p style=\"color:#005b9c;\">Injecting</p><p>If you inject methamphetamine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected methamphetamine we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using methamphetamine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/cannabis.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF CANNABIS USE.</span><br>If you choose to use Cannabis again be aware that Cannabis use can be associated with a range of health, social, financial and legal problems such as:</p><ul><li>Drug driving charges, fines or arrest for possession and supply</li><li>Problems with attention and motivation</li><li>Anxiety, paranoia, panic, depression</li><li>Decreased memory and problem solving ability</li><li>Asthma, bronchitis, chronic obstructive airways disease</li><li>Psychosis in those with a personal or family history of schizophrenia</li><li>Cancers</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/cannabis/\">cannabis click here.</a><br>By not using, or keeping your cannabis use very low, you will find that your attention, motivation, memory and problem solving ability will improve, you will feel calmer and less anxious and your physical and mental health will improve.</p><p>To avoid increasing your risk of cannabis related problems in the future you can use My Diary to track how often and how much you use cannabis and how much you spend. You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/cannabis.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR CANNABIS USE IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>Cannabis use can be associated with a range of health, social, financial and legal problems such as:</p><ul><li>Drug driving charges, arrest for possession and supply,</li><li>Problems with attention and motivation</li><li>Anxiety, paranoia, panic, depression</li><li>Decreased memory and problem solving ability</li><li>Asthma, bronchitis, chronic obstructive airways disease</li><li>Psychosis in those with a personal or family history of schizophrenia</li><li>Cancers</li></ul><p>Be aware that it is dangerous to drive or use machinery after you have used cannabis because it impairs your perception and coordination.<br>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/cannabis/\">cannabis click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your cannabis use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your cannabis use. If you are not sure it can be helpful to list all the good things and the not so good things about your cannabis use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or keeping your cannabis use very low, you will find that your attention, motivation, memory and problem solving will improve, you will feel calmer and less anxious and your physical and mental health will improve.</p><p>If you would like to cut down or stop using cannabis here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cannabis</li><li>Keep a record of the times when you had a strong urge to use cannabis. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of cannabis related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/cannabis.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS BASED ON YOUR CURRENT PATTERN OF CANNABIS USE.</span><br>Cannabis use can be associated with a range of health, social, financial and legal problems such as:</p><ul><li>Drug driving charges, arrest for possession and supply,</li><li>Problems with attention and motivation</li><li>Anxiety, paranoia, panic, depression</li><li>Decreased memory and problem solving ability</li><li>Asthma, bronchitis, chronic obstructive airways disease</li><li>Psychosis in those with a personal or family history of schizophrenia</li><li>Cancers</li></ul><p>Be aware that it is dangerous to drive or use machinery after you have used cannabis because it impairs your perception and coordination.<br>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/cannabis/\">cannabis click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your cannabis use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop using cannabis.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your cannabis use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or keeping your cannabis use very low, you will find that your attention, motivation, memory and problem solving will improve, you will feel calmer and less anxious and your physical and mental health will improve.</p><p>If you would like to cut down or stop using cannabis here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cannabis</li><li>Keep a record of the times when you had a strong urge to use cannabis. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using cannabis? Answer the following questions to find out more:</p><ul><li>Do you experience physical withdrawal symptoms such as sleep difficulties, mood swings, irritability, anxiety, physical restlessness, nausea, reduced appetite, or depression when you haven’t had any cannabis?</li><li>Have you been unable to reduce or stop using cannabis even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using cannabis?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of cannabis related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/cocaine.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF COCAINE USE.</span><br>If you choose to use cocaine again, be aware that cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/cocaine/\">cocaine click here.</a><br>By not using or keeping your cocaine use very low you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject cocaine you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using cocaine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/cocaine.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR COCAINE USE IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>There is no safe level of cocaine use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/cocaine/\">cocaine click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that would have experienced one or more problems related to your cocaine use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your cocaine use. If you are not sure it can be helpful to list all the good things and the not so good things about your cocaine use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or keeping your cocaine use very low, you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.</p><p>If you would like to cut down or stop using cocaine here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you</li><li>Plan some alternative activities to fill the extra time when you are not using</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cocaine</li><li>Keep a record of the times when you had a strong urge to use. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a>.</li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of cocaine related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject cocaine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time.</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using cocaine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/cocaine.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF COCAINE USE.</span><br>There is no safe level of cocaine use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/cocaine/\">cocaine click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that would have experienced one or more problems related to your cocaine use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop cocaine use.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your cocaine use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or keeping your cocaine use very low, you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.</p><p>If you would like to cut down or stop using cocaine here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you</li><li>Plan some alternative activities to fill the extra time when you are not using</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cocaine</li><li>Keep a record of the times when you had a strong urge to use. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using cocaine? Answer the following questions to find out more:</p><ul><li>Do you experience physical withdrawal symptoms such a agitation, depression or anxiety, restless sleep, extreme cocaine cravings, lack of energy, anxiety, angry outbursts and an inability to feel pleasure when you haven’t had any cocaine?</li><li>Have you been unable to reduce or stop using cocaine even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using cocaine?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a>is a free group program assisting people with any problematic behaviours</li></ul><p>To help reduce your risk of cocaine related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject cocaine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time.</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using cocaine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/hallucinogens.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOU ARE AT LOW RISK OF HARMS FROM HALLUCINOGEN USE AT THIS TIME.</span><br><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>The drug itself</li><li>The individual user</li><li>The environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. You may like to find out more about specific drugs and their effects <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/\">here.</a></p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using hallucinogens, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/hallucinogens.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, HALLUCINOGENS ARE PUTTING YOU AT MODERATE RISK OF HARM TO YOUR HEALTH AND SOCIAL SITUATION.</span><br><br>You are at risk of experiencing sleeping difficulties, nausea, vomiting, increased blood pressure, mood swings, anxiety, panic attacks, paranoia, flashbacks and increased effects of mental illnesses such as schizophrenia.<br><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>The drug itself</li><li>The individual user</li><li>The environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about <a href=\"https://assistplus.com.au/drug-information/hallucinogens/\">hallucinogens and their effects here.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using hallucinogens, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/hallucinogens.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT HALLUCINOGEN USE.</span><br><br>You are at risk of experiencing sleeping difficulties, nausea, vomiting, increased blood pressure, mood swings, anxiety, panic attacks, paranoia, flashbacks and increased effects of mental illnesses such as schizophrenia.<br><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>The drug itself</li><li>The individual user</li><li>The environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems. These risks also apply to prescription medication when taken for reasons other than prescribed.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about hallucinogens and their effects <a href=\"https://assistplus.com.au/drug-information/hallucinogens/\">click here./</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using a hallucinogen, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/inhalants.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF INHALANT USE.</span><br>If you choose to use inhalants again, be aware that inhalants use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Dizziness and hallucinations</li><li>Drowsiness, disorientation, blurred vision</li><li>Coordination difficulties, slowed reactions</li><li>Flu-like symptoms, sinusitis, nosebleeds</li><li>Indigestion, stomach ulcers</li><li>Accidents and injury</li><li>Memory loss, confusion, delirium, seizures (fits), coma</li><li>Damage to your brain, heart, lungs, liver, and kidneys</li><li>Death from heart failure</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/inhalants/\">inhalants click here</a><br>By not using, or keeping your inhalant use very low, you will find that your memory, coordination and reaction times will improve, your physical and mental health will improve and you will be less likely to experience accidents and injuries.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using inhalants, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/inhalants.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR USE OF INHALANTS IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>There is no safe level of inhalant use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Inhalant use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Dizziness and hallucinations</li><li>Drowsiness, disorientation, blurred vision</li><li>Coordination difficulties, slowed reactions</li><li>Flu-like symptoms, sinusitis, nosebleeds</li><li>Indigestion, stomach ulcers</li><li>Accidents and injury</li><li>Memory loss, confusion, delirium, seizures (fits), coma</li><li>Damage to your brain, heart, lungs, liver, and kidneys</li><li>Death from heart failure</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/inhalants/\">inhalants click here</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more Inhalants related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>If any of these things have happened to you and you are concerned you may want to consider cutting down or stopping your inhalants use. If you are not sure it can be helpful to list all the good things and the not so good things about your inhalants use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here.</a><br>By not using, or keeping your inhalant use very low, you will find that your memory, coordination and reaction times will improve, your physical and mental health will improve and you will be less likely to experience accidents and injuries.</p><p>If you would like to cut down or stop using inhalants here are some strategies to help you.<br>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using inhalants</li><li>Keep a record of the times when you had a strong urge to use inhalants. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of inhalants related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using inhalants, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/inhalants.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF INHALANT USE.</span><br>There is no safe level of inhalant use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Inhalant use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Dizziness and hallucinations</li><li>Drowsiness, disorientation, blurred vision</li><li>Coordination difficulties, slowed reactions</li><li>Flu-like symptoms, sinusitis, nosebleeds</li><li>Indigestion, stomach ulcers</li><li>Accidents and injury</li><li>Memory loss, confusion, delirium, seizures (fits), coma</li><li>Damage to your brain, heart, lungs, liver, and kidneys</li><li>Death from heart failure</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/inhalants/\">inhalants click here</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more inhalant related problems.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop using inhalants.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your inhalant use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or keeping your inhalant use very low, you will find that your memory, coordination and reaction times will improve, your physical and mental health will improve and you will be less likely to experience accidents and injuries.</p><p>If you would like to cut down or stop using inhalants here are some strategies to help you.<br>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using inhalants</li><li>Keep a record of the times when you had a strong urge to use inhalants. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using inhalants?</p><ul><li>Do you experience physical withdrawal symptoms such as hangover, headache, nausea and stomach pain, tiredness, shakiness, tremors, cramps hallucinations and visual disorders, such as seeing spots when you haven’t had any inhalants?</li><li>Have you been unable to reduce or stop using inhalants even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using inhalants?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of inhalant related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using inhalants, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/opioids.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF OPIOID USE.</span><br>While opioids are very useful medications for pain, non-medical use can be very harmful. If you choose to use opioids/heroin again, be aware that opioid/heroin use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty concentrating and remembering things</li><li>Difficulty urinating; constipation</li><li>Dry mouth, tooth decay</li><li>Nausea, loss of appetite</li><li>Slow breathing and heart rate, irregular heartbeat</li><li>Reduced sexual desire and sexual performance</li><li>Irregular periods and difficulty having children</li><li>Relationship difficulties</li><li>Financial and work problems, legal problems</li><li>Overdose and death from respiratory failure</li><li>Opioid dependence</li></ul><p>The effects of mixing opioids/heroin with alcohol, prescription or over the counter medications, and/or other illicit drugs are often unpredictable. In particular, mixing opioids with other depressant drugs such as alcohol or sedatives increases the depressant effects and can result in respiratory depression, coma and death.<br>If you would like more information about specific <a href=\"https://assistplus.com.au/drug-information/opioids/\">opioids click here.</a><br>By not using, or by keeping your opioid use very low, you will find that your appetite, concentration, memory and alertness will improve, your dental and physical health will improve, your sexual functioning will improve and you will be at lower risk of overdose. If you inject opioids you may be at risk of blood borne viruses such as Hepatitis B & C and HIV. If you have ever injected opioids we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using opioids/heroin, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/opioids.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR OPIOID USE IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>While opioids are very useful medications for pain, non-medical use can be very harmful. Be aware that opioid/heroin use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty concentrating and remembering things</li><li>Difficulty urinating; constipation</li><li>Dry mouth, tooth decay</li><li>Nausea, loss of appetite</li><li>Slow breathing and heart rate, irregular heartbeat</li><li>Reduced sexual desire and sexual performance</li><li>Irregular periods and difficulty having children</li><li>Relationship difficulties</li><li>Financial and work problems, legal problems</li><li>Overdose and death from respiratory failure</li><li>Opioid dependence</li></ul><p>The effects of mixing opioids/heroin with alcohol, prescription or over the counter medications, and/or other illicit drugs are often unpredictable. In particular, mixing opioids with other depressant drugs such as alcohol or sedatives increases the depressant effects and can result in respiratory depression, coma and death.<br>If you would like more information about specific <a href=\"https://assistplus.com.au/drug-information/opioids/\">opioids click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more opioid related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your opioid/heroin use? If you are not sure it can be helpful to list all the good things and the not so good things about your opioid use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or by keeping your opioid/heroin use very low, you will find that your appetite, concentration, memory and alertness will improve, your dental and physical health will improve, your sexual functioning will improve and you will be at lower risk of overdose.</p><p>If you would like to cut down or stop using opioids/heroin here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using opioids/heroin</li><li>Keep a record of the times when you had a strong urge to use opioids/heroin. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-%20worksheets/\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of opioid related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject opioids/heroin you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected opioids/heroin we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using opioids/heroin, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/opioids.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF OPIOID USE.</span><br>While opioids are very useful medications for pain, non-medical use can be very harmful. Be aware that opioid use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty concentrating and remembering things</li><li>Difficulty urinating; constipation</li><li>Dry mouth, tooth decay</li><li>Nausea, loss of appetite</li><li>Slow breathing and heart rate, irregular heartbeat</li><li>Reduced sexual desire and sexual performance</li><li>Irregular periods and difficulty having children</li><li>Relationship difficulties</li><li>Financial and work problems, legal problems</li><li>Overdose and death from respiratory failure</li><li>Opioid dependence</li></ul><p>The effects of mixing opioids/heroin with alcohol, prescription or over the counter medications, and/or other illicit drugs are often unpredictable. In particular, mixing opioids with other depressant drugs such as alcohol or sedatives increases the depressant effects and can result in respiratory depression, coma and death.<br>If you would like more information about specific <a href=\"https://assistplus.com.au/drug-information/opioids/\">opioids click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more inhalant related problems.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop using opioids/heroin.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your opioid use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or by keeping your opioid/heroin use very low, you will find that your appetite, concentration, memory and alertness will improve, your dental and physical health will improve, your sexual functioning will improve and you will be at lower risk of overdose.</p><p>If you would like to cut down or stop using opioids/heroin here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using opioids/heroin</li><li>Keep a record of the times when you had a strong urge to use opioids/heroin. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-%20worksheets/\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using opioids/heroin? Answer the following questions:</p><ul><li>Do you experience physical withdrawal symptoms such as restlessness and irritability, depression and crying, diarrhoea, restless sleep and yawning, stomach and leg cramps, vomiting and no appetite, goosebumps, runny nose fast heartbeat when you haven’t had any opioids/heroin?</li><li>Have you been unable to reduce or stop using opioids/heroin even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using opioids/heroin?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of opioid related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject opioids/heroin you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected opioids/heroin we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using opioids/heroin, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/other.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, THIS SUBSTANCE IS PUTTING YOU AT RISK OF HARM TO YOUR HEALTH AND SOCIAL SITUATION.</span><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>the drug itself</li><li>the individual user</li><li>the environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems. These risks also apply to prescription medication when taken for reasons other than prescribed.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about specific drugs and their effects at <a href=\"https://assistplus.com.au/drug-information/\">here.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject a drug you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using this substance, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/other.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, THIS SUBSTANCE IS PUTTING YOU AT MODERATE RISK OF HARM TO YOUR HEALTH AND SOCIAL SITUATION</span><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>the drug itself</li><li>the individual user</li><li>the environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any drug use can put you at risk of health, social, financial and legal problems. These risks also apply to prescription medication when taken for reasons other than prescribed.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about <a href=\"https://assistplus.com.au/drug-information/\">specific drugs and their effects here.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject a drug you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected a drug we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using this substance, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/other.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF USE.</span><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>the drug itself</li><li>the individual user</li><li>the environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any use can put you at risk of health, social, financial and legal problems.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about specific drugs and their effects at <a href=\"https://assistplus.com.au/drug-information/\">here.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject a drug you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected a drug we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/sedatives.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF SEDATIVE USE.</span><br>While Prescription Medications are very useful when taken as directed by a doctor, non-medical use can be very harmful. If you choose to use prescription medications again, ensure that you use them only as prescribed by a doctor. It is important to be very careful when using any drugs or combination of drugs. Depending which sedative medication you choose, misuse can be associated with a range of health, social, financial and legal problems including:<br>Benzodiazepines</p><ul><li>Drowsiness, dizziness, confusion, falls</li><li>Concentration and memory problems</li><li>Headaches</li><li>Sleeping problems</li><li>Anxiety and depression</li><li>Tolerance and dependence after a short period of use</li><li>Withdrawal symptoms</li><li>Overdose and death if used with alcohol, opioids or other depressant drugs.</li></ul><p>If you would like to learn more information specific about <a href=\"https://assistplus.com.au/drug-information/sedatives-sleeping-pills/\">sedative medication click here.</a><br>By not using, or by keeping your prescription medication use very low, you will find that your appetite, concentration, memory and alertness will improve, you will sleep better, you will be at lower risk of falls, anxiety, and overdose.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject sedative medication you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using sedatives, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/sedatives.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR USE OF SEDATIVE MEDICATION IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>While Prescription Medications are very useful when taken as directed by a doctor, non-medical use can be very harmful. Be aware that prescription medication use can be associated with a range of health, social, financial and legal problems.<br>Benzodiazepines</p><ul><li>Drowsiness, dizziness, confusion, falls</li><li>Concentration and memory problems</li><li>Headaches</li><li>Sleeping problems</li><li>Anxiety and depression</li><li>Tolerance and dependence after a short period of use</li><li>Withdrawal symptoms</li><li>Overdose and death if used with alcohol, opioids or other depressant drugs.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/sedatives-sleeping-pills/\">sedative medication click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more sedative medication related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your sedative use. If you are not sure it can be helpful to list all the good things and the not so good things about your sedative use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or by keeping your prescription medication use very low, you will find that your appetite, concentration, memory and alertness will improve, you will sleep better and you will be at lower risk of falls, anxiety, and overdose.</p><p>If you would like to cut down or stop using prescription medications here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using opioids</li><li>Keep a record of the times when you had a strong urge to use opioids. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of prescription medication related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject sedative medication you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected sedative medications we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using sedatives, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/sedatives.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF SEDATIVE USE.</span><br>Be aware that sedative medication use can be associated with a range of health, social, financial and legal problems.</p><ul><li>Drowsiness</li><li>Difficulty concentrating and remembering things</li><li>Nausea and loss of appetite</li><li>Sleeping problems</li><li>Headaches</li><li>Double or blurred vision</li><li>Jitteriness and excitability</li><li>Impaired coordination, dizziness and tremor</li><li>Mood swings and aggression</li><li>Risk of overdose</li><li>Loss of consciousness, coma, death</li></ul><p>If you would like to learn more information specific about <a href=\"https://assistplus.com.au/drug-information/sedatives-sleeping-pills/\">sedative medication click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your sedatives use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop misusing sedative medication.<br>Within months of cutting down or quitting using sedatives normal sleep patterns return.<br>Also:</p><ul><li>Your appetite will return to normal</li><li>Will no longer have unsteady gait, slurred speech and poor coordination skills</li><li>You will no longer suffer from double or blurred vision or jitteriness</li><li>You will improve your mood, your concentration and your ability to remember things</li><li>You are no longer at risk of early death through overdose</li></ul><p>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your opioid use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using, or by keeping your prescription medication use very low, you will find that your appetite, concentration, memory and alertness will improve, you will sleep better and you will be at lower risk of falls, anxiety, and overdose.</p><p>If you would like to cut down or stop misusing prescription medications here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using sedative mediciation</li><li>Keep a record of the times when you had a strong urge to use sedative mediciation. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using sedative medication? Answer these questions to find out:</p><ul><li>Do you experience physical withdrawal symptoms such as restlessness and irritability, depression and crying, headaches, aching or twitching muscles, dizziness and tremors, convulsions, hallucinations, diarrhoea, restless sleep, bizarre dreams when you haven’t had any sedative medication?</li><li>Have you been unable to reduce or stop using sedative medication even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using sedative medication?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call Headspace for advice and referrals</li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of prescription medication related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject sedative medication you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using sedative medication, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/stimulants.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF STIMULANTS USE.</span><br>There is no safe level of stimulants use. There are a variety of stimulants that excite the nervous system including methamphetamine, cocaine and ecstasy. It is important to be very careful when taking any type of drug or combination of drugs. Also be aware that drugs sold as ecstasy may not contain any MDMA. They can be a mix of other substances including amphetamine, methamphetamine and paramethoxyamphetamine (PMA)<br><br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration,</li><li>Jaw clenching, headaches, muscle pain,</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia,</li><li>Tremors, irregular heartbeat, shortness of breath,</li><li>Aggressive and violent behaviour,</li><li>Drug driving charges, arrests for possession or supply,</li><li>Psychosis after repeated use of high doses,</li><li>Permanent damage to brain cells,</li><li>Stroke or heart attack,</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances.</li></ul><p>Ecstasy use can be associated with a range of health, social, financial and legalproblems including:<ul><li>Drug driving charges, arrests for possession or supply</li><li>Reduced energy, colds, flu and infections</li><li>Loss of appetite, nausea, vomiting</li><li>Jaw clenching and teeth grinding</li><li>Muscle aches and stiffness</li><li>Increased blood pressure and heart rate</li><li>Anxiety, depression, paranoia</li><li>Increased body temperature and sweating</li><li>Damage to brain cells and memory problems</li><li>Convulsions, heart attack and brain haemorrhage</li></ul></p><p>Cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/amphetamine/\">methamphetamine</a> or <a href=\"https://assistplus.com.au/drug-information/ecstasy/\" target=\"_blank\">Ecstasy</a> or <a href=\"https://assistplus.com.au/drug-information/cocaine/\" target=\"_blank\">Cocaine click here.</a></p><p>To avoid increasing your risk of stimulant related problems in the future use My Diary in the <a href=\"https://assistplus.com.au\" target=\"_blank\" rel=\"noopener noreferrer\">ASSIST Checkup App</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject stimulants you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using amphetamines, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/stimulants.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR USE OF STIMULANTS IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>There is no safe level of stimulants use. There are a variety of stimulants that excite the nervous system including methamphetamine, cocaine and ecstasy. It is important to be very careful when taking any type of drug or combination of drugs. Also be aware that drugs sold as ecstasy may not contain any MDMA. They can be a mix of other substances including amphetamine, methamphetamine and paramethoxyamphetamine (PMA).<br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration</li><li>Jaw clenching, headaches, muscle pain</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia</li><li>Tremors, irregular heartbeat, shortness of breath</li><li>Aggressive and violent behaviour</li><li>Drug driving charges, arrests for possession or supply</li><li>Psychosis after repeated use of high doses</li><li>Permanent damage to brain cells,</li><li>Stroke or heart attack</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances.</li></ul><p>Ecstasy use can be associated with a range of health, social, financial and legalproblems including:<ul><li>Drug driving charges, arrests for possession or supply</li><li>Reduced energy, colds, flu and infections</li><li>Loss of appetite, nausea, vomiting</li><li>Jaw clenching and teeth grinding</li><li>Muscle aches and stiffness</li><li>Increased blood pressure and heart rate</li><li>Anxiety, depression, paranoia</li><li>Increased body temperature and sweating</li><li>Damage to brain cells and memory problems</li><li>Convulsions, heart attack and brain haemorrhage</li></ul></p><p>Cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/amphetamine/\">methamphetamine</a> or <a href=\"https://assistplus.com.au/drug-information/ecstasy/\" target=\"_blank\">Ecstasy</a> or <a href=\"https://assistplus.com.au/drug-information/cocaine/\" target=\"_blank\">Cocaine click here.</a></p><p style=\"color:#005b9c;\">Based on your answers it seems that you have experienced one or more problems related to your stimulants use in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop using stimulants.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your stimulant use as well as the benefits and costs of cutting down or stopping. You can find a CostBenefit Analysis <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.<br>By not using ecstasy, or keeping your use very low, you will find that you will have more energy, your memory will improve, you will eat and sleep better, your physical and mental health will improve and you will be less likely to get infections and feel anxious or depressed.<br>By not using, or keeping your cocaine use very low, you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.<br><span style=\"color: #005b9c;\">If you would like to cut down or stop using stimulants here are some strategies to help you.</span><br><br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using stimulants.</li><li>Keep a record of the times when you had a strong urge to use stimulants. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a target=\"_blank\" href=\"https://smartrecoveryaustralia.com.au/resources/smart-%20worksheets/\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call <a target=\"_blank\" href=\"https://headspace.org.au/headspace-centres/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of amphetamine related problems in the future use My Diary in the <a href=\"https://assistplus.com.au\" target=\"_blank\" rel=\"noopener noreferrer\">ASSIST Checkup App</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p style=\"color:#005b9c;\">Injecting</p><p>If you inject stimulants you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected stimulants we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using amphetamines, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/stimulants.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT HIGH RISK OF EXPERIENCING HEATH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF USE.</span><br>There is no safe level of stimulants use. There are a variety of stimulants that excite the nervous system including methamphetamine, cocaine and ecstasy. It is important to be very careful when taking any type of drug or combination of drugs. Also be aware that drugs sold as ecstasy may not contain any MDMA. They can be a mix of other substances including amphetamine, methamphetamine and paramethoxyamphetamine (PMA).<br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration</li><li>Jaw clenching, headaches, muscle pain</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia</li><li>Tremors, irregular heartbeat, shortness of breath</li><li>Aggressive and violent behaviour</li><li>Drug driving charges, arrests for possession or supply</li><li>Psychosis after repeated use of high doses</li><li>Permanent damage to brain cells</li><li>Stroke or heart attack</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances</li></ul><p>Ecstasy use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Drug driving charges, arrests for possession or supply</li><li>Reduced energy, colds, flu and infections</li><li>Loss of appetite, nausea, vomiting</li><li>Jaw clenching and teeth grinding</li><li>Muscle aches and stiffness</li><li>Increased blood pressure and heart rate</li><li>Anxiety, depression, paranoia</li><li>Increased body temperature and sweating</li><li>Damage to brain cells and memory problems</li><li>Convulsions, heart attack and brain haemorrhage</li></ul><p>Cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/amphetamine/\">methamphetamine</a> or <a href=\"https://assistplus.com.au/drug-information/ecstasy/\" target=\"_blank\">Ecstasy</a> or <a href=\"https://assistplus.com.au/drug-information/cocaine/\" target=\"_blank\">Cocaine click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your stimulants use in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about your stimulants use?</span><br>The best way to reduce your risk is to cut down or stop using stimulants.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your stimulant use as well as the benefits and costs of cutting down or stopping.<br>You can find a CostBenefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here.</a><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.<br><br>By not using ecstasy, or keeping your use very low, you will find that you will have more energy, your memory will improve, you will eat and sleep better, your physical and mental health will improve and you will be less likely to get infections and feel anxious or depressed.<br><br>By not using, or keeping your cocaine use very low, you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.<br><br><span style=\"color:#005b9c;\">If you would like to cut down or stop using stimulants here are some strategies to help you.</span><br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using stimulants.</li><li>Keep a record of the times when you had a strong urge to use stimulants. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a target=\"_blank\" href=\"https://smartrecoveryaustralia.com.au/resources/smart-%20worksheets/\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using methamphetamine? Answer the following questions:</p><ul><li>Do you experience physical withdrawal symptoms such as cravings, aches and pains exhaustion, confusion and irritability, restless sleep and nightmares, anxiety, depression and paranoia when you haven’t had any methamphetamine?</li><li>Have you been unable to reduce or stop using methamphetamine even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using methamphetamine?</li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using ecstasy? Answer the following questions:</p><ul><li>Do you experience physical withdrawal symptoms such as aches and pains, loss of concentration, sleepiness or insomnia, anxiety, agitation, restlessness, or depression when you haven’t had any ecstasy?</li><li>Have you been unable to reduce or stop using ecstasy even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using ecstasy?</li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using cocaine? Answer the following questions to find out more:</p><ul><li>Do you experience physical withdrawal symptoms such a agitation, depression or anxiety, restless sleep, extreme cocaine cravings, lack of energy, anxiety, angry outbursts and an inability to feel pleasure when you haven’t had any cocaine?</li><li>Have you been unable to reduce or stop using cocaine even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using cocaine?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a health care professional for further assessment and assistance. There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals: <a href=\"tel:1800250015\">1800250015</a></li><li>If you are aged between 12 and 25 you can call <a target=\"_blank\" href=\"https://headspace.org.au/headspace-centres/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of stimulant related problems in the future use My Diary in the <a href=\"https://assistplus.com.au\" target=\"_blank\" rel=\"noopener noreferrer\">ASSIST Checkup App</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p><p style=\"color:#005b9c;\">Injecting</p><p>If you inject stimulants you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected stimulants we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using amphetamines, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/tobacco.female.brief.partial.html","<p><span style=\"color:#005b9c;\">THERE ARE NO HEALTH BENEFITS OF TOBACCO USE AND NO SAFE LEVEL OF SMOKING.</span><br>If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Premature ageing, wrinkling of the skin</li><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>High blood pressure</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Heart disease, stroke, vascular disease</li><li>Cancers</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/nicotine/\">Tobacco click here.</a><br>By quitting you will find that you will look and feel younger, you will get fitter, your breath, hair and clothes will smell better, your sense of taste and smell will improve, your dental and physical health will improve and you and your family will be at much less risk of serious health problems.</p><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using smoking.</li><li>Get more help from the <a href=\"https://www.health.gov.au/health-topics/smoking-and-tobacco/how-to-quit-smoking?utm_source=quitnow.gov.au&utm_medium=redirect&utm_campaign=digital_transformation\">Quit Now website</a></li><li>If you would like more help you can download <a href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">this free Quit Buddy app</a> and/or talk to a health care professional.</li></ul>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/tobacco.female.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR SMOKING IS PUTTING YOU AT MODERATE RISK OF HEALTH AND FINANCIAL PROBLEMS</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Premature ageing, wrinkling of the skin</li><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>High blood pressure</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Heart disease, stroke, vascular disease</li><li>Cancers</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/nicotine/\">Tobacco click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more tobacco related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>If any of these things have happened to you and you are concerned you may want to consider stopping smoking. If you are not sure it can be helpful to list all the good things and the not so good things about your smoking as well as the benefits and costs of stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By quitting you will find that you will look and feel younger, you will get fitter, your breath, hair and clothes will smell better, your sense of taste and smell will improve, your dental and physical health will improve and you and your family will be at much less risk of serious health problems.<br>A list of the benefits of stopping can be found on the <a href=\"http://www.quitnow.gov.au/\">Quit Now website</a></p><p>If you would like to quit smoking here are some strategies to help you:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid smoking.</li><li>Get more help from the <a href=\"https://www.health.gov.au/health-topics/smoking-and-tobacco/how-to-quit-smoking?utm_source=quitnow.gov.au&utm_medium=redirect&utm_campaign=digital_transformation\">the Quit Now website</a></li><li>If you would like more help you can download <a href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">this free Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p>To avoid increasing your risk of smoking related problems in the future you can use My Diary to track how often and how much you smoke and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/tobacco.female.referral.partial.html","<p><span style=\"color:#005b9c;\">YOUR SMOKING IS PUTTING YOU AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL AND FINANCIAL PROBLEMS.</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Premature ageing, wrinkling of the skin</li><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>High blood pressure</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Heart disease, stroke, vascular disease</li><li>Cancers</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/nicotine/\">Tobacco click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it is likely that you are experiencing a number of problems related to your smoking.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to stop smoking.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about smoking use as well as the benefits and costs of stopping. You can find a Cost- Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By quitting you will find that you will look and feel younger, you will get fitter, your breath, hair and clothes will smell better, your sense of taste and smell will improve, your dental and physical health will improve and you and your family will be at much less risk of serious health problems.<br>A list of the benefits of stopping can be found on the <a href=\"http://www.quitnow.gov.au/\">Quit Now website</a></p><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using Tobacco</li><li>Keep a record of the times when you had a strong urge to use Tobacco. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li><li>Get more help from the <a href=\"https://www.health.gov.au/health-topics/smoking-and-tobacco/how-to-quit-smoking?utm_source=quitnow.gov.au&utm_medium=redirect&utm_campaign=digital_transformation\">Quit Now website</a></li><li>If you would like more help you can download <a href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">this free Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p style=\"color:#005b9c;\">Still not sure if you need to quit smoking? Answer these few questions:</p><ul><li>Do you experience physical withdrawal symptoms such as cravings for a cigarette, Irritability, anxiety and depression, restless sleep, trouble concentrating, headaches, coughing and sore throat, aches and pains, upset stomach and bowels when you haven’t had any Tobacco?</li><li>Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse? Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using Tobacco?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call the Quitline on <a href=\"tel:137848\">137848</a></li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of tobacco related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/tobacco.male.brief.partial.html","<p><span style=\"color:#005b9c;\">THERE ARE NO HEALTH BENEFITS OF TOBACCO USE AND NO SAFE LEVEL OF SMOKING.</span><br>If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Premature ageing, wrinkling of the skin</li><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>High blood pressure</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Heart disease, stroke, vascular disease</li><li>Cancers</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/nicotine/\">Tobacco click here.</a><br>By quitting you will find that you will look and feel younger, you will get fitter, your breath, hair and clothes will smell better, your sense of taste and smell will improve, your dental and physical health will improve and you and your family will be at much less risk of serious health problems.</p><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using smoking.</li><li>Get more help from the <a href=\"https://www.health.gov.au/health-topics/smoking-and-tobacco/how-to-quit-smoking?utm_source=quitnow.gov.au&utm_medium=redirect&utm_campaign=digital_transformation\">Quit Now website</a></li><li>If you would like more help you can download <a href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">this free Quit Buddy app</a> and/or talk to a health care professional.</li></ul>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/tobacco.male.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOUR SMOKING IS PUTTING YOU AT MODERATE RISK OF HEALTH AND FINANCIAL PROBLEMS</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Premature ageing, wrinkling of the skin</li><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>High blood pressure</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Heart disease, stroke, vascular disease</li><li>Cancers</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/nicotine/\">Tobacco click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more tobacco related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>If any of these things have happened to you and you are concerned you may want to consider stopping smoking. If you are not sure it can be helpful to list all the good things and the not so good things about your smoking as well as the benefits and costs of stopping. You can find a Cost-Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By quitting you will find that you will look and feel younger, you will get fitter, your breath, hair and clothes will smell better, your sense of taste and smell will improve, your dental and physical health will improve and you and your family will be at much less risk of serious health problems.<br>A list of the benefits of stopping can be found on the <a href=\"http://www.quitnow.gov.au/\">Quit Now website</a></p><p>If you would like to quit smoking here are some strategies to help you:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid smoking.</li><li>Get more help from the <a href=\"https://www.health.gov.au/health-topics/smoking-and-tobacco/how-to-quit-smoking?utm_source=quitnow.gov.au&utm_medium=redirect&utm_campaign=digital_transformation\">the Quit Now website</a></li><li>If you would like more help you can download <a href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">this free Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p>To avoid increasing your risk of smoking related problems in the future you can use My Diary to track how often and how much you smoke and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/assist-feedback/tobacco.male.referral.partial.html","<p><span style=\"color:#005b9c;\">YOUR SMOKING IS PUTTING YOU AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL AND FINANCIAL PROBLEMS.</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Premature ageing, wrinkling of the skin</li><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>High blood pressure</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Heart disease, stroke, vascular disease</li><li>Cancers</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/nicotine/\">Tobacco click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it is likely that you are experiencing a number of problems related to your smoking.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to stop smoking.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about smoking use as well as the benefits and costs of stopping. You can find a Cost- Benefit Analysis <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">worksheet and other useful tools here</a><br>By quitting you will find that you will look and feel younger, you will get fitter, your breath, hair and clothes will smell better, your sense of taste and smell will improve, your dental and physical health will improve and you and your family will be at much less risk of serious health problems.<br>A list of the benefits of stopping can be found on the <a href=\"http://www.quitnow.gov.au/\">Quit Now website</a></p><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using Tobacco</li><li>Keep a record of the times when you had a strong urge to use Tobacco. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li><li>Get more help from the <a href=\"https://www.health.gov.au/health-topics/smoking-and-tobacco/how-to-quit-smoking?utm_source=quitnow.gov.au&utm_medium=redirect&utm_campaign=digital_transformation\">Quit Now website</a></li><li>If you would like more help you can download <a href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">this free Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p style=\"color:#005b9c;\">Still not sure if you need to quit smoking? Answer these few questions:</p><ul><li>Do you experience physical withdrawal symptoms such as cravings for a cigarette, Irritability, anxiety and depression, restless sleep, trouble concentrating, headaches, coughing and sore throat, aches and pains, upset stomach and bowels when you haven’t had any Tobacco?</li><li>Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse? Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using Tobacco?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call the Quitline on <a href=\"tel:137848\">137848</a></li><li><a href=\"http://smartrecoveryaustralia.com.au/\">SMART Recovery</a> is a free group program assisting people with any problematic behaviours</li></ul><p>To avoid increasing your risk of tobacco related problems in the future you can use My Diary to track how often and how much you use and how much you spend.<br>You can come back and complete the Check Up again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/alcohol.female.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HARM FROM YOUR CURRENT PATTERN OF ALCOHOL USE.</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with a range of health, social, financial and legal problems.<br>If you would like more information about alcohol <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\">click here</a></p><p><span style=\"color:#005b9c;\">Are you aware of the low-risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol–related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.</p><p>If you would like to make sure that you continue to be at low risk of alcohol related problems in the future you can use <a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\">My Diary</a> to track how often and how much you drink, and how much you spend.<br>You can come back and complete the <a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/alcohol.female.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR ALCOHOL CONSUMPTION IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>hangovers</li><li>accidents and injuries</li><li>unsafe or unwise sex</li><li>aggressive or violent behaviour</li><li>relationship problems</li><li>reduced sexual performance</li><li>missing work, failing to fulfil obligations</li><li>memory blackouts</li><li>financial problems</li><li>drink driving charges</li></ul><p>In the long term alcohol use may be associated with weight gain, anxiety and depression high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers. If you drink when pregnant or breastfeeding your baby may be at risk of Foetal Alcohol Spectrum Disorders.</p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more alcohol related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down your alcohol use? If you are not sure it can be helpful to list all the good things and the not so good things about your drinking as well as the benefits and costs of cutting down. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>You can find some useful tips to cut down your alcohol use <a href=\"https://www.betterhealth.vic.gov.au/health/ten-tips/10-tips-to-cut-down-on-alcohol\" target=\"_blank\">here</a><br>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p><span style=\"color:#005b9c;\">Do I drink too much? What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks at on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To avoid increasing your risk of alcohol related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you drink and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/alcohol.female.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF ALCOHOL USE</span><br>Alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>Accidents and injury</li><li>Financial and work problems</li><li>Aggressive and violent behaviour</li><li>Drink driving charges</li><li>Relationship problems</li><li>Premature ageing</li><li>Reduced sexual performance</li><li>Difficulty remembering things and solving problems</li><li>High blood pressure</li><li>Anxiety and depression</li><li>Digestive problems, ulcers</li><li>For pregnant women, risk of Foetal Alcohol Spectrum Disorder.</li></ul><p>In the long term alcohol use may be associated with, muscle and nerve damage, permanent brain injury, stroke, heart disease, kidney disease, pancreatitis, liver disease, and cancers.</p><p>The best way to reduce your risk is to cut down or stop drinking alcohol. People in the high risk range often show signs of dependence on alcohol, meaning if they stop or significantly reduce their alcohol intake they show physical and psychological signs of alcohol withdrawal. It is strongly advised that you seek medical advice when planning to reduce or stop your alcohol use.</p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your alcohol use.</p><p style=\"color:#005b9c;\">How concerned are you about these problems? If you are unsure, answer the following questions:</p><ul><li>Do you think you need help to cut down or stop drinking alcohol?</li><li>Do you experience physical withdrawal symptoms such as anxiety, nausea, or tremor when you haven’t had any alcohol?</li><li>Have you been unable to reduce or stop drinking alcohol even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by drinking alcohol?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a health care professional for further assessment and assistance.<br>There are other services and resources that can help you:</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p><span style=\"color:#005b9c;\">What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To help reduce your risk of alcohol related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you drink, and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/alcohol.male.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HARM FROM YOUR CURRENT PATTERN OF ALCOHOL USE.</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with a range of health, social, financial and legal problems.<br>If you would like more information about alcohol <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/australian-alcohol-guidelines/\">click here</a></p><p><span style=\"color:#005b9c;\">Are you aware of the low-risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol–related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.</p><p>If you would like to make sure that you continue to be at low risk of alcohol related problems in the future you can use <a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\">My Diary</a> to track how often and how much you drink, and how much you spend.<br>You can come back and complete the <a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/alcohol.male.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR ALCOHOL CONSUMPTION IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>Many people use alcohol to socialise and for relaxation and enjoyment. However, alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>hangovers</li><li>accidents and injuries</li><li>unsafe or unwise sex</li><li>aggressive or violent behaviour</li><li>relationship problems</li><li>reduced sexual performance</li><li>missing work, failing to fulfil obligations</li><li>memory blackouts</li><li>financial problems</li><li>drink driving charges</li></ul><p>In the long term alcohol use may be associated with weight gain, anxiety and depression high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers. If you drink when pregnant or breastfeeding your baby may be at risk of Foetal Alcohol Spectrum Disorders.</p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more alcohol related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down your alcohol use? If you are not sure it can be helpful to list all the good things and the not so good things about your drinking as well as the benefits and costs of cutting down. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>You can find some useful tips to cut down your alcohol use <a href=\"https://www.betterhealth.vic.gov.au/health/ten-tips/10-tips-to-cut-down-on-alcohol\" target=\"_blank\">here</a><br>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p><span style=\"color:#005b9c;\">Do I drink too much? What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks at on any one day. The less you drink, the lower your risk of harm from alcohol.<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To avoid increasing your risk of alcohol related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you drink and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/alcohol.male.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF ALCOHOL USE</span><br>Alcohol use can be associated with health, social, financial and legal problems such as:</p><ul><li>Accidents and injury</li><li>Financial and work problems</li><li>Aggressive and violent behaviour</li><li>Drink driving charges</li><li>Relationship problems</li><li>Premature ageing</li><li>Reduced sexual performance</li><li>Difficulty remembering things and solving problems</li><li>High blood pressure</li><li>Anxiety and depression</li><li>Digestive problems, ulcers</li><li>For pregnant women, risk of Foetal Alcohol Spectrum Disorder.</li></ul><p>In the long term alcohol use may be associated with, muscle and nerve damage, permanent brain injury, stroke, heart disease, kidney disease, pancreatitis, liver disease, and cancers.</p><p>The best way to reduce your risk is to cut down or stop drinking alcohol. People in the high risk range often show signs of dependence on alcohol, meaning if they stop or significantly reduce their alcohol intake they show physical and psychological signs of alcohol withdrawal. It is strongly advised that you seek medical advice when planning to reduce or stop your alcohol use.</p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your alcohol use.</p><p style=\"color:#005b9c;\">How concerned are you about these problems? If you are unsure, answer the following questions:</p><ul><li>Do you think you need help to cut down or stop drinking alcohol?</li><li>Do you experience physical withdrawal symptoms such as anxiety, nausea, or tremor when you haven’t had any alcohol?</li><li>Have you been unable to reduce or stop drinking alcohol even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by drinking alcohol?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a health care professional for further assessment and assistance.<br>There are other services and resources that can help you:</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p><span style=\"color:#005b9c;\">What are the low risk drinking guidelines?</span><br>Australian experts recommend that to reduce the risk from alcohol-related disease or injury, healthy adults (who are not pregnant or breastfeeding), should drink no more than 10 standard drinks a week and no more than 4 standard drinks on any one day. The less you drink, the lower your risk of harm from alcohol<br>An Australian standard drink is a drink containing 10g of alcohol</p><img style=\"width: 100%;\" src=\"https://eassist.assistportal.com.au/assets/images/shared/feedback/alcohol.png\"><p style=\"text-align: right;\">Standard drinks guide and images courtesy of the Australian Government Department of Health.</p><p>If you are under 18 experts say that not drinking is the safest option.<br>If you are pregnant or breastfeeding it is safest for you and your baby not to drink alcohol.<br>By keeping within these low risk guidelines you are likely to look and feel better, your sleep and moods may improve, you may find improvements in your relationships with family and friends and you will be less likely to experience alcohol related problems.<br>In the long term your risk of weight gain, anxiety and depression, high blood pressure, stroke, heart disease, kidney disease, liver disease, and cancers will be reduced.</p><p>To help reduce your risk of alcohol related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you drink, and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while drinking alcohol, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/amphetamine.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF METHAMPHETAMINE USE.</span><br>If you choose to use methamphetamine again, be aware that methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration,</li><li>Jaw clenching, headaches, muscle pain,</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia,</li><li>Tremors, irregular heartbeat, shortness of breath,</li><li>Aggressive and violent behaviour,</li><li>Drug driving charges, arrests for possession or supply,</li><li>Psychosis after repeated use of high doses,</li><li>Permanent damage to brain cells,</li><li>Stroke or heart attack,</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/amphetamine/\" target=\"_blank\">methamphetamine click here.</a><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject methamphetamines you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using methamphetamine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/amphetamine.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR USE OF METHAMPHETAMINE IS PUTTING YOU AT MODERATE RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>There is no safe level of methamphetamine use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration</li><li>Jaw clenching, headaches, muscle pain</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia</li><li>Tremors, irregular heartbeat, shortness of breath</li><li>Aggressive and violent behaviour</li><li>Drug driving charges, arrests for possession or supply</li><li>Psychosis after repeated use of high doses</li><li>Permanent damage to brain cells,</li><li>Stroke or heart attack</li><li>Liver damage, brain haemorrhage, and sudden death in rare circumstances.</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/amphetamine/\">methamphetamine click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more methamphetamine related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about your methamphetamine use?</span><br>If any of these things have happened to you and you are concerned you may want to consider cutting down or stopping your methamphetamine use. If you are not sure it can be helpful to list all the good things and the not so good things about your methamphetamine use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.<br>If you would like to cut down or stop using methamphetamine here are some strategies to help you.<br><br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using methamphetamine</li><li>Keep a record of the times when you had a strong urge to use methamphetamine. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a target=\"_blank\" href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of methamphetamine related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p style=\"color:#005b9c;\">Injecting</p><p>If you inject methamphetamine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected methamphetamine we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using methamphetamine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/amphetamine.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEATH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF USE.</span><br>There is no safe level of methamphetamine use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Methamphetamine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty sleeping, loss of appetite, weight loss, dehydration</li><li>Jaw clenching, headaches, muscle pain</li><li>Mood swings, - anxiety, depression, agitation, mania, panic, paranoia</li><li>Tremors, irregular heartbeat, shortness of breath</li><li>Aggressive and violent behaviour</li><li>Drug driving charges, arrests for possession or supply</li><li>Psychosis after repeated use of high doses</li><li>Permanent damage to brain cells</li><li>Stroke or heart attack</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/amphetamine/\" target=\"_blank\">methamphetamine click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your amphetamine use.</p><p><span style=\"color:#005b9c;\">How concerned are you about your methamphetamine use?</span><br>The best way to reduce your risk is to cut down or stop using methamphetamine.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your methamphetamine use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>By not using or keeping your methamphetamine use very low you will find that you will eat and sleep better, your physical and mental health will improve, and you will be less likely to experience mood swings, anxiety, and aggressive behaviour.<br><br>If you would like to cut down or stop using methamphetamine here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using methamphetamine</li><li>Keep a record of the times when you had a strong urge to use methamphetamine. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using methamphetamine? Answer the following questions:</p><ul><li>Do you experience physical withdrawal symptoms such as cravings, aches and pains exhaustion, confusion and irritability, restless sleep and nightmares, anxiety, depression and paranoia when you haven’t had any methamphetamine?</li><li>Have you been unable to reduce or stop using methamphetamine even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using methamphetamine?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a health care professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of methamphetamine related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p style=\"color:#005b9c;\">Injecting</p><p>If you inject methamphetamine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected methamphetamine we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using methamphetamine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/cannabis.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF CANNABIS USE.</span><br>If you choose to use Cannabis again be aware that Cannabis use can be associated with a range of health, social, financial and legal problems such as:</p><ul><li>Drug driving charges, fines or arrest for possession and supply</li><li>Problems with attention and motivation</li><li>Anxiety, paranoia, panic, depression</li><li>Decreased memory and problem solving ability</li><li>Asthma, bronchitis, chronic obstructive airways disease</li><li>Psychosis in those with a personal or family history of schizophrenia</li><li>Cancers</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/cannabis/\">cannabis click here.</a><br>By not using, or keeping your cannabis use very low, you will find that your attention, motivation, memory and problem solving ability will improve, you will feel calmer and less anxious and your physical and mental health will improve.</p><p>To avoid increasing your risk of cannabis related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use cannabis and how much you spend. You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/cannabis.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR CANNABIS USE IS PUTTING YOU AT RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>Cannabis use can be associated with a range of health, social, financial and legal problems such as:</p><ul><li>Drug driving charges, arrest for possession and supply,</li><li>Problems with attention and motivation</li><li>Anxiety, paranoia, panic, depression</li><li>Decreased memory and problem solving ability</li><li>Asthma, bronchitis, chronic obstructive airways disease</li><li>Psychosis in those with a personal or family history of schizophrenia</li><li>Cancers</li></ul><p>Be aware that it is dangerous to drive or use machinery after you have used cannabis because it impairs your perception and coordination.<br>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/cannabis/\">cannabis click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your cannabis use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your cannabis use. If you are not sure it can be helpful to list all the good things and the not so good things about your cannabis use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>By not using, or keeping your cannabis use very low, you will find that your attention, motivation, memory and problem solving will improve, you will feel calmer and less anxious and your physical and mental health will improve.</p><p>If you would like to cut down or stop using cannabis here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cannabis</li><li>Keep a record of the times when you had a strong urge to use cannabis. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of cannabis related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/cannabis.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS BASED ON YOUR CURRENT PATTERN OF CANNABIS USE.</span><br>Cannabis use can be associated with a range of health, social, financial and legal problems such as:</p><ul><li>Drug driving charges, arrest for possession and supply,</li><li>Problems with attention and motivation</li><li>Anxiety, paranoia, panic, depression</li><li>Decreased memory and problem solving ability</li><li>Asthma, bronchitis, chronic obstructive airways disease</li><li>Psychosis in those with a personal or family history of schizophrenia</li><li>Cancers</li></ul><p>Be aware that it is dangerous to drive or use machinery after you have used cannabis because it impairs your perception and coordination.<br>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/cannabis/\">cannabis click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your cannabis use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop using cannabis.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your cannabis use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By not using, or keeping your cannabis use very low, you will find that your attention, motivation, memory and problem solving will improve, you will feel calmer and less anxious and your physical and mental health will improve.</p><p>If you would like to cut down or stop using cannabis here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cannabis</li><li>Keep a record of the times when you had a strong urge to use cannabis. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using cannabis? Answer the following questions to find out more:</p><ul><li>Do you experience physical withdrawal symptoms such as sleep difficulties, mood swings, irritability, anxiety, physical restlessness, nausea, reduced appetite, or depression when you haven’t had any cannabis?</li><li>Have you been unable to reduce or stop using cannabis even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using cannabis?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of cannabis related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/cocaine.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF COCAINE USE.</span><br>If you choose to use cocaine again, be aware that cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/cocaine/\">cocaine click here.</a><br>By not using or keeping your cocaine use very low you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject cocaine you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using cocaine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/cocaine.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR COCAINE USE IS PUTTING YOU AT RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>There is no safe level of cocaine use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/cocaine/\">cocaine click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that would have experienced one or more problems related to your cocaine use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your cocaine use. If you are not sure it can be helpful to list all the good things and the not so good things about your cocaine use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>By not using, or keeping your cocaine use very low, you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.</p><p>If you would like to cut down or stop using cocaine here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you</li><li>Plan some alternative activities to fill the extra time when you are not using</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cocaine</li><li>Keep a record of the times when you had a strong urge to use. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a>.</li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of cocaine related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject cocaine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time.</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using cocaine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/cocaine.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF COCAINE USE.</span><br>There is no safe level of cocaine use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Cocaine use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Heart racing, difficulty sleeping, headaches, weight loss</li><li>Numbness, tingling, clammy skin</li><li>Accidents and injury</li><li>Financial problems, arrests for drug driving, possession and supply</li><li>Irrational thoughts</li><li>Mood swings – anxiety, depression, mania</li><li>Aggression and paranoia</li><li>Intense cravings and stress</li><li>Psychosis after using high doses</li><li>Sudden death from heart problems</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/cocaine/\">cocaine click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that would have experienced one or more problems related to your cocaine use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop cocaine use.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your cocaine use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By not using, or keeping your cocaine use very low, you will find that you will eat and sleep better, your physical and mental health will improve and you will be less likely to experience accidents and injuries, anxiety, mood swings, and aggression.</p><p>If you would like to cut down or stop using cocaine here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you</li><li>Plan some alternative activities to fill the extra time when you are not using</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using cocaine</li><li>Keep a record of the times when you had a strong urge to use. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using cocaine? Answer the following questions to find out more:</p><ul><li>Do you experience physical withdrawal symptoms such a agitation, depression or anxiety, restless sleep, extreme cocaine cravings, lack of energy, anxiety, angry outbursts and an inability to feel pleasure when you haven’t had any cocaine?</li><li>Have you been unable to reduce or stop using cocaine even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using cocaine?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To help reduce your risk of cocaine related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject cocaine you increase your risk of becoming dependent and experiencing psychosis. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time.</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using cocaine, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/hallucinogens.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, YOU ARE AT LOW RISK OF HARMS FROM HALLUCINOGEN USE AT THIS TIME.</span><br><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>The drug itself</li><li>The individual user</li><li>The environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. You may like to find out more about specific drugs and their effects at <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/.\">https://assistplus.com.au/drug-information/.</a></p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using hallucinogens, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/hallucinogens.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, HALLUCINOGENS ARE PUTTING YOU AT MODERATE RISK OF HARM TO YOUR HEALTH AND SOCIAL SITUATION.</span><br><br>You are at risk of experiencing sleeping difficulties, nausea, vomiting, increased blood pressure, mood swings, anxiety, panic attacks, paranoia, flashbacks and increased effects of mental illnesses such as schizophrenia.<br><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>The drug itself</li><li>The individual user</li><li>The environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about hallucinogens and their effects at <a href=\"https://assistplus.com.au/drug-information/hallucinogens/\" target=\"_blank\">https://assistplus.com.au/drug-information/hallucinogens/.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using hallucinogens, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/hallucinogens.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT HALLUCINOGEN USE.</span><br><br>You are at risk of experiencing sleeping difficulties, nausea, vomiting, increased blood pressure, mood swings, anxiety, panic attacks, paranoia, flashbacks and increased effects of mental illnesses such as schizophrenia.<br><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>The drug itself</li><li>The individual user</li><li>The environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems. These risks also apply to prescription medication when taken for reasons other than prescribed.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about hallucinogens and their effects <a href=\"https://assistplus.com.au/drug-information/hallucinogens/\" target=\"_blank\">click here</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using hallucinogens, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/inhalants.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF INHALANT USE.</span><br>If you choose to use inhalants again, be aware that inhalants use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Dizziness and hallucinations</li><li>Drowsiness, disorientation, blurred vision</li><li>Coordination difficulties, slowed reactions</li><li>Flu-like symptoms, sinusitis, nosebleeds</li><li>Indigestion, stomach ulcers</li><li>Accidents and injury</li><li>Memory loss, confusion, delirium, seizures (fits), coma</li><li>Damage to your brain, heart, lungs, liver, and kidneys</li><li>Death from heart failure</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/inhalants/\">inhalants click here</a><br>By not using, or keeping your inhalant use very low, you will find that your memory, coordination and reaction times will improve, your physical and mental health will improve and you will be less likely to experience accidents and injuries.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using inhalants, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/inhalants.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR USE OF INHALANTS IS PUTTING YOU AT RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>There is no safe level of inhalant use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Inhalant use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Dizziness and hallucinations</li><li>Drowsiness, disorientation, blurred vision</li><li>Coordination difficulties, slowed reactions</li><li>Flu-like symptoms, sinusitis, nosebleeds</li><li>Indigestion, stomach ulcers</li><li>Accidents and injury</li><li>Memory loss, confusion, delirium, seizures (fits), coma</li><li>Damage to your brain, heart, lungs, liver, and kidneys</li><li>Death from heart failure</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/inhalants/\">inhalants click here</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more inhalant related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>If any of these things have happened to you and you are concerned you may want to consider cutting down or stopping your inhalants use. If you are not sure it can be helpful to list all the good things and the not so good things about your inhalants use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By not using, or keeping your inhalant use very low, you will find that your memory, coordination and reaction times will improve, your physical and mental health will improve and you will be less likely to experience accidents and injuries.</p><p>If you would like to cut down or stop using inhalants here are some strategies to help you.<br>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using inhalants</li><li>Keep a record of the times when you had a strong urge to use inhalants. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of inhalants related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using inhalants, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/inhalants.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF INHALANT USE.</span><br>There is no safe level of inhalant use. It is important to be very careful when taking any type of drug or combination of drugs.<br>Inhalant use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Dizziness and hallucinations</li><li>Drowsiness, disorientation, blurred vision</li><li>Coordination difficulties, slowed reactions</li><li>Flu-like symptoms, sinusitis, nosebleeds</li><li>Indigestion, stomach ulcers</li><li>Accidents and injury</li><li>Memory loss, confusion, delirium, seizures (fits), coma</li><li>Damage to your brain, heart, lungs, liver, and kidneys</li><li>Death from heart failure</li></ul><p>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/inhalants/\">inhalants click here</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more inhalant related problems.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop using inhalants.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your inhalant use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By not using, or keeping your inhalant use very low, you will find that your memory, coordination and reaction times will improve, your physical and mental health will improve and you will be less likely to experience accidents and injuries.</p><p>If you would like to cut down or stop using inhalants here are some strategies to help you.<br>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using inhalants</li><li>Keep a record of the times when you had a strong urge to use inhalants. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using inhalants?</p><ul><li>Do you experience physical withdrawal symptoms such as hangover, headache, nausea and stomach pain, tiredness, shakiness, tremors, cramps hallucinations and visual disorders, such as seeing spots when you haven’t had any inhalants?</li><li>Have you been unable to reduce or stop using inhalants even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using inhalants?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of inhalant related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using inhalants, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/opioids.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF OPIOID USE.</span><br>While opioids are very useful medications for pain, non-medical use can be very harmful. If you choose to use opioids/heroin again, be aware that opioid/heroin use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty concentrating and remembering things</li><li>Difficulty urinating; constipation</li><li>Dry mouth, tooth decay</li><li>Nausea, loss of appetite</li><li>Slow breathing and heart rate, irregular heartbeat</li><li>Reduced sexual desire and sexual performance</li><li>Irregular periods and difficulty having children</li><li>Relationship difficulties</li><li>Financial and work problems, legal problems</li><li>Overdose and death from respiratory failure</li><li>Opioid dependence</li></ul><p>The effects of mixing opioids/heroin with alcohol, prescription or over the counter medications, and/or other illicit drugs are often unpredictable. In particular, mixing opioids with other depressant drugs such as alcohol or sedatives increases the depressant effects and can result in respiratory depression, coma and death.<br>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/opioids/\">specific opioids click here.</a><br>By not using, or by keeping your opioid use very low, you will find that your appetite, concentration, memory and alertness will improve, your dental and physical health will improve, your sexual functioning will improve and you will be at lower risk of overdose. If you inject opioids you may be at risk of blood borne viruses such as Hepatitis B & C and HIV. If you have ever injected opioids we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using opioids/heroin, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>Stay with them until help arrives.</p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don\'t delay.</p><p>If the person is breathing, place them in the recovery position and give <a target=\"_blank\" href=\"http://www.sahealth.sa.gov.au/naloxone\">naloxone</a> (if available).</p><p>If not breathing, commence CPR.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/opioids.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR OPIOID USE IS PUTTING YOU AT RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>While opioids are very useful medications for pain, non-medical use can be very harmful. Be aware that opioid/heroin use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty concentrating and remembering things</li><li>Difficulty urinating; constipation</li><li>Dry mouth, tooth decay</li><li>Nausea, loss of appetite</li><li>Slow breathing and heart rate, irregular heartbeat</li><li>Reduced sexual desire and sexual performance</li><li>Irregular periods and difficulty having children</li><li>Relationship difficulties</li><li>Financial and work problems, legal problems</li><li>Overdose and death from respiratory failure</li><li>Opioid dependence</li></ul><p>The effects of mixing opioids/heroin with alcohol, prescription or over the counter medications, and/or other illicit drugs are often unpredictable. In particular, mixing opioids with other depressant drugs such as alcohol or sedatives increases the depressant effects and can result in respiratory depression, coma and death.<br>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/opioids/\">specific opioids click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more opioid related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your opioid/heroin use? If you are not sure it can be helpful to list all the good things and the not so good things about your opioid use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>By not using, or by keeping your opioid/heroin use very low, you will find that your appetite, concentration, memory and alertness will improve, your dental and physical health will improve, your sexual functioning will improve and you will be at lower risk of overdose.</p><p>If you would like to cut down or stop using opioids/heroin here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using opioids/heroin</li><li>Keep a record of the times when you had a strong urge to use opioids/heroin. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of opioid related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject opioids/heroin you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected opioids/heroin we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using opioids/heroin, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>Stay with them until help arrives.</p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don\'t delay.</p><p>If the person is breathing, place them in the recovery position and give <a target=\"_blank\" href=\"http://www.sahealth.sa.gov.au/naloxone\">naloxone</a> (if available).</p><p>If not breathing, commence CPR.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/opioids.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF OPIOID USE.</span><br>While opioids are very useful medications for pain, non-medical use can be very harmful. Be aware that opioid use can be associated with a range of health, social, financial and legal problems including:</p><ul><li>Difficulty concentrating and remembering things</li><li>Difficulty urinating; constipation</li><li>Dry mouth, tooth decay</li><li>Nausea, loss of appetite</li><li>Slow breathing and heart rate, irregular heartbeat</li><li>Reduced sexual desire and sexual performance</li><li>Irregular periods and difficulty having children</li><li>Relationship difficulties</li><li>Financial and work problems, legal problems</li><li>Overdose and death from respiratory failure</li><li>Opioid dependence</li></ul><p>The effects of mixing opioids/heroin with alcohol, prescription or over the counter medications, and/or other illicit drugs are often unpredictable. In particular, mixing opioids with other depressant drugs such as alcohol or sedatives increases the depressant effects and can result in respiratory depression, coma and death.<br>If you would like more information about <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/opioids/\">specific opioids click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more inhalant related problems.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop using opioids/heroin.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your opioid use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By not using, or by keeping your opioid/heroin use very low, you will find that your appetite, concentration, memory and alertness will improve, your dental and physical health will improve, your sexual functioning will improve and you will be at lower risk of overdose.</p><p>If you would like to cut down or stop using opioids/heroin here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using opioids/heroin</li><li>Keep a record of the times when you had a strong urge to use opioids/heroin. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using opioids/heroin? Answer the following questions:</p><ul><li>Do you experience physical withdrawal symptoms such as restlessness and irritability, depression and crying, diarrhoea, restless sleep and yawning, stomach and leg cramps, vomiting and no appetite, goosebumps, runny nose fast heartbeat when you haven’t had any opioids/heroin?</li><li>Have you been unable to reduce or stop using opioids/heroin even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using opioids/heroin?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of opioid related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject opioids/heroin you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected opioids/heroin we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using opioids/heroin, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>Stay with them until help arrives.</p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don\'t delay.</p><p>If the person is breathing, place them in the recovery position and give <a target=\"_blank\" href=\"http://www.sahealth.sa.gov.au/naloxone\">naloxone</a> (if available).</p><p>If not breathing, commence CPR.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/other.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, THIS SUBSTANCE IS PUTTING YOU AT RISK OF HARM TO YOUR HEALTH AND SOCIAL SITUATION.</span><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>the drug itself</li><li>the individual user</li><li>the environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any illicit drug use can put you at risk of health, social, financial and legal problems. These risks also apply to prescription medication when taken for reasons other than prescribed.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about specific drugs and their effects at <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/\">https://assistplus.com.au/drug-information/.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject a drug you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using drugs, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/other.moderate.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR ANSWERS, THIS SUBSTANCE IS PUTTING YOU AT RISK OF HARM TO YOUR HEALTH AND SOCIAL SITUATION.</span><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>the drug itself</li><li>the individual user</li><li>the environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any drug use can put you at risk of health, social, financial and legal problems. These risks also apply to prescription medication when taken for reasons other than prescribed.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about specific drugs and their effects at <a target=\"_blank\" href=\"https://assistplus.com.au/drug-information/\">https://assistplus.com.au/drug-information/.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject a drug you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected a drug we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using drugs, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/other.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF USE.</span><br>The effects of any drug vary from person to person. The effect is the result of three interacting factors:</p><ul><li>the drug itself</li><li>the individual user</li><li>the environment in which drug use occurs</li></ul><p>While the effect that a drug has on a person is determined by many factors, the primary factors that influence a drug’s effect are the type of drug and the quantity used. It is important to remember that any use can put you at risk of health, social, financial and legal problems.</p><p>Illegal drugs are not subject to quality controls and the active ingredient is not consistent. You can never be sure what is actually in it and how it will affect you. Even ‘one off’ use can lead to serious harms. Federal and state laws provide penalties for possessing, using, producing, selling or driving under the influence of illicit drugs. Penalties can include fines, disqualification from driving, rehabilitation orders and imprisonment. Think about how any of these consequences could impact your life.</p><p>To avoid the risks and harms associated with drugs, the best option is to not use them. This can be difficult for some people who may have become dependent on them and feel symptoms of withdrawal if they stop or reduce their use.</p><p>Help is available. You may like to start by finding out more about specific drugs and their effects at <a href=\"https://assistplus.com.au/drug-information/\" target=\"_blank\">https://assistplus.com.au/drug-information/.</a></p><p>You are also encouraged to talk to a health professional or local drug and alcohol service if you would like more information or support in quitting your use.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject a drug you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject:</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected a drug we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using drugs, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/sedatives.brief.partial.html","<p><span style=\"color:#005b9c;\">BASED ON YOUR RESPONSES, YOU ARE AT LOW RISK OF HEALTH AND OTHER PROBLEMS FROM YOUR CURRENT PATTERN OF SEDATIVE USE.</span><br>While Prescription Medications are very useful when taken as directed by a doctor, non-medical use can be very harmful. If you choose to use prescription medications again, ensure that you use them only as prescribed by a doctor. It is important to be very careful when using any drugs or combination of drugs. Depending which sedative medication you choose, misuse can be associated with a range of health, social, financial and legal problems including:<br>Benzodiazepines</p><ul><li>Drowsiness, dizziness, confusion, falls</li><li>Concentration and memory problems</li><li>Headaches</li><li>Sleeping problems</li><li>Anxiety and depression</li><li>Tolerance and dependence after a short period of use</li><li>Withdrawal symptoms</li><li>Overdose and death if used with alcohol, opioids or other depressant drugs.</li></ul><p>If you would like to learn more information specific about <a href=\"https://assistplus.com.au/drug-information/sedatives-sleeping-pills/\" target=\"_blank\">sedative medications click here.</a><br>By not using, or by keeping your prescription medication use very low, you will find that your appetite, concentration, memory and alertness will improve, you will sleep better, you will be at lower risk of falls, anxiety, and overdose.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject sedative you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using sedatives, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/sedatives.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR USE OF SEDATIVE MEDIACTION IS PUTTING YOU AT RISK OF HEALTH, SOCIAL, FINANCIAL AND LEGAL PROBLEMS</span><br>While Prescription Medications are very useful when taken as directed by a doctor, non-medical use can be very harmful. Be aware that prescription medication use can be associated with a range of health, social, financial and legal problems.<br>Benzodiazepines</p><ul><li>Drowsiness, dizziness, confusion, falls</li><li>Concentration and memory problems</li><li>Headaches</li><li>Sleeping problems</li><li>Anxiety and depression</li><li>Tolerance and dependence after a short period of use</li><li>Withdrawal symptoms</li><li>Overdose and death if used with alcohol, opioids or other depressant drugs.</li></ul><p>If you would like more information about <a href=\"https://assistplus.com.au/drug-information/sedatives-sleeping-pills/\" target=\"_blank\">sedative medications click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more sedative medication related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>You may want to consider cutting down or stopping your sedative use. If you are not sure it can be helpful to list all the good things and the not so good things about your sedative use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>By not using, or by keeping your prescription medication use very low, you will find that your appetite, concentration, memory and alertness will improve, you will sleep better and you will be at lower risk of falls, anxiety, and overdose.</p><p>If you would like to cut down or stop using prescription medications here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using opioids</li><li>Keep a record of the times when you had a strong urge to use opioids. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p>If you would like more help to cut down there are services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a href=\"http://smartrecoveryaustralia.com.au/\" target=\"_blank\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of prescription medication related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject sedative medication you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected sedative medications we recommend that you see a health care professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using sedatives, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/sedatives.referral.partial.html","<p><span style=\"color:#005b9c;\">YOU ARE AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL, FINANCIAL, LEGAL AND RELATIONSHIP PROBLEMS BASED ON YOUR CURRENT PATTERN OF SEDATIVE USE.</span><br>Be aware that sedative medication use can be associated with a range of health, social, financial and legal problems.</p><ul><li>Drowsiness</li><li>Difficulty concentrating and remembering things</li><li>Nausea and loss of appetite</li><li>Sleeping problems</li><li>Headaches</li><li>Double or blurred vision</li><li>Jitteriness and excitability</li><li>Impaired coordination, dizziness and tremor</li><li>Mood swings and aggression</li><li>Risk of overdose</li><li>Loss of consciousness, coma, death</li></ul><p>If you would like to learn more information specific about <a href=\"https://assistplus.com.au/drug-information/sedatives-sleeping-pills/\" target=\"_blank\">sedative medications click here.</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you have experienced one or more problems related to your sedatives use.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to cut down or stop misusing sedative medication.<br>Within months of cutting down or quitting using sedatives normal sleep patterns return.<br>Also:</p><ul><li>Your appetite will return to normal</li><li>Will no longer have unsteady gait, slurred speech and poor coordination skills</li><li>You will no longer suffer from double or blurred vision or jitteriness</li><li>You will improve your mood, your concentration and your ability to remember things</li><li>You are no longer at risk of early death through overdose</li></ul><p>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about your opioid use as well as the benefits and costs of cutting down or stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By not using, or by keeping your prescription medication use very low, you will find that your appetite, concentration, memory and alertness will improve, you will sleep better and you will be at lower risk of falls, anxiety, and overdose.</p><p>If you would like to cut down or stop misusing prescription medications here are some strategies to help you.<br>If your goal is to cut down:</p><ul><li>Plan how often and how much you are going to use</li><li>Never buy more than you plan to use in one session</li><li>Avoid having a stash that might tempt you to use more</li></ul><p>If your goal is to stop:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using sedative mediciation</li><li>Keep a record of the times when you had a strong urge to use sedative mediciation. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">Urge Log here.</a></li></ul><p style=\"color:#005b9c;\">Do you think you need help to cut down or stop using sedative medication? Answer these questions to find out:</p><ul><li>Do you experience physical withdrawal symptoms such as restlessness and irritability, depression and crying, headaches, aching or twitching muscles, dizziness and tremors, convulsions, hallucinations, diarrhoea, restless sleep, bizarre dreams when you haven’t had any sedative medication?</li><li>Have you been unable to reduce or stop using sedative medication even though your health, family, work, financial or legal problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using sedative medication?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call ADIS – the Alcohol and Drug Information Service for advice and referrals:<br><a href=\"tel:1300 131 340\">1300 131 340</a> available 8.30am to 10pm every day.</li><li>You can access Know Your Options. This website provides individuals, families and health professionals with information about alcohol and other drug treatment and support services in South Australia. Visit <a target=\"_blank\" href=\"https://www.knowyouroptions.sa.gov.au\">www.knowyouroptions.sa.gov.au</a></li><li>If you are aged between 12 and 25 you can call:<ul><li><a target=\"_blank\" href=\"https://www.headspace.com/\">Headspace</a> for advice and referrals</li><li><a target=\"_blank\" href=\"http://www.wch.sa.gov.au/services/az/divisions/mentalhealth/camhs_connect.html\">CAMHS (Child and Adolescent Mental Health Service)</a></li></ul></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of prescription medication related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p><p><span style=\"color:#005b9c;\">Injecting</span><br>If you inject sedative medication you increase your risk of becoming dependent. You may also damage your skin and veins and get infections, abscesses, and ulcers. If you share injecting equipment you are at risk of blood borne virus infections like Hepatitis B & C and HIV. It is always safer not to inject.<br>If you choose to inject</p><ul><li>ALWAYS use clean equipment and a new needle and syringe.</li><li>Do not share any equipment.</li><li>Always clean the preparation area, your hands and the injecting site.</li><li>Inject slowly and in a different site each time</li><li>Dispose of the used needle and syringe in a sharps container.</li></ul><p>If you have ever injected we recommend that you see a healthcare professional to be tested for blood borne viruses.</p><p><span style=\"color:#005b9c;\">Make sure you know what to do in a crisis</span><br>If someone overdoses or has an adverse reaction while using sedative medication, in Australia</p><p style=\"text-align: center;\"><a href=\"tel:000\">Call Triple Zero (000)</a></p><p>It is very important that they receive professional help as soon as possible. A quick response can save their life so don’t delay.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/tobacco.female.brief.partial.html","<p><span style=\"color:#005b9c;\">THERE ARE NO HEALTH BENEFITS OF TOBACCO USE AND NO SAFE LEVEL OF SMOKING.</span><br>If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>Cancers</li><li>High blood pressure</li><li>Heart disease, stroke, vascular disease</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li><li>Premature ageing, wrinkling of the skin</li></ul><p>If you would like more information about tobacco go to: <a target=\"_blank\" href=\"https://www.besmokefree.com.au\">www.besmokefree.com.au</a><br>By quitting smoking, you will reduce your chances of cancer and heart disease, your fitness will improve, you will increase your chances of living longer and spending quality time with your family and friends, and you won’t be exposing your family to dangerous second-hand smoke.</p><ul><li>Think about why you smoke. Take the <a href=\"https://besmokefree.com.au/quiz/\" target=\"_blank\" rel=\"noopener noreferrer\">Quiz</a></li><li>Work out how much you would save - <a href=\"https://besmokefree.com.au/planning-to-quit/cost-calculator/\" target=\"_blank\" rel=\"noopener noreferrer\">Cost calculator</a></li></ul><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid smoking.</li><li>Get more help from the <a href=\"https://www.besmokefree.com.au\" target=\"_blank\">Be Smoke Free website - www.besmokefree.com.au</a></li><li>If you would like more help you can download <a target=\"_blank\" href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">free My Quit Buddy app</a> and/or talk to a health care professional.</li></ul>");
$templateCache.put("app/components/assistLite/partials/feedback/tobacco.female.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR SMOKING IS PUTTING YOU AT RISK OF HEALTH AND FINANCIAL PROBLEMS</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke, be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>Cancers</li><li>High blood pressure</li><li>Heart disease, stroke, vascular disease</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li><li>Premature ageing, wrinkling of the skin</li></ul><p>If you would like more information about tobacco go to: <a target=\"_blank\" href=\"https://www.besmokefree.com.au\">www.besmokefree.com.au</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more tobacco related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>If any of these things have happened to you and you are concerned you may want to consider stopping smoking. If you are not sure it can be helpful to list all the good things and the not so good things about your smoking as well as the benefits and costs of stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>By quitting smoking, you will reduce your chances of cancer and heart disease, your fitness will improve, you will increase your chances of living longer and spending quality time with your family and friends, and you won’t be exposing your family to dangerous second-hand smoke.<br>A list of the benefits of stopping can be found on the Be Smoke Free website - <a target=\"_blank\" href=\"http://www.besmokefree.com.au/\">www.besmokefree.com.au</a></p><ul><li>Think about why you smoke. Take the <a href=\"https://besmokefree.com.au/quiz/\" target=\"_blank\" rel=\"noopener noreferrer\">Quiz</a></li><li>Work out how much you would save - <a href=\"https://besmokefree.com.au/planning-to-quit/cost-calculator/\" target=\"_blank\" rel=\"noopener noreferrer\">Cost calculator</a></li></ul><p>If you would like to quit smoking here are some strategies to help you:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid smoking.</li><li>Get more help from the <a href=\"https://www.besmokefree.com.au\" target=\"_blank\">Be Smoke Free website - www.besmokefree.com.au</a></li><li>If you would like more help you can download <a target=\"_blank\" href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">free My Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p>To avoid increasing your risk of smoking related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you smoke and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/tobacco.female.referral.partial.html","<p><span style=\"color:#005b9c;\">YOUR SMOKING IS PUTTING YOU AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL AND FINANCIAL PROBLEMS.</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke, be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>Cancers</li><li>High blood pressure</li><li>Heart disease, stroke, vascular disease</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li><li>Premature ageing, wrinkling of the skin</li></ul><p>If you would like more information about tobacco go to: <a target=\"_blank\" href=\"https://www.besmokefree.com.au\">www.besmokefree.com.au</a></p><p style=\"color:#005b9c;\">Based on your responses it is likely that you are experiencing a number of problems related to your smoking.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to stop smoking.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about smoking use as well as the benefits and costs of stopping. You can find a Cost- Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By quitting smoking, you will reduce your chances of cancer and heart disease, your fitness will improve, you will increase your chances of living longer and spending quality time with your family and friends, and you won’t be exposing your family to dangerous second-hand smoke.<br>A list of the benefits of stopping can be found on the Be Smoke Free website - <a target=\"_blank\" href=\"http://www.besmokefree.com.au/\">www.besmokefree.com.au</a></p><ul><li>Think about why you smoke. Take the <a href=\"https://besmokefree.com.au/quiz/\" target=\"_blank\" rel=\"noopener noreferrer\">Quiz</a></li><li>Work out how much you would save - <a href=\"https://besmokefree.com.au/planning-to-quit/cost-calculator/\" target=\"_blank\" rel=\"noopener noreferrer\">Cost calculator</a></li></ul><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using Tobacco</li><li>Keep a record of the times when you had a strong urge to use Tobacco. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a target=\"_blank\" href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li><li>Get more help from the <a href=\"https://www.besmokefree.com.au\" target=\"_blank\">Be Smoke Free website - www.besmokefree.com.au</a></li><li>If you would like more help you can download <a target=\"_blank\" href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">free My Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p style=\"color:#005b9c;\">Still not sure if you need to quit smoking? Answer these few questions:</p><ul><li>Do you experience physical withdrawal symptoms such as cravings for a cigarette, Irritability, anxiety and depression, restless sleep, trouble concentrating, headaches, coughing and sore throat, aches and pains, upset stomach and bowels when you haven’t had any Tobacco?</li><li>Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse? Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using Tobacco?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call the Quitline on <a href=\"tel:13 78 48\">13 78 48</a></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of tobacco related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/tobacco.male.brief.partial.html","<p><span style=\"color:#005b9c;\">THERE ARE NO HEALTH BENEFITS OF TOBACCO USE AND NO SAFE LEVEL OF SMOKING.</span><br>If you choose to smoke be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>Cancers</li><li>High blood pressure</li><li>Heart disease, stroke, vascular disease</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li><li>Premature ageing, wrinkling of the skin</li></ul><p>If you would like more information about tobacco go to: <a target=\"_blank\" href=\"https://www.besmokefree.com.au\">www.besmokefree.com.au</a><br>By quitting smoking, you will reduce your chances of cancer and heart disease, your fitness will improve, you will increase your chances of living longer and spending quality time with your family and friends, and you won’t be exposing your family to dangerous second-hand smoke.</p><ul><li>Think about why you smoke. Take the <a href=\"https://besmokefree.com.au/quiz/\" target=\"_blank\" rel=\"noopener noreferrer\">Quiz</a></li><li>Work out how much you would save - <a href=\"https://besmokefree.com.au/planning-to-quit/cost-calculator/\" target=\"_blank\" rel=\"noopener noreferrer\">Cost calculator</a></li></ul><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid smoking.</li><li>Get more help from the <a href=\"https://www.besmokefree.com.au\" target=\"_blank\">Be Smoke Free website - www.besmokefree.com.au</a></li><li>If you would like more help you can download <a target=\"_blank\" href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">free My Quit Buddy app</a> and/or talk to a health care professional.</li></ul>");
$templateCache.put("app/components/assistLite/partials/feedback/tobacco.male.moderate.partial.html","<p><span style=\"color:#005b9c;\">YOUR SMOKING IS PUTTING YOU AT RISK OF HEALTH AND FINANCIAL PROBLEMS</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke, be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>Cancers</li><li>High blood pressure</li><li>Heart disease, stroke, vascular disease</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li><li>Premature ageing, wrinkling of the skin</li></ul><p>If you would like more information about tobacco go to: <a target=\"_blank\" href=\"https://www.besmokefree.com.au\">www.besmokefree.com.au</a></p><p style=\"color:#005b9c;\">Based on your responses it seems that you may have experienced one or more tobacco related problems in the last 3 months.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>If any of these things have happened to you and you are concerned you may want to consider stopping smoking. If you are not sure it can be helpful to list all the good things and the not so good things about your smoking as well as the benefits and costs of stopping. You can find a Cost-Benefit Analysis worksheet and other useful tools <a href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\" target=\"_blank\">here</a><br>By quitting smoking, you will reduce your chances of cancer and heart disease, your fitness will improve, you will increase your chances of living longer and spending quality time with your family and friends, and you won’t be exposing your family to dangerous second-hand smoke.<br>A list of the benefits of stopping can be found on the Be Smoke Free website - <a target=\"_blank\" href=\"http://www.besmokefree.com.au/\">www.besmokefree.com.au</a></p><ul><li>Think about why you smoke. Take the <a href=\"https://besmokefree.com.au/quiz/\" target=\"_blank\" rel=\"noopener noreferrer\">Quiz</a></li><li>Work out how much you would save - <a href=\"https://besmokefree.com.au/planning-to-quit/cost-calculator/\" target=\"_blank\" rel=\"noopener noreferrer\">Cost calculator</a></li></ul><p>If you would like to quit smoking here are some strategies to help you:</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not smoking.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid smoking.</li><li>Get more help from the <a href=\"https://www.besmokefree.com.au\" target=\"_blank\">Be Smoke Free website - www.besmokefree.com.au</a></li><li>If you would like more help you can download <a target=\"_blank\" href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">free My Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p>To avoid increasing your risk of smoking related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you smoke and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/assistLite/partials/feedback/tobacco.male.referral.partial.html","<p><span style=\"color:#005b9c;\">YOUR SMOKING IS PUTTING YOU AT <strong>HIGH RISK</strong> OF EXPERIENCING HEALTH, SOCIAL AND FINANCIAL PROBLEMS.</span><br>There are no health benefits of tobacco use and no safe level of smoking. If you choose to smoke, be aware of the many health problems associated with smoking tobacco such as:</p><ul><li>Asthma, respiratory infections, chronic obstructive airways disease</li><li>Cancers</li><li>High blood pressure</li><li>Heart disease, stroke, vascular disease</li><li>Diabetes, and serious complications of diabetes</li><li>Miscarriage, premature labour and low birthweight babies</li><li>Kidney disease</li><li>Respiratory infections, allergies and asthma in the children of smokers.</li><li>Premature ageing, wrinkling of the skin</li></ul><p>If you would like more information about tobacco go to: <a target=\"_blank\" href=\"https://www.besmokefree.com.au\">www.besmokefree.com.au</a></p><p style=\"color:#005b9c;\">Based on your responses it is likely that you are experiencing a number of problems related to your smoking.</p><p><span style=\"color:#005b9c;\">How concerned are you about these problems?</span><br>The best way to reduce your risk is to stop smoking.<br>If you are not sure what you want to do it can be helpful to list all the good things and the not so good things about smoking use as well as the benefits and costs of stopping. You can find a Cost- Benefit Analysis worksheet and other useful tools <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">here</a><br>By quitting smoking, you will reduce your chances of cancer and heart disease, your fitness will improve, you will increase your chances of living longer and spending quality time with your family and friends, and you won’t be exposing your family to dangerous second-hand smoke.<br>A list of the benefits of stopping can be found on the Be Smoke Free website - <a target=\"_blank\" href=\"http://www.besmokefree.com.au/\">www.besmokefree.com.au</a></p><ul><li>Think about why you smoke. Take the <a href=\"https://besmokefree.com.au/quiz/\" target=\"_blank\" rel=\"noopener noreferrer\">Quiz</a></li><li>Work out how much you would save - <a href=\"https://besmokefree.com.au/planning-to-quit/cost-calculator/\" target=\"_blank\" rel=\"noopener noreferrer\">Cost calculator</a></li></ul><p>If you would like to stop smoking here are some strategies to help you.</p><ul><li>Set a target date and stop on that date</li><li>Tell a friend or family member that you are going to stop so that they can support you.</li><li>Plan some alternative activities to fill the extra time when you are not using.</li><li>Think about situations where you might be tempted to use and plan to avoid them or plan how you will avoid using Tobacco</li><li>Keep a record of the times when you had a strong urge to use Tobacco. This will help you recognise high risk situations and plan to avoid or manage them. You can download an <a href=\"https://smartrecoveryaustralia.com.au/resources/smart-worksheets/\">Urge Log here.</a></li><li>Get more help from the <a href=\"https://www.besmokefree.com.au\" target=\"_blank\">Be Smoke Free website - www.besmokefree.com.au</a></li><li>If you would like more help you can download <a target=\"_blank\" href=\"https://www.health.gov.au/resources/apps-and-tools/my-quitbuddy-app\">free My Quit Buddy app</a> and/or talk to a health care professional.</li></ul><p style=\"color:#005b9c;\">Still not sure if you need to quit smoking? Answer these few questions:</p><ul><li>Do you experience physical withdrawal symptoms such as cravings for a cigarette, Irritability, anxiety and depression, restless sleep, trouble concentrating, headaches, coughing and sore throat, aches and pains, upset stomach and bowels when you haven’t had any Tobacco?</li><li>Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse? Have you been unable to reduce or stop using Tobacco even though your health or financial problems have continued or got worse?</li><li>Do you have health or psychological problems that may be made worse by using Tobacco?</li></ul><p>If you answered yes to any of these questions we strongly recommend that you see a healthcare professional for further assessment and assistance.<br>There are other services and resources that can help you.</p><ul><li>You can call the Quitline on <a href=\"tel:13 78 48\">13 78 48</a></li><li>SMART Recovery is a free group program assisting adults with any problematic behaviours <a target=\"_blank\" href=\"http://smartrecoveryaustralia.com.au/\">http://smartrecoveryaustralia.com.au/</a></li></ul><p>To avoid increasing your risk of tobacco related problems in the future you can use <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">My Diary</a> to track how often and how much you use and how much you spend.<br>You can come back and complete the <a href=\"https://play.google.com/store/apps/details?id=au.edu.adelaide.myassist&hl=en_US\" target=\"_blank\" rel=\"noopener noreferrer\">Check Up</a> again in 3 months time if you would like to see how you are going.</p>");
$templateCache.put("app/components/auth/password/new/password.new.info.template.html","<div class=\"form-signin-wrap\"><div class=\"form-signin\"><h1 class=\"logo logo-colored text-hide\"><a ui-sref=\"guest.login\" class=\"logo-link\">{{portalText.hostName}} portal</a></h1><h2 class=\"form-signin-heading form-signin-heading-info text-center\">Your password was changed successfully. You can <a ui-sref=\"guest.login\"><b>Log In</b></a> now.</h2></div></div>");
$templateCache.put("app/components/auth/password/new/password.new.template.html","<div class=\"form-signin-wrap\"><form class=\"form-signin\" name=\"passwordNew\" ng-submit=\"passwordNew.$valid && passwordCtrl.new()\" novalidate=\"\"><h2 class=\"form-signin-heading text-center\">Choose a new password</h2><div class=\"form-group\" ng-class=\"{ \'has-error\': passwordNew.$submitted && !passwordNew.$valid }\"><p class=\"error-message text-center text-danger\" ng-show=\"passwordNew.$submitted\"><span ng-show=\"passwordNew.password.$error.required\">Password are required.<br></span> <span ng-show=\"passwordNew.password.$error.pattern\">{{ passwordCtrl.passwordErrorMessage }}<br></span> <span ng-show=\"passwordCtrl.error\">{{passwordCtrl.error}}<br></span></p><input type=\"password\" name=\"password\" ng-model=\"passwordCtrl.password\" placeholder=\"New Password\" required=\"\" ng-pattern=\"passwordCtrl.passwordRegex\" class=\"form-control\"></div><button type=\"submit\" class=\"btn btn-signin btn-login btn-block\" ng-disabled=\"passwordCtrl.isDisabled(passwordNew)\"><span ng-if=\"!passwordCtrl.loading\">Continue</span> <span ng-if=\"passwordCtrl.loading\">Saving...</span></button></form></div>");
$templateCache.put("app/components/auth/password/reset/password.reset.info.template.html","<div class=\"form-signin-wrap\"><div class=\"form-signin\"><h2 class=\"form-signin-heading form-signin-heading-info text-center\">We\'ve sent you a link to change your password. Check email.</h2></div></div>");
$templateCache.put("app/components/auth/password/reset/password.reset.template.html","<div class=\"form-signin-wrap\"><form class=\"form-signin\" name=\"resetPassword\" novalidate=\"\" ng-submit=\"resetPassword.$valid && passwordCtrl.reset()\"><h2 class=\"form-signin-heading text-center\">Forgot password?</h2><div class=\"form-group\" ng-class=\"{ \'has-error\': passwordCtrl.hasError(resetPassword) }\"><p class=\"error-message text-center text-danger\" ng-show=\"resetPassword.$submitted\"><span ng-show=\"resetPassword.email.$error.required\">Email is required.<br></span> <span ng-show=\"resetPassword.email.$error.email\">Email is invalid.<br></span> <span ng-if=\"passwordCtrl.error\">{{ passwordCtrl.error }}</span></p><input type=\"email\" name=\"email\" required=\"\" ng-model=\"passwordCtrl.email\" ng-change=\"passwordCtrl.onEmailChange()\" placeholder=\"Email\" class=\"form-control\"> <button type=\"submit\" class=\"btn btn-signin btn-login btn-block\" ng-disabled=\"passwordCtrl.isDisabled(resetPassword)\"><span ng-if=\"!passwordCtrl.loading\">Reset my password</span> <span ng-if=\"passwordCtrl.loading\">Reseting...</span></button></div></form></div>");
$templateCache.put("app/components/assistLite/eAssistSA/template/end.template.html","<div class=\"videoWindow\"><div class=\"assist-section\"><h1 class=\"assist-title\">eASSIST SA results</h1></div><div class=\"assist-section\" ng-if=\"!assistSACtrl.results.feedback.briefAdvice.length&&!assistSACtrl.results.feedback.moderateAdvice.length && !assistSACtrl.results.feedback.referralAdvice.length\">Thank you for completing the questions. Based on your answers, you are not at any risk of harms from Tobacco, Alcohol, Cannabis, Cocaine, Inhalants, Hallucinogens, Sedatives, Opioids, Other use at this time.</div><div class=\"assist-section\" ng-if=\"assistSACtrl.results.feedback.briefAdvice.length ||assistSACtrl.results.feedback.moderateAdvice.length || assistSACtrl.results.feedback.referralAdvice.length\"><table class=\"table-eAssist table-bordered\"><thead><tr><th>Substance</th><th>Score</th><th>Risk</th><th>Criteria</th><th ng-if=\"assistSACtrl.comparison.data.tobacco\">Change</th></tr></thead><tbody><tr><td>a. Tobacco products</td><td>{{assistSACtrl.results.criteria.tobacco}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.tobacco <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.tobacco >= 4 && assistSACtrl.results.criteria.tobacco <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.tobacco >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.tobacco\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.tobacco.currentScore < assistSACtrl.comparison.data.tobacco.previousScore, \'worse\' : assistSACtrl.comparison.data.tobacco.currentScore > assistSACtrl.comparison.data.tobacco.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.tobacco.currentScore < assistSACtrl.comparison.data.tobacco.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.tobacco.currentScore > assistSACtrl.comparison.data.tobacco.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.tobacco.currentScore === assistSACtrl.comparison.data.tobacco.previousScore\">No Change</span></span></td></tr><tr><td>b. Alcoholic beverages</td><td>{{assistSACtrl.results.criteria.alcoholic}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.alcoholic <= 10\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.alcoholic >= 11 && assistSACtrl.results.criteria.alcoholic <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.alcoholic >= 27\">High</span></td><td><p>0-10 Low</p><p>11-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.alcoholic\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.alcoholic.currentScore < assistSACtrl.comparison.data.alcoholic.previousScore, \'worse\' : assistSACtrl.comparison.data.alcoholic.currentScore > assistSACtrl.comparison.data.alcoholic.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.alcoholic.currentScore < assistSACtrl.comparison.data.alcoholic.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.alcoholic.currentScore > assistSACtrl.comparison.data.alcoholic.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.alcoholic.currentScore === assistSACtrl.comparison.data.alcoholic.previousScore\">No Change</span></span></td></tr><tr><td>c. Cannabis</td><td>{{assistSACtrl.results.criteria.cannabis}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.cannabis <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.cannabis >= 4 && assistSACtrl.results.criteria.cannabis <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.cannabis >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.cannabis\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.cannabis.currentScore < assistSACtrl.comparison.data.cannabis.previousScore, \'worse\' : assistSACtrl.comparison.data.cannabis.currentScore > assistSACtrl.comparison.data.cannabis.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.cannabis.currentScore < assistSACtrl.comparison.data.cannabis.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.cannabis.currentScore > assistSACtrl.comparison.data.cannabis.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.cannabis.currentScore === assistSACtrl.comparison.data.cannabis.previousScore\">No Change</span></span></td></tr><tr><td>d. Cocaine</td><td>{{assistSACtrl.results.criteria.cocaine}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.cocaine <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.cocaine >= 4 && assistSACtrl.results.criteria.cocaine <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.cocaine >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.cocaine\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.cocaine.currentScore < assistSACtrl.comparison.data.cocaine.previousScore, \'worse\' : assistSACtrl.comparison.data.cocaine.currentScore > assistSACtrl.comparison.data.cocaine.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.cocaine.currentScore < assistSACtrl.comparison.data.cocaine.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.cocaine.currentScore > assistSACtrl.comparison.data.cocaine.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.cocaine.currentScore === assistSACtrl.comparison.data.cocaine.previousScore\">No Change</span></span></td></tr><tr><td>e. Amphetamine type stimulants</td><td>{{assistSACtrl.results.criteria.amphetamine}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.amphetamine <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.amphetamine >= 4 && assistSACtrl.results.criteria.amphetamine <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.amphetamine >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.amphetamine\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.amphetamine.currentScore < assistSACtrl.comparison.data.amphetamine.previousScore, \'worse\' : assistSACtrl.comparison.data.amphetamine.currentScore > assistSACtrl.comparison.data.amphetamine.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.amphetamine.currentScore < assistSACtrl.comparison.data.amphetamine.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.amphetamine.currentScore > assistSACtrl.comparison.data.amphetamine.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.amphetamine.currentScore === assistSACtrl.comparison.data.amphetamine.previousScore\">No Change</span></span></td></tr><tr><td>f. Inhalants</td><td>{{assistSACtrl.results.criteria.inhalants}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.inhalants <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.inhalants >= 4 && assistSACtrl.results.criteria.inhalants <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.inhalants >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.inhalants\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.inhalants.currentScore < assistSACtrl.comparison.data.inhalants.previousScore, \'worse\' : assistSACtrl.comparison.data.inhalants.currentScore > assistSACtrl.comparison.data.inhalants.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.inhalants.currentScore < assistSACtrl.comparison.data.inhalants.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.inhalants.currentScore > assistSACtrl.comparison.data.inhalants.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.inhalants.currentScore === assistSACtrl.comparison.data.inhalants.previousScore\">No Change</span></span></td></tr><tr><td>g. Sedatives or Sleeping Pills</td><td>{{assistSACtrl.results.criteria.sedatives}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.sedatives <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.sedatives >= 4 && assistSACtrl.results.criteria.sedatives <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.sedatives >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.sedatives\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.sedatives.currentScore < assistSACtrl.comparison.data.sedatives.previousScore, \'worse\' : assistSACtrl.comparison.data.sedatives.currentScore > assistSACtrl.comparison.data.sedatives.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.sedatives.currentScore < assistSACtrl.comparison.data.sedatives.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.sedatives.currentScore > assistSACtrl.comparison.data.sedatives.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.sedatives.currentScore === assistSACtrl.comparison.data.sedatives.previousScore\">No Change</span></span></td></tr><tr><td>h. Hallucinogens</td><td>{{assistSACtrl.results.criteria.hallucinogens}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.hallucinogens <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.hallucinogens >= 4 && assistSACtrl.results.criteria.hallucinogens <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.hallucinogens >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.hallucinogens\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.hallucinogens.currentScore < assistSACtrl.comparison.data.hallucinogens.previousScore, \'worse\' : assistSACtrl.comparison.data.hallucinogens.currentScore > assistSACtrl.comparison.data.hallucinogens.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.hallucinogens.currentScore < assistSACtrl.comparison.data.hallucinogens.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.hallucinogens.currentScore > assistSACtrl.comparison.data.hallucinogens.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.hallucinogens.currentScore === assistSACtrl.comparison.data.hallucinogens.previousScore\">No Change</span></span></td></tr><tr><td>i. Opioids</td><td>{{assistSACtrl.results.criteria.opioids}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.opioids <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.opioids >= 4 && assistSACtrl.results.criteria.opioids <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.opioids >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.opioids\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.opioids.currentScore < assistSACtrl.comparison.data.opioids.previousScore, \'worse\' : assistSACtrl.comparison.data.opioids.currentScore > assistSACtrl.comparison.data.opioids.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.opioids.currentScore < assistSACtrl.comparison.data.opioids.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.opioids.currentScore > assistSACtrl.comparison.data.opioids.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.opioids.currentScore === assistSACtrl.comparison.data.opioids.previousScore\">No Change</span></span></td></tr><tr><td>j. Other <span ng-if=\"assistSACtrl.secondTest.form.otherText\">- {{assistSACtrl.secondTest.form.otherText}}</span></td><td>{{assistSACtrl.results.criteria.other}}</td><td><span class=\"text-success\" ng-if=\"assistSACtrl.results.criteria.other <= 3\">Low</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.other >= 4 && assistSACtrl.results.criteria.other <= 26\">Moderate</span> <span class=\"text-danger\" ng-if=\"assistSACtrl.results.criteria.other >= 27\">High</span></td><td><p>0-3 Low</p><p>4-26 Moderate</p><p>27+ High</p></td><td class=\"normal-table-cell\" ng-if=\"assistSACtrl.comparison.data.other\"><span ng-class=\"{ \'improved\': assistSACtrl.comparison.data.other.currentScore < assistSACtrl.comparison.data.other.previousScore, \'worse\' : assistSACtrl.comparison.data.other.currentScore > assistSACtrl.comparison.data.other.previousScore }\"><span ng-if=\"assistSACtrl.comparison.data.other.currentScore < assistSACtrl.comparison.data.other.previousScore\">Improved</span> <span ng-if=\"assistSACtrl.comparison.data.other.currentScore > assistSACtrl.comparison.data.other.previousScore\">Worse</span> <span ng-if=\"assistSACtrl.comparison.data.other.currentScore === assistSACtrl.comparison.data.other.previousScore\">No Change</span></span></td></tr></tbody></table><div class=\"row\"><h3 class=\"col-md-12 text-center\">What do your scores mean?</h3></div><div class=\"row\"><div class=\"col-md-2\"><strong>Low:</strong></div><div class=\"col-md-9\">You are at low risk of health and other problems from your current pattern of use.</div></div><div class=\"row\"><div class=\"col-md-2\"><strong>Moderate:</strong></div><div class=\"col-md-9\">You are at risk of health and other problems from your current pattern of substance use.</div></div><div class=\"row\"><div class=\"col-md-2\"><strong>High:</strong></div><div class=\"col-md-9\">You are at high risk of experiencing severe problems (health, social, financial, legal, relationship) as a result of your current pattern of use and are likely to be dependant.</div></div><p>* <strong>Referral</strong> only REQUIRED for \'High\' scores, but can be offered to anyone upon their request.</p></div><div class=\"btns-move\"><span ng-if=\"assistSACtrl.results.feedback.briefAdvice.length||assistSACtrl.results.feedback.moderateAdvice.length ||assistSACtrl.results.feedback.referralAdvice.length\"><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-click=\"assistSACtrl.downloadParticipantReportCSV()\">Download Report (CSV)</button></div><div class=\"assist-section assist-form-fields form-group\" ng-class=\"{ \'has-error\': !surveyForm.email.$valid && surveyForm.email.$touched && !surveyForm.email.$error.required }\" ng-hide=\"assistSACtrl.isEmailSent\"><div class=\"form-input\"><input type=\"email\" class=\"form-control\" name=\"email\" placeholder=\"Enter your eMail\" ng-model=\"email.value\" ng-disabled=\"assistSACtrl.isSendingEmail\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.email.$valid && surveyForm.email.$touched\">Please enter a valid email address.</p></div></div><div><button class=\"btn btn-purple next-btn\" type=\"button\" ng-disabled=\"!surveyForm.email.$valid || assistSACtrl.isSendingEmail || assistSACtrl.isEmailSent\" ng-click=\"assistSACtrl.emailParticipantReport(email.value)\"><span ng-if=\"!assistSACtrl.isSendingEmail && !assistSACtrl.isEmailSent\">*eMail me my results</span> <span ng-if=\"assistSACtrl.isSendingEmail\">Sending email...</span> <span ng-if=\"assistSACtrl.isEmailSent\">eMail has been sent</span></button></div></span><div ng-if=\"portalText.hostName===\'assist\'\"><a class=\"btn btn-purple next-btn\" onclick=\"window.location.reload(true);\" href=\"{{assistSACtrl.appBaseUrl}}/#/e-assist-SA\">Return to the instructions page</a></div></div><div ng-if=\"assistCtrl.results.feedback.briefAdvice.length ||assistCtrl.results.feedback.moderateAdvice.length ||assistCtrl.results.feedback.referralAdvice.length\" class=\"assist-section\"><p>*Optional - we will not store your eMail address.</p></div></div>");
$templateCache.put("app/components/assistLite/eAssistSA/template/feedback.template.html","<div class=\"videoWindow\"><div class=\"assist-section text-center\"><h1 class=\"assist-title\">What\'s next?</h1></div><div class=\"assist-section\" ng-if=\"!assistSACtrl.results.feedback.briefAdvice.length&&!assistSACtrl.results.feedback.moderateAdvice.length && !assistSACtrl.results.feedback.referralAdvice.length\">Thank you for completing the questions. Based on your answers, you are not at any risk of harms from Tobacco, Alcohol, Cannabis, Cocaine, Inhalants, Hallucinogens, Sedatives, Opioids, Other use at this time.</div><div class=\"assist-section\" ng-if=\"assistSACtrl.results.feedback.briefAdvice.length || assistCtrl.results.feedback.moderateAdvice.length|| assistSACtrl.results.feedback.referralAdvice.length\">Thanks for completing the questions. Click each section below to view further information and advice.</div><div class=\"assist-section assist-section-feedback\" ng-if=\"assistSACtrl.results.feedback.briefAdvice.length\"><h2 class=\"assist-title\">Brief Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{(assistSACtrl.results.feedback.briefAdvice[0].drugName | capitalize) + (assistSACtrl.results.feedback.briefAdvice[0].substance ? \' - \' + assistSACtrl.results.feedback.briefAdvice[0].substance : \'\')}}\" is-open=\"assistSACtrl.isBriefOpen\"><div ng-include=\"\" src=\"assistSACtrl.results.feedback.briefAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in assistSACtrl.results.feedback.briefAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.drugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"assistSACtrl.results.feedback.moderateAdvice.length\"><h2 class=\"assist-title\">Moderate Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{(assistSACtrl.results.feedback.moderateAdvice[0].drugName | capitalize) + (assistSACtrl.results.feedback.moderateAdvice[0].substance ? \' - \' + assistSACtrl.results.feedback.moderateAdvice[0].substance : \'\')}}\" is-open=\"assistSACtrl.isModerateOpen\"><div ng-include=\"\" src=\"assistSACtrl.results.feedback.moderateAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in assistSACtrl.results.feedback.moderateAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.drugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div><div class=\"assist-section assist-section-feedback\" ng-if=\"assistSACtrl.results.feedback.referralAdvice.length\"><h2 class=\"assist-title\">Referral Advice</h2><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" heading=\"{{(assistSACtrl.results.feedback.referralAdvice[0].drugName | capitalize) + (assistSACtrl.results.feedback.referralAdvice[0].substance ? \' - \' + assistSACtrl.results.feedback.referralAdvice[0].substance : \'\')}}\" is-open=\"assistSACtrl.isReferralOpen\"><div ng-include=\"\" src=\"assistSACtrl.results.feedback.referralAdvice[0].content\"></div></div><div uib-accordion-group=\"\" class=\"panel-default\" scroll-top=\"\" ng-repeat=\"advice in assistSACtrl.results.feedback.referralAdvice\" ng-if=\"$index > 0\" heading=\"{{(advice.drugName | capitalize) + (advice.substance ? \' - \' + advice.substance : \'\')}}\"><div ng-include=\"\" src=\"advice.content\"></div></div></uib-accordion></div></div>");
$templateCache.put("app/components/assistLite/eAssistSA/template/intro.template.html","<div class=\"assistTest\"><div class=\"assist-section\"><h1 class=\"assist-title\">Assist Informed consent</h1></div><h2 class=\"assist-title\">PRINCIPAL INVESTIGATOR: Jannie Hugo (University of Pretoria)</h2><div class=\"assist-section\"><p>Dear Participant,<br>You are invited to participate in the research project described below.</p><p><strong>What is ASSIST and why is it being done ?</strong><br>The excessive use of alcohol, tobacco and other substances (drugs) is making many people in our communities unwell.</p><p>To help people understand the risks of their substance use we are offering the ASSIST test. We will ask you about your experience of using alcohol, tobacco and other drugs in the past three months.</p><p>We will give you some feedback on your scores and information that may help you to decide what (if any) action you may need to take. The ASSIST can be repeated every three months to assess changes in your substance use and risks. All responses are confidential, and your honest responses are appreciated.</p><p><strong>Who is undertaking the project?</strong><br>This project is being conducted by the University of Pretoria, in collaboration with the University of Adelaide.</p><p><strong>Why am I being invited to participate?</strong><br>This activity is designed to support your health. We will also use the information as part of our substance use programme (COSUP). Anyone aged 15 years and over may participate.</p><p><strong>What will I be asked to do?</strong><br>To participate, answer the questions that the study team member will ask you. The study team member will enter this information into their device.</p><p><strong>How much time will the project take?</strong><br>The ASSIST is expected to take between 5 and 15 minutes to complete.</p><p><strong>Are there any risks associated with participating in this project?</strong><br>There are no health or legal risks for taking part. If you do find that completing the survey brings up worries or concerns, discuss these with the person conducting the ASSIST. Ask the person completing the ASSIST about how to access COSUP services in your area. Services are also provided from:</p><ul><li><a href=\"https://www.up.ac.za/family-medicine/article/2714990/contact-cosup-community-oriented-substance-use-programme\">https://www.up.ac.za/family-medicine/article/2714990/contact-cosup-community-oriented-substance-use-programme</a></li></ul><p><strong>What are the benefits of the research project?</strong><br>The information will be used to support your health care and only for research to improve health care services.</p><p><strong>Can I withdraw from the project?</strong><br>Participation in this project is completely voluntary. There will be no change to the care you receive should you choose not to participate in the research. You can stop completing the survey at any time. If you want to ensure that data you have already entered is deleted from our server, please contact Jannie Hugo on (012) 356 3298.</p><p><strong>Can I review my information?</strong><br>You can review the information you have provided and correct any information with which you disagree before your data is submitted.</p><p><strong>What will happen to my information?</strong><br>Survey data will be stored on the University of Adelaide secure server and only the researchers will have access. Contact details, i.e. your mobile number and/or email address will be stored in a separate database on the University of Adelaide secure server. We will not collect your name for the research. We will keep your name and clinical information separate to the research so that this information will be part of your clinical file to support your health service. The separate databases will be linked only by a common identification number. Only the researchers will have access to the data. Contact details will be accessed only for the purpose of follow-up. No individual participants or data will be identified in research articles and conference presentations arising from this research. Data will be destroyed after 7 years.</p><p>Researchers are not obliged to report unlawful behaviour that does not pose a threat to human safety. Occasionally, research data may be subpoenaed for legal processes. As we will not record your name your data will be anonymous although there is a small risk that you could be identified from your mobile number or email address.</p><p><strong>Who do I contact if I have questions about the project?</strong><br>In the first instance, please contact: Jannie Hugo on 012 356 3298</p><p><strong>What if I have a complaint or any concerns?</strong><br>The study has been approved by the Research Ethics Committee of the University of Pretoria, Faculty of Health Sciences. For any concerns or complaints about the study you can contact the ethics committee via telephone at: 012 356 3084 or 012 356 3085. Any complaint or concern will be treated in confidence and investigated.</p><p>If you have questions or problems associated with the practical aspects of your participation in the project, or wish to raise a concern or complaint about the project, then you should consult Jannie Hugo on (012) 356 3298</p><p><strong>If I want to participate, what do I do?</strong><br>By ticking the box and clicking the \'Next\' button below, you indicate your consent to be included in our study, and the survey will begin.</p><ul><li>I have been told about the purpose of doing the ASSIST.</li><li>I understand that the information will be captured and stored electronically.</li><li>I am aware that the information about my health status will be made available ONLY to service providers who are directly involved in providing me with health and social development services. It will not be shared with any other public or private service provider without my permission.</li><li>I understand that the information about my health status may be used for research purposes. I have been told that I will not be identified in any report, publication or other presentation.</li><li>I have had time to ask questions.</li></ul><p>Thank you for your participation.</p><p>Yours sincerely,</p><p>Professor Jannie Hugo and research team.<br>Department of Family Medicine<br>Faculty of Health Sciences<br>University of Pretoria<br></p></div><div class=\"assist-section\"><h4>Instructions</h4><p>Please note this first screen should be completed in the presence of a research team member, a medical student, doctor or nurse. To complete the ASSIST you will need to:</p><ol><li>Select the appropriate Practice from the dropdown options</li><li>Read and agree to the terms and conditions of the User Agreement</li><li>Select the box beside the agreement note</li><li>Click the \'Next\' button to start</li></ol></div><div class=\"assist-section assist-form-fields form-group row\"><div class=\"col-md-12\"><input id=\"liteRepeat\" type=\"checkbox\" ng-change=\"assistSACtrl.errors = {}\" ng-model=\"assistSACtrl.currentTest.form.isTrial\"> <label class=\"label-checkbox\" for=\"liteRepeat\"><span class=\"icon icon-checkbox\"></span>I participated previously and will re-enter my code.</label></div></div><div class=\"assist-section assist-form-fields form-group row\" ng-if=\"!assistSACtrl.currentTest.form.isTrial\"><div class=\"col-md-4\"><label>{{assistSACtrl.currentTest.practice.text}}</label></div><div class=\"col-md-5\"><ui-select theme=\"bootstrap\" class=\"assist-select\" name=\"facility\" required=\"\" ng-model=\"assistSACtrl.currentTest.form.practice.value\"><ui-select-match placeholder=\"Select Practice\"><span ng-bind=\"$select.selected\"></span></ui-select-match><ui-select-choices repeat=\"practice in assistSACtrl.currentTest.practice.options\"><span ng-bind=\"practice\"></span></ui-select-choices></ui-select></div></div><div class=\"assist-section assist-form-fields form-group row\" ng-class=\"{ \'has-error\': (!surveyForm.trialCode.$valid && surveyForm.trialCode.$touched) || assistSACtrl.errors.clientId }\"><div class=\"col-md-4\"><label>Participant Code:</label></div><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" name=\"trialCode\" placeholder=\"Add your Unique ID\" ng-model=\"assistSACtrl.currentTest.form.clientId\" required=\"\"><p class=\"text-danger error-message\" ng-show=\"!surveyForm.trialCode.$valid && surveyForm.trialCode.$touched\"><span ng-show=\"surveyForm.trialCode.$error.required\">Field is required.</span></p><p class=\"text-danger error-message\" ng-show=\"assistSACtrl.errors.clientId\">{{assistSACtrl.errors.clientId}}</p></div></div><div class=\"assist-section assist-license\"><p><strong>Conditions of use of ASSIST Portal</strong></p><p><a href=\"http://assistportal.com.au\">ASSIST Portal</a> provides access to ASSIST and associated materials. In addition to the OpenTute User Agreement, the following terms and conditions (Terms of Use) apply to the use and access to <a href=\"http://assistportal.com.au\">ASSIST Portal</a>. In these Terms of Use, we or us means Adelaide Research & Innovation Pty Ltd, the commercialisation arm of the University of Adelaide and you means you, as an end user of <a href=\"http://assistportal.com.au\">ASSIST Portal</a>.</p><p>You acknowledge that you have read, understand, and agree to be legally bound by these Terms of Use together with the OpenTute User Agreement. We may amend these Terms of Use from time to time with the most updated version being provided on <a href=\"http://assistportal.com.au\">ASSIST Portal</a>. By continuing to use ASSIST Online you accept the amended Terms or Use.</p><ol><li><a href=\"http://assistportal.com.au\">ASSIST Portal</a> provides access to ASSIST and associated materials. ASSIST is a screening tool only and not a diagnostic tool. ASSIST has not been validated for use in people under 18 years of age. ASSIST provides a general indicator of risk due to substance use. You are responsible for determining the suitability or otherwise of ASSIST.</li><li>While \'low\', \'moderate\' and \'high\' risk scores give an indication of the appropriate level of intervention, they should be used in conjunction with clinical judgement. We take no responsibility for the outcome or consequences of using this tool.</li><li>Neither we nor any third party will be liable for any errors in ASSIST and information made available via <a href=\"http://assistportal.com.au\">ASSIST Portal</a>, or for any actions you take in reliance on ASSIST or information in <a href=\"http://assistportal.com.au\">ASSIST Portal</a>. Neither you nor any other person may hold us liable for any delays, inaccuracies, errors or omissions in respect of ASSIST Portal or the transmission or delivery of ASSIST via ASSIST Portal, or for any liability, loss or damage arising from any of them.</li><li>We may, at our discretion, remove, modify or update ASSIST or information in ASSIST Portal from time to time and without notice to you. Such updates include any modifications, enhancements, improvements, or revisions to ASSIST or information, including any updates to correct errors or to comply with changes to law or industry guidelines.</li><li>We grant you a limited, non-exclusive, non-transferrable licence to access and use ASSIST Portal subject to these Terms of Use.</li><li>You must not collect, use, duplicate, license, sublicense, publish, distribute, rebrand, sell or otherwise make available to any third party, in whole or in part the ASSIST Portal and any information, publications or other content published on or made available via ASSIST Portal except as permitted in these Terms of Use or as expressly authorised by us.</li><li>You agree that we may access, preserve, use and disclose your personal information if required to do so by law (or by any judicial or regulatory body), where expressly authorised by you, or where in good faith we believe that such access, preservation, use or disclosure is reasonably necessary in our opinion to:<ol><li>provide the Member Service;</li><li>respond to your enquiries;</li><li>enforce these Terms of Use;</li><li>comply with legal process, including but not limited to civil and criminal subpoenas, court orders or other compulsory disclosures; or</li><li>comply with required or commercially prudent record keeping practices.</li></ol></li><li>The University of Adelaide\'s Privacy Policy governs how we collect, use, handle and disclose any personal information you provide or disclose to us and forms part of these Terms of Use. You should carefully read and review our Privacy Policy in full before disclosing to us any personal information. Our Privacy Policy can be accessed at <a href=\"http://www.adelaide.edu.au/policies/62/\" target=\"_blank\">http://www.adelaide.edu.au/policies/62/</a>.</li></ol><p>Should you have any questions or queries regarding appropriate use of the ASSIST and associated tools please contact Professor Robert Ali via the <a href=\"http://assistportal.com.au\">ASSIST Portal</a>.</p></div><div class=\"assist-section\"><input id=\"license\" type=\"checkbox\" name=\"agree\" required=\"\" ng-model=\"assistSACtrl.currentTest.form.userAgreement\"> <label class=\"label-checkbox\" for=\"license\"><span class=\"icon icon-checkbox assist\"></span>I agree to the above terms and conditions.</label></div></div>");
$templateCache.put("app/components/assistLite/eAssistSA/template/question1.template.html","<span class=\"question-title\" ng-bind-html=\"portalText.eAssist[assistSACtrl.language].question1.title\"></span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"assistSACtrl.currentTestIndex != 0\" value=\"assistSACtrl.readyPercentage\"><span ng-show=\"assistSACtrl.readyPercentage\">{{assistSACtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\" ng-repeat=\"question in portalText.eAssist[assistSACtrl.language].question1.questions\"><p class=\"question-text\">{{ portalText.eAssist[assistSACtrl.language].questionTitle[question] }} <span ng-if=\"question == \'other\'\">- specify</span></p><div class=\"form-group radio-group\" ng-repeat=\"answer in portalText.eAssist[assistSACtrl.language].question1.answers\"><input id=\"question-{{$parent.$index}}-{{$index}}\" name=\"{{$parent.$index + answer}}\" type=\"radio\" required=\"\" ng-model=\"assistSACtrl.currentTest.form[question]\" ng-value=\"answer.value\"> <label class=\"label-radioBtn\" for=\"question-{{$parent.$index}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{answer.label}}</label></div><input type=\"text\" required=\"\" ng-model=\"assistSACtrl.currentTest.form.otherText\" ng-if=\"question == \'other\' && assistSACtrl.currentTest.form[question]\"></div></div>");
$templateCache.put("app/components/assistLite/eAssistSA/template/question2-7.template.html","<span class=\"question-title\" ng-bind-html=\"portalText.eAssist[assistSACtrl.language][assistSACtrl.currentTest.name].title\"></span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"assistSACtrl.currentTestIndex != 0\" value=\"assistSACtrl.readyPercentage\"><span ng-show=\"assistSACtrl.readyPercentage\">{{assistSACtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\" ng-repeat=\"question in assistSACtrl.questions\"><p class=\"question-text\">{{portalText.eAssist[assistSACtrl.language].questionTitle[question]}} <span ng-if=\"question === \'other\' && assistSACtrl.secondTest.form.otherText\">- {{assistSACtrl.secondTest.form.otherText}}</span></p><div class=\"form-group radio-group\" ng-repeat=\"answer in portalText.eAssist[assistSACtrl.language][assistSACtrl.currentTest.name].answers\"><input id=\"question-{{$parent.$index}}-{{$index}}\" name=\"{{$parent.$index + answer + $index}}\" type=\"radio\" required=\"\" ng-model=\"assistSACtrl.currentTest.form[question]\" ng-value=\"answer.value\"> <label class=\"label-radioBtn\" for=\"question-{{$parent.$index}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{answer.label}}</label></div></div></div>");
$templateCache.put("app/components/assistLite/eAssistSA/template/question8.template.html","<span class=\"question-title\" ng-bind-html=\"portalText.eAssist[assistSACtrl.language].question8.title\"></span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"assistSACtrl.currentTestIndex != 0\" value=\"assistSACtrl.readyPercentage\"><span ng-show=\"assistSACtrl.readyPercentage\">{{assistSACtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\"><div class=\"form-group radio-group\" ng-repeat=\"answer in portalText.eAssist[assistSACtrl.language].question8.answers\"><input id=\"question-{{$parent.$index}}-{{$index}}\" name=\"{{$parent.$index + answer + $index}}\" type=\"radio\" required=\"\" ng-model=\"assistSACtrl.currentTest.form.answer\" ng-value=\"answer.value\"> <label class=\"label-radioBtn\" for=\"question-{{$parent.$index}}-{{$index}}\"><span class=\"icon icon-radioBtn\"></span>{{answer.label}}</label></div></div></div>");
$templateCache.put("app/components/assistLite/eAssistSA/template/question9.template.html","<span class=\"question-title\" ng-bind-html=\"portalText.eAssist[assistSACtrl.language][assistSACtrl.currentTest.name].title\"></span><uib-progressbar max=\"100\" class=\"percentage-container\" ng-if=\"assistSACtrl.currentTestIndex != 0\" value=\"assistSACtrl.readyPercentage\"><span ng-show=\"assistSACtrl.readyPercentage\">{{assistSACtrl.readyPercentage}}%</span></uib-progressbar><div class=\"questions\"><div class=\"question\"><p class=\"question-text\">What is your gender?</p><div class=\"form-group radio-group\"><input id=\"question-0-0\" name=\"0answer0\" type=\"radio\" ng-model=\"assistSACtrl.currentTest.form.gender\" value=\"Male\"> <label class=\"label-radioBtn\" for=\"question-0-0\"><span class=\"icon icon-radioBtn\"></span>Male</label></div><div class=\"form-group radio-group\"><input id=\"question-0-1\" name=\"0answer1\" type=\"radio\" ng-model=\"assistSACtrl.currentTest.form.gender\" value=\"Female\"> <label class=\"label-radioBtn\" for=\"question-0-1\"><span class=\"icon icon-radioBtn\"></span>Female</label></div></div><div class=\"question\"><p class=\"question-text\">What is your age?</p><div class=\"form-group radio-group\"><input id=\"question-1-0\" name=\"1answer0\" type=\"number\" ng-min=\"18\" required=\"\" ng-model=\"assistSACtrl.currentTest.form.age\" value=\"\"><br><br><span class=\"error-message\" ng-if=\"surveyForm[\'1answer0\'].$touched && surveyForm[\'1answer0\'].$invalid\">An age of 18+ is required to complete this survey.</span></div></div><div class=\"question\"><p class=\"question-text\">How are you mainly employed at the moment?</p><div class=\"form-group radio-group\"><input id=\"question-2-0\" name=\"2answer0\" type=\"radio\" ng-model=\"assistSACtrl.currentTest.form.employed\" required=\"\" value=\"Not employed\"> <label class=\"label-radioBtn\" for=\"question-2-0\"><span class=\"icon icon-radioBtn\"></span>Not employed</label></div><div class=\"form-group radio-group\"><input id=\"question-2-1\" name=\"2answer1\" type=\"radio\" ng-model=\"assistSACtrl.currentTest.form.employed\" required=\"\" value=\"Full time\"> <label class=\"label-radioBtn\" for=\"question-2-1\"><span class=\"icon icon-radioBtn\"></span>Full time</label></div><div class=\"form-group radio-group\"><input id=\"question-2-2\" name=\"2answer2\" type=\"radio\" ng-model=\"assistSACtrl.currentTest.form.employed\" required=\"\" value=\"Part time/casual\"> <label class=\"label-radioBtn\" for=\"question-2-2\"><span class=\"icon icon-radioBtn\"></span>Part time/casual</label></div><div class=\"form-group radio-group\"><input id=\"question-2-3\" name=\"2answer3\" type=\"radio\" ng-model=\"assistSACtrl.currentTest.form.employed\" required=\"\" value=\"Student\"> <label class=\"label-radioBtn\" for=\"question-2-3\"><span class=\"icon icon-radioBtn\"></span>Student</label></div><div class=\"form-group radio-group\"><input id=\"question-2-4\" name=\"2answer4\" type=\"radio\" ng-model=\"assistSACtrl.currentTest.form.employed\" required=\"\" value=\"Home duties\"> <label class=\"label-radioBtn\" for=\"question-2-4\"><span class=\"icon icon-radioBtn\"></span>Home duties</label></div></div></div>");}]);